/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/view-v2/web/site/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 186);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(31);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = $;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(7),
    __webpack_require__(8),
    __webpack_require__(1),
    __webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    EventBus,
    Events,
    $,
    _
){
    var cdnOrigin = 'https://static.fnji.com';
    var testCdnOrigin = 'http://static.fnji.com';
    var imageOrigin = getImageOrigin();
    var baseUrl = getBaseUrl();

    function genImageUrl(imageName, options, origin){
        if (!imageName) return '';
        if(imageName.substr(0,4) == 'http')
            return imageName;


        imageName = imageName.split('?')[0];

        var defaultOptions = {
            width: 1440,
            useOriginal: false,
            usePng: false,
            color: ''
        };
        options = _.assign({}, defaultOptions, options);
        var query = '?';
        if(imageName.split('?').length>1)
            query+=imageName.split('?')[1]+"&";

        if (!options.useOriginal){
            query += 'imageMogr2/thumbnail/'+options.width+'x>';
            if (isPngImage(imageName) && !options.usePng){
                query += '/format/jpg';
                if (options.color){
                    query += '/background/'+options.color;
                }
            }
        }
        return (origin || cdnOrigin) + '/temp/upload/' + imageName + query;
    }
    function genFnjiImageUrl(imageName, options){
        return genImageUrl(imageName, options, imageOrigin);
    }

    function genCdnImageUrl(imageName, options){
        return genImageUrl(imageName, options, cdnOrigin);
    }
    function genCdnImageUrlOrg(imageName, options){
        return genImageUrl(imageName, {useOriginal:true}, cdnOrigin);
    }

    function isPngImage(imageName){
        imageName = (imageName || '').split('?')[0];
        return /\.png$/i.test(imageName || '');
    }

    function getImageOrigin(){
        switch(window.location.hostname){
            case 'fnji.com':
            case 'www.fnji.com':
            case 'm.fnji.com':
                return cdnOrigin;
            default:
                return testCdnOrigin;
        }
    }

    function emitPageReady(){
        setTimeout(function(){
            EventBus.$emit(Events.PageReady);
        }, 100);
    }

    function genPageLink(path){
        return baseUrl + path;
    }

    function getBaseUrl(){
        var path = window.location.pathname;
        if (path.match(/^\/v2\/src\//)){
            return '/v2/src';
        }
        if (path.match(/^\/v2\//)){
            return '/v2';
        }
        return '';
    }

    function getUrlParam(name){
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]);
        return null;
    }

    // function lazyLoadImages(options){
    //     $('[data-original][data-original!=""]').lazyload(_.assign({
    //         threshold: 100
    //     }, options));
    // }

    function scrollToSelector(selector, options){
        var $selector = $(selector);
        if (!$selector.length) return;
        if (options === 0) {
            $selector[0].scrollIntoView();
        } else {
            var top = $selector.offset().top;
            scrollTo(top, options);
        }
    }
    function scrollTo(top, options){
        var defaultOptions = {
            speed: 1000,
            easing: 'swing'
        };
        $('html,body').animate({scrollTop: top || 0}, _.assign(defaultOptions, options));
    }

    function scrollIntoView(el, times){
        if (!el) return;
        var fixedHeaderHeight = $('.page-header').height();
        var offsetTop = $(el).offset().top;
        // console.log(offsetTop, fixedHeaderHeight, offsetTop-fixedHeaderHeight);
        window.scroll({top: offsetTop - fixedHeaderHeight});
        if (!times) {
            setTimeout(function(){
                scrollIntoView(el, 1);
            }, 100);
        }
    }

    function getUrlHash(name, defval)
    {
        var hash = window.location.hash ? window.location.hash : "";
        var hashObj = $.deparam.fragment( hash, true );
        if(hashObj[name] != undefined)
            return hashObj[name];

        return defval;
    }

    return {
        getUrlHash:getUrlHash,
        emitPageReady: emitPageReady,
        genPageLink: genPageLink,
        genFnjiImageUrl: genFnjiImageUrl,
        genCdnImageUrl: genCdnImageUrl,
        genCdnImageUrlOrg:genCdnImageUrlOrg,
        getUrlParam: getUrlParam,
        scrollTo: scrollTo,
        scrollToSelector: scrollToSelector,
        scrollIntoView: scrollIntoView
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),
    __webpack_require__(3),
    __webpack_require__(9)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $,
    _,
    Toast
){
    // var BaseUrl = 'https://fnji.test.com';
    var BaseUrl = 'https://fnji.com';
    // var BaseUrl = '';
    var ErrorEnum = {
        DataError: {
            code: 'DATA_ERROR',
            data: '数据异常'
        },
        NetworkError: {
            code: 'NETWORK_ERROR',
            data: '网络异常'
        },
        ParamError: {
            code: 'PARAM_ERROR',
            data: '参数错误'
        }
    };
    function Api(path, defaultOptions){
        this.url = BaseUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    Api.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    Api.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };

    return {
        Api: Api,
        getMemberInfoApi: new Api('/s/member/getMemberInfo'),
        loginApi: new Api('/s/member/login', {type: 'POST'}),
        getWxLoginInfoApi: new Api('/s/member/getWxLoginInfo'),
        logoutApi: new Api('/s/member/logOut'),
        sendVerifyCodeApi: new Api('/s/member/sendPhoneVerify'),
        registerApi: new Api('/s/member/reg', {type: 'POST'}),
        resetPassApi: new Api('/s/member/forgot',{type: 'POST'}),

        addAddressApi: new Api('/s/member-address/add', {type: 'POST'}),
        modAddressApi: new Api('/s/member-address/mod', {type: 'POST'}),
        getProvinceApi: new Api('/s/common/getProvince'),
        getCityApi: new Api('/s/common/getCity'),

        getMenuByCategoryApi: new Api('/m/s/product-list/getMenuByCategory'),

        switchZhEnApi: new Api('/m/s/SiteIndexEntity/switchZhEn')//中英文切换
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),

    __webpack_require__(35)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $
){
    var backDropClass = 'modal-backdrop';
    var modalOpenClass = 'modal-open';
    var duration = 200;

    function onModalShow(){
        var $el = $('.'+backDropClass);
        if (!$el.length){
            $el = $('<div/>').addClass(backDropClass).appendTo('body');
        }
        $el.fadeIn(duration);
        $('body').addClass(modalOpenClass);
    }

    function onModalHide(){
        $('.'+backDropClass).fadeOut(duration);
        $('body').removeClass(modalOpenClass);
    }

    return {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            modalData: {
                type: Object
            }
        },
        watch: {
            value: function(value){
                if (value){
                    onModalShow();
                    $(this.$el).fadeIn(duration);
                } else {
                    onModalHide();
                    $(this.$el).fadeOut(duration);
                }
            }
        },
        methods: {
            show: function(){
                this.$emit('input', true);
            },
            hide: function(){
                this.$emit('input', false);
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(Vue){
    return new Vue();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){
    return {
        PageReady: 'page-ready',
        UpdateMemberInfo: 'update-member-info'
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(4),
    __webpack_require__(27),
    __webpack_require__(1)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Vue,
    LoadingToast,
    $
){
    var $toastOverlay = $('<div/>').appendTo('body');

    return new Vue({
        el: $toastOverlay[0],
        template: '<loading-toast v-show="loadingToast.isShow"></loading-toast>',
        components: {
            LoadingToast: LoadingToast
        },
        data: {
            loadingToast: {
                isShow: false
            }
        },
        methods: {
            showLoadingToast: function(){
                this.loadingToast.isShow = true;
            },
            hideLoadingToast: function(){
                this.loadingToast.isShow = false;
            }
        }
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(32),
    __webpack_require__(4),
    __webpack_require__(33),
    __webpack_require__(1),
    __webpack_require__(40),
    __webpack_require__(44),
    __webpack_require__(48),
    __webpack_require__(52),

    __webpack_require__(56)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    Vue,
    MemberLoginModal,
    $,
    MemberRegisterModal,
    PassResetModal,
    FnjiWeixinModal,
    FnjiWeixinSrvModal

){
    var $modalOverlay = $('<div/>').appendTo('body');

    return new Vue({
        el: $modalOverlay[0],
        template: tpl,
        components: {
            MemberLoginModal: MemberLoginModal,
            MemberRegisterModal: MemberRegisterModal,
            PassResetModal: PassResetModal,
            FnjiWeixinModal: FnjiWeixinModal,
            FnjiWeixinSrvModal: FnjiWeixinSrvModal

        },
        data: {
            memberLoginModal: {
                isShow: false,
                data: {
                    from: ''
                }
            },
            memberRegisterModal: {
                isShow: false,
                data: {}
            },
            passResetModal: {
                isShow: false,
                data: {}
            },
            fnjiWeixinModal: {
                isShow: false,
                data: {}
            },
            fnjiWeixinSrvModal: {
                isShow: false,
                data: {}
            }
        },
        methods: {
            showMemberLoginModal: function(from){
                this.memberLoginModal = {
                    isShow: true,
                    data: {
                        from: from || ''
                    }
                };
            },
            showMemberRegisterModal: function(){
                this.memberRegisterModal.isShow = true;
            },
            showPassResetModal: function(){
                this.passResetModal.isShow = true;
            },
            showFnjiWeixinModal: function(){
                this.fnjiWeixinModal.isShow = true;
            },
            showFnjiWeixinSrvModal: function(){
                this.fnjiWeixinSrvModal.isShow = true;
            }
        }
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-i18n v8.15.5 
 * (c) 2020 kazuya kawaguchi
 * Released under the MIT License.
 */
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.VueI18n = factory());
}(this, (function () { 'use strict';

  /*  */

  /**
   * constants
   */

  var numberFormatKeys = [
    'style',
    'currency',
    'currencyDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    'localeMatcher',
    'formatMatcher',
    'unit'
  ];

  /**
   * utilities
   */

  function warn (msg, err) {
    if (typeof console !== 'undefined') {
      console.warn('[vue-i18n] ' + msg);
      /* istanbul ignore if */
      if (err) {
        console.warn(err.stack);
      }
    }
  }

  function error (msg, err) {
    if (typeof console !== 'undefined') {
      console.error('[vue-i18n] ' + msg);
      /* istanbul ignore if */
      if (err) {
        console.error(err.stack);
      }
    }
  }

  function isObject (obj) {
    return obj !== null && typeof obj === 'object'
  }

  var toString = Object.prototype.toString;
  var OBJECT_STRING = '[object Object]';
  function isPlainObject (obj) {
    return toString.call(obj) === OBJECT_STRING
  }

  function isNull (val) {
    return val === null || val === undefined
  }

  function parseArgs () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var locale = null;
    var params = null;
    if (args.length === 1) {
      if (isObject(args[0]) || Array.isArray(args[0])) {
        params = args[0];
      } else if (typeof args[0] === 'string') {
        locale = args[0];
      }
    } else if (args.length === 2) {
      if (typeof args[0] === 'string') {
        locale = args[0];
      }
      /* istanbul ignore if */
      if (isObject(args[1]) || Array.isArray(args[1])) {
        params = args[1];
      }
    }

    return { locale: locale, params: params }
  }

  function looseClone (obj) {
    return JSON.parse(JSON.stringify(obj))
  }

  function remove (arr, item) {
    if (arr.length) {
      var index = arr.indexOf(item);
      if (index > -1) {
        return arr.splice(index, 1)
      }
    }
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;
  function hasOwn (obj, key) {
    return hasOwnProperty.call(obj, key)
  }

  function merge (target) {
    var arguments$1 = arguments;

    var output = Object(target);
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments$1[i];
      if (source !== undefined && source !== null) {
        var key = (void 0);
        for (key in source) {
          if (hasOwn(source, key)) {
            if (isObject(source[key])) {
              output[key] = merge(output[key], source[key]);
            } else {
              output[key] = source[key];
            }
          }
        }
      }
    }
    return output
  }

  function looseEqual (a, b) {
    if (a === b) { return true }
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
      try {
        var isArrayA = Array.isArray(a);
        var isArrayB = Array.isArray(b);
        if (isArrayA && isArrayB) {
          return a.length === b.length && a.every(function (e, i) {
            return looseEqual(e, b[i])
          })
        } else if (!isArrayA && !isArrayB) {
          var keysA = Object.keys(a);
          var keysB = Object.keys(b);
          return keysA.length === keysB.length && keysA.every(function (key) {
            return looseEqual(a[key], b[key])
          })
        } else {
          /* istanbul ignore next */
          return false
        }
      } catch (e) {
        /* istanbul ignore next */
        return false
      }
    } else if (!isObjectA && !isObjectB) {
      return String(a) === String(b)
    } else {
      return false
    }
  }

  /*  */

  function extend (Vue) {
    if (!Vue.prototype.hasOwnProperty('$i18n')) {
      // $FlowFixMe
      Object.defineProperty(Vue.prototype, '$i18n', {
        get: function get () { return this._i18n }
      });
    }

    Vue.prototype.$t = function (key) {
      var values = [], len = arguments.length - 1;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

      var i18n = this.$i18n;
      return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
    };

    Vue.prototype.$tc = function (key, choice) {
      var values = [], len = arguments.length - 2;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

      var i18n = this.$i18n;
      return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
    };

    Vue.prototype.$te = function (key, locale) {
      var i18n = this.$i18n;
      return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
    };

    Vue.prototype.$d = function (value) {
      var ref;

      var args = [], len = arguments.length - 1;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
      return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
    };

    Vue.prototype.$n = function (value) {
      var ref;

      var args = [], len = arguments.length - 1;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
      return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
    };
  }

  /*  */

  var mixin = {
    beforeCreate: function beforeCreate () {
      var options = this.$options;
      options.i18n = options.i18n || (options.__i18n ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          if (options.__i18n) {
            try {
              var localeMessages = {};
              options.__i18n.forEach(function (resource) {
                localeMessages = merge(localeMessages, JSON.parse(resource));
              });
              Object.keys(localeMessages).forEach(function (locale) {
                options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
              });
            } catch (e) {
              {
                error("Cannot parse locale messages via custom blocks.", e);
              }
            }
          }
          this._i18n = options.i18n;
          this._i18nWatcher = this._i18n.watchI18nData();
        } else if (isPlainObject(options.i18n)) {
          // component local i18n
          if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
            options.i18n.root = this.$root;
            options.i18n.formatter = this.$root.$i18n.formatter;
            options.i18n.fallbackLocale = this.$root.$i18n.fallbackLocale;
            options.i18n.formatFallbackMessages = this.$root.$i18n.formatFallbackMessages;
            options.i18n.silentTranslationWarn = this.$root.$i18n.silentTranslationWarn;
            options.i18n.silentFallbackWarn = this.$root.$i18n.silentFallbackWarn;
            options.i18n.pluralizationRules = this.$root.$i18n.pluralizationRules;
            options.i18n.preserveDirectiveContent = this.$root.$i18n.preserveDirectiveContent;
          }

          // init locale messages via custom blocks
          if (options.__i18n) {
            try {
              var localeMessages$1 = {};
              options.__i18n.forEach(function (resource) {
                localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
              });
              options.i18n.messages = localeMessages$1;
            } catch (e) {
              {
                warn("Cannot parse locale messages via custom blocks.", e);
              }
            }
          }

          var ref = options.i18n;
          var sharedMessages = ref.sharedMessages;
          if (sharedMessages && isPlainObject(sharedMessages)) {
            options.i18n.messages = merge(options.i18n.messages, sharedMessages);
          }

          this._i18n = new VueI18n(options.i18n);
          this._i18nWatcher = this._i18n.watchI18nData();

          if (options.i18n.sync === undefined || !!options.i18n.sync) {
            this._localeWatcher = this.$i18n.watchLocale();
          }
        } else {
          {
            warn("Cannot be interpreted 'i18n' option.");
          }
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        // root i18n
        this._i18n = this.$root.$i18n;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        // parent i18n
        this._i18n = options.parent.$i18n;
      }
    },

    beforeMount: function beforeMount () {
      var options = this.$options;
      options.i18n = options.i18n || (options.__i18n ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else if (isPlainObject(options.i18n)) {
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else {
          {
            warn("Cannot be interpreted 'i18n' option.");
          }
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      }
    },

    beforeDestroy: function beforeDestroy () {
      if (!this._i18n) { return }

      var self = this;
      this.$nextTick(function () {
        if (self._subscribing) {
          self._i18n.unsubscribeDataChanging(self);
          delete self._subscribing;
        }

        if (self._i18nWatcher) {
          self._i18nWatcher();
          self._i18n.destroyVM();
          delete self._i18nWatcher;
        }

        if (self._localeWatcher) {
          self._localeWatcher();
          delete self._localeWatcher;
        }

        self._i18n = null;
      });
    }
  };

  /*  */

  var interpolationComponent = {
    name: 'i18n',
    functional: true,
    props: {
      tag: {
        type: String
      },
      path: {
        type: String,
        required: true
      },
      locale: {
        type: String
      },
      places: {
        type: [Array, Object]
      }
    },
    render: function render (h, ref) {
      var data = ref.data;
      var parent = ref.parent;
      var props = ref.props;
      var slots = ref.slots;

      var $i18n = parent.$i18n;
      if (!$i18n) {
        {
          warn('Cannot find VueI18n instance!');
        }
        return
      }

      var path = props.path;
      var locale = props.locale;
      var places = props.places;
      var params = slots();
      var children = $i18n.i(
        path,
        locale,
        onlyHasDefaultPlace(params) || places
          ? useLegacyPlaces(params.default, places)
          : params
      );

      var tag = props.tag || 'span';
      return tag ? h(tag, data, children) : children
    }
  };

  function onlyHasDefaultPlace (params) {
    var prop;
    for (prop in params) {
      if (prop !== 'default') { return false }
    }
    return Boolean(prop)
  }

  function useLegacyPlaces (children, places) {
    var params = places ? createParamsFromPlaces(places) : {};

    if (!children) { return params }

    // Filter empty text nodes
    children = children.filter(function (child) {
      return child.tag || child.text.trim() !== ''
    });

    var everyPlace = children.every(vnodeHasPlaceAttribute);
    if (everyPlace) {
      warn('`place` attribute is deprecated in next major version. Please switch to Vue slots.');
    }

    return children.reduce(
      everyPlace ? assignChildPlace : assignChildIndex,
      params
    )
  }

  function createParamsFromPlaces (places) {
    {
      warn('`places` prop is deprecated in next major version. Please switch to Vue slots.');
    }

    return Array.isArray(places)
      ? places.reduce(assignChildIndex, {})
      : Object.assign({}, places)
  }

  function assignChildPlace (params, child) {
    if (child.data && child.data.attrs && child.data.attrs.place) {
      params[child.data.attrs.place] = child;
    }
    return params
  }

  function assignChildIndex (params, child, index) {
    params[index] = child;
    return params
  }

  function vnodeHasPlaceAttribute (vnode) {
    return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place)
  }

  /*  */

  var numberComponent = {
    name: 'i18n-n',
    functional: true,
    props: {
      tag: {
        type: String,
        default: 'span'
      },
      value: {
        type: Number,
        required: true
      },
      format: {
        type: [String, Object]
      },
      locale: {
        type: String
      }
    },
    render: function render (h, ref) {
      var props = ref.props;
      var parent = ref.parent;
      var data = ref.data;

      var i18n = parent.$i18n;

      if (!i18n) {
        {
          warn('Cannot find VueI18n instance!');
        }
        return null
      }

      var key = null;
      var options = null;

      if (typeof props.format === 'string') {
        key = props.format;
      } else if (isObject(props.format)) {
        if (props.format.key) {
          key = props.format.key;
        }

        // Filter out number format options only
        options = Object.keys(props.format).reduce(function (acc, prop) {
          var obj;

          if (numberFormatKeys.includes(prop)) {
            return Object.assign({}, acc, ( obj = {}, obj[prop] = props.format[prop], obj ))
          }
          return acc
        }, null);
      }

      var locale = props.locale || i18n.locale;
      var parts = i18n._ntp(props.value, locale, key, options);

      var values = parts.map(function (part, index) {
        var obj;

        var slot = data.scopedSlots && data.scopedSlots[part.type];
        return slot ? slot(( obj = {}, obj[part.type] = part.value, obj.index = index, obj.parts = parts, obj )) : part.value
      });

      return h(props.tag, {
        attrs: data.attrs,
        'class': data['class'],
        staticClass: data.staticClass
      }, values)
    }
  };

  /*  */

  function bind (el, binding, vnode) {
    if (!assert(el, vnode)) { return }

    t(el, binding, vnode);
  }

  function update (el, binding, vnode, oldVNode) {
    if (!assert(el, vnode)) { return }

    var i18n = vnode.context.$i18n;
    if (localeEqual(el, vnode) &&
      (looseEqual(binding.value, binding.oldValue) &&
       looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

    t(el, binding, vnode);
  }

  function unbind (el, binding, vnode, oldVNode) {
    var vm = vnode.context;
    if (!vm) {
      warn('Vue instance does not exists in VNode context');
      return
    }

    var i18n = vnode.context.$i18n || {};
    if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
      el.textContent = '';
    }
    el._vt = undefined;
    delete el['_vt'];
    el._locale = undefined;
    delete el['_locale'];
    el._localeMessage = undefined;
    delete el['_localeMessage'];
  }

  function assert (el, vnode) {
    var vm = vnode.context;
    if (!vm) {
      warn('Vue instance does not exists in VNode context');
      return false
    }

    if (!vm.$i18n) {
      warn('VueI18n instance does not exists in Vue instance');
      return false
    }

    return true
  }

  function localeEqual (el, vnode) {
    var vm = vnode.context;
    return el._locale === vm.$i18n.locale
  }

  function t (el, binding, vnode) {
    var ref$1, ref$2;

    var value = binding.value;

    var ref = parseValue(value);
    var path = ref.path;
    var locale = ref.locale;
    var args = ref.args;
    var choice = ref.choice;
    if (!path && !locale && !args) {
      warn('value type not supported');
      return
    }

    if (!path) {
      warn('`path` is required in v-t directive');
      return
    }

    var vm = vnode.context;
    if (choice) {
      el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
    } else {
      el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
    }
    el._locale = vm.$i18n.locale;
    el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
  }

  function parseValue (value) {
    var path;
    var locale;
    var args;
    var choice;

    if (typeof value === 'string') {
      path = value;
    } else if (isPlainObject(value)) {
      path = value.path;
      locale = value.locale;
      args = value.args;
      choice = value.choice;
    }

    return { path: path, locale: locale, args: args, choice: choice }
  }

  function makeParams (locale, args) {
    var params = [];

    locale && params.push(locale);
    if (args && (Array.isArray(args) || isPlainObject(args))) {
      params.push(args);
    }

    return params
  }

  var Vue;

  function install (_Vue) {
    /* istanbul ignore if */
    if (install.installed && _Vue === Vue) {
      warn('already installed.');
      return
    }
    install.installed = true;

    Vue = _Vue;

    var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
    /* istanbul ignore if */
    if (version < 2) {
      warn(("vue-i18n (" + (install.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
      return
    }

    extend(Vue);
    Vue.mixin(mixin);
    Vue.directive('t', { bind: bind, update: update, unbind: unbind });
    Vue.component(interpolationComponent.name, interpolationComponent);
    Vue.component(numberComponent.name, numberComponent);

    // use simple mergeStrategies to prevent i18n instance lose '__proto__'
    var strats = Vue.config.optionMergeStrategies;
    strats.i18n = function (parentVal, childVal) {
      return childVal === undefined
        ? parentVal
        : childVal
    };
  }

  /*  */

  var BaseFormatter = function BaseFormatter () {
    this._caches = Object.create(null);
  };

  BaseFormatter.prototype.interpolate = function interpolate (message, values) {
    if (!values) {
      return [message]
    }
    var tokens = this._caches[message];
    if (!tokens) {
      tokens = parse(message);
      this._caches[message] = tokens;
    }
    return compile(tokens, values)
  };



  var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
  var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

  function parse (format) {
    var tokens = [];
    var position = 0;

    var text = '';
    while (position < format.length) {
      var char = format[position++];
      if (char === '{') {
        if (text) {
          tokens.push({ type: 'text', value: text });
        }

        text = '';
        var sub = '';
        char = format[position++];
        while (char !== undefined && char !== '}') {
          sub += char;
          char = format[position++];
        }
        var isClosed = char === '}';

        var type = RE_TOKEN_LIST_VALUE.test(sub)
          ? 'list'
          : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
            ? 'named'
            : 'unknown';
        tokens.push({ value: sub, type: type });
      } else if (char === '%') {
        // when found rails i18n syntax, skip text capture
        if (format[(position)] !== '{') {
          text += char;
        }
      } else {
        text += char;
      }
    }

    text && tokens.push({ type: 'text', value: text });

    return tokens
  }

  function compile (tokens, values) {
    var compiled = [];
    var index = 0;

    var mode = Array.isArray(values)
      ? 'list'
      : isObject(values)
        ? 'named'
        : 'unknown';
    if (mode === 'unknown') { return compiled }

    while (index < tokens.length) {
      var token = tokens[index];
      switch (token.type) {
        case 'text':
          compiled.push(token.value);
          break
        case 'list':
          compiled.push(values[parseInt(token.value, 10)]);
          break
        case 'named':
          if (mode === 'named') {
            compiled.push((values)[token.value]);
          } else {
            {
              warn(("Type of token '" + (token.type) + "' and format of value '" + mode + "' don't match!"));
            }
          }
          break
        case 'unknown':
          {
            warn("Detect 'unknown' type of token!");
          }
          break
      }
      index++;
    }

    return compiled
  }

  /*  */

  /**
   *  Path parser
   *  - Inspired:
   *    Vue.js Path parser
   */

  // actions
  var APPEND = 0;
  var PUSH = 1;
  var INC_SUB_PATH_DEPTH = 2;
  var PUSH_SUB_PATH = 3;

  // states
  var BEFORE_PATH = 0;
  var IN_PATH = 1;
  var BEFORE_IDENT = 2;
  var IN_IDENT = 3;
  var IN_SUB_PATH = 4;
  var IN_SINGLE_QUOTE = 5;
  var IN_DOUBLE_QUOTE = 6;
  var AFTER_PATH = 7;
  var ERROR = 8;

  var pathStateMachine = [];

  pathStateMachine[BEFORE_PATH] = {
    'ws': [BEFORE_PATH],
    'ident': [IN_IDENT, APPEND],
    '[': [IN_SUB_PATH],
    'eof': [AFTER_PATH]
  };

  pathStateMachine[IN_PATH] = {
    'ws': [IN_PATH],
    '.': [BEFORE_IDENT],
    '[': [IN_SUB_PATH],
    'eof': [AFTER_PATH]
  };

  pathStateMachine[BEFORE_IDENT] = {
    'ws': [BEFORE_IDENT],
    'ident': [IN_IDENT, APPEND],
    '0': [IN_IDENT, APPEND],
    'number': [IN_IDENT, APPEND]
  };

  pathStateMachine[IN_IDENT] = {
    'ident': [IN_IDENT, APPEND],
    '0': [IN_IDENT, APPEND],
    'number': [IN_IDENT, APPEND],
    'ws': [IN_PATH, PUSH],
    '.': [BEFORE_IDENT, PUSH],
    '[': [IN_SUB_PATH, PUSH],
    'eof': [AFTER_PATH, PUSH]
  };

  pathStateMachine[IN_SUB_PATH] = {
    "'": [IN_SINGLE_QUOTE, APPEND],
    '"': [IN_DOUBLE_QUOTE, APPEND],
    '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
    ']': [IN_PATH, PUSH_SUB_PATH],
    'eof': ERROR,
    'else': [IN_SUB_PATH, APPEND]
  };

  pathStateMachine[IN_SINGLE_QUOTE] = {
    "'": [IN_SUB_PATH, APPEND],
    'eof': ERROR,
    'else': [IN_SINGLE_QUOTE, APPEND]
  };

  pathStateMachine[IN_DOUBLE_QUOTE] = {
    '"': [IN_SUB_PATH, APPEND],
    'eof': ERROR,
    'else': [IN_DOUBLE_QUOTE, APPEND]
  };

  /**
   * Check if an expression is a literal value.
   */

  var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
  function isLiteral (exp) {
    return literalValueRE.test(exp)
  }

  /**
   * Strip quotes from a string
   */

  function stripQuotes (str) {
    var a = str.charCodeAt(0);
    var b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27)
      ? str.slice(1, -1)
      : str
  }

  /**
   * Determine the type of a character in a keypath.
   */

  function getPathCharType (ch) {
    if (ch === undefined || ch === null) { return 'eof' }

    var code = ch.charCodeAt(0);

    switch (code) {
      case 0x5B: // [
      case 0x5D: // ]
      case 0x2E: // .
      case 0x22: // "
      case 0x27: // '
        return ch

      case 0x5F: // _
      case 0x24: // $
      case 0x2D: // -
        return 'ident'

      case 0x09: // Tab
      case 0x0A: // Newline
      case 0x0D: // Return
      case 0xA0:  // No-break space
      case 0xFEFF:  // Byte Order Mark
      case 0x2028:  // Line Separator
      case 0x2029:  // Paragraph Separator
        return 'ws'
    }

    return 'ident'
  }

  /**
   * Format a subPath, return its plain form if it is
   * a literal string or number. Otherwise prepend the
   * dynamic indicator (*).
   */

  function formatSubPath (path) {
    var trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === '0' && isNaN(path)) { return false }

    return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
  }

  /**
   * Parse a string path into an array of segments
   */

  function parse$1 (path) {
    var keys = [];
    var index = -1;
    var mode = BEFORE_PATH;
    var subPathDepth = 0;
    var c;
    var key;
    var newChar;
    var type;
    var transition;
    var action;
    var typeMap;
    var actions = [];

    actions[PUSH] = function () {
      if (key !== undefined) {
        keys.push(key);
        key = undefined;
      }
    };

    actions[APPEND] = function () {
      if (key === undefined) {
        key = newChar;
      } else {
        key += newChar;
      }
    };

    actions[INC_SUB_PATH_DEPTH] = function () {
      actions[APPEND]();
      subPathDepth++;
    };

    actions[PUSH_SUB_PATH] = function () {
      if (subPathDepth > 0) {
        subPathDepth--;
        mode = IN_SUB_PATH;
        actions[APPEND]();
      } else {
        subPathDepth = 0;
        if (key === undefined) { return false }
        key = formatSubPath(key);
        if (key === false) {
          return false
        } else {
          actions[PUSH]();
        }
      }
    };

    function maybeUnescapeQuote () {
      var nextChar = path[index + 1];
      if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
        (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
        index++;
        newChar = '\\' + nextChar;
        actions[APPEND]();
        return true
      }
    }

    while (mode !== null) {
      index++;
      c = path[index];

      if (c === '\\' && maybeUnescapeQuote()) {
        continue
      }

      type = getPathCharType(c);
      typeMap = pathStateMachine[mode];
      transition = typeMap[type] || typeMap['else'] || ERROR;

      if (transition === ERROR) {
        return // parse error
      }

      mode = transition[0];
      action = actions[transition[1]];
      if (action) {
        newChar = transition[2];
        newChar = newChar === undefined
          ? c
          : newChar;
        if (action() === false) {
          return
        }
      }

      if (mode === AFTER_PATH) {
        return keys
      }
    }
  }





  var I18nPath = function I18nPath () {
    this._cache = Object.create(null);
  };

  /**
   * External parse that check for a cache hit first
   */
  I18nPath.prototype.parsePath = function parsePath (path) {
    var hit = this._cache[path];
    if (!hit) {
      hit = parse$1(path);
      if (hit) {
        this._cache[path] = hit;
      }
    }
    return hit || []
  };

  /**
   * Get path value from path string
   */
  I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
    if (!isObject(obj)) { return null }

    var paths = this.parsePath(path);
    if (paths.length === 0) {
      return null
    } else {
      var length = paths.length;
      var last = obj;
      var i = 0;
      while (i < length) {
        var value = last[paths[i]];
        if (value === undefined) {
          return null
        }
        last = value;
        i++;
      }

      return last
    }
  };

  /*  */



  var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
  var linkKeyMatcher = /(?:@(?:\.[a-z]+)?:(?:[\w\-_|.]+|\([\w\-_|.]+\)))/g;
  var linkKeyPrefixMatcher = /^@(?:\.([a-z]+))?:/;
  var bracketsMatcher = /[()]/g;
  var defaultModifiers = {
    'upper': function (str) { return str.toLocaleUpperCase(); },
    'lower': function (str) { return str.toLocaleLowerCase(); },
    'capitalize': function (str) { return ("" + (str.charAt(0).toLocaleUpperCase()) + (str.substr(1))); }
  };

  var defaultFormatter = new BaseFormatter();

  var VueI18n = function VueI18n (options) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

    // Auto install if it is not done yet and `window` has `Vue`.
    // To allow users to avoid auto-installation in some cases,
    // this code should be placed here. See #290
    /* istanbul ignore if */
    if (!Vue && typeof window !== 'undefined' && window.Vue) {
      install(window.Vue);
    }

    var locale = options.locale || 'en-US';
    var fallbackLocale = options.fallbackLocale || 'en-US';
    var messages = options.messages || {};
    var dateTimeFormats = options.dateTimeFormats || {};
    var numberFormats = options.numberFormats || {};

    this._vm = null;
    this._formatter = options.formatter || defaultFormatter;
    this._modifiers = options.modifiers || {};
    this._missing = options.missing || null;
    this._root = options.root || null;
    this._sync = options.sync === undefined ? true : !!options.sync;
    this._fallbackRoot = options.fallbackRoot === undefined
      ? true
      : !!options.fallbackRoot;
    this._formatFallbackMessages = options.formatFallbackMessages === undefined
      ? false
      : !!options.formatFallbackMessages;
    this._silentTranslationWarn = options.silentTranslationWarn === undefined
      ? false
      : options.silentTranslationWarn;
    this._silentFallbackWarn = options.silentFallbackWarn === undefined
      ? false
      : !!options.silentFallbackWarn;
    this._dateTimeFormatters = {};
    this._numberFormatters = {};
    this._path = new I18nPath();
    this._dataListeners = [];
    this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
      ? false
      : !!options.preserveDirectiveContent;
    this.pluralizationRules = options.pluralizationRules || {};
    this._warnHtmlInMessage = options.warnHtmlInMessage || 'off';

    this._exist = function (message, key) {
      if (!message || !key) { return false }
      if (!isNull(this$1._path.getPathValue(message, key))) { return true }
      // fallback for flat key
      if (message[key]) { return true }
      return false
    };

    if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
      Object.keys(messages).forEach(function (locale) {
        this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
      });
    }

    this._initVM({
      locale: locale,
      fallbackLocale: fallbackLocale,
      messages: messages,
      dateTimeFormats: dateTimeFormats,
      numberFormats: numberFormats
    });
  };

  var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },formatFallbackMessages: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true },warnHtmlInMessage: { configurable: true } };

  VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage (locale, level, message) {
    var paths = [];

    var fn = function (level, locale, message, paths) {
      if (isPlainObject(message)) {
        Object.keys(message).forEach(function (key) {
          var val = message[key];
          if (isPlainObject(val)) {
            paths.push(key);
            paths.push('.');
            fn(level, locale, val, paths);
            paths.pop();
            paths.pop();
          } else {
            paths.push(key);
            fn(level, locale, val, paths);
            paths.pop();
          }
        });
      } else if (Array.isArray(message)) {
        message.forEach(function (item, index) {
          if (isPlainObject(item)) {
            paths.push(("[" + index + "]"));
            paths.push('.');
            fn(level, locale, item, paths);
            paths.pop();
            paths.pop();
          } else {
            paths.push(("[" + index + "]"));
            fn(level, locale, item, paths);
            paths.pop();
          }
        });
      } else if (typeof message === 'string') {
        var ret = htmlTagMatcher.test(message);
        if (ret) {
          var msg = "Detected HTML in message '" + message + "' of keypath '" + (paths.join('')) + "' at '" + locale + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
          if (level === 'warn') {
            warn(msg);
          } else if (level === 'error') {
            error(msg);
          }
        }
      }
    };

    fn(level, locale, message, paths);
  };

  VueI18n.prototype._initVM = function _initVM (data) {
    var silent = Vue.config.silent;
    Vue.config.silent = true;
    this._vm = new Vue({ data: data });
    Vue.config.silent = silent;
  };

  VueI18n.prototype.destroyVM = function destroyVM () {
    this._vm.$destroy();
  };

  VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
    this._dataListeners.push(vm);
  };

  VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
    remove(this._dataListeners, vm);
  };

  VueI18n.prototype.watchI18nData = function watchI18nData () {
    var self = this;
    return this._vm.$watch('$data', function () {
      var i = self._dataListeners.length;
      while (i--) {
        Vue.nextTick(function () {
          self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
        });
      }
    }, { deep: true })
  };

  VueI18n.prototype.watchLocale = function watchLocale () {
    /* istanbul ignore if */
    if (!this._sync || !this._root) { return null }
    var target = this._vm;
    return this._root.$i18n.vm.$watch('locale', function (val) {
      target.$set(target, 'locale', val);
      target.$forceUpdate();
    }, { immediate: true })
  };

  prototypeAccessors.vm.get = function () { return this._vm };

  prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
  prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
  prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
  prototypeAccessors.availableLocales.get = function () { return Object.keys(this.messages).sort() };

  prototypeAccessors.locale.get = function () { return this._vm.locale };
  prototypeAccessors.locale.set = function (locale) {
    this._vm.$set(this._vm, 'locale', locale);
  };

  prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
  prototypeAccessors.fallbackLocale.set = function (locale) {
    this._vm.$set(this._vm, 'fallbackLocale', locale);
  };

  prototypeAccessors.formatFallbackMessages.get = function () { return this._formatFallbackMessages };
  prototypeAccessors.formatFallbackMessages.set = function (fallback) { this._formatFallbackMessages = fallback; };

  prototypeAccessors.missing.get = function () { return this._missing };
  prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

  prototypeAccessors.formatter.get = function () { return this._formatter };
  prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

  prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
  prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

  prototypeAccessors.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
  prototypeAccessors.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

  prototypeAccessors.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
  prototypeAccessors.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

  prototypeAccessors.warnHtmlInMessage.get = function () { return this._warnHtmlInMessage };
  prototypeAccessors.warnHtmlInMessage.set = function (level) {
      var this$1 = this;

    var orgLevel = this._warnHtmlInMessage;
    this._warnHtmlInMessage = level;
    if (orgLevel !== level && (level === 'warn' || level === 'error')) {
      var messages = this._getMessages();
      Object.keys(messages).forEach(function (locale) {
        this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
      });
    }
  };

  VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
  VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
  VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

  VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values, interpolateMode) {
    if (!isNull(result)) { return result }
    if (this._missing) {
      var missingRet = this._missing.apply(null, [locale, key, vm, values]);
      if (typeof missingRet === 'string') {
        return missingRet
      }
    } else {
      if (!this._isSilentTranslationWarn(key)) {
        warn(
          "Cannot translate the value of keypath '" + key + "'. " +
          'Use the value of keypath as default.'
        );
      }
    }

    if (this._formatFallbackMessages) {
      var parsedArgs = parseArgs.apply(void 0, values);
      return this._render(key, interpolateMode, parsedArgs.params, key)
    } else {
      return key
    }
  };

  VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
    return !val && !isNull(this._root) && this._fallbackRoot
  };

  VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn (key) {
    return this._silentFallbackWarn instanceof RegExp
      ? this._silentFallbackWarn.test(key)
      : this._silentFallbackWarn
  };

  VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale, key) {
    return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale)
  };

  VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn (key) {
    return this._silentTranslationWarn instanceof RegExp
      ? this._silentTranslationWarn.test(key)
      : this._silentTranslationWarn
  };

  VueI18n.prototype._interpolate = function _interpolate (
    locale,
    message,
    key,
    host,
    interpolateMode,
    values,
    visitedLinkStack
  ) {
    if (!message) { return null }

    var pathRet = this._path.getPathValue(message, key);
    if (Array.isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

    var ret;
    if (isNull(pathRet)) {
      /* istanbul ignore else */
      if (isPlainObject(message)) {
        ret = message[key];
        if (typeof ret !== 'string') {
          if (!this._isSilentTranslationWarn(key) && !this._isSilentFallback(locale, key)) {
            warn(("Value of key '" + key + "' is not a string!"));
          }
          return null
        }
      } else {
        return null
      }
    } else {
      /* istanbul ignore else */
      if (typeof pathRet === 'string') {
        ret = pathRet;
      } else {
        if (!this._isSilentTranslationWarn(key) && !this._isSilentFallback(locale, key)) {
          warn(("Value of key '" + key + "' is not a string!"));
        }
        return null
      }
    }

    // Check for the existence of links within the translated string
    if (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0) {
      ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
    }

    return this._render(ret, interpolateMode, values, key)
  };

  VueI18n.prototype._link = function _link (
    locale,
    message,
    str,
    host,
    interpolateMode,
    values,
    visitedLinkStack
  ) {
    var ret = str;

    // Match all the links within the local
    // We are going to replace each of
    // them with its translation
    var matches = ret.match(linkKeyMatcher);
    for (var idx in matches) {
      // ie compatible: filter custom array
      // prototype method
      if (!matches.hasOwnProperty(idx)) {
        continue
      }
      var link = matches[idx];
      var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
      var linkPrefix = linkKeyPrefixMatches[0];
        var formatterName = linkKeyPrefixMatches[1];

      // Remove the leading @:, @.case: and the brackets
      var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

      if (visitedLinkStack.includes(linkPlaceholder)) {
        {
          warn(("Circular reference found. \"" + link + "\" is already visited in the chain of " + (visitedLinkStack.reverse().join(' <- '))));
        }
        return ret
      }
      visitedLinkStack.push(linkPlaceholder);

      // Translate the link
      var translated = this._interpolate(
        locale, message, linkPlaceholder, host,
        interpolateMode === 'raw' ? 'string' : interpolateMode,
        interpolateMode === 'raw' ? undefined : values,
        visitedLinkStack
      );

      if (this._isFallbackRoot(translated)) {
        if (!this._isSilentTranslationWarn(linkPlaceholder)) {
          warn(("Fall back to translate the link placeholder '" + linkPlaceholder + "' with root locale."));
        }
        /* istanbul ignore if */
        if (!this._root) { throw Error('unexpected error') }
        var root = this._root.$i18n;
        translated = root._translate(
          root._getMessages(), root.locale, root.fallbackLocale,
          linkPlaceholder, host, interpolateMode, values
        );
      }
      translated = this._warnDefault(
        locale, linkPlaceholder, translated, host,
        Array.isArray(values) ? values : [values],
        interpolateMode
      );

      if (this._modifiers.hasOwnProperty(formatterName)) {
        translated = this._modifiers[formatterName](translated);
      } else if (defaultModifiers.hasOwnProperty(formatterName)) {
        translated = defaultModifiers[formatterName](translated);
      }

      visitedLinkStack.pop();

      // Replace the link with the translated
      ret = !translated ? ret : ret.replace(link, translated);
    }

    return ret
  };

  VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
    var ret = this._formatter.interpolate(message, values, path);

    // If the custom formatter refuses to work - apply the default one
    if (!ret) {
      ret = defaultFormatter.interpolate(message, values, path);
    }

    // if interpolateMode is **not** 'string' ('row'),
    // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
    return interpolateMode === 'string' && typeof ret !== 'string' ? ret.join('') : ret
  };

  VueI18n.prototype._translate = function _translate (
    messages,
    locale,
    fallback,
    key,
    host,
    interpolateMode,
    args
  ) {
    var res =
      this._interpolate(locale, messages[locale], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) { return res }

    res = this._interpolate(fallback, messages[fallback], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to translate the keypath '" + key + "' with '" + fallback + "' locale."));
      }
      return res
    } else {
      return null
    }
  };

  VueI18n.prototype._t = function _t (key, _locale, messages, host) {
      var ref;

      var values = [], len = arguments.length - 4;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
    if (!key) { return '' }

    var parsedArgs = parseArgs.apply(void 0, values);
    var locale = parsedArgs.locale || _locale;

    var ret = this._translate(
      messages, locale, this.fallbackLocale, key,
      host, 'string', parsedArgs.params
    );
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to translate the keypath '" + key + "' with root locale."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
    } else {
      return this._warnDefault(locale, key, ret, host, values, 'string')
    }
  };

  VueI18n.prototype.t = function t (key) {
      var ref;

      var values = [], len = arguments.length - 1;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
    return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
  };

  VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
    var ret =
      this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key)) {
        warn(("Fall back to interpolate the keypath '" + key + "' with root locale."));
      }
      if (!this._root) { throw Error('unexpected error') }
      return this._root.$i18n.i(key, locale, values)
    } else {
      return this._warnDefault(locale, key, ret, host, [values], 'raw')
    }
  };

  VueI18n.prototype.i = function i (key, locale, values) {
    /* istanbul ignore if */
    if (!key) { return '' }

    if (typeof locale !== 'string') {
      locale = this.locale;
    }

    return this._i(key, locale, this._getMessages(), null, values)
  };

  VueI18n.prototype._tc = function _tc (
    key,
    _locale,
    messages,
    host,
    choice
  ) {
      var ref;

      var values = [], len = arguments.length - 5;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
    if (!key) { return '' }
    if (choice === undefined) {
      choice = 1;
    }

    var predefined = { 'count': choice, 'n': choice };
    var parsedArgs = parseArgs.apply(void 0, values);
    parsedArgs.params = Object.assign(predefined, parsedArgs.params);
    values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
    return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
  };

  VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
    /* istanbul ignore if */
    if (!message && typeof message !== 'string') { return null }
    var choices = message.split('|');

    choice = this.getChoiceIndex(choice, choices.length);
    if (!choices[choice]) { return message }
    return choices[choice].trim()
  };

  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index
  */
  VueI18n.prototype.getChoiceIndex = function getChoiceIndex (choice, choicesLength) {
    // Default (old) getChoiceIndex implementation - english-compatible
    var defaultImpl = function (_choice, _choicesLength) {
      _choice = Math.abs(_choice);

      if (_choicesLength === 2) {
        return _choice
          ? _choice > 1
            ? 1
            : 0
          : 1
      }

      return _choice ? Math.min(_choice, 2) : 0
    };

    if (this.locale in this.pluralizationRules) {
      return this.pluralizationRules[this.locale].apply(this, [choice, choicesLength])
    } else {
      return defaultImpl(choice, choicesLength)
    }
  };

  VueI18n.prototype.tc = function tc (key, choice) {
      var ref;

      var values = [], len = arguments.length - 2;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
    return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
  };

  VueI18n.prototype._te = function _te (key, locale, messages) {
      var args = [], len = arguments.length - 3;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

    var _locale = parseArgs.apply(void 0, args).locale || locale;
    return this._exist(messages[_locale], key)
  };

  VueI18n.prototype.te = function te (key, locale) {
    return this._te(key, this.locale, this._getMessages(), locale)
  };

  VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
    return looseClone(this._vm.messages[locale] || {})
  };

  VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
    if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
      this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
      if (this._warnHtmlInMessage === 'error') { return }
    }
    this._vm.$set(this._vm.messages, locale, message);
  };

  VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
    if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
      this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
      if (this._warnHtmlInMessage === 'error') { return }
    }
    this._vm.$set(this._vm.messages, locale, merge({}, this._vm.messages[locale] || {}, message));
  };

  VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
    return looseClone(this._vm.dateTimeFormats[locale] || {})
  };

  VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
    this._vm.$set(this._vm.dateTimeFormats, locale, format);
  };

  VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
    this._vm.$set(this._vm.dateTimeFormats, locale, merge(this._vm.dateTimeFormats[locale] || {}, format));
  };

  VueI18n.prototype._localizeDateTime = function _localizeDateTime (
    value,
    locale,
    fallback,
    dateTimeFormats,
    key
  ) {
    var _locale = locale;
    var formats = dateTimeFormats[_locale];

    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + fallback + "' datetime formats from '" + locale + "' datetime formats."));
      }
      _locale = fallback;
      formats = dateTimeFormats[_locale];
    }

    if (isNull(formats) || isNull(formats[key])) {
      return null
    } else {
      var format = formats[key];
      var id = _locale + "__" + key;
      var formatter = this._dateTimeFormatters[id];
      if (!formatter) {
        formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
      }
      return formatter.format(value)
    }
  };

  VueI18n.prototype._d = function _d (value, locale, key) {
    /* istanbul ignore if */
    if (!VueI18n.availabilities.dateTimeFormat) {
      warn('Cannot format a Date value due to not supported Intl.DateTimeFormat.');
      return ''
    }

    if (!key) {
      return new Intl.DateTimeFormat(locale).format(value)
    }

    var ret =
      this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to datetime localization of root: key '" + key + "'."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      return this._root.$i18n.d(value, key, locale)
    } else {
      return ret || ''
    }
  };

  VueI18n.prototype.d = function d (value) {
      var args = [], len = arguments.length - 1;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

    var locale = this.locale;
    var key = null;

    if (args.length === 1) {
      if (typeof args[0] === 'string') {
        key = args[0];
      } else if (isObject(args[0])) {
        if (args[0].locale) {
          locale = args[0].locale;
        }
        if (args[0].key) {
          key = args[0].key;
        }
      }
    } else if (args.length === 2) {
      if (typeof args[0] === 'string') {
        key = args[0];
      }
      if (typeof args[1] === 'string') {
        locale = args[1];
      }
    }

    return this._d(value, locale, key)
  };

  VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
    return looseClone(this._vm.numberFormats[locale] || {})
  };

  VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
    this._vm.$set(this._vm.numberFormats, locale, format);
  };

  VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
    this._vm.$set(this._vm.numberFormats, locale, merge(this._vm.numberFormats[locale] || {}, format));
  };

  VueI18n.prototype._getNumberFormatter = function _getNumberFormatter (
    value,
    locale,
    fallback,
    numberFormats,
    key,
    options
  ) {
    var _locale = locale;
    var formats = numberFormats[_locale];

    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + fallback + "' number formats from '" + locale + "' number formats."));
      }
      _locale = fallback;
      formats = numberFormats[_locale];
    }

    if (isNull(formats) || isNull(formats[key])) {
      return null
    } else {
      var format = formats[key];

      var formatter;
      if (options) {
        // If options specified - create one time number formatter
        formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
      } else {
        var id = _locale + "__" + key;
        formatter = this._numberFormatters[id];
        if (!formatter) {
          formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
        }
      }
      return formatter
    }
  };

  VueI18n.prototype._n = function _n (value, locale, key, options) {
    /* istanbul ignore if */
    if (!VueI18n.availabilities.numberFormat) {
      {
        warn('Cannot format a Number value due to not supported Intl.NumberFormat.');
      }
      return ''
    }

    if (!key) {
      var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
      return nf.format(value)
    }

    var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
    var ret = formatter && formatter.format(value);
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to number localization of root: key '" + key + "'."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
    } else {
      return ret || ''
    }
  };

  VueI18n.prototype.n = function n (value) {
      var args = [], len = arguments.length - 1;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

    var locale = this.locale;
    var key = null;
    var options = null;

    if (args.length === 1) {
      if (typeof args[0] === 'string') {
        key = args[0];
      } else if (isObject(args[0])) {
        if (args[0].locale) {
          locale = args[0].locale;
        }
        if (args[0].key) {
          key = args[0].key;
        }

        // Filter out number format options only
        options = Object.keys(args[0]).reduce(function (acc, key) {
            var obj;

          if (numberFormatKeys.includes(key)) {
            return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
          }
          return acc
        }, null);
      }
    } else if (args.length === 2) {
      if (typeof args[0] === 'string') {
        key = args[0];
      }
      if (typeof args[1] === 'string') {
        locale = args[1];
      }
    }

    return this._n(value, locale, key, options)
  };

  VueI18n.prototype._ntp = function _ntp (value, locale, key, options) {
    /* istanbul ignore if */
    if (!VueI18n.availabilities.numberFormat) {
      {
        warn('Cannot format to parts a Number value due to not supported Intl.NumberFormat.');
      }
      return []
    }

    if (!key) {
      var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
      return nf.formatToParts(value)
    }

    var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
    var ret = formatter && formatter.formatToParts(value);
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key)) {
        warn(("Fall back to format number to parts of root: key '" + key + "' ."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      return this._root.$i18n._ntp(value, locale, key, options)
    } else {
      return ret || []
    }
  };

  Object.defineProperties( VueI18n.prototype, prototypeAccessors );

  var availabilities;
  // $FlowFixMe
  Object.defineProperty(VueI18n, 'availabilities', {
    get: function get () {
      if (!availabilities) {
        var intlDefined = typeof Intl !== 'undefined';
        availabilities = {
          dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
          numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
        };
      }

      return availabilities
    }
  });

  VueI18n.install = install;
  VueI18n.version = '8.15.5';

  return VueI18n;

})));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
   __webpack_require__(7),
    __webpack_require__(8)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    EventBus,
    Events
){
    return {
        data: function(){
            return {
                isPageReady: false
            };
        },
        mounted: function(){
            var _this = this;
            EventBus.$on(Events.PageReady, function(){
                _this.isPageReady = true;
            });
        },
        destroy: function(){
            EventBus.$off(Events.PageReady);
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(14),
    __webpack_require__(7),
    __webpack_require__(8),
    __webpack_require__(2)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Auth,
    EventBus,
    Events,
    Utils
){
    return {
        data: function(){
            return {
                auth: {
                    user: Auth.getUser(),
                    member: Auth.getMember(),
                    memberLink: Utils.genPageLink('/member')
                }
            };
        },
        computed: {
            isLoggedIn: function(){
                console.log(this.auth.user.login)
                return this.auth.user.login;
            }
        },
        methods: {
            fetchMemberInfo: Auth.fetchMemberInfo,
            logout: Auth.logout
        },
        created: function(){
            var _this = this;
            EventBus.$on(Events.UpdateMemberInfo, function(member){
                _this.auth.member = member;
                // console.log(_this.auth);
            });
        },
        destroy: function(){
            EventBus.$off(Events.UpdateMemberInfo);
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(5),
    __webpack_require__(7),
    __webpack_require__(8),
    __webpack_require__(2)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Api,
    EventBus,
    Events,
    Utils
){
    var user = window.FNJISite?window.FNJISite.user:{};
    var member = {};
    function fetchMemberInfo(){
        if (!user.login){
            member = {};
            emitMemberInfo();
            return;
        }
        Api.getMemberInfoApi.ajax()
            .done(function(data){
                member = data;
                emitMemberInfo();
            });
    }
    function emitMemberInfo(){
        EventBus.$emit(Events.UpdateMemberInfo, member);
    }
    function getMember(){
        return member;
    }
    function getUser(){
        return user;
    }
    function isLoggedIn(){
        return !!user.login;
    }

    function loginRedirect(from){
        console.log(from)
        from = from || Utils.getUrlParam('from') || location.href;
        // window.location.href = decodeURIComponent(from);
        window.location.href = from;

        setTimeout(function () {
            window.location.reload();
        }, 100);

    }
    function login(info, from){
        Api.loginApi.ajax({data_json: JSON.stringify(info)})
            .done(function(){
                loginRedirect(from);
            });
    }
    function logout(){
        Api.logoutApi.ajax()
            .done(function(){
                window.location.reload();
            });
    }

    return {
        fetchMemberInfo: fetchMemberInfo,
        getMember: getMember,
        getUser: getUser,
        isLoggedIn: isLoggedIn,
        loginRedirect: loginRedirect,
        login: login,
        logout: logout
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports) {

/*
 * jQuery BBQ: Back Button & Query Library - v1.3pre - 8/26/2010
 * http://benalman.com/projects/jquery-bbq-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function($,r){var h,n=Array.prototype.slice,t=decodeURIComponent,a=$.param,j,c,m,y,b=$.bbq=$.bbq||{},s,x,k,e=$.event.special,d="hashchange",B="querystring",F="fragment",z="elemUrlAttr",l="href",w="src",p=/^.*\?|#.*$/g,u,H,g,i,C,E={};function G(I){return typeof I==="string"}function D(J){var I=n.call(arguments,1);return function(){return J.apply(this,I.concat(n.call(arguments)))}}function o(I){return I.replace(H,"$2")}function q(I){return I.replace(/(?:^[^?#]*\?([^#]*).*$)?.*/,"$1")}function f(K,P,I,L,J){var R,O,N,Q,M;if(L!==h){N=I.match(K?H:/^([^#?]*)\??([^#]*)(#?.*)/);M=N[3]||"";if(J===2&&G(L)){O=L.replace(K?u:p,"")}else{Q=m(N[2]);L=G(L)?m[K?F:B](L):L;O=J===2?L:J===1?$.extend({},L,Q):$.extend({},Q,L);O=j(O);if(K){O=O.replace(g,t)}}R=N[1]+(K?C:O||!N[1]?"?":"")+O+M}else{R=P(I!==h?I:location.href)}return R}a[B]=D(f,0,q);a[F]=c=D(f,1,o);a.sorted=j=function(J,K){var I=[],L={};$.each(a(J,K).split("&"),function(P,M){var O=M.replace(/(?:%5B|=).*$/,""),N=L[O];if(!N){N=L[O]=[];I.push(O)}N.push(M)});return $.map(I.sort(),function(M){return L[M]}).join("&")};c.noEscape=function(J){J=J||"";var I=$.map(J.split(""),encodeURIComponent);g=new RegExp(I.join("|"),"g")};c.noEscape(",/");c.ajaxCrawlable=function(I){if(I!==h){if(I){u=/^.*(?:#!|#)/;H=/^([^#]*)(?:#!|#)?(.*)$/;C="#!"}else{u=/^.*#/;H=/^([^#]*)#?(.*)$/;C="#"}i=!!I}return i};c.ajaxCrawlable(0);$.deparam=m=function(L,I){var K={},J={"true":!0,"false":!1,"null":null};$.each(L.replace(/\+/g," ").split("&"),function(O,T){var N=T.split("="),S=t(N[0]),M,R=K,P=0,U=S.split("]["),Q=U.length-1;if(/\[/.test(U[0])&&/\]$/.test(U[Q])){U[Q]=U[Q].replace(/\]$/,"");U=U.shift().split("[").concat(U);Q=U.length-1}else{Q=0}if(N.length===2){M=t(N[1]);if(I){M=M&&!isNaN(M)?+M:M==="undefined"?h:J[M]!==h?J[M]:M}if(Q){for(;P<=Q;P++){S=U[P]===""?R.length:U[P];R=R[S]=P<Q?R[S]||(U[P+1]&&isNaN(U[P+1])?{}:[]):M}}else{if($.isArray(K[S])){K[S].push(M)}else{if(K[S]!==h){K[S]=[K[S],M]}else{K[S]=M}}}}else{if(S){K[S]=I?h:""}}});return K};function A(K,I,J){if(I===h||typeof I==="boolean"){J=I;I=a[K?F:B]()}else{I=G(I)?I.replace(K?u:p,""):I}return m(I,J)}m[B]=D(A,0);m[F]=y=D(A,1);$[z]||($[z]=function(I){return $.extend(E,I)})({a:l,base:l,iframe:w,img:w,input:w,form:"action",link:l,script:w});k=$[z];function v(L,J,K,I){if(!G(K)&&typeof K!=="object"){I=K;K=J;J=h}return this.each(function(){var O=$(this),M=J||k()[(this.nodeName||"").toLowerCase()]||"",N=M&&O.attr(M)||"";O.attr(M,a[L](N,K,I))})}$.fn[B]=D(v,B);$.fn[F]=D(v,F);b.pushState=s=function(L,I){if(G(L)&&/^#/.test(L)&&I===h){I=2}var K=L!==h,J=c(location.href,K?L:{},K?I:2);location.href=J};b.getState=x=function(I,J){return I===h||typeof I==="boolean"?y(I):y(J)[I]};b.removeState=function(I){var J={};if(I!==h){J=x();$.each($.isArray(I)?I:arguments,function(L,K){delete J[K]})}s(J,2)};e[d]=$.extend(e[d],{add:function(I){var K;function J(M){var L=M[F]=c();M.getState=function(N,O){return N===h||typeof N==="boolean"?m(L,N):m(L,O)[N]};K.apply(this,arguments)}if($.isFunction(I)){K=I;return J}else{K=I.handler;I.handler=J}}})})(jQuery,this);
/*
 * jQuery hashchange event - v1.3 - 7/21/2010
 * http://benalman.com/projects/jquery-hashchange-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
/*(function($,e,b){var c="hashchange",h=document,f,g=$.event.special,i=h.documentMode,d="on"+c in e&&(i===b||i>7);function a(j){j=j||location.href;return"#"+j.replace(/^[^#]*#?(.*)$/,"$1")}$.fn[c]=function(j){return j?this.bind(c,j):this.trigger(c)};$.fn[c].delay=50;g[c]=$.extend(g[c],{setup:function(){if(d){return false}$(f.start)},teardown:function(){if(d){return false}$(f.stop)}});f=(function(){var j={},p,m=a(),k=function(q){return q},l=k,o=k;j.start=function(){p||n()};j.stop=function(){p&&clearTimeout(p);p=b};function n(){var r=a(),q=o(m);if(r!==m){l(m=r,q);$(e).trigger(c)}else{if(q!==m){location.href=location.href.replace(/#.*!/,"")+q}}p=setTimeout(n,$.fn[c].delay)}$.browser.msie&&!d&&(function(){var q,r;j.start=function(){if(!q){r=$.fn[c].src;r=r&&r+a();q=$('<iframe tabindex="-1" title="empty"/>').hide().one("load",function(){r||l(a());n()}).attr("src",r||"javascript:0").insertAfter("body")[0].contentWindow;h.onpropertychange=function(){try{if(event.propertyName==="title"){q.document.title=h.title}}catch(s){}}}};j.stop=k;o=function(){return a(q.location.href)};l=function(v,s){var u=q.document,t=$.fn[c].domain;if(v!==s){u.title=h.title;u.open();t&&u.write('<script>document.domain="'+t+'"<\/script>');u.close();q.location.hash=v}}})();return j})()})(jQuery,this);*/


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),
    __webpack_require__(3),
    __webpack_require__(9)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $,
    _,
    Toast
){
    // var BaseUrl = 'https://fnji.com';
    var BaseUrl = '';
    var ErrorEnum = {
        DataError: {
            code: 'DATA_ERROR',
            data: '数据异常'
        },
        NetworkError: {
            code: 'NETWORK_ERROR',
            data: '网络异常'
        },
        ParamError: {
            code: 'PARAM_ERROR',
            data: '参数错误'
        }
    };
    function Api(path, defaultOptions){
        this.url = BaseUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    Api.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    Api.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };

    return {
        Api: Api,
        // ridgeListApi: new Api('/m/s/SiteIndexEntity/ridge'),//山脊线产品（高端线）
        // earthListApi: new Api('/m/s/SiteIndexEntity/earth'),//大地线产品（高端线）
        // highListApi: new Api('/s/product-list/getLineProducts'),//高端线产品
        getIndexImagesApi: new Api('/m/s/SiteIndexEntity/getIndexImages'),//首页图片

        switchZhEnApi: new Api('/m/s/SiteIndexEntity/switchZhEn')//中英文切换
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(65);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fangzheng.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fangzheng.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(89);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./common.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./common.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(4),
    __webpack_require__(11),
    __webpack_require__(20),
    __webpack_require__(21)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Vue,
    VueI18n,
    zh,en
){
    Vue.use(VueI18n);

    var i18n = new VueI18n({
        //设置默认语言
        locale: localStorage.getItem('locale')||'zh',//语言标识
        //添加多语言（每一种语言对应一个语言文件）
        messages: {
            zh:zh,//中文
            en:en//英文
        }
    });
    //暴露i18n
    return i18n;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){
    var zh = {
        detail: {name: '案例展示'},
        topBarLinks: [
            {name: '上海客厅预约', class: 'sh-appoint'},

            // {name: '如何购买', link: '/shop'},
            // {name: 'vr逛店', link: 'https://realsee.com/lianjia/ZBgxP9kO80L9RNnl/qk0a74LqNmzkSxh6hVtPzBKjfr89MBpA/?from=groupmessage&isappinstalled=0',img: '/view-v2/web/static/img/common/vrnew.png'},
            {name: '联系我们', link: '/site/cooperate'}
        ],
        headLeft: {
            brand: '品牌',
            crest: '山脊线',
            earth: '大地线',
            ff: 'FF线',
            register: '注册',
            login: '登录',
            logout: '注销',
            cart: '购物车',
            order: '订单'
        },
        // navMenu: [
        //     {name: '首页', link: '/', menu: []},
        //     {name: '家具', link: '',category: '1',
        //         menu: [{name: '全部',link: '/furniture?tab=all'},
        //                 {name: '椅',link: '/furniture?tab=all#chair'},
        //                 {name: '桌',link: '/furniture?tab=all#desk'},
        //                 {name: '床',link: '/furniture?tab=all#bed'},
        //                 {name: '几',link: '/furniture?tab=all#lowtable'},
        //                 {name: '柜',link: '/furniture?tab=all#cab'},
        //                 {name: '沙发',link: '/furniture?tab=all#sofa'},
        //                 {name: '一枚板',link: '/furniture?tab=all#ymb'},
        //                 {name: '其他',link: '/furniture?tab=all#other'},
        //             ],
        //         newMenu: [{name: '大地线',link: '/furniture-l2?bom=base'},
        //             {name: '山脊线',link: '/furniture-l2?bom=high'},
        //             {name: 'FF线',link: '/furniture-l2?bom=ff'}
        //         ]},
        //     {name: '家居', link: '',category: '2', menu:
        //             [{name: '全部',link: '/grocery?tab=all'},
        //                 {name: '灯具',link: '/grocery-l2?bom=C01-11'},
        //                 {name: '家纺',link: '/grocery-l2?bom=C01-12'},
        //                 {name: '餐厨用品',link: '/grocery-l2?bom=C01-13'},
        //                 {name: '收纳杂物',link: '/grocery-l2?bom=C01-14'},
        //                 {name: '香氛洗护',link: '/grocery-l2?bom=C01-15'},
        //                 {name: '装饰',link: '/grocery-l2?bom=C01-16'},
        //                 {name: '家居电器',link: '/grocery-l2?bom=C01-17'},
        //                 {name: '户外园艺',link: '/grocery-l2?bom=C01-18'},
        //                 {name: '文创',link: '/grocery-l2?bom=C01-19'}
        //                 // {name: '备品',link: '/grocery-l2?bom=C01-99'}
        //             ]},
        //     {name: '艺术', link: '/gallery', menu:
        //             [
        //                 // {name:"艺术家", link:"/gallery#artist"},
        //                 // {name:"作品", link:"/gallery#works"},
        //                 // {name:"展览", link:"/gallery#exhibit"}
        //             ]},
        //     {name: '栏目', link: '',menu: [
        //             {name:"全部", link:"/home"},
        //             {name:"梵几在家", link:"/home#home"},
        //             {name:"串门", link:"/home#drop"},
        //             // {name:"ARTSTAGE", link:"/home#artist"}
        //         ]},
        //     {name: '关于梵几', link: '/fnjinews', menu: []},
        //     {name: '如何购买', link: '/buyChannel', menu: []}
        // ],
        // navMenu: [
        //     {name: '首页', link: '/', menu: []},
        //     {name: '家具', link: '',category: '1',
        //          menu: [{name: '全部',link: '/furniture?tab=all'},
        //                 {name: '椅',link: '/furniture?tab=all#chair'},
        //                 {name: '桌',link: '/furniture?tab=all#desk'},
        //                 {name: '床',link: '/furniture?tab=all#bed'},
        //                 {name: '几',link: '/furniture?tab=all#lowtable'},
        //                 {name: '柜',link: '/furniture?tab=all#cab'},
        //                 {name: '沙发',link: '/furniture?tab=all#sofa'},
        //                 {name: '一枚板',link: '/furniture?tab=all#ymb'},
        //                 {name: '其他',link: '/furniture?tab=all#other'},
        //             ],
        //          newMenu: [{name: '新品',link: '/furniture-l2?bom=recommend'},
        //                  {name: '大地线',link: '/furniture-l2?bom=base'},
        //                  {name: '山脊线',link: '/furniture-l2?bom=high'},
        //                  {name: 'FF线',link: '/furniture-l2?bom=ff'},
        //                  // {name: '回顾',link: '/furniture-l2?bom=ff'}
        //              ]},
        //     {name: '家居', link: '',category: '2', menu:
        //             [{name: '全部',link: '/grocery?tab=all'},
        //                 {name: '灯具',link: '/grocery-l2?bom=C01-11'},
        //                 {name: '家纺',link: '/grocery-l2?bom=C01-12'},
        //                 {name: '餐厨用品',link: '/grocery-l2?bom=C01-13'},
        //                 {name: '收纳杂物',link: '/grocery-l2?bom=C01-14'},
        //                 {name: '香氛洗护',link: '/grocery-l2?bom=C01-15'},
        //                 {name: '装饰',link: '/grocery-l2?bom=C01-16'},
        //                 {name: '家居电器',link: '/grocery-l2?bom=C01-17'},
        //                 {name: '户外园艺',link: '/grocery-l2?bom=C01-18'},
        //                 {name: '文创',link: '/grocery-l2?bom=C01-19'}
        //                 // {name: '备品',link: '/grocery-l2?bom=C01-99'}
        //             ]},
        //     {name: 'ART', link: '/gallery', menu:
        //             [
        //                 // {name:"展览", link:"/gallery#artist"},
        //                 // {name:"橱窗", link:"/gallery#works"},
        //                 // {name:"快闪", link:"/gallery#exhibit"}
        //             ]},
        //     {name: 'JOURNAL', link: '',menu: [
        //             {name:"全部", link:"/home"},
        //             {name:"梵几在家", link:"/home-athome"},
        //             {name:"串门", link:"/home-drop"},
        //             // {name:"ARTSTAGE", link:"/home#artist"}
        //         ]},
        //     // {name: 'PROJECT', link: '',menu: []},
        //     {name: '关于梵几', link: '/fnjinews', menu: []},
        //     {name: '如何购买', link: '/buyChannel', menu: []}
        // ],
        navMenu: [
            {name: '首页', link: '/', children: []},
            {name: '家具', link: '/furniture?tab=C09',category: '1', children: []},
            {name: '家居', link: '/grocery?tab=G01',category: '2', children: []},
            {name: '案例', link: '/caseNew', children: [
                    {name: '梵几在家',link: '/athome',type: 1},
                    {name: '商业',link: '/project',type: 2}
                ]},
            {name: '实体展厅', link: '/shops', children: [
                    {name: '北京·梵几三里屯太古里店',phoneTitle: '北京',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                    {name: '北京·梵几颐堤港店',phoneTitle: '',phoneName: '颐堤港店',link: '/exhibitionhall?id=3',type: 1},
                    {name: '北京·梵几客厅国子监店（升级中）',phoneTitle: '国子监店（升级中）',phoneName: '',link: '/exhibitionhall?id=4',type: 1},
                    {name: '上海·梵几上海前滩太古里店',phoneTitle: '上海',phoneName: '前滩太古里店',link: '/exhibitionhall?id=5',type: 2},
                    {name: '上海·梵几客厅武康路店',phoneTitle: '',phoneName: '武康路店',link: '/exhibitionhall?id=6',type: 2},
                    {name: '广州·梵几广州粤海天地店',phoneTitle: '广州',phoneName: '粤海天地店',link: '/exhibitionhall?id=7',type: 3},
                    {name: '深圳·梵几万象前海店',phoneTitle: '深圳',phoneName: '万象前海店',link: '/exhibitionhall?id=8',type: 4},
                    {name: '深圳·梵几卓越中心店',phoneTitle: '',phoneName: '卓越中心店',link: '/exhibitionhall?id=9',type: 4},
                    // {name: '成都·梵几远洋太古里店',link: '/exhibitionhall?id=10',type: 5},
                    {name: '杭州·梵几留和路店',phoneTitle: '杭州',phoneName: '留和路店',link: '/exhibitionhall?id=11',type: 6},
                    {name: '苏州·梵几苏州诚品店',phoneTitle: '苏州',phoneName: '诚品店',link: '/exhibitionhall?id=12',type: 7},
                    // {name: '苏州·梵几苏州春风里店',link: '/exhibitionhall?id=13',type: 7},
                    {name: '南京·梵几南京金鹰世界店',phoneTitle: '南京',phoneName: '金鹰世界店',link: '/exhibitionhall?id=14',type: 8},
                    {name: '成都·梵几成都富森店',phoneTitle: '成都',phoneName: '富森店',link: '/exhibitionhall?id=15',type: 5},
                    {name: '西安·梵几西安万象城店',phoneTitle: '西安',phoneName: '万象城店',link: '/exhibitionhall?id=16',type: 9}
                ]},
            {name: '艺术/栏目', link: '/gallery', children: [
                    {name: '艺术展览·艺术橱窗·艺术快闪',link: '/gallery',type: 1,phoneChildren: [
                            {name: '艺术展览',link: '/gallery'},
                            {name: '艺术橱窗',link: '/gallery'},
                            {name: '艺术快闪',link: '/gallery'}
                        ]},
                    {name: '串门',link: '/home-drop',type: 2}
                ]},
            // {name: '栏目', link: '/home'},
            {name: '关于梵几', link: '/fnjinews', children: []},
            {name: '下载区', link: '/download', children: [
                    {name: '产品模型',link: '/download',type: 1},
                    {name: '产品册',link: '/catalog',type: 2},
                ]},
            {name: '如何购买', link: '/buyChannel', children: []}
        ],
        footerNew: [
            {name: '媒体报道', link: '/fnjimedia'},
            {name: '招聘信息', link: '/job'},
            {name: '售后服务', link: '/aboutservice'},
            {name: '联系我们', link: '/site/cooperate?type=1'}
        ],
        menuGroups: [
            {
                title: '关于我们',
                list: [
                    {name: '关于梵几', link: '/fnjinews'},
                    {name: '如何购买', link: '/buyChannel'},
                    {name: '媒体报道', link: '/fnjimedia'},
                    {name: '招聘信息', link: '/job'}
                ]
            },
            {
                title: '购物指南',
                list: [
                    {name: '购物流程', link: '/howshop'},
                    {name: '会员制度', link: '/membership'}
                ]
            },
            {
                title: '关于配送',
                list: [
                    {name: '家具配送', link: '/aboutdeliver?index=0'},
                    {name: '家居配送', link: '/aboutdeliver?index=1'},
                    {name: '一枚板配送', link: '/aboutdeliver?index=2'}
                ]
            },
            {
                title: '售后服务',
                list: [
                    {name: '家具售后', link: '/aboutservice?index=0'},
                    {name: '家居售后', link: '/aboutservice?index=1'}
                ]
            },
            {
                title: '联系我们',
                list: [
                    {name: '项目批量采购', link: '/site/cooperate?type=1'},
                    {name: '设计公司合作', link: '/site/cooperate?type=2'},
                    {name: '家居品牌合作', link: '/site/cooperate?type=3'},
                    {name: '市场&媒体合作', link: '/site/cooperate?type=4'},
                    {name: '艺术品合作', link: '/site/cooperate?type=5'},
                    {name: '产品目录下载', link: '/temp/upload/productinfo/产品目录.zip'}
                ]
            }
        ],
        fnjiIndexNew: {
            aboutFnji: '关于梵几',
            // aboutFnjiCon: '“生长于野，安于室”是梵几扎根东方土壤的理念传达，取自然之材，拟自然之态，使其共生与传承。',
            // aboutFnjiCon2: '梵几希望在设计与生活、东方与西方、现代与未来之间找到一种平衡，将自然带入居家空间中，',
            // aboutFnjiCon3: '并成为人们日常生活里的长久陪伴。',
            aboutFnjiCon: '梵几创立于2010年，是集家具与家居为一体的生活美学品牌。“梵”是净空与安静的意思，“几”是家具，',
            aboutFnjiCon2: '意为净空安静的家具，同时梵几的谐音是“凡几”一平凡的家具。“东方现代，自然隽永”是品牌的关键词，',
            aboutFnjiCon3: '是梵几扎根东方土壤、不断探索美学生活的理念和坚持。“生长于野，安于室”，取自然之材，拟自然之态。',
            aboutFnjiCon4: '梵几坚持以木为主体，融合皮、羊毛、石材等多种自然材质，将取诸山野的灵气回归日常生活之中。',
            aboutFnjiBt: '更多关于梵几',
            furnitureTitle: '家具',
            furniture: '梵几家具围绕生野安室的理念，融合深沉肃穆、简单质朴、现代多元等多种设计语言',
            furniture2: '探索东方与西方之间、现代与传统之间、记忆与未来之间的美学平衡与灵感世界',
            earth: '大地线',
            earthInfo: '简练淳厚  如无垠大地',
            crest: '山脊线',
            crestInfo: '沉穆缥缈，如云上山影',
            fnjiFore: 'FF线',
            fnjiForeInfo: '探索中国未来生活的可能',
            moreFur: '更多家具',
            fnjiathome: '梵几在家',
            fnjiathomeCon: '为了深入探索家具主人的生活态度，观察家具与人',
            fnjiathomeCon2: '人与人之间的亲密连结，梵几自制栏目“梵几在家”',
            fnjiathomeCon3: '从不同维度出发，讲述家具，设计与人的故事',
            cooperation: '商业',
            cooperationCon: '梵几与商业空间、设计师及主理人产生联动，在不同风格中共同演绎梵几家具的包容度',
            cooperationCon2: '与无限可能性。',
            furnishings: '家居',
            homeCon: '甄选源自全球的家居好物，用充盈细节点缀家中空间，勾勒质感生活的完满形态',
            homeCon2: '将梵几认可、推崇的生活美学体系更加极致地呈现出来',
            moreHome: '更多家居',
            artTitle: '艺术/栏目',
            artCon: 'ART包含艺术展览、艺术橱窗以及快闪等多个艺术相关活动',
            artCon2: '梵几拓展传统艺术的界限，挖掘艺术的无限可能性，让观众感知以不同载体呈现的艺术',
            artCon3: '并带领他们进入无限遐想的艺术世界',
            moreInfo: '更多详情',
            journalCon: '为了深入探索家具主人的生活态度，观察家具与人、人与人之间的亲密连结，梵几自制栏目“梵几在家”、“串门”，',
            journalCon2: '从不同维度出发，讲述家具，设计与人的故事。',
            projectCon: '梵几与商业空间、设计师及主理人产生联动，在不同风格中共同演绎梵几家具的包容度',
            projectCon2: '与无限可能性。',
            morePro: '更多项目',
            howtobuy: '如何购买',
            lineStore: '线上店铺',
            lineStores: '| 天猫 | 京东 | 微信小程序 |',
            phyStore: '实体门店',
            phyStores: ['北京','上海','广州','深圳','成都','杭州','苏州','南京'],
            aboutAllBt: '查看全部购买方式',
            footerInfo: '探寻东方与西方之间',
            footerInfo2: '现代与传统之间',
            footerInfo3: '记忆与未来之间的美学平衡与灵感世界'
        },
        fnjiIndexPhoneNew: {
            // aboutFnjiCon: '“生长于野，安于室”是梵几扎根东方土壤的理念传',
            // aboutFnjiCon2: '达，取自然之材，拟自然之态，使其共生与传承。梵',
            // aboutFnjiCon3: '几希望在设计与生活、东方与西方、现代与未来之间',
            // aboutFnjiCon4: '找到一种平衡，将自然带入居家空间中，并成为人们',
            // aboutFnjiCon5: '日常生活里的长久陪伴。',
            aboutFnjiCon: '梵几创立于2010年，是集家具与家居为一体的生活美学',
            aboutFnjiCon2: '品牌。“梵”是净空与安静的意思，“几”是家具，意为净',
            aboutFnjiCon3: '空安静的家具，同时梵几的谐音是“凡几”一平凡的家具。',
            aboutFnjiCon4: '“东方现代，自然隽永”是品牌的关键词，是梵几扎根东',
            aboutFnjiCon5: '方土壤、不断探索美学生活的理念和坚持。“生长于野，',
            aboutFnjiCon6: '安于室”，取自然之材，拟自然之态。梵几坚持以木为主',
            aboutFnjiCon7: '体，融合皮、羊毛、石材等多种自然材质，将取诸山野的',
            aboutFnjiCon8: '灵气回归日常生活之中。',
            furniture: '梵几家具围绕生野安室的理念，融合深沉肃',
            furniture2: '穆、简单质朴、现代多元等多种设计语言，探',
            furniture3: '索东方与西方之间、现代与传统之间、记忆与',
            furniture4: '未来之间的美学平衡与灵感世界',
            homeCon: '甄选源自全球的家居好物，用充盈细节点缀家',
            homeCon2: '中空间，勾勒质感生活的完满形态，将梵几认',
            homeCon3: '可、推崇的生活美学体系更加极致地呈现出来',
            fnjiathomeCon: '为了深入探索家具主人的生活态度，观察家具与人',
            fnjiathomeCon2: '人与人之间的亲密连结，梵几自制栏目“梵几在家”',
            fnjiathomeCon3: '从不同维度出发，讲述家具，设计与人的故事',
            cooperationCon: '梵几与商业空间、设计师及',
            cooperationCon2: '主理人产生联动，在不同风格中共同演绎',
            cooperationCon3: '梵几家具的包容度与无限可能性。',

            fnjiAtHomeDesc:'为了深入探索家具主人的生活态度，观察家具与人\n' +
                '人与人之间的亲密连结，梵几自制栏目“梵几在家”\n' +
                '从不同维度出发，讲述家具，设计与人的故事',

            fnjiProjectDesc: '梵几与商业空间、设计师及主理人产生联动，在不同风格中共同演绎梵几家具的包容度\n' +
                '与无限可能性。',
            fnjiProject: '商业',

            EXHIBITION: '展览',
            EXHIBITION2: 'EXHIBITION',
            ARTSTAGE: '橱窗',
            ARTSTAGE2: 'ART STAGE',
            STORE: '快闪店',
            STORE2: 'POP-UP STORE',
            artCon: 'ART包含艺术展览、艺术橱窗以及快闪等多个',
            artCo2: '艺术相关活动梵几拓展传统艺术的界限，挖掘',
            artCon3: '艺术的无限可能性，让观众感知以不同载体呈',
            artCon4: '现的艺术，并带领他们进入无限遐想的艺术世',
            artCon5: '界。',
            journalCon: '为了深入探索家具主人的生活态度，观察家具',
            journalCon2: '与人、人与人之间的亲密连结，梵几自制栏目',
            journalCon3: '“梵几在家”、“串门”，从不同维度出发，',
            journalCon4: '讲述家具，设计与人的故事。',
            projectCon: '梵几与商业空间、设计师及主理人产生联动，',
            projectCon2: '在不同风格中共同演绎梵几家具的包容度与无',
            projectCon3: '限可能性。',
        },
        aboutFnjiNew: {
            titleOne: '记忆',
            titleTwo: '传承',
            titleThree: '自然',
            titleFour: '隽永',
            memory: '梵几的设计灵感源于对中国文化与传统生活的感知，将东方韵味与哲思凝练于设计中。把中国人的共同记',
            memory2: '忆和文化共鸣以符合现代生活方式的设计语言传达出来，让记忆中逐渐消逝的过去，以新的方式长久地存',
            memory3: '在于当今人们的生活中，留住记忆里的烟火气。',
            productsImg: [
                {img:'s20480_1627452972_1499.png',name: '竹椅',ename: ' BAMBOO CHAIR',info1: '以木代替竹子，外形经过提炼与简化，线条呈现粗细变化，简洁质朴中流动着',info2: '中式意蕴，是梵几品牌的开端。'},
                {img:'s20480_1627452940_9411.png',name: '团扇屏风',ename: ' CIRCULAR FAN SCREEN',info1: '木与藤虚实交错，空气流转之间，让传统中式元素融入现代的空间动线和生活方式，',info2: '空间隔断不再是一种切割，而是成为一种人与人之间既可交流、又相互独立的关系。'},
                {img:'s20480_1627452916_7972.png',name: '胡同推车',ename: ' LITTLE CART',info1: '以中国传统的竹推车为灵感依托，用中式特有的设计语言回归记忆中最质朴的',info2: '空间需求，不为家具功能所限定，灵活适用于家中的各个空间和场景。'},
                {img:'s20480_1627452875_7826.png',name: '线轴几',ename: ' REEL SIDE TABLE',info1: '细腻变化的自然石材肌理形成更加丰富的触感，',info2: '高低错落组合衬出独具灵气的东方美。'},
                {img:'s20480_1627452846_8757.png',name: 'CIGAR置物架',ename: ' CIGAR DISPLAY SHELF',info1: '取竹编簸箕架之形，又灌之以现代设计的巧思，四个方向均可拿取和展示物',info2: '品，纵横交错中勾勒出重叠的美感。'},
                {img:'s20480_1627452815_5473.png',name: '马扎',ename: ' CAMPSTOOL',info1: '圆滑细腻的木质架构形成可随身提携的拎手，色泽温润的植鞣坐面注入时间的',info2: '自然印记。'},
                {img:'s20480_1627452661_7271.png',name: '鸟笼立柜',ename: ' CAGE CABINET',info1: '参照鸟笼的笼体，厚实且造型独特的木条温润包围，柔和灯光中呈现虚实互通',info2: '的视觉体系。'}
            ],
            inheritance: '传承中国传统工艺，通过木工匠人的亲手打磨，保留木材原生纹理与质感。为了在结构、性能和感官上凝',
            inheritance2: '聚最佳的体验，每一道工艺都承载着梵几追寻的情感表达。是对中国传统技艺的传承与保护，也是对设计',
            inheritance3: '的极致追求。',
            nature: '人与自然的亲近感是与生俱来的，契合“生于野，安于室”的本质，坚持以实木为主体，融合皮、羊毛、',
            nature2: '石材等多种自然材质，将取诸山野的灵气回归日常生活之中。甄选世界级品牌进口材料，保障安全与环',
            nature3: '保的同时经久耐用。',
            timeLess: '什么才是真正属于中国的设计——是梵几一直以来的思考与探索。',
            timeLess2: '每一个设计背后，都隐藏着对自然万物与人文艺术的大爱与珍视。',
            events: '梵几事件',
            commercials: '历年广告回顾',
            commercialsInfo: '十年间，除了探寻自身产品的可能性，我们也同样思考产品多样的视觉呈现。这是梵几对艺术美感的思考，也同样是',
            commercialsInfo2: '品牌精神的表达。梵几希望，在东方与西方之间，当代与传统之间，记忆与未来之间，取得一种平衡，进而探索属于',
            commercialsInfo3: '中国人未来的家具。',
            designer: '梵几设计师'
        },
        aboutFnjiPhoneNew: {
            memory: '梵几的设计灵感源于对中国文化与传统生活',
            memory2: '的感知，将东方韵味与哲思凝练于设计中。',
            memory3: '把中国人的共同记忆和文化共鸣以符合现代',
            memory4: '生活方式的设计语言传达出来，让记忆中逐',
            memory5: '渐消逝的过去，以新的方式长久地存在于当',
            memory6: '今人们的生活中，留住记忆里的烟火气。',
            inheritance: '传承中国传统工艺，通过木工匠人的亲手',
            inheritance2: '打磨，保留木材原生纹理与质感。为了在',
            inheritance3: '结构、性能和感官上凝聚最佳的体验，每',
            inheritance4: '一道工艺都承载着梵几追寻的情感表达。',
            inheritance5: '是对中国传统技艺的传承与保护，也是对',
            inheritance6: '设计的极致追求。',
            nature: '人与自然的亲近感是与生俱来的，契合“生',
            nature2: '于野，安于室”的本质，坚持以实木为主体，',
            nature3: '融合皮、羊毛、石材等多种自然材质，将取',
            nature4: '诸山野的灵气回归日常生活之中。甄选世界',
            nature5: '级品牌进口材料，保障安全与环保的同时经',
            nature6: '久耐用。',
            timeLess: '什么才是真正属于中国的设计——是梵几一',
            timeLess2: '直以来的思考与探索。',
            timeLess3: '每一个设计背后，都隐藏着对自然万物与人',
            timeLess4: '文艺术的大爱与珍视。',
            commercialsInfo: '十年间，除了探寻自身产品的可能性，我们也',
            commercialsInfo2: '同样思考产品多样的视觉呈现。这是梵几对艺',
            commercialsInfo3: '术美感的思考，也同样是品牌精神的表达。梵',
            commercialsInfo4: '几希望，在东方与西方之间，当代与传统之间，',
            commercialsInfo5: '记忆与未来之间，取得一种平衡，进而探索属',
            commercialsInfo6: '于中国人未来的家具。',
        },
        artInfoNew: {

            artTypeList: [
                {id: '100',artType: '艺术展览',info: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。',
                    infoPhone1: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。',infoPhone2: '当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。'},
                {id: '101',artType: '艺术橱窗',info: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……',
                    infoPhone2: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……'},
                {id: '102',artType: '艺术快闪',info: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。',
                    infoPhone2: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。'},
            ],
        },
        moreBtn: '查看更多',
        fnjiIndex: {
            aboutFnjiLogo: '/view-v2/web/static/img/index/fnji_about.png',
            indexFurnitureLogo: '/view-v2/web/static/img/index/fnji_furture.png',
            indexGroLogo: '/view-v2/web/static/img/index/fnji_gro_zh.png',
            indexArtLogo: '/view-v2/web/static/img/index/fnji_art.png',
            indexColumnLogo: '/view-v2/web/static/img/index/fnji_column_zh.png',
            indexHowBuyLogo: '/view-v2/web/static/img/index/fnji_how_buy_zh.png',

            aboutFnjiCon: '传承中国传统工艺，甄选优质自然材质，凝练记忆中的灵感，用世界级严苛标准，创造真正属于中国人的家具。',
            aboutFnjiBt: '了解更多梵几',
            aboutBt: '了解更多',
            aboutAllBt: '查看全部购买方式',
            furnitureLine: '| 山脊线 | 大地线 | FF线 |',
            crestInfo: '梵几山脊线系列的灵感来源于大自然以及儿时记忆，扎根中国传统文化，将更具东方空灵艺术性的元素融合深沉肃穆的设计语言。以螳螂椅为首款产品，历时3年，从设计、结构到工艺，不断推敲升级，采用大曲线，多细节的实木加工，配合国际品牌的面料，突出现代中国家具的雕塑感，艺术感以及为生活带来仪式感。',
            earthInfo: '梵几大地线，品牌中最早的一条线，关注寻常人家生活中真实所需的家居设计，简单质朴，在葆有中国的设计语言的基础上，将大自然中的树木变为与家相融的家具，在四季更迭中长久陪伴，慢慢变成我们的家人。',
            ffInfo: 'FF=Fnji Fore，代表梵几向前一步，是梵几品牌全新实验性的产品线。有别于延续传统工艺探索的设计，FF系列在设计语言上更为简洁直接， 以多元材质和工艺结合赋予家具更多可能，现代简约而不失温度感。',
            groceryInfo: '家居馆延续生野安室的理念，用挑剔的品位甄选源自全球的家居好物。',
            groceryInfo2: '美好家居品可以提升幸福感，增加仪式感，与家具完美搭配，亦是过节送礼的佳选。',
            groceryInfo3: '更重要的是，它们将梵几认可、推崇的生活美学体系更加极致地呈现出来。',
            galleryInfo: '梵几艺术画廊包含艺术展览、艺术橱窗以及快闪等多个艺术相关活动。',
            galleryInfo2: '梵几拓展传统艺术的界限，挖掘艺术的无限可能性，让观众感知以不同载体呈现的艺术，',
            galleryInfo3: '并带领他们进入无限遐想的艺术世界。',
            columnInfo: '为了深入探索家具主人的生活态度，观察家具与人、人与人之间的亲密连结，梵几自制栏目“梵几在家”、“串门”，从不同维度出发，讲述家具，设计与人的故事。',
            phyStore: '实体门店',
            phyStores: '| 北京 | 上海 | 广州 | 深圳 | 成都 | 杭州 | 苏州 | 南京 |',
            lineStore: '线上店铺',
            lineStores: '| 天猫 | 京东 | 微信小程序 |',
            indexDown: '/view-v2/web/static/img/index/index2020_zh.png',
            indexDown2: ''
        },
        catalog: {
            name: '产品册',
            btn: '点击下载产品册'
        },
        aboutFnji: {
            aboutFnji1Title: '十年雕琢 初心未改',
            aboutFnji1: '梵几由设计师高古奇创立于2010年，是中国原创家具的先锋代表。“梵”是净空与安静，“几”是家具，意为净空安静的家具。“什么才是真正属于中国的设计”是梵几一直以来的思考与探索。',
            aboutFnji2Title: '传承中国 传统工艺',
            aboutFnji2: '通过木工匠人的亲手打磨，保留木材原生纹理与质感。每一处转角和线条的细节处理，非十年功底不可得。是对中国传统技艺的传承与保护，也是对设计的极致追求。',
            aboutFnji3Title: '甄选优质 自然材质',
            aboutFnji3: '坚持以实木为主体，融合皮、羊毛、石材等多种自然材质。选用世界级品牌进口材料，保障安全与环保的同时经久耐用。契合“生于野，安于室”的本质，回归自然与练达。',
            aboutFnji4Title: '凝练记忆中的灵感',
            aboutFnji4: '设计不应只是线条与元素的堆砌，梵几的设计灵感源于对中国文化与传统生活的感知，将东方韵味与哲思凝练于设计中。每一个设计背后，都隐藏着对自然万物与人文艺术的大爱与珍视。',
            aboutFnji5Title: '十年 寻河',
            aboutFnji5: '十年。寻河。',
            aboutFnji51: '“不知道从什么时候开始，我经常做一个类似的梦。梦里的自己在寻找一条河，那条河清澈见底，应该就在不远处。',
            aboutFnji52: '但这也许只是我梦中的景象，',
            aboutFnji53: '那条河，我仍未找到。”',
            aboutFnji54: '梵几从创立到不断变得完整，也如同一场寻河之旅。'
        },
        cooperateItem: [
            { title: '项目批量采购', desc: '', type: 1, class: 'project'},
            { title: '设计公司合作', desc: '', type: 2, class: 'desgin'},
            { title: '家居品牌合作', desc: '', type: 3, class: 'grocery'},
            { title: '市场&媒体合作', desc: '', type: 4, class: 'marketing'},
            { title: '艺术品合作', desc: '', type: 5, class: 'gallery'}
        ],
        cooperateFnji: {
            topTitle: '商业合作',
            topCon: '梵几对外开放多方向商业合作，',
            topCon2: '如果您有合作意向请点击相应入口填写信息。',
            topCon3: '若有需要我们将会在5个工作日内回复您。',
            companyName: '公司名称',
            projectName: '项目名称',
            city: '城市',
            budget: '预算',
            time: '进场时间',
            contact: '联系人',
            position: '职务',
            phoneNumber: '电话',
            phone: '联系电话',
            companyIntro: '公司介绍',
            project: '合作项目',
            artistBrandstudio: '艺术家/品牌/工作室',
            summary: '简介',
            email: '邮箱',
            importantEmail: '邮箱（很重要，请填写常用邮箱）',
            attachFile: '添加附件',
            fileTips: '附件不得超过15M，支持jpg，pdf',
            note: '备注',
            submit: '提交',
            successfully: '提交成功'
        },
        fnjiAtHome: '[梵几在家] 是梵几品牌的自媒体栏目，透过栏目展现梵几家具在不同人家中的状态，分享家具不同的搭配使用，传达家具主人的生活态度......',
        fnjiVisitFriend: '2009年，梵几成立的前一年，古奇（梵几创始人兼主设计师）来到北京，那时和朋友们见面不是约在咖啡管就是商场，而小时候，父母友人间相互串门的方式让他难以忘怀，那时古奇就在朋友圈发起了一场“串门“活动......',
        addCart: '加入购物车',

        buyChannel:{
            online: '线上商城',
            project: '商业采购',
            shop: '实体门店',
        },
        buy: '直接购买',

        clickShow: {
            partOne: '点击查看',
            partTwo: '配送详情',
            partThree: '或',
            partFour: '会员制度'
        },
        usingClick: {
            partOne: '点击购买',
            partTwo: '家具保养套装'
        },
        artInfo: {
            artExhibtion1: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。',
            artExhibtion2: '当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。',
            artExhibtionBtn: '查看全部展览',
            artStage1: '通过木工匠人的亲手打磨，保留木材原生纹理与质感',
            artStage2: '每一处转角和线条的细节处理，非十年功底不可得',
            artStage3: '是对中国传统技艺的传承与保护，也是对设计的极致追求',
            artStageBtn: '查看全部橱窗',
            artStore1: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，',
            artStore2: '期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。',
        },
        homeInfo: {
            homeTitle: '梵几在家',
            homeAtHome1: '梵几在家是梵几品牌的自媒体栏目，透过展现梵几家具在不同人家中的状态',
            homeAtHome2: '分享家具不同的搭配使用以及传达家具主人的生活态度',
            homeBtn: '查看全部',
            homeVisitTitle: '串门',
            homeVisit1: '2009年，梵几成立的前一年，古奇（梵几创始人兼主设计师）来到北京，那时和朋',
            homeVisit2: '友们见面不是约在咖啡馆就是商场，而小时候，父母友人间相互串门的方式让他难',
            homeVisit3: '以忘怀，那时古奇就在朋友圈发起了一场“串门“活动……'
        },
        homeInfoPhone: {
            homeAtHome1: '梵几在家是梵几品牌的自媒体栏目，',
            homeAtHome2: '透过展现梵几家具在不同人家中的状态。',
            homeAtHome3: '分享家具不同的搭配使用以及传达家具主人的生活态度。',
            homeVisit1: '2009年，梵几成立的前一年，古奇（梵几创始人兼主设',
            homeVisit2: '计师）来到北京，那时和朋友们见面不是约在咖啡馆就是',
            homeVisit3: '商场，而小时候，父母友人间相互串门的方让他难以忘',
            homeVisit4: '怀，那时古奇就在朋友圈发起了一场“串门“活动……'
        },
        typeList: [
            {name: '全部',tab: '',link: '/furniture?tab=all'},
            {name: '椅',tab: '#chair',link: '/furniture?tab=all#chair'},
            {name: '桌',tab: '#desk',link: '/furniture?tab=all#desk'},
            {name: '床',tab: '#bed',link: '/furniture?tab=all#bed'},
            {name: '几',tab: '#lowtable',link: '/furniture?tab=all#lowtable'},
            {name: '柜',tab: '#cab',link: '/furniture?tab=all#cab'},
            {name: '沙发',tab: '#sofa',link: '/furniture?tab=all#sofa'},
            {name: '一枚板',tab: '#ymb',link: '/furniture?tab=all#ymb'},
            {name: '其他',tab: '#other',link: '/furniture?tab=all#other'}
        ],
        newTypeList: [
            {name: '新品',tab: 'recommend',link: '/furniture-l2?bom=recommend'},
            {name: '大地线',tab: 'base',link: '/furniture-l2?bom=base'},
            {name: '山脊线',tab: 'high',link: '/furniture-l2?bom=high'},
            {name: 'FF线',tab: 'ff',link: '/furniture-l2?bom=ff'},
            // {name: '回顾',tab: '',link: '/furniture-l2?bom=ff'},
        ],
        groTypeList: [
            {theName: '全部',name: '全部',bom: '',link: '/grocery?tab=all'},
            {theName: '灯具',name: '灯具',bom: 'C01-11',link: '/grocery-l2?bom=C01-11'},
            {theName: '家纺',name: '家纺',bom: 'C01-12',link: '/grocery-l2?bom=C01-12'},
            {theName: '餐厨用品',name: '餐厨用品',bom: 'C01-13',link: '/grocery-l2?bom=C01-13'},
            {theName: '收纳杂物',name: '收纳杂物',bom: 'C01-14',link: '/grocery-l2?bom=C01-14'},
            {theName: '香氛洗护',name: '香氛洗护',bom: 'C01-15',link: '/grocery-l2?bom=C01-15'},
            {theName: '装饰',name: '装饰',bom: 'C01-16',link: '/grocery-l2?bom=C01-16'},
            {theName: '家居电器',name: '家居电器',bom: 'C01-17',link: '/grocery-l2?bom=C01-17'},
            {theName: '户外园艺',name: '户外园艺',bom: 'C01-18',link: '/grocery-l2?bom=C01-18'},
            {theName: '文创',name: '文创',bom: 'C01-19',link: '/grocery-l2?bom=C01-19'}
        ]
    };
    return  zh;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){
    var en = {
        detail: {name: 'Case Presentation Images'},
        topBarLinks: [
            {name: 'Visit Shanghai Living Room', class: 'sh-appoint'},

            // {name: 'How to Shop', link: '/shop'},
            // {name: 'vr逛店', link: 'https://realsee.com/lianjia/ZBgxP9kO80L9RNnl/qk0a74LqNmzkSxh6hVtPzBKjfr89MBpA/?from=groupmessage&isappinstalled=0',img: '/view-v2/web/static/img/common/vrnew.png'},
            {name: 'Contact Us', link: '/site/cooperate'}
        ],
        headLeft: {
            brand: 'Brand',
            crest: 'CrestLine',
            earth: 'EarthLine',
            ff: 'FnjiFore',
            register: 'Register',
            login: 'Login',
            logout: 'Logout',
            cart: 'Cart',
            order: 'Order'
        },
        // navMenu: [
        //     {name: 'FNJI', link: '/', menu: []},
        //     {name: 'FURNITURE', link: '/furniture?tab=all',category: '1',menu:
        //             [{name: 'All',link: '/furniture?tab=all'},
        //                 {name: 'Chair',link: '/furniture?tab=all#chair'},
        //                 {name: 'Table',link: '/furniture?tab=all#desk'},
        //                 {name: 'Bed',link: '/furniture?tab=all#bed'},
        //                 {name: 'Teapoy',link: '/furniture?tab=all#lowtable'},
        //                 {name: 'Cabinet',link: '/furniture?tab=all#cab'},
        //                 {name: 'Sofa',link: '/furniture?tab=all#sofa'},
        //                 {name: 'Fnji Plank',link: '/furniture?tab=all#ymb'},
        //                 {name: 'Others',link: '/furniture?tab=all#other'},
        //             ]},
        //     {name: 'HOME', link: '/grocery?tab=all',category: '2', menu:
        //             [{name: 'All',link: '/grocery?tab=all'},
        //                 {name: 'Lighting',link: '/grocery-l2?bom=C01-11'},
        //                 {name: 'Textiles',link: '/grocery-l2?bom=C01-12'},
        //                 {name: 'Dinning&Kitchen',link: '/grocery-l2?bom=C01-13'},
        //                 {name: 'Storage',link: '/grocery-l2?bom=C01-14'},
        //                 {name: 'Fragrance',link: '/grocery-l2?bom=C01-15'},
        //                 {name: 'Accessories',link: '/grocery-l2?bom=C01-16'},
        //                 {name: 'Electronics',link: '/grocery-l2?bom=C01-17'},
        //                 {name: 'Outdoor',link: '/grocery-l2?bom=C01-18'},
        //                 {name: 'Lifestyle',link: '/grocery-l2?bom=C01-19'}
        //                 // {name: '备品',link: '/grocery-l2?bom=C01-99'}
        //             ]},
        //     {name: 'GALLERY', link: '/gallery', menu:
        //             [
        //                 // {name:"Exhibit", link:"/gallery#artist"},
        //                 // {name:"Stage", link:"/gallery#works"},
        //                 // {name:"POP-UP Store", link:"/gallery#exhibit"}
        //             ]},
        //     {name: 'COLUMN', link: '/home',menu: [
        //             {name:"FNJI at Home", link:"/home-athome"},
        //             {name:"FNJI visit Friend", link:"/home-drop"},
        //             // {name:"ARTSTAGE", link:"/home#artist"}
        //         ]},
        //     {name: 'ABOUT FNJI', link: '/fnjinews', menu: []},
        //     {name: 'PURCHASE', link: '/buyChannel', menu: []}
        // ],
        navMenu: [
            {name: 'Home', link: '/', children: []},
            {name: 'Furniture', link: '/furniture?tab=C09',category: '1', children: []},
            {name: 'Furnishings', link: '/grocery?tab=G01',category: '2', children: []},
            {name: 'Projects', link: '/caseNew', children: [
                    {name: 'Fnji At Home',link: '/athome',type: 1},
                    {name: 'Commercial Project',link: '/project',type: 2}
                ]},
            {name: 'ShowRooms', link: '/shops', children: [
                    {name: 'Beijing Sanlitun Taikooli Store',phoneTitle: 'Beijing',phoneName: 'Sanlitun Taikooli Store',link: '/exhibitionhall?id=2',type: 1},
                    {name: 'Beijing Indigo Store',phoneTitle: '',phoneName: 'Indigo Store',link: '/exhibitionhall?id=3',type: 1},
                    {name: 'Beijing Guozijian Living Room',phoneTitle: '',phoneName: 'Guozijian Living Room',link: '/exhibitionhall?id=4',type: 1},
                    {name: 'Shanghai Qiantan Taikoo Li store',phoneTitle: 'Shanghai',phoneName: 'Qiantan Taikoo Li store',link: '/exhibitionhall?id=5',type: 2},
                    {name: 'Shanghai Wukang Rd Living Room',phoneTitle: '',phoneName: 'Wukang Rd Living Room',link: '/exhibitionhall?id=6',type: 2},
                    {name: 'Guangzhou TEEM SENSES Store',phoneTitle: 'Guangzhou',phoneName: 'Yuehai Tiandi Store',link: '/exhibitionhall?id=7',type: 3},
                    {name: 'Shenzhen Wanxiang Qianhai Store ',phoneTitle: 'Shenzhen',phoneName: 'Wanxiang Qianhai Store',link: '/exhibitionhall?id=8',type: 4},
                    {name: 'Shenzhen Zhuoyue Center store',phoneTitle: '',phoneName: 'Zhuoyue Center store',link: '/exhibitionhall?id=9',type: 4},
                    // {name: '成都·梵几远洋太古里店',link: '/exhibitionhall?id=10',type: 5},
                    {name: 'Hangzhou Liuhe Road Store',phoneTitle: 'Hangzhou',phoneName: 'Liuhe Road Store',link: '/exhibitionhall?id=11',type: 6},
                    {name: 'Suzhou Eslite Store',phoneTitle: 'Suzhou',phoneName: 'Eslite Store',link: '/exhibitionhall?id=12',type: 7},
                    // {name: '苏州·梵几苏州春风里店',link: '/exhibitionhall?id=13',type: 7},
                    {name: 'Nanjing Jinying Store',phoneTitle: 'Nanjing',phoneName: 'Jinying Store',link: '/exhibitionhall?id=14',type: 8},
                    {name: 'Chengdu Fusen Store',phoneTitle: 'Chengdu',phoneName: 'Fusen Store',link: '/exhibitionhall?id=15',type: 5},
                    {name: 'Xian Wanxiang Store',phoneTitle: 'Xian',phoneName: 'Wanxiang Store',link: '/exhibitionhall?id=16',type: 9}
                ]},
            {name: 'Arts/Column', link: '/gallery', children: [
                    {name: 'Exhibition·Stage·Pop-Up·',link: '/gallery',type: 1,phoneChildren: [
                            {name: 'Exhibition',link: '/gallery'},
                            {name: 'Stage',link: '/gallery'},
                            {name: 'Pop-Up',link: '/gallery'}
                        ]},
                    {name: 'VISITING FRIENDS',link: '/home-drop',type: 2}
                ]},
            // {name: '栏目', link: '/home'},
            {name: 'About', link: '/fnjinews', children: []},
            {name: 'Downloads', link: '/download', children: [
                    {name: 'Product Models',link: '/download',type: 1},
                    {name: 'Catalog',link: '/catalog',type: 2},
                ]},
            {name: 'Purchase', link: '/buyChannel', children: []}
        ],
        footerNew: [
            {name: 'PRESS', link: '/fnjimedia'},
            {name: 'HIRING', link: '/job'},
            {name: 'SERVICE', link: '/aboutservice'},
            {name: 'CONTACT', link: '/site/cooperate?type=1'}
        ],
        menuGroups: [
            {
                title: 'ABOUT US',
                list: [
                    {name: 'About Fnji', link: '/fnjinews'},
                    {name: 'How to Buy', link: '/buyChannel'},
                    {name: 'Press', link: '/fnjimedia'},
                    {name: 'Join Us', link: '/job'}
                ]
            },
            {
                title: 'SHOPPING GUIDANCE',
                list: [
                    {name: 'Placing an Order', link: '/howshop'},
                    {name: 'Membership', link: '/membership'}
                ]
            },
            {
                title: 'ABOUT DELIVERY',
                list: [
                    {name: 'Furniture Delivery', link: '/aboutdeliver?index=0'},
                    {name: 'Grocery Delivery', link: '/aboutdeliver?index=1'},
                    {name: 'Fnji Plank Delivery', link: '/aboutdeliver?index=2'}
                ]
            },
            {
                title: 'CUSTOMERSERVICE',
                list: [
                    {name: 'Furniture Service', link: '/aboutservice?index=0'},
                    {name: 'Grocery Delivery', link: '/aboutservice?index=1'}
                ]
            },
            {
                title: 'CONTACT US',
                list: [
                    {name: 'Bulk Purchase', link: '/site/cooperate?type=1'},
                    {name: 'Design Studio Collaboration', link: '/site/cooperate?type=2'},
                    {name: 'Home Furnishing Brand Cooperation', link: '/site/cooperate?type=3'},
                    {name: 'Marketing & Media Cooperation', link: '/site/cooperate?type=4'},
                    {name: 'Artwork Collaboration', link: '/site/cooperate?type=5'},
                    {name: 'Download Catalogs', link: '/temp/upload/productinfo/产品目录.zip'}
                ]
            }
        ],
        fnjiIndexNew: {
            aboutFnji: 'ABOUT FNJI',
            // aboutFnjiCon: 'Rooted in the profound oriental aesthetics, the design condenses the expression and inheritance, and',
            // aboutFnjiCon2: 'integrates the understanding and thinking of nature.It is Fnji\'s value and mission to be loyal to the self by',
            // aboutFnjiCon3: 'conveying its distinctive style, aesthetics and lifestyle delicately and effectively.',
            // aboutFnjiCon4: 'It is also an interpretation of the concept of “Nature bred, Home nourished”.',
            aboutFnjiCon: 'FNJI was founded in 2010 and is a lifestyle aesthetics brand that integrates furniture and home furnishings.',
            aboutFnjiCon2: '"Fan" means clean and quiet, and "Ji" means furniture, which means clean and quiet furniture. At the same time,',
            aboutFnjiCon3: 'the homonym of Fanji is "FANJI", which means ordinary furniture. "Oriental modern, natural and meaningful" is ',
            aboutFnjiCon4: 'the keyword of the brand, which is the concept and persistence of Fanji rooted in the soil of the East and ',
            aboutFnjiCon5: 'constantly exploring aesthetic life. "NATURE BRED HOME NOURISHED" takes natural materials and simulates the ',
            aboutFnjiCon6: 'state of nature. FNJI insists on using wood as the main body, integrating leather, wool, stone and other natural ',
            aboutFnjiCon7: 'materials, and returning the aura taken from the mountains to daily life.',
            aboutFnjiBt: 'More about FNJI',
            furnitureTitle: 'Furniture',
            furniture: 'The concept of "Nature bred, Home nourished" of Fnji furniture integrates a variety of',
            furniture2: 'design languages such as deep solemnity, simplicity, modern diversity and so on.',
            furniture3: 'Explore aesthetic balance and inspiration between East and West, between modernity',
            furniture4: 'and tradition, and between memory and future.',
            earth: 'EARTH LINE',
            earthInfo: 'Wise and pure as boundless earth.',
            crest: 'CREST LINE',
            crestInfo: 'Solemn as the misty shadow above the mountain crest.',
            fnjiFore: 'FNJI FORE',
            fnjiForeInfo: 'Explore the possibilities of future life in China.',
            moreFur: 'More Furniture',
            fnjiathome: 'Fnji At Home',
            fnjiathomeCon: 'In order to deeply explore the lifestyle attitude of furniture owners and observe the relationship ',
            fnjiathomeCon2: 'between furniture and people Intimate connections between people, Fnji self-made program ',
            fnjiathomeCon3: '"Fnji at Home" Starting from different dimensions, tell the story of furniture, design, and people',
            cooperation: 'Commercial Project',
            cooperationCon: 'FNJI and commercial space produce linkage, in different styles together interpret the tolerance and ',
            cooperationCon2: 'infinite possibilities of FNJI furniture. FNJI has been exploring the resonance of design and nature',
            cooperationCon3: 'between different places and objects. ',
            furnishings: 'HOME FURNlSHlNGS',
            homeCon: 'Life Store selects quality household goods from around the world with high',
            homeCon2: 'standards. Quality household goods make people feel happy and bring to life',
            homeCon3: 'a sense of ceremony. More importantly, they present the life aesthetic system',
            homeCon4: 'recognized and admired by Fnji.',
            moreHome: 'More Homeware',
            artTitle: 'Arts/Column',
            artCon: 'Fnji Art Gallery contains Art Exhibition, Artstage, and Pop-up Store. Fnji breaks the',
            artCon2: 'boundaries of traditional art and taps into the infinite possibilities of art. It allows',
            artCon3: 'the audience to perceive the art presented in different carriers and leads them into the',
            artCon4: 'art world of infinite imagination.',
            moreInfo: 'More Information',
            journalCon: 'In order to explore the living attitudes of furniture owners and observe the intimate',
            journalCon2: 'connections between furniture and people and among people, Fnji makes columns "FNJI at',
            journalCon3: 'Home" and "FNJI Visit Friend" to tell the stories of furniture, design and people from',
            journalCon4: 'different dimensions.',
            projectCon: 'Fnji cooperate with commercial spaces, designers and owner-principals to interpret',
            projectCon2: 'the comprehensive and infinite possibility of Fnji furniture in different styles.',
            morePro: 'More Project',
            howtobuy: 'Purchase',
            lineStore: 'ONLINE STORE',
            lineStores: '| TMALL | JD | Wechat mini program｜',
            phyStore: 'SHOWROOMS',
            phyStores: ['Beijing','Shanghai','Guangzhou','Shenzhen','Chengdu','Hangzhou','Suzhou','Nanjing'],
            aboutAllBt: 'More Purchase',
            footerInfo: 'Explore aesthetic balance and inspiration between oriental',
            footerInfo2: 'and occidental, between modernity and tradition, and',
            footerInfo3: 'between memory and future.'
        },
        fnjiIndexPhoneNew: {
            aboutFnjiCon: 'FNJI was founded in 2010 and is a lifestyle aesthetics brand that',
            aboutFnjiCon2: 'integrates furniture and home furnishings."Fan" means clean and',
            aboutFnjiCon3: 'quiet, and "Ji" means furniture, which means clean and quiet',
            aboutFnjiCon4: 'furniture. At thesame time, the homonym of Fanji is "FANJI", which',
            aboutFnjiCon5: 'means ordinary furniture."Oriental modern, natural and meaningful"',
            aboutFnjiCon6: 'is the keyword of the brand, which is the concept and persistence of',
            aboutFnjiCon7: 'Fanji rooted in the soil of the East and constantly exploring aesthetic',
            aboutFnjiCon8: 'life. "NATURE BRED HOME NOURISHED" takes natural materials and',
            aboutFnjiCon9: 'simulates the state of nature. FNJI insists on using wood as the main',
            aboutFnjiCon10: 'body, integrating leather, wool, stone and other natural materials,',
            aboutFnjiCon11: 'and returning the aura taken from the mountains to daily life.',
            // aboutFnjiCon: 'Rooted in the profound oriental aesthetics, the design condenses',
            // aboutFnjiCon2: 'the expression and inheritance, and integrates the understanding',
            // aboutFnjiCon3: 'and thinking of nature.It is Fnji\'s value and mission to be loyal to the',
            // aboutFnjiCon4: 'self by conveying its distinctive style, aesthetics and lifestyle',
            // aboutFnjiCon5: 'delicately and effectively.',
            // aboutFnjiCon6: 'It is also an interpretation of the concept of “Nature bred, Home nourished”.',
            furniture: 'The concept of "Nature bred, Home nourished" of Fnji furniture',
            furniture2: 'integrates a variety of design languages such as deep solemnity,',
            furniture3: 'simplicity, modern diversity and so on. Explore aesthetic balance',
            furniture4: 'and inspiration between East and West, between modernity and',
            furniture5: 'tradition, and between memory and future. ',
            homeCon: 'Life Store selects quality household goods from around the',
            homeCon2: 'world with high standards. Quality household goods make',
            homeCon3: 'people feel happy and bring to life a sense of ceremony. More',
            homeCon4: 'importantly, they present the life aesthetic system recognized',
            homeCon5: 'and admired by Fnji.',

            fnjiAtHomeDesc: 'Fnji At Home\n' +
                'In order to deeply explore the lifestyle attitude of furniture owners and observe the relationship between furniture and people\n' +
                'Intimate connections between people, Fnji self-made program "Fnji at Home"\n' +
                'Starting from different dimensions, tell the story of furniture, design, and people\n',

            fnjiProjectDesc: 'Cooperation\n' +
                'FNJI and commercial space produce linkage, in different styles together interpret \n' +
                ' the tolerance and infinite possibilities of FNJI furniture. FNJI has been exploring the \n' +
                'resonance of design and nature between different places and objects.',

            fnjiProject: 'Commercial Project',

            fnjiathomeCon: 'In order to deeply explore the lifestyle attitude of',
            fnjiathomeCon2: 'furniture owners and observe the relationship ',
            fnjiathomeCon3: 'between furniture and people Intimate connections',
            fnjiathomeCon4: 'between people, Fnji self-made program "Fnji at',
            fnjiathomeCon5: 'Home" Starting from different dimensions, tell',
            fnjiathomeCon6: 'the story of furniture, design, and people',
            cooperationCon: 'FNJI and commercial space produce linkage, in ',
            cooperationCon2: 'different styles together interpret the tolerance',
            cooperationCon3: 'and infinite possibilities of FNJI furniture. FNJI',
            cooperationCon4: 'has been exploring the resonance of design and ',
            cooperationCon5: 'nature between different places and objects. ',
            EXHIBITION: 'EXHIBITION',
            EXHIBITION2: '',
            ARTSTAGE: 'ART STAGE',
            ARTSTAGE2: '',
            STORE: 'POP-UP STORE',
            STORE2: '',
            artCon: 'Fnji Art Gallery contains Art Exhibition, Artstage, and Pop-',
            artCon2: 'up Store. Fnji breaks the boundaries of traditional art and',
            artCon3: 'taps into the infinite possibilities of art. It allows the',
            artCon4: 'audience to perceive the art presented in different carriers',
            artCon5: 'and leads them into the art world of infinite imagination.',
            journalCon: 'In order to explore the living attitudes of furniture owners',
            journalCon2: 'and observe the intimate connections between furniture',
            journalCon3: 'and people and among people, Fnji makes columns "FNJI',
            journalCon4: 'at Home" and "FNJI Visit Friend" to tell the stories of',
            journalCon5: 'furniture, design and people from different dimensions.',
            projectCon: 'Fnji cooperate with commercial spaces, designers and',
            projectCon2: 'owner-principals to interpret the comprehensive and',
            projectCon3: 'infinite possibility of Fnji furniture in different styles.',
        },
        aboutFnjiNew: {
            titleOne: 'MEMORY',
            titleTwo: 'INHERITANCE',
            titleThree: 'NATURE',
            titleFour: 'TIMELESS',
            memory: 'Inspired by the perception of Chinese culture and traditional life, Fnji condenses the oriental charm and philosophy in the design and',
            memory2: 'conveys the common memory and cultural resonance of the Chinese people with the design language in line with the modern lifestyle,',
            memory3: 'hence reproducing the disappearing bygones in people\'s life in a new and lasting way, and retaining the fireworks of the memory.',
            productsImg: [
                {img:'s20480_1627452972_1499.png',name: '竹椅',ename: ' BAMBOO CHAIR',info1: 'Replacing bamboo with wood, the shape is refined and simplified, the lines show changes in thickness,',info2: 'and the Chinese implications are revealed in the simplicity, which is the beginning of Fnji brand.'},
                {img:'s20480_1627452940_9411.png',name: '团扇屏风',ename: ' CIRCULAR FAN SCREEN',info1: 'Wood and rattan are intertwined with the air flowing between to integrate the traditional Chinese elements into the modern space with moving',info2: 'lines and lifestyle. The space partition is no longer a cutting, but an independent yet connected relationship that allows people to communicate.'},
                {img:'s20480_1627452916_7972.png',name: '胡同推车',ename: ' LITTLE CART',info1: 'Inspired by the traditional Chinese bamboo cart, we use the unique Chinese design language to reproduce the most simple space',info2: 'needs in memory. It is not limited by the functions of furniture, but applicable to all spaces and scenes at home in a flexible manner.'},
                {img:'s20480_1627452875_7826.png',name: '线轴几',ename: ' REEL SIDE TABLE',info1: 'The delicate and varied natural stone texture forms a richer touch, while the',info2: 'scattered combination of high and low highlights the unique Oriental beauty.'},
                {img:'s20480_1627452846_8757.png',name: 'CIGAR置物架',ename: ' CIGAR DISPLAY SHELF',info1: 'Decorated with the ingenious thinking of modern design on the shape of bamboo dustpan frame,',info2: 'items can be taken and displayed in four directions to outline the overlapping beauty.'},
                {img:'s20480_1627452815_5473.png',name: '马扎',ename: ' CAMPSTOOL',info1: 'The smooth and delicate wooden structure forms a portable handle, and the vegetable tanning',info2: 'seat with warm color reflects the natural mark of time.'},
                {img:'s20480_1627452661_7271.png',name: '鸟笼立柜',ename: ' CAGE CABINET',info1: 'Referring to the body of the bird cage, the cage is surrounded by thick and smooth wooden strips',info2: 'in a unique shape, forming a visual system of virtual and real communication under the soft light.'}
            ],
            inheritance: 'Inheritance of Chinese traditional crafts refers to preserving the original texture and quality of wood through the hand polishing of',
            inheritance2: 'carpenters.Each craft carries the emotional expression pursued by Fnji to present the best experience in structure, performance and',
            inheritance3: 'senses, which is not only the inheritance and protection of Chinese traditional crafts, but also the ultimate pursuit of design.',
            nature: 'Human beings are born to be close to the nature, which is in line with the essence of "originating from the wildness but settling in the house". We adhere to taking solid',
            nature2: 'wood as the main body and integrating a variety of natural materials such as leather, wool and stone, so as to introduce the aura of mountains and wildness to daily life.',
            nature3: 'We select imported materials from world-class brands to ensure safety and environmental protection and durability at the same time.',
            timeLess: '"What is the design that truly belongs to China" has always been the thinking and exploration of Fnji.',
            timeLess2: 'Behind every design there is a great love and treasure for all things in nature and humanities and art.',
            events: 'FNJI EVENTS',
            commercials: 'PREVIOUS COMMERCIALS',
            commercialsInfo: 'In addition to exploring the possibility of our own products, we also thought about the visual presentation of various',
            commercialsInfo2: 'products in last decade. This is Fnji\'s thinking on artistic beauty and the expression of brand spirit as well. Fnji hopes to',
            commercialsInfo3: 'achieve a balance between the East and the West, contemporary and tradition, memory and the future, and then explore the',
            commercialsInfo4: 'furniture belonging to the Chinese people in the future.',
            designer: 'DESIGNER'
        },
        aboutFnjiPhoneNew: {
            memory: 'Inspired by the perception of Chinese culture and traditional life, Fnji',
            memory2: 'condenses the oriental charm and philosophy in the design and',
            memory3: 'conveys the common memory and cultural resonance of the Chinese',
            memory4: 'people with the design language in line with the modern lifestyle,',
            memory5: 'hence reproducing the disappearing bygones in people\'s life in a new',
            memory6: 'and lasting way, and retaining the fireworks of the memory.',
            inheritance: 'Inheritance of Chinese traditional crafts refers to preserving the',
            inheritance2: 'original texture and quality of wood through the hand polishing of',
            inheritance3: 'carpenters.Each craft carries the emotional expression pursued by',
            inheritance4: 'Fnji to present the best experience in structure, performance and',
            inheritance5: 'senses, which is not only the inheritance and protection of Chinese',
            inheritance6: 'traditional crafts, but also the ultimate pursuit of design.',
            nature: 'Human beings are born to be close to the nature, which is in line with',
            nature2: 'the essence of "originating from the wildness but settling in the',
            nature3: 'house". We adhere to taking solid wood as the main body and',
            nature4: 'integrating a variety of natural materials such as leather, wool and',
            nature5: 'stone, so as to introduce the aura of mountains and wildness to daily',
            nature6: 'life. We select imported materials from world-class brands to ensure',
            nature7: 'safety and environmental protection and durability at the same time.',
            timeLess: '"What is the design that truly belongs to China" has always been the',
            timeLess2: 'thinking and exploration of Fnji. Behind every design there is a great',
            timeLess3: 'love and treasure for all things in nature and humanities and art.',
            commercialsInfo: 'In addition to exploring the possibility of our own products, we also',
            commercialsInfo2: 'thought about the visual presentation of various products in last',
            commercialsInfo3: 'decade. This is Fnji\'s thinking on artistic beauty and the expression',
            commercialsInfo4: 'of brand spirit as well. Fnji hopes to achieve a balance between the',
            commercialsInfo5: 'East and the West, contemporary and tradition, memory and the',
            commercialsInfo6: 'future, and then explore the furniture belonging to the Chinese',
            commercialsInfo7: 'people in the future.',
        },
        artInfoNew: {

            artTypeList: [
                {id: '100',artType: 'EXHIBITION',info: 'Fnji invites artists from all over the world to hold art exhibitions in the living room of Fnji throughout the country and exchange and share their ' +
                        'inspirations at the scene. When there are common pursuit of aesthetics and encounters with art lovers, Fnji brings everyone who comes to the exhibition closer to art.',
                    infoPhone1: '',infoPhone2: 'Fnji invites artists from all over the world to hold art exhibitions in the living room of Fnji throughout the country and exchange and share their inspirations ' +
                        'at the scene. When there are common pursuit of aesthetics and encounters with art lovers, Fnji brings everyone who comes to the exhibition closer to art.'},
                {id: '101',artType: 'STAGE',info: 'Fnji occasionally invites artists to create theme art stages through “playing”They are not strictly defined and they are cross-border new experiments of ' +
                        'brands and artists. They are a unique visual feast made by imagination and artworks.',
                    infoPhone2: 'Fnji occasionally invites artists to create theme art stages through “playing”They are not strictly defined and they are cross-border new experiments of brands and artists. ' +
                        'They are a unique visual feast made by imagination and artworks.'},
                {id: '102',artType: 'POP-UP',info: 'The Pop-up Store will invite new and unique brands to Fnji living rooms to inject unique perspectives and tastes into Fnji space and inspire more sparks ' +
                        'and possibilities. ',
                    infoPhone2: 'The Pop-up Store will invite new and unique brands to Fnji living rooms to inject unique perspectives and tastes into Fnji space and inspire more sparks and possibilities.'},
            ],
        },
        moreBtn: 'Check All',
        fnjiIndex: {
            aboutFnjiLogo: '/view-v2/web/static/img/index/fnji_about_en.png',
            indexFurnitureLogo: '/view-v2/web/static/img/index/fnji_furture_en.png',
            indexGroLogo: '/view-v2/web/static/img/index/fnji_gro_en_new.png',
            indexArtLogo: '/view-v2/web/static/img/index/fnji_art_en.png',
            indexColumnLogo: '/view-v2/web/static/img/index/fnji_column_en.png',
            indexHowBuyLogo: '/view-v2/web/static/img/index/fnji_how_buy_en.png',

            aboutFnjiCon: 'Fnji inherits traditional Chinese craftsmanship and selects quality natural materials. ',
            aboutFnjiCon2: 'With memories in life and inspiration from nature, ',
            aboutFnjiCon3: 'we create modern furniture that truly belongs to the Chinese.',
            aboutFnjiBt: 'MORE ABOUT FNJI',
            aboutBt: 'READ MORE',
            aboutAllBt: 'CHECK ALL',
            furnitureLine: '| CREST LINE | EARTH LINE | FNJI FORE |',
            crestInfo: 'Inspired by nature and childhood memories and rooted in traditional Chinese culture, the Crest Line incorporates oriental ethereal artistic elements into solemn designs. With Mantis Chair being its first product, the Crest Line has been continuously upgrading its design, structure, and craftsmanship in the last three years. It adopts solid wood with large curves and many details and fabrics of international brands to highlight the sculptural and artistic sense of modern Chinese furniture and brings to life a sense of ceremony.',
            earthInfo: 'The Earth Line is the earliest line of Fnji. With its simple style, it focuses on the home design that is needed by ordinary people in real life. While keeping traditional Chinese design, the Earth Line turns trees in nature into furniture integrated with home. These pieces of furniture accompany us through all seasons and gradually become our family members.',
            ffInfo: 'FF refers to Fnji Fore and represents a step forward of Fnji. It is a new experimental product line. Instead of inheriting traditional craftsmanship, the FF Line is simpler in its design and gives the furniture more possibilities with the combination of various materials and craftsmanship. It has both modern simplicity and a sense of warmth.',
            groceryInfo: 'Fnji Home Museum continues the concept of “born in nature and settled at home” and selects quality household goods from around the world with high standards. ',
            groceryInfo2: 'Quality household goods make people feel happy and bring to life a sense of ceremony.',
            groceryInfo3: 'They perfectly match with furniture and are also a good choice for holiday gifts. More importantly,',
            groceryInfo4: 'they present the life aesthetic system recognized and admired by Fnji.',
            galleryInfo: 'Fnji Art Gallery contains Art Exhibition, Artstage, and Pop-up Store. Fnji breaks the boundaries of traditional art',
            galleryInfo2: 'and taps into the infinite possibilities of art. ',
            galleryInfo3: 'It allows the audience to perceive the art presented in different carriers and leads them into the art world of infinite imagination.',
            columnInfo: 'In order to explore the living attitudes of furniture owners and observe the intimate connections between',
            columnInfo2: 'furniture and people and among people, Fnji makes columns "FNJI at Home" and "FNJI Visit Friend" to tell the',
            columnInfo3: 'stories of furniture, design and people from different dimensions.',
            phyStore: 'STORE LOCATOR',
            phyStores: '| BEIJING | SHANGHAI | Guangzhou | SHENZHEN | CHENGDU | HANGZHOU | SUZHOU | NANJING |',
            lineStore: 'ONLINE STORES',
            lineStores: '| TMALL | JD | WX |',
            indexDown: '/view-v2/web/static/img/index/index2020_new_en.png',
            indexDown2: 'BETWEEN MODERNITY AND TRADITION, AND BETWEEN MEMORY AND FUTURE. '
        },
        catalog: {
            name: 'Catalog',
            btn: 'Download'
        },
        aboutFnji: {
            aboutFnji1Title: 'REMAIN TRUE TO OUR ORIGINAL ASPIRATION WITH EFFORTS OVER THE PAST DECADE',
            aboutFnji1: 'Founded in 2010 by designer Gao Guqi, Fnji (梵几) is a pioneer representative of Chinese original',
            aboutFnji12: 'furniture. “梵” refers to serenity and “几” refers to furniture',
            aboutFnji13: 'so “梵几” refers to furniture with a sense of serenity',
            aboutFnji14: 'Fnji has been thinking about and exploring “what is the design that really belongs to China".',
            aboutFnji2Title: 'INHERIT TRADITIONAL CHINESE CRAFTS',
            aboutFnji2: 'Fnji preserves the original texture and feel of the wood through carpenters’ grinding.',
            aboutFnji22: 'For the treatment of each corner and line, the carpenter will need more than ten years’ experience.',
            aboutFnji23: 'This is  Fnji’s inheritance and protection of traditional Chinese crafts and pursuit of design.',
            aboutFnji3Title: 'SELECT QUALITY NATURAL MATERIALS',
            aboutFnji3: 'Fnji takes solid wood as the main material and uses many other natural materials like leather, wool, and stone. We select imported materials of world-class brands so that our products are both safe and environmentally friendly and durable. This is consistent with our concept of “born in nature and settled at home” and brings people back to nature. ',
            aboutFnji4Title: 'GET INSPIRATION FROM MEMORY',
            aboutFnji4: 'Design should not be simply loaded with lines and elements. Fnji\'s design is inspired by the perception of Chinese culture and traditional life and embodies oriental flavor and philosophy. Behind every design is our great love and cherishment of nature and humanities.',
            aboutFnji5Title: '十年 寻河',
            aboutFnji5: '十年。寻河。',
            aboutFnji51: '“不知道从什么时候开始，我经常做一个类似的梦。梦里的自己在寻找一条河，那条河清澈见底，应该就在不远处。',
            aboutFnji52: '但这也许只是我梦中的景象，',
            aboutFnji53: '那条河，我仍未找到。”',
            aboutFnji54: '梵几从创立到不断变得完整，也如同一场寻河之旅。'
        },
        cooperateItem: [
            { title: 'BULK PIRCHASE', desc: '', type: 1, class: 'project'},
            { title: 'DESIGN STUDIO COLLABORATION', desc: '', type: 2, class: 'desgin'},
            { title: 'HOME FURNISHING BRAND COOPERATION', desc: '', type: 3, class: 'grocery'},
            { title: 'MARKETING & MEDIA COOPERATION', desc: '', type: 4, class: 'marketing'},
            { title: 'ARTWORK COLLABORATION', desc: '', type: 5, class: 'gallery'}
        ],
        cooperateFnji: {
            topTitle: 'Contact Us',
            topCon: 'FNJI has opened to the outside world about multi-directional business cooperation.',
            topCon2: 'If you are interested in cooperation, please click the corresponding entry to fill',
            topCon3: 'in the information. We will reply to you within 5 working days if necessary.',
            companyName: 'Company Name',
            projectName: 'Project Name',
            city: 'City',
            budget: 'Budget',
            time: 'Time requirement for delivery',
            contact: 'Contact',
            position: 'Position',
            phoneNumber: 'Phone Number',
            phone: 'Phone Number',
            companyIntro: 'Company Introduction',
            project: 'Collaboration Project',
            artistBrandstudio: 'Artist/Brand/studio',
            summary: 'Summary',
            email: 'Email',
            importantEmail: 'Email(very important）',
            attachFile: 'Attach File',
            fileTips: 'The attachment must not exceed 15M; you may upload JPG or PDF files.',
            note: 'Note',
            submit: 'Submit',
            successfully: 'Submitted successfully'
        },
        fnjiAtHome: '"FNJI at Home" is the self-media column of Fnji. By showing Fnji furniture in different people\'s homes, it shares different uses of furniture and conveys the living attitude of furniture owners.',
        fnjiVisitFriend: 'In 2009, one year before the founding of Fnji, Guqi (founder and chief designer of Fnji) came to Beijing. At that time, he met with friends either in a coffee shop or a shopping mall. When he was a child, however, parents and friends visited each other at home. With such an unforgettable memory, he launched a “visiting friends” activity among his friends.',
        addCart: 'ADD TO CART',
        buy: 'SHOP NOW',

        buyChannel:{
            online: 'Online Store',
            project: 'Commercial Project',
            shop: 'Showrooms',
        },

        clickShow: {
            partOne: 'Check',
            partTwo: 'delivery information',
            partThree: 'or',
            partFour: 'membership'
        },
        usingClick: {
            partOne: 'Click to buy',
            partTwo: 'Furniture Maintenance Set'
        },
        artInfo: {
            artExhibtion1: 'Fnji invites artists from all over the world to hold art exhibitions in the living room of Fnji',
            artExhibtion2: 'throughout the country and exchange and share their inspirations at the scene.',
            artExhibtion3: 'When there are common pursuit of aesthetics and encounters with art lovers,',
            artExhibtion4: 'Fnji brings everyone who comes to the exhibition closer to art.',
            artExhibtionBtn: 'Check All',
            artStage1: 'Fnji occasionally invites artists to create theme art stages through',
            artStage2: '“playing”. They are not strictly defined and they are cross-border new',
            artStage3: 'experiments of brands and artists. They are a unique visual feast made',
            artStage4: 'by imagination and artworks.',
            artStageBtn: 'Check All',
            artStore1: 'The Pop-up Store will invite new and unique brands to Fnji living rooms to inject unique',
            artStore2: 'perspectives and tastes into Fnji space and inspire more sparks and possibilities.',
        },
        homeInfo: {
            homeTitle: 'FNJI AT HOME',
            homeAtHome1: '"FNJI at Home" is the self-media column of Fnji. By showing Fnji furniture in',
            homeAtHome2: 'different people\'s homes, it shares different uses of furniture and conveys the',
            homeAtHome3: 'living attitude of furniture owners.',
            homeBtn: 'More',
            homeVisitTitle: 'VISITING FRIENDS',
            homeVisit1: 'In 2009, one year before the founding of Fnji, Guqi (founder and chief',
            homeVisit2: 'designer of Fnji) came to Beijing. At that time, he met with friends either in a',
            homeVisit3: 'coffee shop or a shopping mall. When he was a child, however, parents and',
            homeVisit4: 'friends visited each other at home. With such an unforgettable memory, he',
            homeVisit5: 'launched a “visiting friends” activity among his friends.'
        },
        homeInfoPhone: {
            homeAtHome1: '"FNJI at Home" is the self-media column of Fnji. By showing Fnji',
            homeAtHome2: 'furniture in different people\'s homes, it shares different uses of',
            homeAtHome3: 'furniture and conveys the living attitude of furniture owners.',
            homeVisit1: 'In 2009, one year before the founding of Fnji, Guqi (founder and',
            homeVisit2: 'chief designer of Fnji) came to Beijing. At that time, he met with',
            homeVisit3: 'friends either in a coffee shop or a shopping mall. When he was',
            homeVisit4: 'a child, however, parents and friends visited each other at home.',
            homeVisit5: 'With such an unforgettable memory, he launched a “visiting',
            homeVisit6: 'friends” activity among his friends.'
        },
        typeList: [
            {name: 'All',tab: '',link: '/furniture?tab=all'},
            {name: 'Chair',tab: '#chair',link: '/furniture?tab=all#chair'},
            {name: 'Table',tab: '#desk',link: '/furniture?tab=all#desk'},
            {name: 'Bed',tab: '#bed',link: '/furniture?tab=all#bed'},
            {name: 'Teapoy',tab: '#lowtable',link: '/furniture?tab=all#lowtable'},
            {name: 'Cabinet',tab: '#cab',link: '/furniture?tab=all#cab'},
            {name: 'Sofa',tab: '#sofa',link: '/furniture?tab=all#sofa'},
            {name: 'Plank',tab: '#ymb',link: '/furniture?tab=all#ymb'},
            {name: 'Other',tab: '#other',link: '/furniture?tab=all#other'}
        ],
        newTypeList: [
            {name: 'New',tab: 'recommend',link: '/furniture-l2?bom=recommend'},
            {name: 'Crest Line',tab: 'base',link: '/furniture-l2?bom=base'},
            {name: 'Earth Line',tab: 'high',link: '/furniture-l2?bom=high'},
            {name: 'Fnji Fore',tab: 'ff',link: '/furniture-l2?bom=ff'},
            // {name: '回顾',tab: '',link: '/furniture-l2?bom=ff'},
        ],
        groTypeList: [
            {theName: 'All',name: '全部',bom: '',link: '/grocery?tab=all'},
            {theName: 'Lighting',name: '灯具',bom: 'C01-11',link: '/grocery-l2?bom=C01-11'},
            {theName: 'Textiles',name: '家纺',bom: 'C01-12',link: '/grocery-l2?bom=C01-12'},
            {theName: 'Dinning&Kitchen',name: '餐厨用品',bom: 'C01-13',link: '/grocery-l2?bom=C01-13'},
            {theName: 'Storage',name: '收纳杂物',bom: 'C01-14',link: '/grocery-l2?bom=C01-14'},
            {theName: 'Fragrance',name: '香氛洗护',bom: 'C01-15',link: '/grocery-l2?bom=C01-15'},
            {theName: 'Accessories',name: '装饰',bom: 'C01-16',link: '/grocery-l2?bom=C01-16'},
            {theName: 'Electronics',name: '家居电器',bom: 'C01-17',link: '/grocery-l2?bom=C01-17'},
            {theName: 'Outdoor',name: '户外园艺',bom: 'C01-18',link: '/grocery-l2?bom=C01-18'},
            {theName: 'Lifestyle',name: '文创',bom: 'C01-19',link: '/grocery-l2?bom=C01-19'}
        ]
    };
    return  en;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    // 'WebCommon/component/page-header-new',
    // 'WebCommon/component/page-footer-new',
    __webpack_require__(23),
    __webpack_require__(63),

    __webpack_require__(68),
    __webpack_require__(87),
    __webpack_require__(18)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    // PageHeaderPhone,
    PageHeader,
    PageFooter
){
    return {
        components: {
            // PageHeaderPhone: PageHeaderPhone,
            PageHeader: PageHeader,
            PageFooter: PageFooter
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(24),
    __webpack_require__(1),
    __webpack_require__(25),
    __webpack_require__(12),
    __webpack_require__(13),
    __webpack_require__(10),
    __webpack_require__(2),
    __webpack_require__(5),
    __webpack_require__(16),
    __webpack_require__(3),
    __webpack_require__(58),
    __webpack_require__(60),

    // 'css!web/static/fonts/fangzheng.css',
    __webpack_require__(61)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    $,
    HeadroomMixin,
    PageReadyMixin,
    AuthMixin,
    Modal,
    Utils,
    Api,
    Api2020,
    _,
    SubNav,
    Newapi
){
    var topBarLinks = [
        {name: '上海客厅预约', class: 'sh-appoint'},

        {name: '实体店', link: '/shop'},
        // {name: 'vr逛店', link: 'https://realsee.com/lianjia/ZBgxP9kO80L9RNnl/qk0a74LqNmzkSxh6hVtPzBKjfr89MBpA/?from=groupmessage&isappinstalled=0',img: '/view-v2/web/static/img/common/vrnew.png'},
        {name: '商业合作', link: '/site/cooperate'}
    ];
    var navMenu = [
        {name: '首页', link: '/', menu: []},
        {name: '家具', link: '/furniture?tab=all',category: '1'},
        {name: '家居', link: '/grocery?tab=all',category: '2'},
        {name: '艺术/栏目', link: '/gallery'},
        // {name: '栏目', link: '/home'},
        {name: '新事', link: '/fnjinews', menu: []}
    ];
    return {
        template: tpl,
        mixins: [PageReadyMixin, AuthMixin, HeadroomMixin],
        components: {
            SubNav: SubNav
        },
        data: function(){
            return {
                searchText: '',
                searchShow: false,
                navMenu: [
                    {name: '首页', link: '/', children: []},
                    {name: '家具', link: '/furniture?tab=C09',category: '1', children: []},
                    {name: '家居', link: '/grocery?tab=G01',category: '2', children: []},
                    {name: '案例', link: '/caseNew', children: [
                            {name: '梵几在家',link: '/athome',type: 1},
                            {name: '商业',link: '/project',type: 2}
                        ]},
                    {name: '实体展厅', link: '/shops', children: [
                            {name: '北京·梵几三里屯太古里店',phoneTitle: '北京',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                            {name: '北京·梵几颐堤港店',phoneTitle: '',phoneName: '颐堤港店',link: '/exhibitionhall?id=3',type: 1},
                            {name: '北京·梵几客厅国子监店（升级中）',phoneTitle: '国子监店（升级中）',phoneName: '',link: '/exhibitionhall?id=4',type: 1},
                            {name: '上海·梵几上海前滩太古里店',phoneTitle: '上海',phoneName: '前滩太古里店',link: '/exhibitionhall?id=5',type: 2},
                            {name: '上海·梵几客厅武康路店',phoneTitle: '',phoneName: '武康路店',link: '/exhibitionhall?id=6',type: 2},
                            {name: '广州·梵几广州粤海天地店',phoneTitle: '广州',phoneName: '粤海天地店',link: '/exhibitionhall?id=7',type: 3},
                            {name: '深圳·梵几万象前海店',phoneTitle: '深圳',phoneName: '万象前海店',link: '/exhibitionhall?id=8',type: 4},
                            {name: '深圳·梵几卓越中心店',phoneTitle: '',phoneName: '卓越中心店',link: '/exhibitionhall?id=9',type: 4},
                            {name: '成都·梵几成都富森店',phoneTitle: '成都',phoneName: '富森店',link: '/exhibitionhall?id=15',type: 5},
                            // {name: '成都·梵几远洋太古里店',link: '/exhibitionhall?id=10',type: 5},
                            {name: '杭州·梵几留和路店',phoneTitle: '杭州',phoneName: '留和路店',link: '/exhibitionhall?id=11',type: 6},
                            {name: '苏州·梵几苏州诚品店',phoneTitle: '苏州',phoneName: '诚品店',link: '/exhibitionhall?id=12',type: 7},
                            // {name: '苏州·梵几苏州春风里店',link: '/exhibitionhall?id=13',type: 7},
                            {name: '南京·梵几南京金鹰世界店',phoneTitle: '南京',phoneName: '金鹰世界店',link: '/exhibitionhall?id=14',type: 8},
                            {name: '西安·梵几西安万象城店',phoneTitle: '西安',phoneName: '万象城店',link: '/exhibitionhall?id=16',type: 9}
                        ]},
                    {name: '艺术/栏目', link: '/gallery', children: [
                            {name: '艺术展览·艺术橱窗·艺术快闪',link: '/gallery',type: 1,phoneChildren: [
                                    {name: '艺术展览',link: '/gallery'},
                                    {name: '艺术橱窗',link: '/gallery'},
                                    {name: '艺术快闪',link: '/gallery'}
                                ]},
                            {name: '串门',link: '/home-drop',type: 2}
                        ]},
                    // {name: '栏目', link: '/home'},
                    {name: '关于梵几', link: '/fnjinews', children: []},
                    {name: '下载区', link: '/download', children: [
                            {name: 'Sketchup&3dmax',link: '/download',type: 1},
                            {name: '产品册',link: '/catalog',type: 2},
                        ]},
                    {name: '如何购买', link: '/buyChannel', children: []}
                ],
                navMenuShopsPhone: [
                    {phoneTitle: '北京',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                    {phoneTitle: '',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                    {phoneTitle: '',phoneName: '颐堤港店',link: '/exhibitionhall?id=3',type: 1},
                    {phoneTitle: '',phoneName: '国子监(升级中)',link: '/exhibitionhall?id=4',type: 1},
                    {phoneTitle: '上海',phoneName: '',link: '/exhibitionhall?id=5',type: 2},
                    {phoneTitle: '',phoneName: '前滩太古里店',link: '/exhibitionhall?id=5',type: 2},
                    {phoneTitle: '',phoneName: '武康路店',link: '/exhibitionhall?id=6',type: 2},
                    {phoneTitle: '广州',phoneName: '',link: '/exhibitionhall?id=7',type: 3},
                    {phoneTitle: '',phoneName: '粤海天地店',link: '/exhibitionhall?id=7',type: 3},
                    {phoneTitle: '深圳',phoneName: '',link: '/exhibitionhall?id=8',type: 4},
                    {phoneTitle: '',phoneName: '万象前海店',link: '/exhibitionhall?id=8',type: 4},
                    {phoneTitle: '',phoneName: '卓越中心店',link: '/exhibitionhall?id=9',type: 4},
                    {phoneTitle: '成都',phoneName: '',link: '/exhibitionhall?id=15',type: 5},
                    {phoneTitle: '',phoneName: '富森店',link: '/exhibitionhall?id=15',type: 5},
                    {phoneTitle: '杭州',phoneName: '',link: '/exhibitionhall?id=11',type: 6},
                    {phoneTitle: '',phoneName: '留和路店',link: '/exhibitionhall?id=11',type: 6},
                    {phoneTitle: '苏州',phoneName: '',link: '/exhibitionhall?id=12',type: 7},
                    {phoneTitle: '',phoneName: '诚品店',link: '/exhibitionhall?id=12',type: 7},
                    {phoneTitle: '南京',phoneName: '',link: '/exhibitionhall?id=14',type: 8},
                    {phoneTitle: '',phoneName: '金鹰世界店',link: '/exhibitionhall?id=14',type: 8},
                    {phoneTitle: '西安',phoneName: '',link: '/exhibitionhall?id=14',type: 9},
                    {phoneTitle: '',phoneName: '万象城店',link: '/exhibitionhall?id=16',type: 9}
                ],
                navMenuArt: [
                    {name: '艺术展览',link: '/gallery?tab=1'},
                    {name: '艺术橱窗',link: '/gallery?tab=2'},
                    {name: '艺术快闪',link: '/gallery?tab=3'},
                    {name: '串门',link: '/home-drop'}
                ],
                navMenuList: [],
                navMenuNewList: [],

                topBarLinks: [],
                headLeft: {},
                navMenuOffsetLeft: 903.5,
                // navMenuOffsetLeft: 200,
                newShow: true,
                isZh: true,

                menuShow: false,
                theMenu: 0,
                isPC: true,
                pageHeaderShow: true,
                scrollTimer: {},
                whitchTab: 100,
                memberId: ''
            };
        },
        methods: {
            toLogin: function(){
                window.location.href = "/loginnew";
            },
            Logout: function(){
                var _this = this;
                _this.memberId = '';
                localStorage.removeItem('fnjinew_memberId');
            },
            toSearch: function(){
                window.location.href = "/search";
            },
            init: function(){
                var _this = this;
                var zhOrEn = '';
                if(_this.$i18n.locale=='en'){
                    // _this.topBarLinks = _this.$i18n.messages.en.topBarLinks;
                    _this.headLeft = _this.$i18n.messages.en.headLeft;
                    _this.navMenu = _this.$i18n.messages.en.navMenu;
                    _this.$set(_this.navMenu,_this.navMenu);
                    zhOrEn = 'en';
                    _this.isZh = false;
                }else {
                    // _this.topBarLinks = _this.$i18n.messages.zh.topBarLinks;
                    _this.headLeft = _this.$i18n.messages.zh.headLeft;
                    _this.navMenu = _this.$i18n.messages.zh.navMenu;
                    _this.$set(_this.navMenu,_this.navMenu);
                    zhOrEn = 'zh';
                    _this.isZh = true;
                }
                if(_this.navMenuList.length){
                    // _this.navMenuList = _this.navMenu[_this.theMenu].menu;
                }
                if(_this.navMenuNewList.length){
                    // _this.navMenuNewList = _this.navMenu[_this.theMenu].newMenu;
                }
                if($(window).width()<755){
                    _this.isPC = false;
                }
                var memberid = localStorage.getItem('fnjinew_memberId');
                if(memberid){
                    _this.memberId = memberid;
                }
                Api2020.switchZhEnApi.ajax({language: zhOrEn})
                    .done(function(data){

                    });
                var pr = {
                    fnjiType: 1,
                    lang: ''
                };
                var pr2 = {
                    fnjiType: 2,
                    lang: ''
                };
                if(_this.$i18n.locale=='en'){
                    pr.lang = 'en';
                    pr2.lang = 'en';
                }
                Newapi.getFurnitureApi.ajax(pr)
                    .done(function(data){
                        console.log(data);
                        for(var i=0;i<data.length;i++){
                            _this.navMenu[1].children.push({name: data[i].name,link: '/furniture?tab='+data[i].value})
                        }
                    });
                Newapi.getFurnitureApi.ajax(pr2)
                    .done(function(data){
                        console.log(data);
                        for(var i=0;i<data.length;i++){
                            _this.navMenu[2].children.push({name: data[i].name,link: '/grocery?tab='+data[i].value})
                        }
                    });
            },
            menuClick: function(index){
                var obj = this;
                if(index===1){
                    obj.menuShow = true;
                    $('.page-header-new-menu-one').css({width: '375px'});
                    $('.page-header-new-menu-list-first li').css({opacity: 1});
                }else {
                    obj.menuShow = false;
                    $('.page-header-new-menu-one').css({width: '0'});
                    $('.page-header-new-menu-two').css({width: '0',transform: 'translateX(0)',transition: 'all 0.5s'});
                    obj.navMenuNewList = [];
                    // $('.page-header-new-menu-list li').css({opacity: 0});
                }
            },
            menuItemOver: function(item,index){
                var obj = this;
                obj.theMenu = index;
                if(item.children.length){
                    obj.navMenuList = item.children;
                    // obj.navMenuNewList = item.newMenu;
                    $('.page-header-new-menu-two').css({width: '375px',transform: 'translateX(-375px)',transition: 'all 0.5s'});
                }else {
                    $('.page-header-new-menu-two').css({width: '375px',transform: 'translateX(0)',transition: 'all 0.5s'});
                }
            },
            changeType: function(type){
                localStorage.setItem('locale',type);
                this.$i18n.locale = type;
                console.log(this.$i18n.locale);
                this.init();
            },
            showFnjiWeixinModal: function(){
                Modal.showFnjiWeixinSrvModal();
            },
            search: function(){
                var obj = this;
                if(obj.searchText){
                    window.location.href = Utils.genPageLink('/search-shop?word='+this.searchText);
                }else {
                    obj.searchShow = !obj.searchShow;
                }
            },
            login: function(from){
                Modal.showMemberLoginModal(from);
            },
            register: function(){
                Modal.showMemberRegisterModal();
            },
            genPageLink: Utils.genPageLink,
            isLinkActive: function(link){
                if(link=='/'&&window.location.href=='http://fnji.com/'){
                    return true;
                }else if(link=='/'&&window.location.href!='http://fnji.com/') {
                    return false;
                }else {
                    var pathName = window.location.pathname+'?tab=all';
                    var fullLink = this.genPageLink(link);
                    return pathName.indexOf(fullLink) === 0;
                }
            },
            goNeedAuthPage: function(link){
                var fullLink = this.genPageLink(link);
                if (this.isLoggedIn){
                    window.location.href = fullLink;
                } else {
                    this.login(fullLink);
                }
            },
            initNavMenu: function(){
                var _this = this;
                _.forEach(this.navMenu, function(o){
                    if (o.category){
                        Api.getMenuByCategoryApi.ajax({category: o.category})
                            .done(function(data){
                                o.menu = _.map(data, function(obj){
                                    obj.name = obj.descriptionM;
                                    obj.link = _this.genL2Link(o.category, obj.bom);
                                    return obj;
                                });
                            });
                    }
                });
            },
            updateNavMenuOffsetLeft: function(index)
            {
                var _this = this;
                var $target = $(_this.$refs.menuNavItem[index]);
                console.log($target);
                if(index===1||index===2){
                    _this.navMenuOffsetLeft = 100;
                }else if(index===3){
                    if(_this.isZh){
                        _this.navMenuOffsetLeft = 405;
                    }else {
                        _this.navMenuOffsetLeft = 520;
                    }
                }else if(index===4){
                    if(_this.isZh){
                        _this.navMenuOffsetLeft = 500;
                    }else {
                        _this.navMenuOffsetLeft = 600;
                    }
                }
            },
            getCategoryName: function(category){
                switch(category){
                    case 1:
                        return '';
                    case 2:
                        return '';
                    default:
                        return '';
                }
            },
            genL2Link: function(category, bom){
                var categoryName = this.getCategoryName(category);
                if (!categoryName) return '';
                return '/'+categoryName+'-l2?bom='+bom;
            },
            run: function() {
                // var num = 0;
                // var _this = this;
                // var i = setInterval(function () {
                //     if($(document).scrollTop()==0) {
                //         if (num < 40) {
                //             _this.newShow = false;
                //             // console.log(_this.newShow);
                //             num++;
                //         }
                //     }else {
                //         num = 40;
                //         _this.newShow = true;
                //     }
                // },300);
                // if($(document).scrollTop()!=0) {
                //     window.clearInterval(i);
                //     _this.newShow = true;
                // }
            }
        },
        mounted: function() {
            this.fetchMemberInfo();
            // this.initNavMenu();
            // this.run();
            // window.run = this.run;
            // isTop();
            this.init();
            // var obj = this;
            // $(window).scroll(function() {
            //     var pathname = window.location.pathname;
            //     if((pathname!='/buyChannel'&&pathname!='/gallery')||!obj.isPC){
            //         if(!obj.menuShow){
            //         }
            //     }
            // });
            // document.addEventListener("scroll", function(){
            //     clearTimeout(obj.scrollTimer);
            //     obj.scrollTimer = setTimeout(function() {
            //     }, 300);
            // });
        }
    };
    // function isTop() {
    //     $(document).scroll(function() {
    //         run()
    //     });
    // }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div v-if=\"isPC\" id=\"page-header2024\">\r\n        <div class=\"page-header-row\" style=\"height: 100%;\">\r\n            <img style=\"height: 100%;\" src=\"/view-v2/web/static/img/page-header2024/fnji_logo.png\" alt=\"\">\r\n            <div class=\"page-header2024-con\">\r\n                <div class=\"page-header-row\">\r\n                    <div style=\"flex-grow: 1;\" class=\"page-header-row\">\r\n                        <div style=\"position:relative;\">\r\n                            <div @mouseover=\"whitchTab=index\" @mouseleave=\"whitchTab=100\" :style=\"{marginLeft: index>0?'38px':'0'}\" style=\"position:relative;float: left;\" v-for=\"(item,index) in navMenu\">\r\n                                <a v-if=\"item.link\" :href=\"item.link\">{{item.name}}</a>\r\n                                <a style=\"cursor: pointer\" v-else>{{item.name}}</a>\r\n                                <div class=\"header2024_tab_item\" v-if=\"item.children.length>0&&whitchTab==index\">\r\n                                    <div class=\"header2024_tab_item_in\">\r\n                                        <div v-for=\"(con,ind) in item.children\" :style=\"{marginTop: ind>0&&item.children[ind-1].type!=item.children[ind].type?'20px':'0'}\">\r\n                                            <a :href=\"con.link\">{{con.name}}</a>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div style=\"clear: both;\"></div>\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"memberId\" @click=\"Logout\" style=\"cursor: pointer;width: 60px;text-align: right;\">{{$t(\"headLeft.logout\")}}</div>\r\n                    <div v-else @click=\"toLogin\" style=\"cursor: pointer;width: 60px;text-align: right;\">{{$t(\"headLeft.login\")}}</div>\r\n                    <div @click=\"changeType('zh')\" style=\"cursor: pointer;margin-left: 38px;font-family: MiSans-Normal;\">CN</div>\r\n                    <div style=\"margin-left: 9px;font-family: MiSans-Normal;\">|</div>\r\n                    <div @click=\"changeType('en')\" style=\"cursor: pointer;margin-left: 9px;font-family: MiSans-Normal;\">EN</div>\r\n                    <!--                <img @click=\"toLogin\" class=\"page-header2024-con-icon\" src=\"/view-v2/web/static/img/page-header2024/user.png\" alt=\"\">-->\r\n                    <!--                <img class=\"page-header2024-con-icon\" src=\"/view-v2/web/static/img/page-header2024/barcode.png\" alt=\"\">-->\r\n                    <img @click=\"toSearch\" class=\"page-header2024-con-icon\" src=\"/view-v2/web/static/img/page-header2024/search_new.png\" alt=\"\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div v-else id=\"page-header-new\">\r\n        <div class=\"page-header-new\">\r\n            <div class=\"page-header-new-con\">\r\n                <a href=\"/\">\r\n<!--                    <img :style=\"{width: isPC?'64px':'108px',top: isPC?'40px':'78px',left:isPC?'40px':'28px'}\" class=\"page-header-new-fnji\" src=\"https://static.fnji.com/temp/upload/s20480_1630830637_5109.png?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1\" alt=\"\">-->\r\n                    <img :style=\"{width: isPC?'64px':'108px',top: isPC?'40px':'78px',left:isPC?'40px':'28px'}\" class=\"page-header-new-fnji\" src=\"/view-v2/web/static/img/page-header2024/fnji_logo.png\" alt=\"\">\r\n                </a>\r\n                <div :style=\"{top: isPC?'40px':'78px',right: isPC?'40px':'28px'}\" class=\"page-header-new-right\">\r\n                    <div class=\"page-header-new-cormal\" style=\"height: 32px;padding-top: 2px;\">\r\n<!--                        <img :style=\"{width: isPC?'26px':'44px',height: isPC?'22px':'36px'}\" @click=\"menuClick(1)\" v-if=\"!menuShow\" class=\"page-header-new-menu-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/fnji_menu_new.png\" alt=\"\">-->\r\n                        <img :style=\"{width: isPC?'26px':'44px',height: isPC?'22px':'36px'}\" @click=\"menuClick(1)\" v-if=\"!menuShow\" class=\"page-header-new-menu-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header2024/fnji_menu.png\" alt=\"\">\r\n<!--                        <img :style=\"{width: isPC?'26px':'44px',height: isPC?'22px':'36px'}\" @click=\"menuClick(2)\" v-if=\"menuShow\" class=\"page-header-new-close-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/close_menu_new.png\" alt=\"\">-->\r\n                    </div>\r\n                    <!--                <div :style=\"{'font-size': isPC?'22px':'38px','margin-right': isPC?'12px':'20px'}\" class=\"page-header-new-cormal page-header-new-l page-header-new-mouseover\">EN</div>-->\r\n                    <!--                <div :style=\"{'font-size': isPC?'22px':'38px','margin-right': isPC?'12px':'20px'}\" class=\"page-header-new-cormal page-header-new-ls\">|</div>-->\r\n                    <!--                <div :style=\"{'font-size': isPC?'22px':'38px','margin-right': isPC?'12px':'20px'}\" class=\"page-header-new-cormal page-header-new-l page-header-new-mouseover\">CN</div>-->\r\n                    <!--                <div class=\"page-header-new-cormal\" style=\"height: 32px;padding-top: 4px;\">-->\r\n                    <!--                    <input :style=\"{'font-size': isPC?'14px':'18px'}\" v-if=\"searchShow\" type=\"text\" class=\"u-search-input\" style=\"margin-right: 5px;\" v-model=\"searchText\" @keyup.enter=\"search()\">-->\r\n                    <!--                    <img :style=\"{width: isPC?'22px':'36px',height: isPC?'22px':'36px'}\" class=\"page-header-new-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/search_new.png\" alt=\"\">-->\r\n                    <!--                </div>-->\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"page-header-new-menu\">\r\n            <div class=\"page-header-new-right\" style=\"z-index: 1;\">\r\n                <div class=\"page-header-new-cormal\" style=\"height: 32px;padding-top: 2px;\">\r\n                    <img :style=\"{width: isPC?'22px':'36px',height: isPC?'22px':'36px'}\" @click=\"menuClick(2)\" v-if=\"menuShow\" class=\"page-header-new-close-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/close_menu_new.png\" alt=\"\">\r\n                </div>\r\n                <div style=\"clear: both;\"></div>\r\n            </div>\r\n            <div class=\"page-header-new-menu-one\">\r\n                <div :style=\"{'font-size': isPC?'24px':'37px'}\" class=\"page-header-new-menu-list page-header-new-menu-list-first\">\r\n                    <ul>\r\n                        <li :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(item,index) in navMenu\" :key=\"index\"><a @mouseover=\"menuItemOver(item,index)\" :href=\"index==0||index==6||index==8?item.link:'javascript:void(0)'\" :class=\"{'page-header-new-menuList-color': theMenu==index}\">{{item.name}}</a></li>\r\n                    </ul>\r\n                </div>\r\n                <div class=\"page-header-new-menu-call\">\r\n                    <div class=\"page-header-new-menu-call-con\">\r\n<!--                        <div :style=\"{height:isPC?'72px':'102px'}\" style=\"margin-bottom: 20px;position:relative;\">-->\r\n<!--                            <div :class=\"searchShow?'page-header-new-menuList-search-hover':'page-header-new-menuList-search'\" class=\"page-header-new-cormal\" :style=\"{width:isPC?'213px':'240px','margin-left':isPC?'112px':'84px',height:isPC?'28px':'36px'}\" style=\"float: none;margin-bottom: 10px;margin-right: 0;\">-->\r\n<!--                                <input :style=\"{'font-size': isPC?'14px':'18px',width:isPC?'':'200px'}\" type=\"text\" class=\"u-search-input\" style=\"margin-right: 5px;border: 0;outline: none;\" v-model=\"searchText\" @keyup.enter=\"search()\">-->\r\n<!--                                <img :style=\"{width: isPC?'20px':'26px',height: isPC?'20px':'26px'}\" @click=\"search\" class=\"page-header-new-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/search_new_black.png\" alt=\"\">-->\r\n<!--                            </div>-->\r\n<!--                            <div style=\"height: 32px;overflow: hidden;\">-->\r\n<!--                                <div @click=\"changeType('en')\" :style=\"{'font-size': isPC?'18px':'22px','margin-left': isPC?'12px':'20px'}\" style=\"margin-right: 0;\" class=\"page-header-new-cormal page-header-new-l page-header-new-mouseover\">EN</div>-->\r\n<!--                                <div :style=\"{'font-size': isPC?'18px':'22px','margin-left': isPC?'12px':'20px'}\" style=\"margin-right: 0;\" class=\"page-header-new-cormal page-header-new-ls\">|</div>-->\r\n<!--                                <div @click=\"changeType('zh')\" :style=\"{'font-size': isPC?'18px':'22px','margin-left': isPC?'12px':'20px'}\" style=\"margin-right: 0;\" class=\"page-header-new-cormal page-header-new-l page-header-new-mouseover\">CN</div>-->\r\n<!--                            </div>-->\r\n<!--                        </div>-->\r\n                        <div v-if=\"isPC\" class=\"page-header-new-menu-call-item\">BEIJING,CHINA 400-641-6399</div>\r\n                        <div v-if=\"!isPC\" style=\"font-size: 16px;line-height: 20px;height: 32px\" class=\"page-header-new-menu-call-item\">400-641-6399</div>\r\n                        <div class=\"page-header-new-menu-call-type\" style=\"margin-top: 5px\">\r\n                            <div :style=\"{'font-size': isPC?'10px':'16px','line-height': isPC?'16px':'30px',height: isPC?'16px':'30px'}\" class=\"page-header-new-menu-call-info\">service@fnji.com  |  marketing@fnji.com</div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"page-header-new-menu-two\" style=\"z-index: -1;border-right: 3px solid #979797;\">\r\n                    <div :style=\"{'font-size': isPC?'24px':'37px'}\" style=\"height: 100%;overflow-y: auto;\" class=\"page-header-new-menu-list page-header-new-menu-list-last\">\r\n                        <ul v-if=\"theMenu==4\" style=\"margin-bottom: 30px;\">\r\n                            <li :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(items,indexs) in navMenuShopsPhone\" :key=\"indexs\">\r\n                                <div v-if=\"items.phoneTitle!=''\">{{items.phoneTitle}}</div>\r\n                                <a v-else :href=\"items.link\" style=\"font-size: 30px\">{{items.phoneName}}</a>\r\n                            </li>\r\n                        </ul>\r\n                        <ul v-else-if=\"theMenu==5\" style=\"margin-bottom: 30px;\">\r\n                            <li :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(items,indexs) in navMenuArt\" :key=\"indexs\">\r\n                                <a :href=\"items.link\">{{items.name}}</a>\r\n                            </li>\r\n                        </ul>\r\n                        <ul v-else style=\"margin-bottom: 30px;\">\r\n                            <li :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(items,indexs) in navMenuList\"  v-if=\"items.link!='/download'\" :key=\"indexs\">\r\n                                <a :href=\"items.link\">{{items.name}}</a>\r\n                            </li>\r\n                            <!--                        <li v-if=\"navMenuNewList.length\"><div style=\"width: 100px;height: 1px;background: #C7C7C7;\"></div></li>-->\r\n                        </ul>\r\n                        <ul v-if=\"navMenuNewList&&navMenuNewList.length\" :style=\"{width:isPC?'85px':'150px'}\" style=\"padding-top: 30px;border-top: 2px solid #C7C7C7;padding-left: 0;float: right;\">\r\n                            <li v-if=\"navMenuNewList.length\" :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(itemss,indexss) in navMenuNewList\">\r\n                                <div><a :href=\"itemss.link\">{{itemss.name}}</a></div>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(26)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Headroom
){
    return {
        mounted: function(){
            var headroom = new Headroom(this.$el);
            headroom.init();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

!function(a,b){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=b():a.Headroom=b()}(this,function(){"use strict";function a(a){this.callback=a,this.ticking=!1}function b(a){return a&&"undefined"!=typeof window&&(a===window||a.nodeType)}function c(a){if(arguments.length<=0)throw new Error("Missing arguments in extend function");var d,e,f=a||{};for(e=1;e<arguments.length;e++){var g=arguments[e]||{};for(d in g)"object"!=typeof f[d]||b(f[d])?f[d]=f[d]||g[d]:f[d]=c(f[d],g[d])}return f}function d(a){return a===Object(a)?a:{down:a,up:a}}function e(a,b){b=c(b,e.options),this.lastKnownScrollY=0,this.elem=a,this.tolerance=d(b.tolerance),this.classes=b.classes,this.offset=b.offset,this.scroller=b.scroller,this.initialised=!1,this.onPin=b.onPin,this.onUnpin=b.onUnpin,this.onTop=b.onTop,this.onNotTop=b.onNotTop,this.onBottom=b.onBottom,this.onNotBottom=b.onNotBottom}var f={bind:!!function(){}.bind,classList:"classList"in document.documentElement,rAF:!!(window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame)};return window.requestAnimationFrame=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame,a.prototype={constructor:a,update:function(){this.callback&&this.callback(),this.ticking=!1},requestTick:function(){this.ticking||(requestAnimationFrame(this.rafCallback||(this.rafCallback=this.update.bind(this))),this.ticking=!0)},handleEvent:function(){this.requestTick()}},e.prototype={constructor:e,init:function(){if(e.cutsTheMustard)return this.debouncer=new a(this.update.bind(this)),this.elem.classList.add(this.classes.initial),setTimeout(this.attachEvent.bind(this),100),this},destroy:function(){var a=this.classes;this.initialised=!1;for(var b in a)a.hasOwnProperty(b)&&this.elem.classList.remove(a[b]);this.scroller.removeEventListener("scroll",this.debouncer,!1)},attachEvent:function(){this.initialised||(this.lastKnownScrollY=this.getScrollY(),this.initialised=!0,this.scroller.addEventListener("scroll",this.debouncer,!1),this.debouncer.handleEvent())},unpin:function(){var a=this.elem.classList,b=this.classes;!a.contains(b.pinned)&&a.contains(b.unpinned)||(a.add(b.unpinned),a.remove(b.pinned),this.onUnpin&&this.onUnpin.call(this))},pin:function(){var a=this.elem.classList,b=this.classes;a.contains(b.unpinned)&&(a.remove(b.unpinned),a.add(b.pinned),this.onPin&&this.onPin.call(this))},top:function(){var a=this.elem.classList,b=this.classes;a.contains(b.top)||(a.add(b.top),a.remove(b.notTop),this.onTop&&this.onTop.call(this))},notTop:function(){var a=this.elem.classList,b=this.classes;a.contains(b.notTop)||(a.add(b.notTop),a.remove(b.top),this.onNotTop&&this.onNotTop.call(this))},bottom:function(){var a=this.elem.classList,b=this.classes;a.contains(b.bottom)||(a.add(b.bottom),a.remove(b.notBottom),this.onBottom&&this.onBottom.call(this))},notBottom:function(){var a=this.elem.classList,b=this.classes;a.contains(b.notBottom)||(a.add(b.notBottom),a.remove(b.bottom),this.onNotBottom&&this.onNotBottom.call(this))},getScrollY:function(){return void 0!==this.scroller.pageYOffset?this.scroller.pageYOffset:void 0!==this.scroller.scrollTop?this.scroller.scrollTop:(document.documentElement||document.body.parentNode||document.body).scrollTop},getViewportHeight:function(){return window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight},getElementPhysicalHeight:function(a){return Math.max(a.offsetHeight,a.clientHeight)},getScrollerPhysicalHeight:function(){return this.scroller===window||this.scroller===document.body?this.getViewportHeight():this.getElementPhysicalHeight(this.scroller)},getDocumentHeight:function(){var a=document.body,b=document.documentElement;return Math.max(a.scrollHeight,b.scrollHeight,a.offsetHeight,b.offsetHeight,a.clientHeight,b.clientHeight)},getElementHeight:function(a){return Math.max(a.scrollHeight,a.offsetHeight,a.clientHeight)},getScrollerHeight:function(){return this.scroller===window||this.scroller===document.body?this.getDocumentHeight():this.getElementHeight(this.scroller)},isOutOfBounds:function(a){var b=a<0,c=a+this.getScrollerPhysicalHeight()>this.getScrollerHeight();return b||c},toleranceExceeded:function(a,b){return Math.abs(a-this.lastKnownScrollY)>=this.tolerance[b]},shouldUnpin:function(a,b){var c=a>this.lastKnownScrollY,d=a>=this.offset;return c&&d&&b},shouldPin:function(a,b){var c=a<this.lastKnownScrollY,d=a<=this.offset;return c&&b||d},update:function(){var a=this.getScrollY(),b=a>this.lastKnownScrollY?"down":"up",c=this.toleranceExceeded(a,b);this.isOutOfBounds(a)||(a<=this.offset?this.top():this.notTop(),a+this.getViewportHeight()>=this.getScrollerHeight()?this.bottom():this.notBottom(),this.shouldUnpin(a,c)?this.unpin():this.shouldPin(a,c)&&this.pin(),this.lastKnownScrollY=a)}},e.options={tolerance:{up:0,down:0},offset:0,scroller:window,classes:{pinned:"headroom--pinned",unpinned:"headroom--unpinned",top:"headroom--top",notTop:"headroom--not-top",bottom:"headroom--bottom",notBottom:"headroom--not-bottom",initial:"headroom"}},e.cutsTheMustard="undefined"!=typeof f&&f.rAF&&f.bind&&f.classList,e});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(28),

    __webpack_require__(29)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl
){
    return {
        template: tpl
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div class=\"weui-mask_transparent\"></div>\r\n    <div class=\"weui-toast\">\r\n        <i class=\"weui-loading weui-icon_toast\"></i>\r\n        <p class=\"weui-toast__content\">Loading...</p>\r\n    </div>\r\n</div>"

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(30);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./loading.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./loading.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <member-login-modal\r\n            v-model=\"memberLoginModal.isShow\"\r\n            :modal-data=\"memberLoginModal.data\"\r\n            @register=\"showMemberRegisterModal\"\r\n            @reset-pass=\"showPassResetModal\"\r\n    ></member-login-modal>\r\n    <member-register-modal\r\n            v-model=\"memberRegisterModal.isShow\"\r\n            :modal-data=\"memberRegisterModal.data\"\r\n            @login=\"showMemberLoginModal\"\r\n    ></member-register-modal>\r\n    <pass-reset-modal\r\n            v-model=\"passResetModal.isShow\"\r\n            :modal-data=\"passResetModal.data\"\r\n            @login=\"showMemberLoginModal\"\r\n    ></pass-reset-modal>\r\n    <fnji-weixin-modal\r\n            v-model=\"fnjiWeixinModal.isShow\"\r\n            :modal-data=\"fnjiWeixinModal.data\"\r\n    ></fnji-weixin-modal>\r\n\r\n    <fnji-weixin-srv-modal\r\n            v-model=\"fnjiWeixinSrvModal.isShow\"\r\n            :modal-data=\"fnjiWeixinSrvModal.data\"\r\n    ></fnji-weixin-srv-modal>\r\n</div>"

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(34),
    __webpack_require__(6),
    __webpack_require__(14),
    __webpack_require__(5),

    __webpack_require__(37),
    __webpack_require__(38)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin,
    Auth,
    Api
){
    function genDefaultInfo(){
        return {
            phone: '',
            password: '',
            rememberMe: false
        };
    }
    function genDefaultQuickInfo(){
        return {
            phone: '',
            verifyCode: ''
        };
    }
    return {
        template: tpl,
        mixins: [ModalMixin],
        data: function(){
            return {
                info: genDefaultInfo(),
                infoQuick: genDefaultQuickInfo(),
                qrcodeId: 'wx_qrcode',
                isQuickLogin:true
            };
        },
        computed: {
            backUrl: function(){
                return this.modalData.from || window.location.href;
            }
        },
        watch: {
            value: function(v){
                if (v) {
                    this.initWxLogin();
                }
            }
        },
        methods: {
            changeQuickLogin:function()
            {
                this.isQuickLogin = !this.isQuickLogin;
            },
            sendVerifyCode: function(){
                var phone = this.infoQuick.phone;
                if (!phone){
                    return alert('手机或邮箱格式错误');
                }
                Api.sendVerifyCodeApi.ajax({phone:phone, jammer:FNJISite.user.jammer})
                    .done(function(data){
                        alert(data);
                    });
            },
            loginQuick:function(){
                this.infoQuick['isQuickLogin'] = true;
                Auth.login(this.infoQuick, this.modalData.from);
            },
            login: function(){
                this.info['isQuickLogin'] = false;
                Auth.login(this.info, this.modalData.from);
            },
            initWxLogin: function(){
                var _this = this;
                Api.getWxLoginInfoApi.ajax({backUrl: this.backUrl})
                    .done(function(data){
                        new WxLogin({
                            id:_this.qrcodeId,
                            appid: "wx9d5a22c9e6d334c2",
                            scope: "snsapi_login",
                            redirect_uri: data.callback,
                            href: 'data:text/css;base64,KiB7DQogICAgbWFyZ2luOiAwOw0KICAgIHBhZGRpbmc6IDA7DQp9DQouaW1wb3dlckJveCB7DQogICAgbGluZS1oZWlnaHQ6IDE7DQogICAgZm9udC1zaXplOiAwOw0KfQ0KLmltcG93ZXJCb3ggLnRpdGxlLA0KLmltcG93ZXJCb3ggLmluZm8NCnsNCiAgICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogICAgYm9yZGVyOiBub25lOw0KICAgIG1hcmdpbi10b3A6IDA7DQogICAgd2lkdGg6IDE1MHB4Ow0KfQ=='
                        });
                    });
            },
            register: function(){
                this.hide();
                this.$emit('register');
            },
            resetPass: function(){
                this.hide();
                this.$emit('reset-pass');
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-member-login\" v-show=\"value\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <button class=\"close\" @click=\"hide()\">&times;</button>\r\n            <div class=\"d-flex justify-content-between\">\r\n                <div class=\"block-left\">\r\n                    <div class=\"modal-title\">\r\n                        手机扫码登录\r\n                    </div>\r\n                    <div class=\"block-qrcode\">\r\n                        <div :id=\"qrcodeId\"></div>\r\n                    </div>\r\n                    <div class=\"text-muted\">\r\n                        打开微信扫一扫登录\r\n                    </div>\r\n                </div>\r\n<!--                <div class=\"block-right\" v-if=\"!isQuickLogin\">-->\r\n<!--                    <div class=\"modal-title\">-->\r\n<!--                        账户登录-->\r\n<!--                    </div>-->\r\n<!--                    <form @submit.prevent=\"login()\">-->\r\n<!--                        <div class=\"form-row\">-->\r\n<!--                            <input type=\"text\" autocomplete=\"off\" class=\"form-control\" placeholder=\"手机/邮箱\" required v-model=\"info.phone\">-->\r\n<!--                        </div>-->\r\n<!--                        <div class=\"form-row\">-->\r\n<!--                            <input type=\"password\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"密码\" required v-model=\"info.password\">-->\r\n<!--                        </div>-->\r\n<!--                        <div class=\"form-row\">-->\r\n<!--                            <label class=\"control checkbox\">-->\r\n<!--                                <input type=\"checkbox\" v-model=\"info.rememberMe\">-->\r\n<!--                                <span class=\"control-indicator\"></span>-->\r\n<!--                                记住密码-->\r\n<!--                            </label>-->\r\n<!--                            <a class=\"link\" href=\"javascript:\" @click=\"resetPass()\">忘记密码或账号</a>-->\r\n<!--                        </div>-->\r\n<!--                        <div class=\"block-btn\">-->\r\n<!--                            <button class=\"btn\" type=\"submit\">登录</button>-->\r\n<!--                        </div>-->\r\n<!--                    </form>-->\r\n<!--                    <div class=\"text-muted\">-->\r\n<!--                        还没有梵几账号-->\r\n<!--                        <a class=\"link\" href=\"javascript:\" @click=\"register()\">点击注册</a>-->\r\n\r\n\r\n<!--                    </div>-->\r\n\r\n<!--                    <div class=\"block-btn\">-->\r\n<!--                        <button class=\"btn btn-muted\" @click=\"changeQuickLogin()\" >手机快捷登录</button>-->\r\n<!--                    </div>-->\r\n\r\n<!--                </div>-->\r\n\r\n                <div class=\"block-right\" v-if=\"isQuickLogin\">\r\n                    <div class=\"modal-title\">\r\n                        手机快捷登录\r\n                    </div>\r\n                    <form @submit.prevent=\"loginQuick()\">\r\n\r\n                        <div class=\"form-row form-row-phone\">\r\n                            <input type=\"text\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"手机\" required v-model=\"infoQuick.phone\">\r\n                            <button class=\"btn verify-code\" type=\"button\" @click=\"sendVerifyCode()\">验证</button>\r\n                        </div>\r\n                        <div class=\"form-row\">\r\n                            <input type=\"text\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"验证码\" required v-model=\"infoQuick.verifyCode\">\r\n                        </div>\r\n\r\n                        <div class=\"form-row\" style=\"height: 18px;\">\r\n                        </div>\r\n\r\n                        <div class=\"block-btn\">\r\n                            <button class=\"btn\" type=\"submit\">登录</button>\r\n                        </div>\r\n                    </form>\r\n                    <div class=\"text-muted\">\r\n                        还没有梵几账号\r\n                        <a class=\"link\" href=\"javascript:\" @click=\"register()\">点击注册</a>\r\n\r\n                    </div>\r\n\r\n<!--                    <div class=\"block-btn\">-->\r\n<!--                        <button class=\"btn btn-muted\" @click=\"changeQuickLogin()\" >账户登录</button>-->\r\n<!--                    </div>-->\r\n\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(36);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./modal.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./modal.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

!function(a,b){function d(a){var e,c=b.createElement("iframe"),d="https://open.weixin.qq.com/connect/qrconnect?appid="+a.appid+"&scope="+a.scope+"&redirect_uri="+a.redirect_uri+"&state="+a.state+"&login_type=jssdk";d+=a.style?"&style="+a.style:"",d+=a.href?"&href="+a.href:"",c.src=d,c.frameBorder="0",c.allowTransparency="true",c.scrolling="no",c.sandbox='allow-top-navigation allow-forms allow-scripts allow-same-origin', c.width="300px",c.height="400px",e=b.getElementById(a.id),e.innerHTML="",e.appendChild(c)}a.WxLogin=d}(window,document);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(39);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./member-login.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./member-login.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(41),
    __webpack_require__(6),
    __webpack_require__(5),

    __webpack_require__(42)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin,
    Api
){
    function genDefaultInfo(){
        return {
            phone: '',
            verifyCode: '',
            password: '',
            passwordRepeat: '',
            readLaw: false
        };
    }
    return {
        template: tpl,
        mixins: [ModalMixin],
        data: function(){
            return {
                info: genDefaultInfo()
            };
        },
        methods: {
            sendVerifyCode: function(){
                var phone = this.info.phone;
                if (!phone){
                    return alert('手机或邮箱格式错误');
                }
                Api.sendVerifyCodeApi.ajax({phone:phone, jammer:FNJISite.user.jammer})
                    .done(function(data){
                        alert(data);
                    });
            },
            onConfirm: function(){
                if (this.info.password !== this.info.passwordRepeat){
                    return alert('两次密码输入不一致');
                }
                var _this = this;
                Api.registerApi.ajax({data_json: JSON.stringify(this.info)})
                    .done(function(){
                        _this.hide();
                        _this.$emit('login');
                    });
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-member-register\" v-show=\"value\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <button class=\"close\" @click=\"hide()\">&times;</button>\r\n            <div class=\"modal-title\">\r\n                注册\r\n            </div>\r\n            <form @submit.prevent=\"onConfirm()\">\r\n                <div class=\"form-row form-row-phone\">\r\n                    <input type=\"text\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"手机/邮箱\" required v-model=\"info.phone\">\r\n                    <button style=\"font-size: 12px;\" class=\"btn\" type=\"button\" @click=\"sendVerifyCode()\">验证</button>\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"text\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"验证码\" required v-model=\"info.verifyCode\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"password\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"密码\" required v-model=\"info.password\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"password\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"重复密码\" required v-model=\"info.passwordRepeat\">\r\n                </div>\r\n                <div class=\"form-row\" style=\"border: none;\">\r\n                    <label class=\"control checkbox\">\r\n                        <input type=\"checkbox\" v-model=\"info.readLaw\">\r\n                        <span class=\"control-indicator\"></span>\r\n                        我已阅读并同意遵守\r\n                        <a href=\"javascript:\" class=\"link\">法律声明</a>\r\n                        和\r\n                        <a href=\"javascript:\" class=\"link\">隐私条款</a>\r\n                    </label>\r\n                </div>\r\n                <div class=\"block-btn\">\r\n                    <button class=\"btn\">注册</button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(43);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./member-register.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./member-register.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(45),
    __webpack_require__(6),
    __webpack_require__(5),

    __webpack_require__(46)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin,
    Api
){
    function genDefaultInfo(){
        return {
            phone: '',
            verifyCode: '',
            password: '',
            passwordRepeat: '',
            remember: true
        };
    }
    return {
        template: tpl,
        mixins: [ModalMixin],
        data: function(){
            return {
                info: genDefaultInfo()
            };
        },
        methods: {
            sendVerifyCode: function(){
                var phone = this.info.phone;
                if (!phone){
                    return alert('手机或邮箱格式错误');
                }
                Api.sendVerifyCodeApi.ajax({phone:phone, jammer:FNJISite.user.jammer})
                    .done(function(data){
                        alert(data);
                    });
            },
            onConfirm: function(){
                if (this.info.password !== this.info.passwordRepeat){
                    return alert('两次密码输入不一致');
                }
                var _this = this;
                Api.resetPassApi.ajax({data_json: JSON.stringify(this.info)})
                    .done(function(){
                        _this.$emit('login');
                    });
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-pass-reset\" v-show=\"value\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <button class=\"close\" @click=\"hide()\">&times;</button>\r\n            <div class=\"modal-title\">\r\n                找回密码<br>\r\n                <small>RESET PASSWORD</small>\r\n            </div>\r\n            <form @submit.prevent=\"onConfirm()\">\r\n                <div class=\"form-row form-row-phone\">\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"手机/邮箱\" required v-model=\"info.phone\">\r\n                    <button class=\"btn\" type=\"button\" @click=\"sendVerifyCode()\">验证</button>\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"验证码\" required v-model=\"info.verifyCode\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"password\" class=\"form-control\" placeholder=\"密码\" required v-model=\"info.password\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"password\" class=\"form-control\" placeholder=\"重复密码\" required v-model=\"info.passwordRepeat\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <label class=\"control checkbox\">\r\n                        <input type=\"checkbox\" v-model=\"info.remember\">\r\n                        <span class=\"control-indicator\"></span>\r\n                        我已阅读并同意遵守\r\n                        <a href=\"javascript:\">法律声明</a>\r\n                        和\r\n                        <a href=\"javascript:\">隐私条款</a>\r\n                    </label>\r\n                </div>\r\n                <div class=\"block-btn\">\r\n                    <button class=\"btn\">更新密码</button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(47);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./pass-reset.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./pass-reset.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(49),
    __webpack_require__(6),

    __webpack_require__(50)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin
){
    return {
        template: tpl,
        mixins: [ModalMixin]
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-fnji-weixin\" v-show=\"value\" @click=\"hide()\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <i class=\"u-icon u-icon-fnji-weixin\"></i>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(51);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fnji-weixin.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fnji-weixin.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(53),
    __webpack_require__(6),

    __webpack_require__(54)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin
){
    return {
        template: tpl,
        mixins: [ModalMixin]
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-fnji-weixin-srv\" v-show=\"value\" @click=\"hide()\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <i class=\"u-icon u-icon-fnji-weixin\"></i>\r\n            <div style=\"font-size: 12px;padding-top: 10px;line-height: 20px;letter-spacing: 1px;\">微信扫描二维码关注梵几服务号<br>可以进行预约</div>\r\n\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(55);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fnji-weixin-srv.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fnji-weixin-srv.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(57);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./wtf-forms.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./wtf-forms.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(59),
    __webpack_require__(1),
    __webpack_require__(2)

], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    $,
    Utils
){
    return {
        template: tpl,
        props: {
            menu: {
                type: Array
            },
            menuParent: {
                type: Object
            },
            offsetLeft: {
                type: Number,
                default: 0
            }
        },
        computed: {
            innerStyle: function(){
                return {
                    marginLeft: this.offsetLeft+ 'px'
                };
            }
        },
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "<div class=\"block-sub-nav\">\r\n    <div class=\"inner\">\r\n        <ul class=\"nav\" :style=\"{'margin-left': offsetLeft+'px'}\">\r\n\r\n            <!--<li class=\"nav-item\" v-if=\"menuParent.category==2\">-->\r\n                <!--<a class=\"nav-link\" :href=\"'/grocery?tab=recommend' | pageLink \">推荐</a>-->\r\n            <!--</li>-->\r\n\r\n\r\n\r\n            <!--<li class=\"nav-item\" v-if=\"menuParent.category==2\">-->\r\n                <!--<a style=\"font-family: sans-serif;\" class=\"nav-link\" >|</a>-->\r\n            <!--</li>-->\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/grocery?tab=new' | pageLink \">new</a>\r\n            </li>\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2\">\r\n                <a style=\"font-family: sans-serif;\" class=\"nav-link\" >|</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-for=\"(o,index) in menu\">\r\n                <a :href=\"o.link | pageLink\" class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\">{{o.name}}</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2 || menuParent.category==1\">\r\n                <a style=\"font-family: sans-serif;\" class=\"nav-link\" >|</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/grocery-brands?brand=brand' | pageLink \">{{$t('headLeft.brand')}}</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/grocery?tab=discount' | pageLink \">Sale</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==1\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/furniture-l2?bom=high' | pageLink \">{{$t('headLeft.crest')}}</a>\r\n            </li>\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==1\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/furniture-l2?bom=base' | pageLink \">{{$t('headLeft.earth')}}</a>\r\n            </li>\r\n<!--            <li class=\"nav-item\" v-if=\"menuParent.category==1\">-->\r\n<!--                <a class=\"nav-link\" :href=\"'/furniture-l2?bom=base' | pageLink \">本线</a>-->\r\n<!--            </li>-->\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==1\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/furniture-l2?bom=ff' | pageLink \">{{$t('headLeft.ff')}}</a>\r\n            </li>\r\n\r\n        </ul>\r\n    </div>\r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),
    __webpack_require__(3),
    __webpack_require__(9)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $,
    _,
    Toast
){
    var BaseUrl = 'https://website.fnji.com/mt/s';
    // var BaseUrl = '';
    var ErrorEnum = {
        DataError: {
            code: 'DATA_ERROR',
            data: '数据异常'
        },
        NetworkError: {
            code: 'NETWORK_ERROR',
            data: '网络异常'
        },
        ParamError: {
            code: 'PARAM_ERROR',
            data: '参数错误'
        }
    };
    function Api(path, defaultOptions){
        this.url = BaseUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    Api.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    Api.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };

    return {
        Api: Api,
        getFurnitureApi: new Api('/ProductCategoryModel/enum'),//家具列表
        getProListApi: new Api('/ProductSkuModel/getByCategory')//家具产品列表
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(62);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-header2024.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-header2024.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(64),
    __webpack_require__(12),
    __webpack_require__(10),
    __webpack_require__(1),

    __webpack_require__(17),
    __webpack_require__(66)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    PageReadyMixin,
    Modal,
    $
){
    var menuGroups = [
        {
            title: '关于我们',
            list: [
                {name: '梵几STORY', link: '/fnjibrand'},
                {name: '梵几实体店', link: '/shop'},
                {name: '媒体报道', link: '/fnjimedia'},
                {name: '招聘信息', link: '/job'}
            ]
        },
        {
            title: '购物指南',
            list: [
                {name: '购物流程', link: '/howshop'},
                {name: '会员制度', link: '/membership'}
            ]
        },
        {
            title: '关于配送',
            list: [
                {name: '家具配送', link: '/aboutdeliver?index=0'},
                {name: '家居配送', link: '/aboutdeliver?index=1'},
                {name: '一枚板配送', link: '/aboutdeliver?index=2'}
            ]
        },
        {
            title: '售后服务',
            list: [
                {name: '家具售后', link: '/aboutservice?index=0'},
                {name: '家居售后', link: '/aboutservice?index=1'}
            ]
        },
        {
            title: '商业合作',
            list: [
                {name: '项目批量采购', link: '/site/cooperate?type=1'},
                {name: '设计公司合作', link: '/site/cooperate?type=2'},
                {name: '家居品牌合作', link: '/site/cooperate?type=3'},
                {name: '市场&媒体合作', link: '/site/cooperate?type=4'},
                {name: '艺术品合作', link: '/site/cooperate?type=5'},
                {name: '产品目录下载', link: '/temp/upload/productinfo/产品目录.zip'}
            ]
        }
    ];
    return {
        template: tpl,
        mixins: [PageReadyMixin],
        data: function(){
            return {
                menuGroups: [],
                footerNew: [
                    {name: '媒体报道', link: '/fnjimedia'},
                    {name: '招聘信息', link: '/job'},
                    {name: '售后服务', link: '/aboutservice'},
                    {name: '联系我们', link: '/site/cooperate?type=1'}
                ],
                isPC: true,
                isZh: true
            };
        },
        methods: {
            init: function(){
                var _this = this;
                if($(window).width()<755){
                    _this.isPC = false;
                }
                if(_this.$i18n.locale=='en'){
                    _this.footerNew = _this.$i18n.messages.en.footerNew;
                    _this.isZh = false;
                }else {
                    _this.footerNew = _this.$i18n.messages.zh.footerNew;
                    _this.isZh = true;
                }
            },
            showFnjiWeixinModal: function(){
                Modal.showFnjiWeixinModal();
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "<!--<div class=\"page-footer font-sy\" v-show=\"isPageReady\">-->\r\n<div id=\"page-footer-new\" :style=\"{height:isPC?'560px':'940px'}\" :class=\"isPC?'page-footer-new':'page-footer-new-phone'\" style=\"float: none;\" class=\"page-footer font-sy\">\r\n    <div class=\"container\" style=\"margin-right: auto;margin-left: auto;width: 100%;\">\r\n<!--        <div class=\"page-footer-new-header\">-->\r\n<!--            <div class=\"page-footer-new-header-icon\"></div>-->\r\n<!--            <div :style=\"{'font-size':isPC?'16px':'22px','line-height':isPC?'17px':'24px'}\" class=\"page-footer-new-header-info\">-->\r\n<!--                <div>探寻东方与西方之间</div>-->\r\n<!--                <div>现代与传统之间</div>-->\r\n<!--                <div>记忆与未来之间的美学平衡与灵感世界</div>-->\r\n<!--            </div>-->\r\n<!--        </div>-->\r\n        <div v-if=\"!isPC\" class=\"page-footer-new-bottom-phone\">\r\n            <div class=\"page-footer-new-bottom-phone-icon\">\r\n                <a href=\"https://weibo.com/fnji\" target=\"_blank\"><i style=\"margin: 0 26px 0 0;width: 40px;height: 40px;\" class=\"u-icon u-icon-weibo\"></i></a>\r\n                <a href=\"javascript:\" @click=\"showFnjiWeixinModal()\"><i style=\"margin: 0;width: 40px;height: 40px;\" class=\"u-icon u-icon-weixin\"></i></a>\r\n            </div>\r\n            <div class=\"page-footer-new-bottom-info-phone\">\r\n                <div></div><div class=\"page-footer-new-rbt\">service@fnji.com</div>\r\n                <div></div><div class=\"page-footer-new-rbt\">marketing@fnji.com</div>\r\n                <div class=\"page-footer-new-rbt\">TEL</div><div>400-641-6399</div>\r\n            </div>\r\n            <div style=\"justify-content: center;\" class=\"d-flex block-nav\">\r\n                <ul class=\"nav flex-column\" :style=\"{'width': $i18n.locale=='en'?'250px':'180px'}\" :class=\"{'page-fo-first-phone':$i18n.locale=='en'&&indexs===0,'page-fo-second-phone':$i18n.locale=='en'&&indexs===2,'page-fo-seconds-phone':$i18n.locale=='en'&&indexs===1}\" v-for=\"(groups,indexs) in footerNew\" :key=\"indexs\">\r\n                    <li :style=\"{'padding-left': isPC?'25px!important':'36px!important'}\" :class=\"indexs===0?'':'page-footer-new-bottom-header-phone'\" class=\"page-footer-new-bottom-link-phone\">\r\n                        <a style=\"color: #4D4D4D;\" :href=\"groups.link | genUrl\" class=\"nav-link page-footer-new-link\">{{groups.name}}</a>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n            <div class=\"page-footer-new-bottom-do-phone\">\r\n                © Fnji Interior design Co,Ltd.Beijing,China 京ICP备13004049号－3\r\n            </div>\r\n        </div>\r\n        <div v-if=\"isPC\" class=\"page-footer-new-bottom\">\r\n            <div class=\"d-flex justify-content-between\">\r\n                <div class=\"d-flex block-nav\">\r\n                    <ul class=\"nav flex-column\" :style=\"{'width': $i18n.locale=='en'?'160px':'150px'}\" :class=\"{'page-fo-first':$i18n.locale=='en'&&index===0,'page-fo-second':$i18n.locale=='en'&&index===2}\" v-for=\"(group,index) in footerNew\" :key=\"index\">\r\n                        <li class=\"nav-header\">\r\n                            <a :href=\"group.link | genUrl\" class=\"nav-link\">{{group.name}}</a>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n                <div style=\"margin-bottom: 20px;\">\r\n                    <a href=\"javascript:\" @click=\"showFnjiWeixinModal()\"><i class=\"u-icon u-icon-weixin\"></i></a>\r\n                    <a href=\"https://weibo.com/fnji\" target=\"_blank\"><i class=\"u-icon u-icon-weibo\"></i></a>\r\n                </div>\r\n            </div>\r\n            <div class=\"d-flex justify-content-between\">\r\n                <div class=\"fs-12 align-self-end\" style=\"font-size: 14px;\">\r\n<!--                    梵几独立家居品牌 © 2017 Fnji Interior design Co. Ltd. Beijing, China 京ICP备13004049号-3-->\r\n                    梵几独立家居品牌 © Fnji Interior design Co,Ltd.Beijing,China 京ICP备13004049号－3\r\n                </div>\r\n                <div class=\"text-right align-self-end\">\r\n                    <div class=\"fs-12\" style=\"font-size: 14px;\">\r\n\r\n                        <span class=\"page-footer-new-rbt\">service@fnji.com</span>\r\n                        <span style=\"margin: 0 10px;\">/</span>\r\n\r\n                        <span class=\"page-footer-new-rbt\">marketing@fnji.com</span>\r\n                        <span class=\"page-footer-new-rbt\" style=\"margin: 0 10px;\">/</span>\r\n                        TEL 400-641-6399\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(67);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-footer-new.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-footer-new.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(2),
    __webpack_require__(4),
    __webpack_require__(1),
    __webpack_require__(69),
    __webpack_require__(11),
    __webpack_require__(70),

    __webpack_require__(71),
    __webpack_require__(85)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Utils,
    Vue,
    $,
    VueLazyload,
    VueI18n,
    VueCustom
){
    Vue.use(VueLazyload, {
        preLoad: 1
    });
    Vue.use(VueI18n);
    Vue.use(VueCustom);

    Vue.prototype.V2 = {cdn:'http://static-test.fnji.com'}
    Vue.prototype.V1 = {cdn:'https://static.fnji.com'}

    $(document).on('click', 'a[href="#"]', function(e){
        e.preventDefault();
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Vue-Lazyload.js v1.2.6
 * (c) 2018 Awe <hilongjw@gmail.com>
 * Released under the MIT License.
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.VueLazyload=e()}(this,function(){"use strict";function t(t){return t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}function e(t){t=t||{};var e=arguments.length,i=0;if(1===e)return t;for(;++i<e;){var o=arguments[i];g(t)&&(t=o),r(o)&&n(t,o)}return t}function n(t,n){m(t,n);for(var o in n)if("__proto__"!==o&&i(n,o)){var a=n[o];r(a)?("undefined"===L(t[o])&&"function"===L(a)&&(t[o]=a),t[o]=e(t[o]||{},a)):t[o]=a}return t}function r(t){return"object"===L(t)||"function"===L(t)}function i(t,e){return Object.prototype.hasOwnProperty.call(t,e)}function o(t,e){if(t.length){var n=t.indexOf(e);return n>-1?t.splice(n,1):void 0}}function a(t,e){for(var n=!1,r=0,i=t.length;r<i;r++)if(e(t[r])){n=!0;break}return n}function s(t,e){if("IMG"===t.tagName&&t.getAttribute("data-srcset")){var n=t.getAttribute("data-srcset"),r=[],i=t.parentNode,o=i.offsetWidth*e,a=void 0,s=void 0,u=void 0;n=n.trim().split(","),n.map(function(t){t=t.trim(),a=t.lastIndexOf(" "),-1===a?(s=t,u=999998):(s=t.substr(0,a),u=parseInt(t.substr(a+1,t.length-a-2),10)),r.push([u,s])}),r.sort(function(t,e){if(t[0]<e[0])return-1;if(t[0]>e[0])return 1;if(t[0]===e[0]){if(-1!==e[1].indexOf(".webp",e[1].length-5))return 1;if(-1!==t[1].indexOf(".webp",t[1].length-5))return-1}return 0});for(var l="",d=void 0,c=r.length,h=0;h<c;h++)if(d=r[h],d[0]>=o){l=d[1];break}return l}}function u(t,e){for(var n=void 0,r=0,i=t.length;r<i;r++)if(e(t[r])){n=t[r];break}return n}function l(){if(!E)return!1;var t=!0,e=document;try{var n=e.createElement("object");n.type="image/webp",n.style.visibility="hidden",n.innerHTML="!",e.body.appendChild(n),t=!n.offsetWidth,e.body.removeChild(n)}catch(e){t=!1}return t}function d(t,e){var n=null,r=0;return function(){if(!n){var i=Date.now()-r,o=this,a=arguments,s=function(){r=Date.now(),n=!1,t.apply(o,a)};i>=e?s():n=setTimeout(s,e)}}}function c(t){return null!==t&&"object"===(void 0===t?"undefined":p(t))}function h(t){if(!(t instanceof Object))return[];if(Object.keys)return Object.keys(t);var e=[];for(var n in t)t.hasOwnProperty(n)&&e.push(n);return e}function f(t){for(var e=t.length,n=[],r=0;r<e;r++)n.push(t[r]);return n}function v(){}var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},b=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},y=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),g=function(t){return null==t||"function"!=typeof t&&"object"!==(void 0===t?"undefined":p(t))},m=function(t,e){if(null===t||void 0===t)throw new TypeError("expected first argument to be an object.");if(void 0===e||"undefined"==typeof Symbol)return t;if("function"!=typeof Object.getOwnPropertySymbols)return t;for(var n=Object.prototype.propertyIsEnumerable,r=Object(t),i=arguments.length,o=0;++o<i;)for(var a=Object(arguments[o]),s=Object.getOwnPropertySymbols(a),u=0;u<s.length;u++){var l=s[u];n.call(a,l)&&(r[l]=a[l])}return r},w=Object.prototype.toString,L=function(e){var n=void 0===e?"undefined":p(e);return"undefined"===n?"undefined":null===e?"null":!0===e||!1===e||e instanceof Boolean?"boolean":"string"===n||e instanceof String?"string":"number"===n||e instanceof Number?"number":"function"===n||e instanceof Function?void 0!==e.constructor.name&&"Generator"===e.constructor.name.slice(0,9)?"generatorfunction":"function":void 0!==Array.isArray&&Array.isArray(e)?"array":e instanceof RegExp?"regexp":e instanceof Date?"date":(n=w.call(e),"[object RegExp]"===n?"regexp":"[object Date]"===n?"date":"[object Arguments]"===n?"arguments":"[object Error]"===n?"error":"[object Promise]"===n?"promise":t(e)?"buffer":"[object Set]"===n?"set":"[object WeakSet]"===n?"weakset":"[object Map]"===n?"map":"[object WeakMap]"===n?"weakmap":"[object Symbol]"===n?"symbol":"[object Map Iterator]"===n?"mapiterator":"[object Set Iterator]"===n?"setiterator":"[object String Iterator]"===n?"stringiterator":"[object Array Iterator]"===n?"arrayiterator":"[object Int8Array]"===n?"int8array":"[object Uint8Array]"===n?"uint8array":"[object Uint8ClampedArray]"===n?"uint8clampedarray":"[object Int16Array]"===n?"int16array":"[object Uint16Array]"===n?"uint16array":"[object Int32Array]"===n?"int32array":"[object Uint32Array]"===n?"uint32array":"[object Float32Array]"===n?"float32array":"[object Float64Array]"===n?"float64array":"object")},_=e,E="undefined"!=typeof window,A=E&&"IntersectionObserver"in window,k={event:"event",observer:"observer"},z=function(){function t(t,e){e=e||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(t,e.bubbles,e.cancelable,e.detail),n}if(E)return"function"==typeof window.CustomEvent?window.CustomEvent:(t.prototype=window.Event.prototype,t)}(),j=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return E?window.devicePixelRatio||t:t},T=function(){if(E){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("test",null,e)}catch(t){}return t}}(),S={on:function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];T?t.addEventListener(e,n,{capture:r,passive:!0}):t.addEventListener(e,n,r)},off:function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];t.removeEventListener(e,n,r)}},I=function(t,e,n){var r=new Image;r.src=t.src,r.onload=function(){e({naturalHeight:r.naturalHeight,naturalWidth:r.naturalWidth,src:r.src})},r.onerror=function(t){n(t)}},O=function(t,e){return"undefined"!=typeof getComputedStyle?getComputedStyle(t,null).getPropertyValue(e):t.style[e]},$=function(t){return O(t,"overflow")+O(t,"overflow-y")+O(t,"overflow-x")},x=function(t){if(E){if(!(t instanceof HTMLElement))return window;for(var e=t;e&&e!==document.body&&e!==document.documentElement&&e.parentNode;){if(/(scroll|auto)/.test($(e)))return e;e=e.parentNode}return window}},H={},Q=function(){function t(e){var n=e.el,r=e.src,i=e.error,o=e.loading,a=e.bindType,s=e.$parent,u=e.options,l=e.elRenderer;b(this,t),this.el=n,this.src=r,this.error=i,this.loading=o,this.bindType=a,this.attempt=0,this.naturalHeight=0,this.naturalWidth=0,this.options=u,this.rect=null,this.$parent=s,this.elRenderer=l,this.performanceData={init:Date.now(),loadStart:0,loadEnd:0},this.filter(),this.initState(),this.render("loading",!1)}return y(t,[{key:"initState",value:function(){"dataset"in this.el?this.el.dataset.src=this.src:this.el.setAttribute("data-src",this.src),this.state={error:!1,loaded:!1,rendered:!1}}},{key:"record",value:function(t){this.performanceData[t]=Date.now()}},{key:"update",value:function(t){var e=t.src,n=t.loading,r=t.error,i=this.src;this.src=e,this.loading=n,this.error=r,this.filter(),i!==this.src&&(this.attempt=0,this.initState())}},{key:"getRect",value:function(){this.rect=this.el.getBoundingClientRect()}},{key:"checkInView",value:function(){return this.getRect(),this.rect.top<window.innerHeight*this.options.preLoad&&this.rect.bottom>this.options.preLoadTop&&this.rect.left<window.innerWidth*this.options.preLoad&&this.rect.right>0}},{key:"filter",value:function(){var t=this;h(this.options.filter).map(function(e){t.options.filter[e](t,t.options)})}},{key:"renderLoading",value:function(t){var e=this;I({src:this.loading},function(n){e.render("loading",!1),t()},function(){t(),e.options.silent||console.warn("VueLazyload log: load failed with loading image("+e.loading+")")})}},{key:"load",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v;return this.attempt>this.options.attempt-1&&this.state.error?(this.options.silent||console.log("VueLazyload log: "+this.src+" tried too more than "+this.options.attempt+" times"),void e()):this.state.loaded||H[this.src]?(this.state.loaded=!0,e(),this.render("loaded",!0)):void this.renderLoading(function(){t.attempt++,t.record("loadStart"),I({src:t.src},function(n){t.naturalHeight=n.naturalHeight,t.naturalWidth=n.naturalWidth,t.state.loaded=!0,t.state.error=!1,t.record("loadEnd"),t.render("loaded",!1),H[t.src]=1,e()},function(e){!t.options.silent&&console.error(e),t.state.error=!0,t.state.loaded=!1,t.render("error",!1)})})}},{key:"render",value:function(t,e){this.elRenderer(this,t,e)}},{key:"performance",value:function(){var t="loading",e=0;return this.state.loaded&&(t="loaded",e=(this.performanceData.loadEnd-this.performanceData.loadStart)/1e3),this.state.error&&(t="error"),{src:this.src,state:t,time:e}}},{key:"destroy",value:function(){this.el=null,this.src=null,this.error=null,this.loading=null,this.bindType=null,this.attempt=0}}]),t}(),C="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",R=["scroll","wheel","mousewheel","resize","animationend","transitionend","touchmove"],W={rootMargin:"0px",threshold:0},B=function(t){return function(){function e(t){var n=t.preLoad,r=t.error,i=t.throttleWait,o=t.preLoadTop,a=t.dispatchEvent,s=t.loading,u=t.attempt,c=t.silent,h=void 0===c||c,f=t.scale,v=t.listenEvents,p=(t.hasbind,t.filter),y=t.adapter,g=t.observer,m=t.observerOptions;b(this,e),this.version="1.2.6",this.mode=k.event,this.ListenerQueue=[],this.TargetIndex=0,this.TargetQueue=[],this.options={silent:h,dispatchEvent:!!a,throttleWait:i||200,preLoad:n||1.3,preLoadTop:o||0,error:r||C,loading:s||C,attempt:u||3,scale:f||j(f),ListenEvents:v||R,hasbind:!1,supportWebp:l(),filter:p||{},adapter:y||{},observer:!!g,observerOptions:m||W},this._initEvent(),this.lazyLoadHandler=d(this._lazyLoadHandler.bind(this),this.options.throttleWait),this.setMode(this.options.observer?k.observer:k.event)}return y(e,[{key:"config",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};_(this.options,t)}},{key:"performance",value:function(){var t=[];return this.ListenerQueue.map(function(e){t.push(e.performance())}),t}},{key:"addLazyBox",value:function(t){this.ListenerQueue.push(t),E&&(this._addListenerTarget(window),this._observer&&this._observer.observe(t.el),t.$el&&t.$el.parentNode&&this._addListenerTarget(t.$el.parentNode))}},{key:"add",value:function(e,n,r){var i=this;if(a(this.ListenerQueue,function(t){return t.el===e}))return this.update(e,n),t.nextTick(this.lazyLoadHandler);var o=this._valueFormatter(n.value),u=o.src,l=o.loading,d=o.error;t.nextTick(function(){u=s(e,i.options.scale)||u,i._observer&&i._observer.observe(e);var o=Object.keys(n.modifiers)[0],a=void 0;o&&(a=r.context.$refs[o],a=a?a.$el||a:document.getElementById(o)),a||(a=x(e));var c=new Q({bindType:n.arg,$parent:a,el:e,loading:l,error:d,src:u,elRenderer:i._elRenderer.bind(i),options:i.options});i.ListenerQueue.push(c),E&&(i._addListenerTarget(window),i._addListenerTarget(a)),i.lazyLoadHandler(),t.nextTick(function(){return i.lazyLoadHandler()})})}},{key:"update",value:function(e,n){var r=this,i=this._valueFormatter(n.value),o=i.src,a=i.loading,l=i.error;o=s(e,this.options.scale)||o;var d=u(this.ListenerQueue,function(t){return t.el===e});d&&d.update({src:o,loading:a,error:l}),this._observer&&(this._observer.unobserve(e),this._observer.observe(e)),this.lazyLoadHandler(),t.nextTick(function(){return r.lazyLoadHandler()})}},{key:"remove",value:function(t){if(t){this._observer&&this._observer.unobserve(t);var e=u(this.ListenerQueue,function(e){return e.el===t});e&&(this._removeListenerTarget(e.$parent),this._removeListenerTarget(window),o(this.ListenerQueue,e)&&e.destroy())}}},{key:"removeComponent",value:function(t){t&&(o(this.ListenerQueue,t),this._observer&&this._observer.unobserve(t.el),t.$parent&&t.$el.parentNode&&this._removeListenerTarget(t.$el.parentNode),this._removeListenerTarget(window))}},{key:"setMode",value:function(t){var e=this;A||t!==k.observer||(t=k.event),this.mode=t,t===k.event?(this._observer&&(this.ListenerQueue.forEach(function(t){e._observer.unobserve(t.el)}),this._observer=null),this.TargetQueue.forEach(function(t){e._initListen(t.el,!0)})):(this.TargetQueue.forEach(function(t){e._initListen(t.el,!1)}),this._initIntersectionObserver())}},{key:"_addListenerTarget",value:function(t){if(t){var e=u(this.TargetQueue,function(e){return e.el===t});return e?e.childrenCount++:(e={el:t,id:++this.TargetIndex,childrenCount:1,listened:!0},this.mode===k.event&&this._initListen(e.el,!0),this.TargetQueue.push(e)),this.TargetIndex}}},{key:"_removeListenerTarget",value:function(t){var e=this;this.TargetQueue.forEach(function(n,r){n.el===t&&(--n.childrenCount||(e._initListen(n.el,!1),e.TargetQueue.splice(r,1),n=null))})}},{key:"_initListen",value:function(t,e){var n=this;this.options.ListenEvents.forEach(function(r){return S[e?"on":"off"](t,r,n.lazyLoadHandler)})}},{key:"_initEvent",value:function(){var t=this;this.Event={listeners:{loading:[],loaded:[],error:[]}},this.$on=function(e,n){t.Event.listeners[e]||(t.Event.listeners[e]=[]),t.Event.listeners[e].push(n)},this.$once=function(e,n){function r(){i.$off(e,r),n.apply(i,arguments)}var i=t;t.$on(e,r)},this.$off=function(e,n){if(!n){if(!t.Event.listeners[e])return;return void(t.Event.listeners[e].length=0)}o(t.Event.listeners[e],n)},this.$emit=function(e,n,r){t.Event.listeners[e]&&t.Event.listeners[e].forEach(function(t){return t(n,r)})}}},{key:"_lazyLoadHandler",value:function(){var t=this,e=[];this.ListenerQueue.forEach(function(t,n){if(!t.state.error&&t.state.loaded)return e.push(t);t.checkInView()&&t.load()}),e.forEach(function(e){return o(t.ListenerQueue,e)})}},{key:"_initIntersectionObserver",value:function(){var t=this;A&&(this._observer=new IntersectionObserver(this._observerHandler.bind(this),this.options.observerOptions),this.ListenerQueue.length&&this.ListenerQueue.forEach(function(e){t._observer.observe(e.el)}))}},{key:"_observerHandler",value:function(t,e){var n=this;t.forEach(function(t){t.isIntersecting&&n.ListenerQueue.forEach(function(e){if(e.el===t.target){if(e.state.loaded)return n._observer.unobserve(e.el);e.load()}})})}},{key:"_elRenderer",value:function(t,e,n){if(t.el){var r=t.el,i=t.bindType,o=void 0;switch(e){case"loading":o=t.loading;break;case"error":o=t.error;break;default:o=t.src}if(i?r.style[i]='url("'+o+'")':r.getAttribute("src")!==o&&r.setAttribute("src",o),r.setAttribute("lazy",e),this.$emit(e,t,n),this.options.adapter[e]&&this.options.adapter[e](t,this.options),this.options.dispatchEvent){var a=new z(e,{detail:t});r.dispatchEvent(a)}}}},{key:"_valueFormatter",value:function(t){var e=t,n=this.options.loading,r=this.options.error;return c(t)&&(t.src||this.options.silent||console.error("Vue Lazyload warning: miss src with "+t),e=t.src,n=t.loading||this.options.loading,r=t.error||this.options.error),{src:e,loading:n,error:r}}}]),e}()},D=function(t){return{props:{tag:{type:String,default:"div"}},render:function(t){return!1===this.show?t(this.tag):t(this.tag,null,this.$slots.default)},data:function(){return{el:null,state:{loaded:!1},rect:{},show:!1}},mounted:function(){this.el=this.$el,t.addLazyBox(this),t.lazyLoadHandler()},beforeDestroy:function(){t.removeComponent(this)},methods:{getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),E&&this.rect.top<window.innerHeight*t.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*t.options.preLoad&&this.rect.right>0},load:function(){this.show=!0,this.state.loaded=!0,this.$emit("show",this)}}}},V=function(){function t(e){var n=e.lazy;b(this,t),this.lazy=n,n.lazyContainerMananger=this,this._queue=[]}return y(t,[{key:"bind",value:function(t,e,n){var r=new N({el:t,binding:e,vnode:n,lazy:this.lazy});this._queue.push(r)}},{key:"update",value:function(t,e,n){var r=u(this._queue,function(e){return e.el===t});r&&r.update({el:t,binding:e,vnode:n})}},{key:"unbind",value:function(t,e,n){var r=u(this._queue,function(e){return e.el===t});r&&(r.clear(),o(this._queue,r))}}]),t}(),M={selector:"img"},N=function(){function t(e){var n=e.el,r=e.binding,i=e.vnode,o=e.lazy;b(this,t),this.el=null,this.vnode=i,this.binding=r,this.options={},this.lazy=o,this._queue=[],this.update({el:n,binding:r})}return y(t,[{key:"update",value:function(t){var e=this,n=t.el,r=t.binding;this.el=n,this.options=_({},M,r.value),this.getImgs().forEach(function(t){e.lazy.add(t,_({},e.binding,{value:{src:"dataset"in t?t.dataset.src:t.getAttribute("data-src"),error:"dataset"in t?t.dataset.error:t.getAttribute("data-error"),loading:"dataset"in t?t.dataset.loading:t.getAttribute("data-loading")}}),e.vnode)})}},{key:"getImgs",value:function(){return f(this.el.querySelectorAll(this.options.selector))}},{key:"clear",value:function(){var t=this;this.getImgs().forEach(function(e){return t.lazy.remove(e)}),this.vnode=null,this.binding=null,this.lazy=null}}]),t}(),P=function(t){return{props:{src:[String,Object],tag:{type:String,default:"img"}},render:function(t){return t(this.tag,{attrs:{src:this.renderSrc}},this.$slots.default)},data:function(){return{el:null,options:{src:"",error:"",loading:"",attempt:t.options.attempt},state:{loaded:!1,error:!1,attempt:0},rect:{},renderSrc:""}},watch:{src:function(){this.init(),t.addLazyBox(this),t.lazyLoadHandler()}},created:function(){this.init(),this.renderSrc=this.options.loading},mounted:function(){this.el=this.$el,t.addLazyBox(this),t.lazyLoadHandler()},beforeDestroy:function(){t.removeComponent(this)},methods:{init:function(){var e=t._valueFormatter(this.src),n=e.src,r=e.loading,i=e.error;this.state.loaded=!1,this.options.src=n,this.options.error=i,this.options.loading=r,this.renderSrc=this.options.loading},getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),E&&this.rect.top<window.innerHeight*t.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*t.options.preLoad&&this.rect.right>0},load:function(){var e=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v;if(this.state.attempt>this.options.attempt-1&&this.state.error)return t.options.silent||console.log("VueLazyload log: "+this.options.src+" tried too more than "+this.options.attempt+" times"),void n();var r=this.options.src;I({src:r},function(t){var n=t.src;e.renderSrc=n,e.state.loaded=!0},function(t){e.state.attempt++,e.renderSrc=e.options.error,e.state.error=!0})}}}};return{install:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=B(t),r=new n(e),i=new V({lazy:r}),o="2"===t.version.split(".")[0];t.prototype.$Lazyload=r,e.lazyComponent&&t.component("lazy-component",D(r)),e.lazyImage&&t.component("lazy-image",P(r)),o?(t.directive("lazy",{bind:r.add.bind(r),update:r.update.bind(r),componentUpdated:r.lazyLoadHandler.bind(r),unbind:r.remove.bind(r)}),t.directive("lazy-container",{bind:i.bind.bind(i),update:i.update.bind(i),unbind:i.unbind.bind(i)})):(t.directive("lazy",{bind:r.lazyLoadHandler.bind(r),update:function(t,e){_(this.vm.$refs,this.vm.$els),r.add(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:t,oldValue:e},{context:this.vm})},unbind:function(){r.remove(this.el)}}),t.directive("lazy-container",{update:function(t,e){i.update(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:t,oldValue:e},{context:this.vm})},unbind:function(){i.unbind(this.el)}}))}}});


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(2)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Utils
){
    return {
        install: function(Vue, options){
            Vue.mixin({
                methods: {
                    fnjiImage: Utils.genFnjiImageUrl,
                    cdnImage: Utils.genCdnImageUrl
                },
                filters: {
                    fnjiImage: Utils.genFnjiImageUrl,
                    cdnImage: Utils.genCdnImageUrl,
                    cdnImageOrg: Utils.genCdnImageUrlOrg,
                    pageLink: Utils.genPageLink,
                    genUrl: Utils.genPageLink
                }
            });
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(72),
    __webpack_require__(4),
    __webpack_require__(1),
    __webpack_require__(2),
    __webpack_require__(73),
    __webpack_require__(77),

    __webpack_require__(83)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    Vue,
    $,
    Utils,
    TalkBtn,
    ShareBtn
){
    var $overlay = $('<div/>').appendTo('body');

    return new Vue({
        el: $overlay[0],
        template: tpl,
        components: {
            TalkBtn: TalkBtn,
            ShareBtn: ShareBtn
        },
        data: {
            isBottomBtnShow: true,
            isTopBtnShow: false,
            shareBtnData: null
        },
        methods: {
            initTopBtn: function(){
                var $window = $(window);
                var height = $window.height();
                var _this = this;

                $window.on('scroll resize', function(){
                    var scrollTop = $window.scrollTop();
                    _this.isTopBtnShow = scrollTop > height;
                });
            },
            scrollToTop: function(){
                Utils.scrollTo(0);
            },
            setShareBtnData: function(obj){
                this.shareBtnData = obj;
            },
            scrollToBottom: function () {
                var $windows = $(window);
                var heights = $windows.height();
                var bodyHeight = document.body.scrollHeight;
                var scrollHeight = bodyHeight - heights;
                Utils.scrollTo(scrollHeight)
            }
        },
        mounted: function(){
            this.initTopBtn();
        }
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fixed-menu\">\r\n    <share-btn class=\"icon\" :item=\"shareBtnData\"></share-btn>\r\n<!--    <talk-btn class=\"icon\"></talk-btn>-->\r\n    <div class=\"icon icon-top\" v-show=\"isTopBtnShow\" @click=\"scrollToTop()\">\r\n        <i class=\"u-icon u-icon-top\"></i>\r\n    </div>\r\n    <div class=\"icon icon-top\" @click=\"scrollToBottom()\">\r\n        <i class=\"u-icon u-icon-bottom\"></i>\r\n    </div>\r\n</div>"

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(74),
    __webpack_require__(1),
    __webpack_require__(13),
    __webpack_require__(3),
    __webpack_require__(2),
    __webpack_require__(10),

    __webpack_require__(15),
    __webpack_require__(75)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    $,
    AuthMixin,
    _,
    Utils,
    Modal
){
    var chatOrigin = '//talk.fnji.com';
    var hidePages = [
        '/fnjihome',
        '/fnjidrop',
        '/fnjiartist',
        '/fnjiad',
        '/fnjithings'
    ];
    hidePages = _.map(hidePages, Utils.genPageLink);

    return {
        template: tpl,
        mixins: [AuthMixin],
        data: function(){
            return {
                chatOrigin: chatOrigin,
                hidePages: hidePages,
                isShow: false,
                hashKey: 'showChat'
            };
        },
        computed: {
            chatJsUrl: function(){
                return this.chatOrigin + '/php/app.php?widget-init.js';
            },
            hasNewMessageUrl: function(){
                return this.chatOrigin + '/php/app.php?guest-has-unread-message';
            },
            isHidePage: function(){
                var pathname = location.pathname;
                return _.some(this.hidePages, function(o){
                    return pathname.indexOf(o) === 0;
                });
            }
        },
        methods: {
            init: function(){
                if (this.isHidePage) return;
                var _this = this;
                $.getScript(_this.chatJsUrl)
                    .done(function(){
                        if (!window.phpLiveChat) {
                            return onError();
                        }
                        _this.isShow = true;
                        _this.checkShowChatHash();
                    })
                    .fail(onError);

                function onError(){
                    console.warn('Load Chat JS Error');
                }
            },
            toggle: function(){
                if (!window.phpLiveChat) return;
                if (!this.isLoggedIn){
                    var obj = {};
                    obj[this.hashKey] = 1;
                    var from = $.param.fragment(location.href, obj);
                    Modal.showMemberLoginModal(from);
                } else {
                    window.phpLiveChat.toggle();
                }
            },
            checkShowChatHash: function(){
                var hashObj = $.deparam.fragment();
                var key = this.hashKey;
                if (hashObj[key]) {
                    delete hashObj[key];
                    var url = $.param.fragment(location.pathname+location.search, hashObj);
                    location.replace(url);
                    this.toggle();
                }
            }
        },
        mounted: function(){
            this.init();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-talk-btn\" v-if=\"isShow\" @click=\"toggle()\">\r\n    <i class=\"u-icon u-icon-talk\"></i>\r\n</div>"

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(76);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./talk-btn.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./talk-btn.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(78),
    __webpack_require__(1),
    __webpack_require__(79),

    __webpack_require__(15),
    __webpack_require__(81)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    $,
    Qrcode
){
    return {
        template: tpl,
        props: {
            item: {
                type: Object
            }
        },
        components: {
            Qrcode: Qrcode
        },
        computed: {
            twitterUrl: function(){
                var url = 'https://www.tumblr.com/widgets/share/tool';
                var query = {
                    canonicalUrl: this.item.url,
                    posttype: 'phone',
                    title: this.item.title,
                    content: this.item.pic
                };
                return $.param.querystring(url, query);
            },
            pinterestUrl: function(){
                var url = 'http://pinterest.com/pin/create/button/';
                var query = {
                    url: this.item.url,
                    media: this.item.pic
                };
                return $.param.querystring(url, query);
            },
            weiboUrl: function(){
                var url = 'http://service.weibo.com/share/share.php';
                var query = {
                    url: this.item.url,
                    title: this.item.title,
                    pic: this.item.pic
                };
                return $.param.querystring(url, query);
            },
            url: function(){
                return this.item.url || window.location.href;
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-share-btn\" v-if=\"item\">\r\n    <div class=\"control-btn\">\r\n        <i class=\"u-icon u-icon-share\"></i>\r\n    </div>\r\n    <div class=\"popover\">\r\n        <ul class=\"nav\">\r\n            <li class=\"nav-item\">\r\n                <a :href=\"weiboUrl\" target=\"_blank\" class=\"nav-link\">\r\n                    <i class=\"u-icon u-icon-weibo\"></i>\r\n                </a>\r\n            </li>\r\n            <li class=\"nav-item nav-item-weixin\">\r\n                <a href=\"javascript:\" target=\"_blank\" class=\"nav-link\">\r\n                    <i class=\"u-icon u-icon-weixin\"></i>\r\n                </a>\r\n                <div class=\"weixin-qrcode\">\r\n                    <div class=\"qrcode\">\r\n                        <qrcode :url=\"url\"></qrcode>\r\n                    </div>\r\n                    <div class=\"title\">微信扫一扫 分享</div>\r\n                </div>\r\n            </li>\r\n            <li class=\"nav-item\">\r\n                <a :href=\"pinterestUrl\" target=\"_blank\" class=\"nav-link\">\r\n                    <i class=\"u-icon u-icon-pinterest\"></i>\r\n                </a>\r\n            </li>\r\n            <li class=\"nav-item\" style=\"display: none;\">\r\n                <a :href=\"twitterUrl\" target=\"_blank\" class=\"nav-link\">\r\n                    <i class=\"u-icon u-icon-twitter\"></i>\r\n                </a>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</div>"

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),

    __webpack_require__(80)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $
){
    return {
        template: '<span class="u-qrcode"></span>',
        props: {
            url: {
                type: String
            }
        },
        watch: {
            url: 'updateQrcode'
        },
        methods: {
            updateQrcode: function(){
                $(this.$el).empty().qrcode({
                    width: 100,
                    height: 100,
                    text: this.url
                });
            }
        },
        mounted: function(){
            this.updateQrcode();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 80 */
/***/ (function(module, exports) {

(function(r){r.fn.qrcode=function(h){var s;function u(a){this.mode=s;this.data=a}function o(a,c){this.typeNumber=a;this.errorCorrectLevel=c;this.modules=null;this.moduleCount=0;this.dataCache=null;this.dataList=[]}function q(a,c){if(void 0==a.length)throw Error(a.length+"/"+c);for(var d=0;d<a.length&&0==a[d];)d++;this.num=Array(a.length-d+c);for(var b=0;b<a.length-d;b++)this.num[b]=a[b+d]}function p(a,c){this.totalCount=a;this.dataCount=c}function t(){this.buffer=[];this.length=0}u.prototype={getLength:function(){return this.data.length},
write:function(a){for(var c=0;c<this.data.length;c++)a.put(this.data.charCodeAt(c),8)}};o.prototype={addData:function(a){this.dataList.push(new u(a));this.dataCache=null},isDark:function(a,c){if(0>a||this.moduleCount<=a||0>c||this.moduleCount<=c)throw Error(a+","+c);return this.modules[a][c]},getModuleCount:function(){return this.moduleCount},make:function(){if(1>this.typeNumber){for(var a=1,a=1;40>a;a++){for(var c=p.getRSBlocks(a,this.errorCorrectLevel),d=new t,b=0,e=0;e<c.length;e++)b+=c[e].dataCount;
for(e=0;e<this.dataList.length;e++)c=this.dataList[e],d.put(c.mode,4),d.put(c.getLength(),j.getLengthInBits(c.mode,a)),c.write(d);if(d.getLengthInBits()<=8*b)break}this.typeNumber=a}this.makeImpl(!1,this.getBestMaskPattern())},makeImpl:function(a,c){this.moduleCount=4*this.typeNumber+17;this.modules=Array(this.moduleCount);for(var d=0;d<this.moduleCount;d++){this.modules[d]=Array(this.moduleCount);for(var b=0;b<this.moduleCount;b++)this.modules[d][b]=null}this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-
7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(a,c);7<=this.typeNumber&&this.setupTypeNumber(a);null==this.dataCache&&(this.dataCache=o.createData(this.typeNumber,this.errorCorrectLevel,this.dataList));this.mapData(this.dataCache,c)},setupPositionProbePattern:function(a,c){for(var d=-1;7>=d;d++)if(!(-1>=a+d||this.moduleCount<=a+d))for(var b=-1;7>=b;b++)-1>=c+b||this.moduleCount<=c+b||(this.modules[a+d][c+b]=
0<=d&&6>=d&&(0==b||6==b)||0<=b&&6>=b&&(0==d||6==d)||2<=d&&4>=d&&2<=b&&4>=b?!0:!1)},getBestMaskPattern:function(){for(var a=0,c=0,d=0;8>d;d++){this.makeImpl(!0,d);var b=j.getLostPoint(this);if(0==d||a>b)a=b,c=d}return c},createMovieClip:function(a,c,d){a=a.createEmptyMovieClip(c,d);this.make();for(c=0;c<this.modules.length;c++)for(var d=1*c,b=0;b<this.modules[c].length;b++){var e=1*b;this.modules[c][b]&&(a.beginFill(0,100),a.moveTo(e,d),a.lineTo(e+1,d),a.lineTo(e+1,d+1),a.lineTo(e,d+1),a.endFill())}return a},
setupTimingPattern:function(){for(var a=8;a<this.moduleCount-8;a++)null==this.modules[a][6]&&(this.modules[a][6]=0==a%2);for(a=8;a<this.moduleCount-8;a++)null==this.modules[6][a]&&(this.modules[6][a]=0==a%2)},setupPositionAdjustPattern:function(){for(var a=j.getPatternPosition(this.typeNumber),c=0;c<a.length;c++)for(var d=0;d<a.length;d++){var b=a[c],e=a[d];if(null==this.modules[b][e])for(var f=-2;2>=f;f++)for(var i=-2;2>=i;i++)this.modules[b+f][e+i]=-2==f||2==f||-2==i||2==i||0==f&&0==i?!0:!1}},setupTypeNumber:function(a){for(var c=
j.getBCHTypeNumber(this.typeNumber),d=0;18>d;d++){var b=!a&&1==(c>>d&1);this.modules[Math.floor(d/3)][d%3+this.moduleCount-8-3]=b}for(d=0;18>d;d++)b=!a&&1==(c>>d&1),this.modules[d%3+this.moduleCount-8-3][Math.floor(d/3)]=b},setupTypeInfo:function(a,c){for(var d=j.getBCHTypeInfo(this.errorCorrectLevel<<3|c),b=0;15>b;b++){var e=!a&&1==(d>>b&1);6>b?this.modules[b][8]=e:8>b?this.modules[b+1][8]=e:this.modules[this.moduleCount-15+b][8]=e}for(b=0;15>b;b++)e=!a&&1==(d>>b&1),8>b?this.modules[8][this.moduleCount-
b-1]=e:9>b?this.modules[8][15-b-1+1]=e:this.modules[8][15-b-1]=e;this.modules[this.moduleCount-8][8]=!a},mapData:function(a,c){for(var d=-1,b=this.moduleCount-1,e=7,f=0,i=this.moduleCount-1;0<i;i-=2)for(6==i&&i--;;){for(var g=0;2>g;g++)if(null==this.modules[b][i-g]){var n=!1;f<a.length&&(n=1==(a[f]>>>e&1));j.getMask(c,b,i-g)&&(n=!n);this.modules[b][i-g]=n;e--; -1==e&&(f++,e=7)}b+=d;if(0>b||this.moduleCount<=b){b-=d;d=-d;break}}}};o.PAD0=236;o.PAD1=17;o.createData=function(a,c,d){for(var c=p.getRSBlocks(a,
c),b=new t,e=0;e<d.length;e++){var f=d[e];b.put(f.mode,4);b.put(f.getLength(),j.getLengthInBits(f.mode,a));f.write(b)}for(e=a=0;e<c.length;e++)a+=c[e].dataCount;if(b.getLengthInBits()>8*a)throw Error("code length overflow. ("+b.getLengthInBits()+">"+8*a+")");for(b.getLengthInBits()+4<=8*a&&b.put(0,4);0!=b.getLengthInBits()%8;)b.putBit(!1);for(;!(b.getLengthInBits()>=8*a);){b.put(o.PAD0,8);if(b.getLengthInBits()>=8*a)break;b.put(o.PAD1,8)}return o.createBytes(b,c)};o.createBytes=function(a,c){for(var d=
0,b=0,e=0,f=Array(c.length),i=Array(c.length),g=0;g<c.length;g++){var n=c[g].dataCount,h=c[g].totalCount-n,b=Math.max(b,n),e=Math.max(e,h);f[g]=Array(n);for(var k=0;k<f[g].length;k++)f[g][k]=255&a.buffer[k+d];d+=n;k=j.getErrorCorrectPolynomial(h);n=(new q(f[g],k.getLength()-1)).mod(k);i[g]=Array(k.getLength()-1);for(k=0;k<i[g].length;k++)h=k+n.getLength()-i[g].length,i[g][k]=0<=h?n.get(h):0}for(k=g=0;k<c.length;k++)g+=c[k].totalCount;d=Array(g);for(k=n=0;k<b;k++)for(g=0;g<c.length;g++)k<f[g].length&&
(d[n++]=f[g][k]);for(k=0;k<e;k++)for(g=0;g<c.length;g++)k<i[g].length&&(d[n++]=i[g][k]);return d};s=4;for(var j={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,
78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:1335,G18:7973,G15_MASK:21522,getBCHTypeInfo:function(a){for(var c=a<<10;0<=j.getBCHDigit(c)-j.getBCHDigit(j.G15);)c^=j.G15<<j.getBCHDigit(c)-j.getBCHDigit(j.G15);return(a<<10|c)^j.G15_MASK},getBCHTypeNumber:function(a){for(var c=a<<12;0<=j.getBCHDigit(c)-
j.getBCHDigit(j.G18);)c^=j.G18<<j.getBCHDigit(c)-j.getBCHDigit(j.G18);return a<<12|c},getBCHDigit:function(a){for(var c=0;0!=a;)c++,a>>>=1;return c},getPatternPosition:function(a){return j.PATTERN_POSITION_TABLE[a-1]},getMask:function(a,c,d){switch(a){case 0:return 0==(c+d)%2;case 1:return 0==c%2;case 2:return 0==d%3;case 3:return 0==(c+d)%3;case 4:return 0==(Math.floor(c/2)+Math.floor(d/3))%2;case 5:return 0==c*d%2+c*d%3;case 6:return 0==(c*d%2+c*d%3)%2;case 7:return 0==(c*d%3+(c+d)%2)%2;default:throw Error("bad maskPattern:"+
a);}},getErrorCorrectPolynomial:function(a){for(var c=new q([1],0),d=0;d<a;d++)c=c.multiply(new q([1,l.gexp(d)],0));return c},getLengthInBits:function(a,c){if(1<=c&&10>c)switch(a){case 1:return 10;case 2:return 9;case s:return 8;case 8:return 8;default:throw Error("mode:"+a);}else if(27>c)switch(a){case 1:return 12;case 2:return 11;case s:return 16;case 8:return 10;default:throw Error("mode:"+a);}else if(41>c)switch(a){case 1:return 14;case 2:return 13;case s:return 16;case 8:return 12;default:throw Error("mode:"+
a);}else throw Error("type:"+c);},getLostPoint:function(a){for(var c=a.getModuleCount(),d=0,b=0;b<c;b++)for(var e=0;e<c;e++){for(var f=0,i=a.isDark(b,e),g=-1;1>=g;g++)if(!(0>b+g||c<=b+g))for(var h=-1;1>=h;h++)0>e+h||c<=e+h||0==g&&0==h||i==a.isDark(b+g,e+h)&&f++;5<f&&(d+=3+f-5)}for(b=0;b<c-1;b++)for(e=0;e<c-1;e++)if(f=0,a.isDark(b,e)&&f++,a.isDark(b+1,e)&&f++,a.isDark(b,e+1)&&f++,a.isDark(b+1,e+1)&&f++,0==f||4==f)d+=3;for(b=0;b<c;b++)for(e=0;e<c-6;e++)a.isDark(b,e)&&!a.isDark(b,e+1)&&a.isDark(b,e+
2)&&a.isDark(b,e+3)&&a.isDark(b,e+4)&&!a.isDark(b,e+5)&&a.isDark(b,e+6)&&(d+=40);for(e=0;e<c;e++)for(b=0;b<c-6;b++)a.isDark(b,e)&&!a.isDark(b+1,e)&&a.isDark(b+2,e)&&a.isDark(b+3,e)&&a.isDark(b+4,e)&&!a.isDark(b+5,e)&&a.isDark(b+6,e)&&(d+=40);for(e=f=0;e<c;e++)for(b=0;b<c;b++)a.isDark(b,e)&&f++;a=Math.abs(100*f/c/c-50)/5;return d+10*a}},l={glog:function(a){if(1>a)throw Error("glog("+a+")");return l.LOG_TABLE[a]},gexp:function(a){for(;0>a;)a+=255;for(;256<=a;)a-=255;return l.EXP_TABLE[a]},EXP_TABLE:Array(256),
LOG_TABLE:Array(256)},m=0;8>m;m++)l.EXP_TABLE[m]=1<<m;for(m=8;256>m;m++)l.EXP_TABLE[m]=l.EXP_TABLE[m-4]^l.EXP_TABLE[m-5]^l.EXP_TABLE[m-6]^l.EXP_TABLE[m-8];for(m=0;255>m;m++)l.LOG_TABLE[l.EXP_TABLE[m]]=m;q.prototype={get:function(a){return this.num[a]},getLength:function(){return this.num.length},multiply:function(a){for(var c=Array(this.getLength()+a.getLength()-1),d=0;d<this.getLength();d++)for(var b=0;b<a.getLength();b++)c[d+b]^=l.gexp(l.glog(this.get(d))+l.glog(a.get(b)));return new q(c,0)},mod:function(a){if(0>
this.getLength()-a.getLength())return this;for(var c=l.glog(this.get(0))-l.glog(a.get(0)),d=Array(this.getLength()),b=0;b<this.getLength();b++)d[b]=this.get(b);for(b=0;b<a.getLength();b++)d[b]^=l.gexp(l.glog(a.get(b))+c);return(new q(d,0)).mod(a)}};p.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],
[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,
116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,
43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,
3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,
55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,
45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];p.getRSBlocks=function(a,c){var d=p.getRsBlockTable(a,c);if(void 0==d)throw Error("bad rs block @ typeNumber:"+a+"/errorCorrectLevel:"+c);for(var b=d.length/3,e=[],f=0;f<b;f++)for(var h=d[3*f+0],g=d[3*f+1],j=d[3*f+2],l=0;l<h;l++)e.push(new p(g,j));return e};p.getRsBlockTable=function(a,c){switch(c){case 1:return p.RS_BLOCK_TABLE[4*(a-1)+0];case 0:return p.RS_BLOCK_TABLE[4*(a-1)+1];case 3:return p.RS_BLOCK_TABLE[4*
(a-1)+2];case 2:return p.RS_BLOCK_TABLE[4*(a-1)+3]}};t.prototype={get:function(a){return 1==(this.buffer[Math.floor(a/8)]>>>7-a%8&1)},put:function(a,c){for(var d=0;d<c;d++)this.putBit(1==(a>>>c-d-1&1))},getLengthInBits:function(){return this.length},putBit:function(a){var c=Math.floor(this.length/8);this.buffer.length<=c&&this.buffer.push(0);a&&(this.buffer[c]|=128>>>this.length%8);this.length++}};"string"===typeof h&&(h={text:h});h=r.extend({},{render:"canvas",width:256,height:256,typeNumber:-1,
correctLevel:2,background:"#ffffff",foreground:"#000000"},h);return this.each(function(){var a;if("canvas"==h.render){a=new o(h.typeNumber,h.correctLevel);a.addData(h.text);a.make();var c=document.createElement("canvas");c.width=h.width;c.height=h.height;for(var d=c.getContext("2d"),b=h.width/a.getModuleCount(),e=h.height/a.getModuleCount(),f=0;f<a.getModuleCount();f++)for(var i=0;i<a.getModuleCount();i++){d.fillStyle=a.isDark(f,i)?h.foreground:h.background;var g=Math.ceil((i+1)*b)-Math.floor(i*b),
j=Math.ceil((f+1)*b)-Math.floor(f*b);d.fillRect(Math.round(i*b),Math.round(f*e),g,j)}}else{a=new o(h.typeNumber,h.correctLevel);a.addData(h.text);a.make();c=r("<table></table>").css("width",h.width+"px").css("height",h.height+"px").css("border","0px").css("border-collapse","collapse").css("background-color",h.background);d=h.width/a.getModuleCount();b=h.height/a.getModuleCount();for(e=0;e<a.getModuleCount();e++){f=r("<tr></tr>").css("height",b+"px").appendTo(c);for(i=0;i<a.getModuleCount();i++)r("<td></td>").css("width",
d+"px").css("background-color",a.isDark(e,i)?h.foreground:h.background).appendTo(f)}}a=c;jQuery(a).appendTo(this)})}})(jQuery);


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(82);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./share-btn.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./share-btn.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(84);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./menu.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./menu.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(86);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./lazyload.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./lazyload.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(88);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./global.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./global.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Swiper 6.6.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: May 19, 2021
 */

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Swiper=t()}(this,(function(){"use strict";function e(e,t){for(var a=0;a<t.length;a++){var i=t[a];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function t(){return(t=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var i in a)Object.prototype.hasOwnProperty.call(a,i)&&(e[i]=a[i])}return e}).apply(this,arguments)}function a(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function i(e,t){void 0===e&&(e={}),void 0===t&&(t={}),Object.keys(t).forEach((function(s){void 0===e[s]?e[s]=t[s]:a(t[s])&&a(e[s])&&Object.keys(t[s]).length>0&&i(e[s],t[s])}))}var s={body:{},addEventListener:function(){},removeEventListener:function(){},activeElement:{blur:function(){},nodeName:""},querySelector:function(){return null},querySelectorAll:function(){return[]},getElementById:function(){return null},createEvent:function(){return{initEvent:function(){}}},createElement:function(){return{children:[],childNodes:[],style:{},setAttribute:function(){},getElementsByTagName:function(){return[]}}},createElementNS:function(){return{}},importNode:function(){return null},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function r(){var e="undefined"!=typeof document?document:{};return i(e,s),e}var n={document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState:function(){},pushState:function(){},go:function(){},back:function(){}},CustomEvent:function(){return this},addEventListener:function(){},removeEventListener:function(){},getComputedStyle:function(){return{getPropertyValue:function(){return""}}},Image:function(){},Date:function(){},screen:{},setTimeout:function(){},clearTimeout:function(){},matchMedia:function(){return{}},requestAnimationFrame:function(e){return"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0)},cancelAnimationFrame:function(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function l(){var e="undefined"!=typeof window?window:{};return i(e,n),e}function o(e){return(o=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function d(e,t){return(d=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function p(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}function u(e,t,a){return(u=p()?Reflect.construct:function(e,t,a){var i=[null];i.push.apply(i,t);var s=new(Function.bind.apply(e,i));return a&&d(s,a.prototype),s}).apply(null,arguments)}function c(e){var t="function"==typeof Map?new Map:void 0;return(c=function(e){if(null===e||(a=e,-1===Function.toString.call(a).indexOf("[native code]")))return e;var a;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,i)}function i(){return u(e,arguments,o(this).constructor)}return i.prototype=Object.create(e.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),d(i,e)})(e)}var h=function(e){var t,a;function i(t){var a,i,s;return a=e.call.apply(e,[this].concat(t))||this,i=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(a),s=i.__proto__,Object.defineProperty(i,"__proto__",{get:function(){return s},set:function(e){s.__proto__=e}}),a}return a=e,(t=i).prototype=Object.create(a.prototype),t.prototype.constructor=t,t.__proto__=a,i}(c(Array));function v(e){void 0===e&&(e=[]);var t=[];return e.forEach((function(e){Array.isArray(e)?t.push.apply(t,v(e)):t.push(e)})),t}function f(e,t){return Array.prototype.filter.call(e,t)}function m(e,t){var a=l(),i=r(),s=[];if(!t&&e instanceof h)return e;if(!e)return new h(s);if("string"==typeof e){var n=e.trim();if(n.indexOf("<")>=0&&n.indexOf(">")>=0){var o="div";0===n.indexOf("<li")&&(o="ul"),0===n.indexOf("<tr")&&(o="tbody"),0!==n.indexOf("<td")&&0!==n.indexOf("<th")||(o="tr"),0===n.indexOf("<tbody")&&(o="table"),0===n.indexOf("<option")&&(o="select");var d=i.createElement(o);d.innerHTML=n;for(var p=0;p<d.childNodes.length;p+=1)s.push(d.childNodes[p])}else s=function(e,t){if("string"!=typeof e)return[e];for(var a=[],i=t.querySelectorAll(e),s=0;s<i.length;s+=1)a.push(i[s]);return a}(e.trim(),t||i)}else if(e.nodeType||e===a||e===i)s.push(e);else if(Array.isArray(e)){if(e instanceof h)return e;s=e}return new h(function(e){for(var t=[],a=0;a<e.length;a+=1)-1===t.indexOf(e[a])&&t.push(e[a]);return t}(s))}m.fn=h.prototype;var g,b,y,w={addClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));return this.forEach((function(e){var t;(t=e.classList).add.apply(t,i)})),this},removeClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));return this.forEach((function(e){var t;(t=e.classList).remove.apply(t,i)})),this},hasClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));return f(this,(function(e){return i.filter((function(t){return e.classList.contains(t)})).length>0})).length>0},toggleClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));this.forEach((function(e){i.forEach((function(t){e.classList.toggle(t)}))}))},attr:function(e,t){if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(var a=0;a<this.length;a+=1)if(2===arguments.length)this[a].setAttribute(e,t);else for(var i in e)this[a][i]=e[i],this[a].setAttribute(i,e[i]);return this},removeAttr:function(e){for(var t=0;t<this.length;t+=1)this[t].removeAttribute(e);return this},transform:function(e){for(var t=0;t<this.length;t+=1)this[t].style.transform=e;return this},transition:function(e){for(var t=0;t<this.length;t+=1)this[t].style.transitionDuration="string"!=typeof e?e+"ms":e;return this},on:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=t[0],s=t[1],r=t[2],n=t[3];function l(e){var t=e.target;if(t){var a=e.target.dom7EventData||[];if(a.indexOf(e)<0&&a.unshift(e),m(t).is(s))r.apply(t,a);else for(var i=m(t).parents(),n=0;n<i.length;n+=1)m(i[n]).is(s)&&r.apply(i[n],a)}}function o(e){var t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),r.apply(this,t)}"function"==typeof t[1]&&(i=t[0],r=t[1],n=t[2],s=void 0),n||(n=!1);for(var d,p=i.split(" "),u=0;u<this.length;u+=1){var c=this[u];if(s)for(d=0;d<p.length;d+=1){var h=p[d];c.dom7LiveListeners||(c.dom7LiveListeners={}),c.dom7LiveListeners[h]||(c.dom7LiveListeners[h]=[]),c.dom7LiveListeners[h].push({listener:r,proxyListener:l}),c.addEventListener(h,l,n)}else for(d=0;d<p.length;d+=1){var v=p[d];c.dom7Listeners||(c.dom7Listeners={}),c.dom7Listeners[v]||(c.dom7Listeners[v]=[]),c.dom7Listeners[v].push({listener:r,proxyListener:o}),c.addEventListener(v,o,n)}}return this},off:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=t[0],s=t[1],r=t[2],n=t[3];"function"==typeof t[1]&&(i=t[0],r=t[1],n=t[2],s=void 0),n||(n=!1);for(var l=i.split(" "),o=0;o<l.length;o+=1)for(var d=l[o],p=0;p<this.length;p+=1){var u=this[p],c=void 0;if(!s&&u.dom7Listeners?c=u.dom7Listeners[d]:s&&u.dom7LiveListeners&&(c=u.dom7LiveListeners[d]),c&&c.length)for(var h=c.length-1;h>=0;h-=1){var v=c[h];r&&v.listener===r||r&&v.listener&&v.listener.dom7proxy&&v.listener.dom7proxy===r?(u.removeEventListener(d,v.proxyListener,n),c.splice(h,1)):r||(u.removeEventListener(d,v.proxyListener,n),c.splice(h,1))}}return this},trigger:function(){for(var e=l(),t=arguments.length,a=new Array(t),i=0;i<t;i++)a[i]=arguments[i];for(var s=a[0].split(" "),r=a[1],n=0;n<s.length;n+=1)for(var o=s[n],d=0;d<this.length;d+=1){var p=this[d];if(e.CustomEvent){var u=new e.CustomEvent(o,{detail:r,bubbles:!0,cancelable:!0});p.dom7EventData=a.filter((function(e,t){return t>0})),p.dispatchEvent(u),p.dom7EventData=[],delete p.dom7EventData}}return this},transitionEnd:function(e){var t=this;return e&&t.on("transitionend",(function a(i){i.target===this&&(e.call(this,i),t.off("transitionend",a))})),this},outerWidth:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetWidth+parseFloat(t.getPropertyValue("margin-right"))+parseFloat(t.getPropertyValue("margin-left"))}return this[0].offsetWidth}return null},outerHeight:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetHeight+parseFloat(t.getPropertyValue("margin-top"))+parseFloat(t.getPropertyValue("margin-bottom"))}return this[0].offsetHeight}return null},styles:function(){var e=l();return this[0]?e.getComputedStyle(this[0],null):{}},offset:function(){if(this.length>0){var e=l(),t=r(),a=this[0],i=a.getBoundingClientRect(),s=t.body,n=a.clientTop||s.clientTop||0,o=a.clientLeft||s.clientLeft||0,d=a===e?e.scrollY:a.scrollTop,p=a===e?e.scrollX:a.scrollLeft;return{top:i.top+d-n,left:i.left+p-o}}return null},css:function(e,t){var a,i=l();if(1===arguments.length){if("string"!=typeof e){for(a=0;a<this.length;a+=1)for(var s in e)this[a].style[s]=e[s];return this}if(this[0])return i.getComputedStyle(this[0],null).getPropertyValue(e)}if(2===arguments.length&&"string"==typeof e){for(a=0;a<this.length;a+=1)this[a].style[e]=t;return this}return this},each:function(e){return e?(this.forEach((function(t,a){e.apply(t,[t,a])})),this):this},html:function(e){if(void 0===e)return this[0]?this[0].innerHTML:null;for(var t=0;t<this.length;t+=1)this[t].innerHTML=e;return this},text:function(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(var t=0;t<this.length;t+=1)this[t].textContent=e;return this},is:function(e){var t,a,i=l(),s=r(),n=this[0];if(!n||void 0===e)return!1;if("string"==typeof e){if(n.matches)return n.matches(e);if(n.webkitMatchesSelector)return n.webkitMatchesSelector(e);if(n.msMatchesSelector)return n.msMatchesSelector(e);for(t=m(e),a=0;a<t.length;a+=1)if(t[a]===n)return!0;return!1}if(e===s)return n===s;if(e===i)return n===i;if(e.nodeType||e instanceof h){for(t=e.nodeType?[e]:e,a=0;a<t.length;a+=1)if(t[a]===n)return!0;return!1}return!1},index:function(){var e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);)1===t.nodeType&&(e+=1);return e}},eq:function(e){if(void 0===e)return this;var t=this.length;if(e>t-1)return m([]);if(e<0){var a=t+e;return m(a<0?[]:[this[a]])}return m([this[e]])},append:function(){for(var e,t=r(),a=0;a<arguments.length;a+=1){e=a<0||arguments.length<=a?void 0:arguments[a];for(var i=0;i<this.length;i+=1)if("string"==typeof e){var s=t.createElement("div");for(s.innerHTML=e;s.firstChild;)this[i].appendChild(s.firstChild)}else if(e instanceof h)for(var n=0;n<e.length;n+=1)this[i].appendChild(e[n]);else this[i].appendChild(e)}return this},prepend:function(e){var t,a,i=r();for(t=0;t<this.length;t+=1)if("string"==typeof e){var s=i.createElement("div");for(s.innerHTML=e,a=s.childNodes.length-1;a>=0;a-=1)this[t].insertBefore(s.childNodes[a],this[t].childNodes[0])}else if(e instanceof h)for(a=0;a<e.length;a+=1)this[t].insertBefore(e[a],this[t].childNodes[0]);else this[t].insertBefore(e,this[t].childNodes[0]);return this},next:function(e){return this.length>0?e?this[0].nextElementSibling&&m(this[0].nextElementSibling).is(e)?m([this[0].nextElementSibling]):m([]):this[0].nextElementSibling?m([this[0].nextElementSibling]):m([]):m([])},nextAll:function(e){var t=[],a=this[0];if(!a)return m([]);for(;a.nextElementSibling;){var i=a.nextElementSibling;e?m(i).is(e)&&t.push(i):t.push(i),a=i}return m(t)},prev:function(e){if(this.length>0){var t=this[0];return e?t.previousElementSibling&&m(t.previousElementSibling).is(e)?m([t.previousElementSibling]):m([]):t.previousElementSibling?m([t.previousElementSibling]):m([])}return m([])},prevAll:function(e){var t=[],a=this[0];if(!a)return m([]);for(;a.previousElementSibling;){var i=a.previousElementSibling;e?m(i).is(e)&&t.push(i):t.push(i),a=i}return m(t)},parent:function(e){for(var t=[],a=0;a<this.length;a+=1)null!==this[a].parentNode&&(e?m(this[a].parentNode).is(e)&&t.push(this[a].parentNode):t.push(this[a].parentNode));return m(t)},parents:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].parentNode;i;)e?m(i).is(e)&&t.push(i):t.push(i),i=i.parentNode;return m(t)},closest:function(e){var t=this;return void 0===e?m([]):(t.is(e)||(t=t.parents(e).eq(0)),t)},find:function(e){for(var t=[],a=0;a<this.length;a+=1){try{var i=this[a].querySelectorAll(e)}catch(t){console.log(e)}for(var s=0;s<i.length;s+=1)t.push(i[s])}return m(t)},children:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].children,s=0;s<i.length;s+=1)e&&!m(i[s]).is(e)||t.push(i[s]);return m(t)},filter:function(e){return m(f(this,e))},remove:function(){for(var e=0;e<this.length;e+=1)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this}};function E(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function x(){return Date.now()}function T(e,t){void 0===t&&(t="x");var a,i,s,r=l(),n=function(e){var t,a=l();return a.getComputedStyle&&(t=a.getComputedStyle(e,null)),!t&&e.currentStyle&&(t=e.currentStyle),t||(t=e.style),t}(e);return r.WebKitCSSMatrix?((i=n.transform||n.webkitTransform).split(",").length>6&&(i=i.split(", ").map((function(e){return e.replace(",",".")})).join(", ")),s=new r.WebKitCSSMatrix("none"===i?"":i)):a=(s=n.MozTransform||n.OTransform||n.MsTransform||n.msTransform||n.transform||n.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,")).toString().split(","),"x"===t&&(i=r.WebKitCSSMatrix?s.m41:16===a.length?parseFloat(a[12]):parseFloat(a[4])),"y"===t&&(i=r.WebKitCSSMatrix?s.m42:16===a.length?parseFloat(a[13]):parseFloat(a[5])),i||0}function C(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function S(){for(var e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"],a=1;a<arguments.length;a+=1){var i=a<0||arguments.length<=a?void 0:arguments[a];if(null!=i)for(var s=Object.keys(Object(i)).filter((function(e){return t.indexOf(e)<0})),r=0,n=s.length;r<n;r+=1){var l=s[r],o=Object.getOwnPropertyDescriptor(i,l);void 0!==o&&o.enumerable&&(C(e[l])&&C(i[l])?i[l].__swiper__?e[l]=i[l]:S(e[l],i[l]):!C(e[l])&&C(i[l])?(e[l]={},i[l].__swiper__?e[l]=i[l]:S(e[l],i[l])):e[l]=i[l])}}return e}function M(e,t){Object.keys(t).forEach((function(a){C(t[a])&&Object.keys(t[a]).forEach((function(i){"function"==typeof t[a][i]&&(t[a][i]=t[a][i].bind(e))})),e[a]=t[a]}))}function z(e){return void 0===e&&(e=""),"."+e.trim().replace(/([\.:\/])/g,"\\$1").replace(/ /g,".")}function P(){return g||(g=function(){var e=l(),t=r();return{touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch),pointerEvents:!!e.PointerEvent&&"maxTouchPoints"in e.navigator&&e.navigator.maxTouchPoints>=0,observer:"MutationObserver"in e||"WebkitMutationObserver"in e,passiveListener:function(){var t=!1;try{var a=Object.defineProperty({},"passive",{get:function(){t=!0}});e.addEventListener("testPassiveListener",null,a)}catch(e){}return t}(),gestures:"ongesturestart"in e}}()),g}function k(e){return void 0===e&&(e={}),b||(b=function(e){var t=(void 0===e?{}:e).userAgent,a=P(),i=l(),s=i.navigator.platform,r=t||i.navigator.userAgent,n={ios:!1,android:!1},o=i.screen.width,d=i.screen.height,p=r.match(/(Android);?[\s\/]+([\d.]+)?/),u=r.match(/(iPad).*OS\s([\d_]+)/),c=r.match(/(iPod)(.*OS\s([\d_]+))?/),h=!u&&r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),v="Win32"===s,f="MacIntel"===s;return!u&&f&&a.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(o+"x"+d)>=0&&((u=r.match(/(Version)\/([\d.]+)/))||(u=[0,1,"13_0_0"]),f=!1),p&&!v&&(n.os="android",n.android=!0),(u||h||c)&&(n.os="ios",n.ios=!0),n}(e)),b}function $(){return y||(y=function(){var e,t=l();return{isEdge:!!t.navigator.userAgent.match(/Edge/g),isSafari:(e=t.navigator.userAgent.toLowerCase(),e.indexOf("safari")>=0&&e.indexOf("chrome")<0&&e.indexOf("android")<0),isWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)}}()),y}Object.keys(w).forEach((function(e){Object.defineProperty(m.fn,e,{value:w[e],writable:!0})}));var L={name:"resize",create:function(){var e=this;S(e,{resize:{observer:null,createObserver:function(){e&&!e.destroyed&&e.initialized&&(e.resize.observer=new ResizeObserver((function(t){var a=e.width,i=e.height,s=a,r=i;t.forEach((function(t){var a=t.contentBoxSize,i=t.contentRect,n=t.target;n&&n!==e.el||(s=i?i.width:(a[0]||a).inlineSize,r=i?i.height:(a[0]||a).blockSize)})),s===a&&r===i||e.resize.resizeHandler()})),e.resize.observer.observe(e.el))},removeObserver:function(){e.resize.observer&&e.resize.observer.unobserve&&e.el&&(e.resize.observer.unobserve(e.el),e.resize.observer=null)},resizeHandler:function(){e&&!e.destroyed&&e.initialized&&(e.emit("beforeResize"),e.emit("resize"))},orientationChangeHandler:function(){e&&!e.destroyed&&e.initialized&&e.emit("orientationchange")}}})},on:{init:function(e){var t=l();e.params.resizeObserver&&void 0!==l().ResizeObserver?e.resize.createObserver():(t.addEventListener("resize",e.resize.resizeHandler),t.addEventListener("orientationchange",e.resize.orientationChangeHandler))},destroy:function(e){var t=l();e.resize.removeObserver(),t.removeEventListener("resize",e.resize.resizeHandler),t.removeEventListener("orientationchange",e.resize.orientationChangeHandler)}}},I={attach:function(e,t){void 0===t&&(t={});var a=l(),i=this,s=new(a.MutationObserver||a.WebkitMutationObserver)((function(e){if(1!==e.length){var t=function(){i.emit("observerUpdate",e[0])};a.requestAnimationFrame?a.requestAnimationFrame(t):a.setTimeout(t,0)}else i.emit("observerUpdate",e[0])}));s.observe(e,{attributes:void 0===t.attributes||t.attributes,childList:void 0===t.childList||t.childList,characterData:void 0===t.characterData||t.characterData}),i.observer.observers.push(s)},init:function(){var e=this;if(e.support.observer&&e.params.observer){if(e.params.observeParents)for(var t=e.$el.parents(),a=0;a<t.length;a+=1)e.observer.attach(t[a]);e.observer.attach(e.$el[0],{childList:e.params.observeSlideChildren}),e.observer.attach(e.$wrapperEl[0],{attributes:!1})}},destroy:function(){this.observer.observers.forEach((function(e){e.disconnect()})),this.observer.observers=[]}},O={name:"observer",params:{observer:!1,observeParents:!1,observeSlideChildren:!1},create:function(){M(this,{observer:t({},I,{observers:[]})})},on:{init:function(e){e.observer.init()},destroy:function(e){e.observer.destroy()}}};function A(e){var t=this,a=r(),i=l(),s=t.touchEventsData,n=t.params,o=t.touches;if(t.enabled&&(!t.animating||!n.preventInteractionOnTransition)){var d=e;d.originalEvent&&(d=d.originalEvent);var p=m(d.target);if("wrapper"!==n.touchEventsTarget||p.closest(t.wrapperEl).length)if(s.isTouchEvent="touchstart"===d.type,s.isTouchEvent||!("which"in d)||3!==d.which)if(!(!s.isTouchEvent&&"button"in d&&d.button>0))if(!s.isTouched||!s.isMoved)if(!!n.noSwipingClass&&""!==n.noSwipingClass&&d.target&&d.target.shadowRoot&&e.path&&e.path[0]&&(p=m(e.path[0])),n.noSwiping&&p.closest(n.noSwipingSelector?n.noSwipingSelector:"."+n.noSwipingClass)[0])t.allowClick=!0;else if(!n.swipeHandler||p.closest(n.swipeHandler)[0]){o.currentX="touchstart"===d.type?d.targetTouches[0].pageX:d.pageX,o.currentY="touchstart"===d.type?d.targetTouches[0].pageY:d.pageY;var u=o.currentX,c=o.currentY,h=n.edgeSwipeDetection||n.iOSEdgeSwipeDetection,v=n.edgeSwipeThreshold||n.iOSEdgeSwipeThreshold;if(h&&(u<=v||u>=i.innerWidth-v)){if("prevent"!==h)return;e.preventDefault()}if(S(s,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),o.startX=u,o.startY=c,s.touchStartTime=x(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,n.threshold>0&&(s.allowThresholdMove=!1),"touchstart"!==d.type){var f=!0;p.is(s.formElements)&&(f=!1),a.activeElement&&m(a.activeElement).is(s.formElements)&&a.activeElement!==p[0]&&a.activeElement.blur();var g=f&&t.allowTouchMove&&n.touchStartPreventDefault;!n.touchStartForcePreventDefault&&!g||p[0].isContentEditable||d.preventDefault()}t.emit("touchStart",d)}}}function D(e){var t=r(),a=this,i=a.touchEventsData,s=a.params,n=a.touches,l=a.rtlTranslate;if(a.enabled){var o=e;if(o.originalEvent&&(o=o.originalEvent),i.isTouched){if(!i.isTouchEvent||"touchmove"===o.type){var d="touchmove"===o.type&&o.targetTouches&&(o.targetTouches[0]||o.changedTouches[0]),p="touchmove"===o.type?d.pageX:o.pageX,u="touchmove"===o.type?d.pageY:o.pageY;if(o.preventedByNestedSwiper)return n.startX=p,void(n.startY=u);if(!a.allowTouchMove)return a.allowClick=!1,void(i.isTouched&&(S(n,{startX:p,startY:u,currentX:p,currentY:u}),i.touchStartTime=x()));if(i.isTouchEvent&&s.touchReleaseOnEdges&&!s.loop)if(a.isVertical()){if(u<n.startY&&a.translate<=a.maxTranslate()||u>n.startY&&a.translate>=a.minTranslate())return i.isTouched=!1,void(i.isMoved=!1)}else if(p<n.startX&&a.translate<=a.maxTranslate()||p>n.startX&&a.translate>=a.minTranslate())return;if(i.isTouchEvent&&t.activeElement&&o.target===t.activeElement&&m(o.target).is(i.formElements))return i.isMoved=!0,void(a.allowClick=!1);if(i.allowTouchCallbacks&&a.emit("touchMove",o),!(o.targetTouches&&o.targetTouches.length>1)){n.currentX=p,n.currentY=u;var c=n.currentX-n.startX,h=n.currentY-n.startY;if(!(a.params.threshold&&Math.sqrt(Math.pow(c,2)+Math.pow(h,2))<a.params.threshold)){var v;if(void 0===i.isScrolling)a.isHorizontal()&&n.currentY===n.startY||a.isVertical()&&n.currentX===n.startX?i.isScrolling=!1:c*c+h*h>=25&&(v=180*Math.atan2(Math.abs(h),Math.abs(c))/Math.PI,i.isScrolling=a.isHorizontal()?v>s.touchAngle:90-v>s.touchAngle);if(i.isScrolling&&a.emit("touchMoveOpposite",o),void 0===i.startMoving&&(n.currentX===n.startX&&n.currentY===n.startY||(i.startMoving=!0)),i.isScrolling)i.isTouched=!1;else if(i.startMoving){a.allowClick=!1,!s.cssMode&&o.cancelable&&o.preventDefault(),s.touchMoveStopPropagation&&!s.nested&&o.stopPropagation(),i.isMoved||(s.loop&&a.loopFix(),i.startTranslate=a.getTranslate(),a.setTransition(0),a.animating&&a.$wrapperEl.trigger("webkitTransitionEnd transitionend"),i.allowMomentumBounce=!1,!s.grabCursor||!0!==a.allowSlideNext&&!0!==a.allowSlidePrev||a.setGrabCursor(!0),a.emit("sliderFirstMove",o)),a.emit("sliderMove",o),i.isMoved=!0;var f=a.isHorizontal()?c:h;n.diff=f,f*=s.touchRatio,l&&(f=-f),a.swipeDirection=f>0?"prev":"next",i.currentTranslate=f+i.startTranslate;var g=!0,b=s.resistanceRatio;if(s.touchReleaseOnEdges&&(b=0),f>0&&i.currentTranslate>a.minTranslate()?(g=!1,s.resistance&&(i.currentTranslate=a.minTranslate()-1+Math.pow(-a.minTranslate()+i.startTranslate+f,b))):f<0&&i.currentTranslate<a.maxTranslate()&&(g=!1,s.resistance&&(i.currentTranslate=a.maxTranslate()+1-Math.pow(a.maxTranslate()-i.startTranslate-f,b))),g&&(o.preventedByNestedSwiper=!0),!a.allowSlideNext&&"next"===a.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!a.allowSlidePrev&&"prev"===a.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),a.allowSlidePrev||a.allowSlideNext||(i.currentTranslate=i.startTranslate),s.threshold>0){if(!(Math.abs(f)>s.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,n.startX=n.currentX,n.startY=n.currentY,i.currentTranslate=i.startTranslate,void(n.diff=a.isHorizontal()?n.currentX-n.startX:n.currentY-n.startY)}s.followFinger&&!s.cssMode&&((s.freeMode||s.watchSlidesProgress||s.watchSlidesVisibility)&&(a.updateActiveIndex(),a.updateSlidesClasses()),s.freeMode&&(0===i.velocities.length&&i.velocities.push({position:n[a.isHorizontal()?"startX":"startY"],time:i.touchStartTime}),i.velocities.push({position:n[a.isHorizontal()?"currentX":"currentY"],time:x()})),a.updateProgress(i.currentTranslate),a.setTranslate(i.currentTranslate))}}}}}else i.startMoving&&i.isScrolling&&a.emit("touchMoveOpposite",o)}}function N(e){var t=this,a=t.touchEventsData,i=t.params,s=t.touches,r=t.rtlTranslate,n=t.$wrapperEl,l=t.slidesGrid,o=t.snapGrid;if(t.enabled){var d=e;if(d.originalEvent&&(d=d.originalEvent),a.allowTouchCallbacks&&t.emit("touchEnd",d),a.allowTouchCallbacks=!1,!a.isTouched)return a.isMoved&&i.grabCursor&&t.setGrabCursor(!1),a.isMoved=!1,void(a.startMoving=!1);i.grabCursor&&a.isMoved&&a.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);var p,u=x(),c=u-a.touchStartTime;if(t.allowClick&&(t.updateClickedSlide(d),t.emit("tap click",d),c<300&&u-a.lastClickTime<300&&t.emit("doubleTap doubleClick",d)),a.lastClickTime=x(),E((function(){t.destroyed||(t.allowClick=!0)})),!a.isTouched||!a.isMoved||!t.swipeDirection||0===s.diff||a.currentTranslate===a.startTranslate)return a.isTouched=!1,a.isMoved=!1,void(a.startMoving=!1);if(a.isTouched=!1,a.isMoved=!1,a.startMoving=!1,p=i.followFinger?r?t.translate:-t.translate:-a.currentTranslate,!i.cssMode)if(i.freeMode){if(p<-t.minTranslate())return void t.slideTo(t.activeIndex);if(p>-t.maxTranslate())return void(t.slides.length<o.length?t.slideTo(o.length-1):t.slideTo(t.slides.length-1));if(i.freeModeMomentum){if(a.velocities.length>1){var h=a.velocities.pop(),v=a.velocities.pop(),f=h.position-v.position,m=h.time-v.time;t.velocity=f/m,t.velocity/=2,Math.abs(t.velocity)<i.freeModeMinimumVelocity&&(t.velocity=0),(m>150||x()-h.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=i.freeModeMomentumVelocityRatio,a.velocities.length=0;var g=1e3*i.freeModeMomentumRatio,b=t.velocity*g,y=t.translate+b;r&&(y=-y);var w,T,C=!1,S=20*Math.abs(t.velocity)*i.freeModeMomentumBounceRatio;if(y<t.maxTranslate())i.freeModeMomentumBounce?(y+t.maxTranslate()<-S&&(y=t.maxTranslate()-S),w=t.maxTranslate(),C=!0,a.allowMomentumBounce=!0):y=t.maxTranslate(),i.loop&&i.centeredSlides&&(T=!0);else if(y>t.minTranslate())i.freeModeMomentumBounce?(y-t.minTranslate()>S&&(y=t.minTranslate()+S),w=t.minTranslate(),C=!0,a.allowMomentumBounce=!0):y=t.minTranslate(),i.loop&&i.centeredSlides&&(T=!0);else if(i.freeModeSticky){for(var M,z=0;z<o.length;z+=1)if(o[z]>-y){M=z;break}y=-(y=Math.abs(o[M]-y)<Math.abs(o[M-1]-y)||"next"===t.swipeDirection?o[M]:o[M-1])}if(T&&t.once("transitionEnd",(function(){t.loopFix()})),0!==t.velocity){if(g=r?Math.abs((-y-t.translate)/t.velocity):Math.abs((y-t.translate)/t.velocity),i.freeModeSticky){var P=Math.abs((r?-y:y)-t.translate),k=t.slidesSizesGrid[t.activeIndex];g=P<k?i.speed:P<2*k?1.5*i.speed:2.5*i.speed}}else if(i.freeModeSticky)return void t.slideToClosest();i.freeModeMomentumBounce&&C?(t.updateProgress(w),t.setTransition(g),t.setTranslate(y),t.transitionStart(!0,t.swipeDirection),t.animating=!0,n.transitionEnd((function(){t&&!t.destroyed&&a.allowMomentumBounce&&(t.emit("momentumBounce"),t.setTransition(i.speed),setTimeout((function(){t.setTranslate(w),n.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(t.updateProgress(y),t.setTransition(g),t.setTranslate(y),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,n.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()})))):(t.emit("_freeModeNoMomentumRelease"),t.updateProgress(y)),t.updateActiveIndex(),t.updateSlidesClasses()}else{if(i.freeModeSticky)return void t.slideToClosest();i.freeMode&&t.emit("_freeModeNoMomentumRelease")}(!i.freeModeMomentum||c>=i.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}else{for(var $=0,L=t.slidesSizesGrid[0],I=0;I<l.length;I+=I<i.slidesPerGroupSkip?1:i.slidesPerGroup){var O=I<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;void 0!==l[I+O]?p>=l[I]&&p<l[I+O]&&($=I,L=l[I+O]-l[I]):p>=l[I]&&($=I,L=l[l.length-1]-l[l.length-2])}var A=(p-l[$])/L,D=$<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;if(c>i.longSwipesMs){if(!i.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(A>=i.longSwipesRatio?t.slideTo($+D):t.slideTo($)),"prev"===t.swipeDirection&&(A>1-i.longSwipesRatio?t.slideTo($+D):t.slideTo($))}else{if(!i.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(d.target===t.navigation.nextEl||d.target===t.navigation.prevEl)?d.target===t.navigation.nextEl?t.slideTo($+D):t.slideTo($):("next"===t.swipeDirection&&t.slideTo($+D),"prev"===t.swipeDirection&&t.slideTo($))}}}}function G(){var e=this,t=e.params,a=e.el;if(!a||0!==a.offsetWidth){t.breakpoints&&e.setBreakpoint();var i=e.allowSlideNext,s=e.allowSlidePrev,r=e.snapGrid;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses(),("auto"===t.slidesPerView||t.slidesPerView>1)&&e.isEnd&&!e.isBeginning&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.run(),e.allowSlidePrev=s,e.allowSlideNext=i,e.params.watchOverflow&&r!==e.snapGrid&&e.checkOverflow()}}function B(e){var t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function H(){var e=this,t=e.wrapperEl,a=e.rtlTranslate;if(e.enabled){e.previousTranslate=e.translate,e.isHorizontal()?e.translate=a?t.scrollWidth-t.offsetWidth-t.scrollLeft:-t.scrollLeft:e.translate=-t.scrollTop,-0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();var i=e.maxTranslate()-e.minTranslate();(0===i?0:(e.translate-e.minTranslate())/i)!==e.progress&&e.updateProgress(a?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}}var X=!1;function Y(){}var R={init:!0,direction:"horizontal",touchEventsTarget:"container",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!1,nested:!1,enabled:!0,width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,freeMode:!1,freeModeMomentum:!0,freeModeMomentumRatio:1,freeModeMomentumBounce:!0,freeModeMomentumBounceRatio:1,freeModeMomentumVelocityRatio:1,freeModeSticky:!1,freeModeMinimumVelocity:.02,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerColumn:1,slidesPerColumnFill:"column",slidesPerGroup:1,slidesPerGroupSkip:0,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!1,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,watchSlidesVisibility:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopFillGroupWithBlank:!1,loopPreventsSlide:!0,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,containerModifierClass:"swiper-container-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0,_emitClasses:!1},W={modular:{useParams:function(e){var t=this;t.modules&&Object.keys(t.modules).forEach((function(a){var i=t.modules[a];i.params&&S(e,i.params)}))},useModules:function(e){void 0===e&&(e={});var t=this;t.modules&&Object.keys(t.modules).forEach((function(a){var i=t.modules[a],s=e[a]||{};i.on&&t.on&&Object.keys(i.on).forEach((function(e){t.on(e,i.on[e])})),i.create&&i.create.bind(t)(s)}))}},eventsEmitter:{on:function(e,t,a){var i=this;if("function"!=typeof t)return i;var s=a?"unshift":"push";return e.split(" ").forEach((function(e){i.eventsListeners[e]||(i.eventsListeners[e]=[]),i.eventsListeners[e][s](t)})),i},once:function(e,t,a){var i=this;if("function"!=typeof t)return i;function s(){i.off(e,s),s.__emitterProxy&&delete s.__emitterProxy;for(var a=arguments.length,r=new Array(a),n=0;n<a;n++)r[n]=arguments[n];t.apply(i,r)}return s.__emitterProxy=t,i.on(e,s,a)},onAny:function(e,t){var a=this;if("function"!=typeof e)return a;var i=t?"unshift":"push";return a.eventsAnyListeners.indexOf(e)<0&&a.eventsAnyListeners[i](e),a},offAny:function(e){var t=this;if(!t.eventsAnyListeners)return t;var a=t.eventsAnyListeners.indexOf(e);return a>=0&&t.eventsAnyListeners.splice(a,1),t},off:function(e,t){var a=this;return a.eventsListeners?(e.split(" ").forEach((function(e){void 0===t?a.eventsListeners[e]=[]:a.eventsListeners[e]&&a.eventsListeners[e].forEach((function(i,s){(i===t||i.__emitterProxy&&i.__emitterProxy===t)&&a.eventsListeners[e].splice(s,1)}))})),a):a},emit:function(){var e,t,a,i=this;if(!i.eventsListeners)return i;for(var s=arguments.length,r=new Array(s),n=0;n<s;n++)r[n]=arguments[n];"string"==typeof r[0]||Array.isArray(r[0])?(e=r[0],t=r.slice(1,r.length),a=i):(e=r[0].events,t=r[0].data,a=r[0].context||i),t.unshift(a);var l=Array.isArray(e)?e:e.split(" ");return l.forEach((function(e){i.eventsAnyListeners&&i.eventsAnyListeners.length&&i.eventsAnyListeners.forEach((function(i){i.apply(a,[e].concat(t))})),i.eventsListeners&&i.eventsListeners[e]&&i.eventsListeners[e].forEach((function(e){e.apply(a,t)}))})),i}},update:{updateSize:function(){var e,t,a=this,i=a.$el;e=void 0!==a.params.width&&null!==a.params.width?a.params.width:i[0].clientWidth,t=void 0!==a.params.height&&null!==a.params.height?a.params.height:i[0].clientHeight,0===e&&a.isHorizontal()||0===t&&a.isVertical()||(e=e-parseInt(i.css("padding-left")||0,10)-parseInt(i.css("padding-right")||0,10),t=t-parseInt(i.css("padding-top")||0,10)-parseInt(i.css("padding-bottom")||0,10),Number.isNaN(e)&&(e=0),Number.isNaN(t)&&(t=0),S(a,{width:e,height:t,size:a.isHorizontal()?e:t}))},updateSlides:function(){var e=this;function t(t){return e.isHorizontal()?t:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[t]}function a(e,a){return parseFloat(e.getPropertyValue(t(a))||0)}var i=e.params,s=e.$wrapperEl,r=e.size,n=e.rtlTranslate,l=e.wrongRTL,o=e.virtual&&i.virtual.enabled,d=o?e.virtual.slides.length:e.slides.length,p=s.children("."+e.params.slideClass),u=o?e.virtual.slides.length:p.length,c=[],h=[],v=[],f=i.slidesOffsetBefore;"function"==typeof f&&(f=i.slidesOffsetBefore.call(e));var m=i.slidesOffsetAfter;"function"==typeof m&&(m=i.slidesOffsetAfter.call(e));var g=e.snapGrid.length,b=e.slidesGrid.length,y=i.spaceBetween,w=-f,E=0,x=0;if(void 0!==r){var T,C;"string"==typeof y&&y.indexOf("%")>=0&&(y=parseFloat(y.replace("%",""))/100*r),e.virtualSize=-y,n?p.css({marginLeft:"",marginTop:""}):p.css({marginRight:"",marginBottom:""}),i.slidesPerColumn>1&&(T=Math.floor(u/i.slidesPerColumn)===u/e.params.slidesPerColumn?u:Math.ceil(u/i.slidesPerColumn)*i.slidesPerColumn,"auto"!==i.slidesPerView&&"row"===i.slidesPerColumnFill&&(T=Math.max(T,i.slidesPerView*i.slidesPerColumn)));for(var M,z,P,k=i.slidesPerColumn,$=T/k,L=Math.floor(u/i.slidesPerColumn),I=0;I<u;I+=1){C=0;var O=p.eq(I);if(i.slidesPerColumn>1){var A=void 0,D=void 0,N=void 0;if("row"===i.slidesPerColumnFill&&i.slidesPerGroup>1){var G=Math.floor(I/(i.slidesPerGroup*i.slidesPerColumn)),B=I-i.slidesPerColumn*i.slidesPerGroup*G,H=0===G?i.slidesPerGroup:Math.min(Math.ceil((u-G*k*i.slidesPerGroup)/k),i.slidesPerGroup);A=(D=B-(N=Math.floor(B/H))*H+G*i.slidesPerGroup)+N*T/k,O.css({"-webkit-box-ordinal-group":A,"-moz-box-ordinal-group":A,"-ms-flex-order":A,"-webkit-order":A,order:A})}else"column"===i.slidesPerColumnFill?(N=I-(D=Math.floor(I/k))*k,(D>L||D===L&&N===k-1)&&(N+=1)>=k&&(N=0,D+=1)):D=I-(N=Math.floor(I/$))*$;O.css(t("margin-top"),0!==N&&i.spaceBetween&&i.spaceBetween+"px")}if("none"!==O.css("display")){if("auto"===i.slidesPerView){var X=getComputedStyle(O[0]),Y=O[0].style.transform,R=O[0].style.webkitTransform;if(Y&&(O[0].style.transform="none"),R&&(O[0].style.webkitTransform="none"),i.roundLengths)C=e.isHorizontal()?O.outerWidth(!0):O.outerHeight(!0);else{var W=a(X,"width"),V=a(X,"padding-left"),F=a(X,"padding-right"),_=a(X,"margin-left"),q=a(X,"margin-right"),j=X.getPropertyValue("box-sizing");if(j&&"border-box"===j)C=W+_+q;else{var U=O[0],K=U.clientWidth;C=W+V+F+_+q+(U.offsetWidth-K)}}Y&&(O[0].style.transform=Y),R&&(O[0].style.webkitTransform=R),i.roundLengths&&(C=Math.floor(C))}else C=(r-(i.slidesPerView-1)*y)/i.slidesPerView,i.roundLengths&&(C=Math.floor(C)),p[I]&&(p[I].style[t("width")]=C+"px");p[I]&&(p[I].swiperSlideSize=C),v.push(C),i.centeredSlides?(w=w+C/2+E/2+y,0===E&&0!==I&&(w=w-r/2-y),0===I&&(w=w-r/2-y),Math.abs(w)<.001&&(w=0),i.roundLengths&&(w=Math.floor(w)),x%i.slidesPerGroup==0&&c.push(w),h.push(w)):(i.roundLengths&&(w=Math.floor(w)),(x-Math.min(e.params.slidesPerGroupSkip,x))%e.params.slidesPerGroup==0&&c.push(w),h.push(w),w=w+C+y),e.virtualSize+=C+y,E=C,x+=1}}if(e.virtualSize=Math.max(e.virtualSize,r)+m,n&&l&&("slide"===i.effect||"coverflow"===i.effect)&&s.css({width:e.virtualSize+i.spaceBetween+"px"}),i.setWrapperSize)s.css(((z={})[t("width")]=e.virtualSize+i.spaceBetween+"px",z));if(i.slidesPerColumn>1)if(e.virtualSize=(C+i.spaceBetween)*T,e.virtualSize=Math.ceil(e.virtualSize/i.slidesPerColumn)-i.spaceBetween,s.css(((P={})[t("width")]=e.virtualSize+i.spaceBetween+"px",P)),i.centeredSlides){M=[];for(var Z=0;Z<c.length;Z+=1){var J=c[Z];i.roundLengths&&(J=Math.floor(J)),c[Z]<e.virtualSize+c[0]&&M.push(J)}c=M}if(!i.centeredSlides){M=[];for(var Q=0;Q<c.length;Q+=1){var ee=c[Q];i.roundLengths&&(ee=Math.floor(ee)),c[Q]<=e.virtualSize-r&&M.push(ee)}c=M,Math.floor(e.virtualSize-r)-Math.floor(c[c.length-1])>1&&c.push(e.virtualSize-r)}if(0===c.length&&(c=[0]),0!==i.spaceBetween){var te,ae=e.isHorizontal()&&n?"marginLeft":t("marginRight");p.filter((function(e,t){return!i.cssMode||t!==p.length-1})).css(((te={})[ae]=y+"px",te))}if(i.centeredSlides&&i.centeredSlidesBounds){var ie=0;v.forEach((function(e){ie+=e+(i.spaceBetween?i.spaceBetween:0)}));var se=(ie-=i.spaceBetween)-r;c=c.map((function(e){return e<0?-f:e>se?se+m:e}))}if(i.centerInsufficientSlides){var re=0;if(v.forEach((function(e){re+=e+(i.spaceBetween?i.spaceBetween:0)})),(re-=i.spaceBetween)<r){var ne=(r-re)/2;c.forEach((function(e,t){c[t]=e-ne})),h.forEach((function(e,t){h[t]=e+ne}))}}S(e,{slides:p,snapGrid:c,slidesGrid:h,slidesSizesGrid:v}),u!==d&&e.emit("slidesLengthChange"),c.length!==g&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),h.length!==b&&e.emit("slidesGridLengthChange"),(i.watchSlidesProgress||i.watchSlidesVisibility)&&e.updateSlidesOffset()}},updateAutoHeight:function(e){var t,a=this,i=[],s=a.virtual&&a.params.virtual.enabled,r=0;"number"==typeof e?a.setTransition(e):!0===e&&a.setTransition(a.params.speed);var n=function(e){return s?a.slides.filter((function(t){return parseInt(t.getAttribute("data-swiper-slide-index"),10)===e}))[0]:a.slides.eq(e)[0]};if("auto"!==a.params.slidesPerView&&a.params.slidesPerView>1)if(a.params.centeredSlides)a.visibleSlides.each((function(e){i.push(e)}));else for(t=0;t<Math.ceil(a.params.slidesPerView);t+=1){var l=a.activeIndex+t;if(l>a.slides.length&&!s)break;i.push(n(l))}else i.push(n(a.activeIndex));for(t=0;t<i.length;t+=1)if(void 0!==i[t]){var o=i[t].offsetHeight;r=o>r?o:r}r&&a.$wrapperEl.css("height",r+"px")},updateSlidesOffset:function(){for(var e=this.slides,t=0;t<e.length;t+=1)e[t].swiperSlideOffset=this.isHorizontal()?e[t].offsetLeft:e[t].offsetTop},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);var t=this,a=t.params,i=t.slides,s=t.rtlTranslate;if(0!==i.length){void 0===i[0].swiperSlideOffset&&t.updateSlidesOffset();var r=-e;s&&(r=e),i.removeClass(a.slideVisibleClass),t.visibleSlidesIndexes=[],t.visibleSlides=[];for(var n=0;n<i.length;n+=1){var l=i[n],o=(r+(a.centeredSlides?t.minTranslate():0)-l.swiperSlideOffset)/(l.swiperSlideSize+a.spaceBetween);if(a.watchSlidesVisibility||a.centeredSlides&&a.autoHeight){var d=-(r-l.swiperSlideOffset),p=d+t.slidesSizesGrid[n];(d>=0&&d<t.size-1||p>1&&p<=t.size||d<=0&&p>=t.size)&&(t.visibleSlides.push(l),t.visibleSlidesIndexes.push(n),i.eq(n).addClass(a.slideVisibleClass))}l.progress=s?-o:o}t.visibleSlides=m(t.visibleSlides)}},updateProgress:function(e){var t=this;if(void 0===e){var a=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*a||0}var i=t.params,s=t.maxTranslate()-t.minTranslate(),r=t.progress,n=t.isBeginning,l=t.isEnd,o=n,d=l;0===s?(r=0,n=!0,l=!0):(n=(r=(e-t.minTranslate())/s)<=0,l=r>=1),S(t,{progress:r,isBeginning:n,isEnd:l}),(i.watchSlidesProgress||i.watchSlidesVisibility||i.centeredSlides&&i.autoHeight)&&t.updateSlidesProgress(e),n&&!o&&t.emit("reachBeginning toEdge"),l&&!d&&t.emit("reachEnd toEdge"),(o&&!n||d&&!l)&&t.emit("fromEdge"),t.emit("progress",r)},updateSlidesClasses:function(){var e,t=this,a=t.slides,i=t.params,s=t.$wrapperEl,r=t.activeIndex,n=t.realIndex,l=t.virtual&&i.virtual.enabled;a.removeClass(i.slideActiveClass+" "+i.slideNextClass+" "+i.slidePrevClass+" "+i.slideDuplicateActiveClass+" "+i.slideDuplicateNextClass+" "+i.slideDuplicatePrevClass),(e=l?t.$wrapperEl.find("."+i.slideClass+'[data-swiper-slide-index="'+r+'"]'):a.eq(r)).addClass(i.slideActiveClass),i.loop&&(e.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+n+'"]').addClass(i.slideDuplicateActiveClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+n+'"]').addClass(i.slideDuplicateActiveClass));var o=e.nextAll("."+i.slideClass).eq(0).addClass(i.slideNextClass);i.loop&&0===o.length&&(o=a.eq(0)).addClass(i.slideNextClass);var d=e.prevAll("."+i.slideClass).eq(0).addClass(i.slidePrevClass);i.loop&&0===d.length&&(d=a.eq(-1)).addClass(i.slidePrevClass),i.loop&&(o.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass),d.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+d.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+d.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass)),t.emitSlidesClasses()},updateActiveIndex:function(e){var t,a=this,i=a.rtlTranslate?a.translate:-a.translate,s=a.slidesGrid,r=a.snapGrid,n=a.params,l=a.activeIndex,o=a.realIndex,d=a.snapIndex,p=e;if(void 0===p){for(var u=0;u<s.length;u+=1)void 0!==s[u+1]?i>=s[u]&&i<s[u+1]-(s[u+1]-s[u])/2?p=u:i>=s[u]&&i<s[u+1]&&(p=u+1):i>=s[u]&&(p=u);n.normalizeSlideIndex&&(p<0||void 0===p)&&(p=0)}if(r.indexOf(i)>=0)t=r.indexOf(i);else{var c=Math.min(n.slidesPerGroupSkip,p);t=c+Math.floor((p-c)/n.slidesPerGroup)}if(t>=r.length&&(t=r.length-1),p!==l){var h=parseInt(a.slides.eq(p).attr("data-swiper-slide-index")||p,10);S(a,{snapIndex:t,realIndex:h,previousIndex:l,activeIndex:p}),a.emit("activeIndexChange"),a.emit("snapIndexChange"),o!==h&&a.emit("realIndexChange"),(a.initialized||a.params.runCallbacksOnInit)&&a.emit("slideChange")}else t!==d&&(a.snapIndex=t,a.emit("snapIndexChange"))},updateClickedSlide:function(e){var t,a=this,i=a.params,s=m(e.target).closest("."+i.slideClass)[0],r=!1;if(s)for(var n=0;n<a.slides.length;n+=1)if(a.slides[n]===s){r=!0,t=n;break}if(!s||!r)return a.clickedSlide=void 0,void(a.clickedIndex=void 0);a.clickedSlide=s,a.virtual&&a.params.virtual.enabled?a.clickedIndex=parseInt(m(s).attr("data-swiper-slide-index"),10):a.clickedIndex=t,i.slideToClickedSlide&&void 0!==a.clickedIndex&&a.clickedIndex!==a.activeIndex&&a.slideToClickedSlide()}},translate:{getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");var t=this,a=t.params,i=t.rtlTranslate,s=t.translate,r=t.$wrapperEl;if(a.virtualTranslate)return i?-s:s;if(a.cssMode)return s;var n=T(r[0],e);return i&&(n=-n),n||0},setTranslate:function(e,t){var a=this,i=a.rtlTranslate,s=a.params,r=a.$wrapperEl,n=a.wrapperEl,l=a.progress,o=0,d=0;a.isHorizontal()?o=i?-e:e:d=e,s.roundLengths&&(o=Math.floor(o),d=Math.floor(d)),s.cssMode?n[a.isHorizontal()?"scrollLeft":"scrollTop"]=a.isHorizontal()?-o:-d:s.virtualTranslate||r.transform("translate3d("+o+"px, "+d+"px, 0px)"),a.previousTranslate=a.translate,a.translate=a.isHorizontal()?o:d;var p=a.maxTranslate()-a.minTranslate();(0===p?0:(e-a.minTranslate())/p)!==l&&a.updateProgress(e),a.emit("setTranslate",a.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,a,i,s){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0),void 0===i&&(i=!0);var r=this,n=r.params,l=r.wrapperEl;if(r.animating&&n.preventInteractionOnTransition)return!1;var o,d=r.minTranslate(),p=r.maxTranslate();if(o=i&&e>d?d:i&&e<p?p:e,r.updateProgress(o),n.cssMode){var u,c=r.isHorizontal();if(0===t)l[c?"scrollLeft":"scrollTop"]=-o;else if(l.scrollTo)l.scrollTo(((u={})[c?"left":"top"]=-o,u.behavior="smooth",u));else l[c?"scrollLeft":"scrollTop"]=-o;return!0}return 0===t?(r.setTransition(0),r.setTranslate(o),a&&(r.emit("beforeTransitionStart",t,s),r.emit("transitionEnd"))):(r.setTransition(t),r.setTranslate(o),a&&(r.emit("beforeTransitionStart",t,s),r.emit("transitionStart")),r.animating||(r.animating=!0,r.onTranslateToWrapperTransitionEnd||(r.onTranslateToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.$wrapperEl[0].removeEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.$wrapperEl[0].removeEventListener("webkitTransitionEnd",r.onTranslateToWrapperTransitionEnd),r.onTranslateToWrapperTransitionEnd=null,delete r.onTranslateToWrapperTransitionEnd,a&&r.emit("transitionEnd"))}),r.$wrapperEl[0].addEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.$wrapperEl[0].addEventListener("webkitTransitionEnd",r.onTranslateToWrapperTransitionEnd))),!0}},transition:{setTransition:function(e,t){var a=this;a.params.cssMode||a.$wrapperEl.transition(e),a.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);var a=this,i=a.activeIndex,s=a.params,r=a.previousIndex;if(!s.cssMode){s.autoHeight&&a.updateAutoHeight();var n=t;if(n||(n=i>r?"next":i<r?"prev":"reset"),a.emit("transitionStart"),e&&i!==r){if("reset"===n)return void a.emit("slideResetTransitionStart");a.emit("slideChangeTransitionStart"),"next"===n?a.emit("slideNextTransitionStart"):a.emit("slidePrevTransitionStart")}}},transitionEnd:function(e,t){void 0===e&&(e=!0);var a=this,i=a.activeIndex,s=a.previousIndex,r=a.params;if(a.animating=!1,!r.cssMode){a.setTransition(0);var n=t;if(n||(n=i>s?"next":i<s?"prev":"reset"),a.emit("transitionEnd"),e&&i!==s){if("reset"===n)return void a.emit("slideResetTransitionEnd");a.emit("slideChangeTransitionEnd"),"next"===n?a.emit("slideNextTransitionEnd"):a.emit("slidePrevTransitionEnd")}}}},slide:{slideTo:function(e,t,a,i,s){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0),"number"!=typeof e&&"string"!=typeof e)throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. ["+typeof e+"] given.");if("string"==typeof e){var r=parseInt(e,10);if(!isFinite(r))throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. ["+e+"] given.");e=r}var n=this,l=e;l<0&&(l=0);var o=n.params,d=n.snapGrid,p=n.slidesGrid,u=n.previousIndex,c=n.activeIndex,h=n.rtlTranslate,v=n.wrapperEl,f=n.enabled;if(n.animating&&o.preventInteractionOnTransition||!f&&!i&&!s)return!1;var m=Math.min(n.params.slidesPerGroupSkip,l),g=m+Math.floor((l-m)/n.params.slidesPerGroup);g>=d.length&&(g=d.length-1),(c||o.initialSlide||0)===(u||0)&&a&&n.emit("beforeSlideChangeStart");var b,y=-d[g];if(n.updateProgress(y),o.normalizeSlideIndex)for(var w=0;w<p.length;w+=1){var E=-Math.floor(100*y),x=Math.floor(100*p[w]),T=Math.floor(100*p[w+1]);void 0!==p[w+1]?E>=x&&E<T-(T-x)/2?l=w:E>=x&&E<T&&(l=w+1):E>=x&&(l=w)}if(n.initialized&&l!==c){if(!n.allowSlideNext&&y<n.translate&&y<n.minTranslate())return!1;if(!n.allowSlidePrev&&y>n.translate&&y>n.maxTranslate()&&(c||0)!==l)return!1}if(b=l>c?"next":l<c?"prev":"reset",h&&-y===n.translate||!h&&y===n.translate)return n.updateActiveIndex(l),o.autoHeight&&n.updateAutoHeight(),n.updateSlidesClasses(),"slide"!==o.effect&&n.setTranslate(y),"reset"!==b&&(n.transitionStart(a,b),n.transitionEnd(a,b)),!1;if(o.cssMode){var C,S=n.isHorizontal(),M=-y;if(h&&(M=v.scrollWidth-v.offsetWidth-M),0===t)v[S?"scrollLeft":"scrollTop"]=M;else if(v.scrollTo)v.scrollTo(((C={})[S?"left":"top"]=M,C.behavior="smooth",C));else v[S?"scrollLeft":"scrollTop"]=M;return!0}return 0===t?(n.setTransition(0),n.setTranslate(y),n.updateActiveIndex(l),n.updateSlidesClasses(),n.emit("beforeTransitionStart",t,i),n.transitionStart(a,b),n.transitionEnd(a,b)):(n.setTransition(t),n.setTranslate(y),n.updateActiveIndex(l),n.updateSlidesClasses(),n.emit("beforeTransitionStart",t,i),n.transitionStart(a,b),n.animating||(n.animating=!0,n.onSlideToWrapperTransitionEnd||(n.onSlideToWrapperTransitionEnd=function(e){n&&!n.destroyed&&e.target===this&&(n.$wrapperEl[0].removeEventListener("transitionend",n.onSlideToWrapperTransitionEnd),n.$wrapperEl[0].removeEventListener("webkitTransitionEnd",n.onSlideToWrapperTransitionEnd),n.onSlideToWrapperTransitionEnd=null,delete n.onSlideToWrapperTransitionEnd,n.transitionEnd(a,b))}),n.$wrapperEl[0].addEventListener("transitionend",n.onSlideToWrapperTransitionEnd),n.$wrapperEl[0].addEventListener("webkitTransitionEnd",n.onSlideToWrapperTransitionEnd))),!0},slideToLoop:function(e,t,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0);var s=this,r=e;return s.params.loop&&(r+=s.loopedSlides),s.slideTo(r,t,a,i)},slideNext:function(e,t,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var i=this,s=i.params,r=i.animating;if(!i.enabled)return i;var n=i.activeIndex<s.slidesPerGroupSkip?1:s.slidesPerGroup;if(s.loop){if(r&&s.loopPreventsSlide)return!1;i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft}return i.slideTo(i.activeIndex+n,e,t,a)},slidePrev:function(e,t,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var i=this,s=i.params,r=i.animating,n=i.snapGrid,l=i.slidesGrid,o=i.rtlTranslate;if(!i.enabled)return i;if(s.loop){if(r&&s.loopPreventsSlide)return!1;i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft}function d(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}var p=d(o?i.translate:-i.translate),u=n.map((function(e){return d(e)}));n[u.indexOf(p)];var c,h=n[u.indexOf(p)-1];return void 0===h&&s.cssMode&&n.forEach((function(e){!h&&p>=e&&(h=e)})),void 0!==h&&(c=l.indexOf(h))<0&&(c=i.activeIndex-1),i.slideTo(c,e,t,a)},slideReset:function(e,t,a){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,a)},slideToClosest:function(e,t,a,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===i&&(i=.5);var s=this,r=s.activeIndex,n=Math.min(s.params.slidesPerGroupSkip,r),l=n+Math.floor((r-n)/s.params.slidesPerGroup),o=s.rtlTranslate?s.translate:-s.translate;if(o>=s.snapGrid[l]){var d=s.snapGrid[l];o-d>(s.snapGrid[l+1]-d)*i&&(r+=s.params.slidesPerGroup)}else{var p=s.snapGrid[l-1];o-p<=(s.snapGrid[l]-p)*i&&(r-=s.params.slidesPerGroup)}return r=Math.max(r,0),r=Math.min(r,s.slidesGrid.length-1),s.slideTo(r,e,t,a)},slideToClickedSlide:function(){var e,t=this,a=t.params,i=t.$wrapperEl,s="auto"===a.slidesPerView?t.slidesPerViewDynamic():a.slidesPerView,r=t.clickedIndex;if(a.loop){if(t.animating)return;e=parseInt(m(t.clickedSlide).attr("data-swiper-slide-index"),10),a.centeredSlides?r<t.loopedSlides-s/2||r>t.slides.length-t.loopedSlides+s/2?(t.loopFix(),r=i.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+a.slideDuplicateClass+")").eq(0).index(),E((function(){t.slideTo(r)}))):t.slideTo(r):r>t.slides.length-s?(t.loopFix(),r=i.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+a.slideDuplicateClass+")").eq(0).index(),E((function(){t.slideTo(r)}))):t.slideTo(r)}else t.slideTo(r)}},loop:{loopCreate:function(){var e=this,t=r(),a=e.params,i=e.$wrapperEl;i.children("."+a.slideClass+"."+a.slideDuplicateClass).remove();var s=i.children("."+a.slideClass);if(a.loopFillGroupWithBlank){var n=a.slidesPerGroup-s.length%a.slidesPerGroup;if(n!==a.slidesPerGroup){for(var l=0;l<n;l+=1){var o=m(t.createElement("div")).addClass(a.slideClass+" "+a.slideBlankClass);i.append(o)}s=i.children("."+a.slideClass)}}"auto"!==a.slidesPerView||a.loopedSlides||(a.loopedSlides=s.length),e.loopedSlides=Math.ceil(parseFloat(a.loopedSlides||a.slidesPerView,10)),e.loopedSlides+=a.loopAdditionalSlides,e.loopedSlides>s.length&&(e.loopedSlides=s.length);var d=[],p=[];s.each((function(t,a){var i=m(t);a<e.loopedSlides&&p.push(t),a<s.length&&a>=s.length-e.loopedSlides&&d.push(t),i.attr("data-swiper-slide-index",a)}));for(var u=0;u<p.length;u+=1)i.append(m(p[u].cloneNode(!0)).addClass(a.slideDuplicateClass));for(var c=d.length-1;c>=0;c-=1)i.prepend(m(d[c].cloneNode(!0)).addClass(a.slideDuplicateClass))},loopFix:function(){var e=this;e.emit("beforeLoopFix");var t,a=e.activeIndex,i=e.slides,s=e.loopedSlides,r=e.allowSlidePrev,n=e.allowSlideNext,l=e.snapGrid,o=e.rtlTranslate;e.allowSlidePrev=!0,e.allowSlideNext=!0;var d=-l[a]-e.getTranslate();if(a<s)t=i.length-3*s+a,t+=s,e.slideTo(t,0,!1,!0)&&0!==d&&e.setTranslate((o?-e.translate:e.translate)-d);else if(a>=i.length-s){t=-i.length+a+s,t+=s,e.slideTo(t,0,!1,!0)&&0!==d&&e.setTranslate((o?-e.translate:e.translate)-d)}e.allowSlidePrev=r,e.allowSlideNext=n,e.emit("loopFix")},loopDestroy:function(){var e=this,t=e.$wrapperEl,a=e.params,i=e.slides;t.children("."+a.slideClass+"."+a.slideDuplicateClass+",."+a.slideClass+"."+a.slideBlankClass).remove(),i.removeAttr("data-swiper-slide-index")}},grabCursor:{setGrabCursor:function(e){var t=this;if(!(t.support.touch||!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)){var a=t.el;a.style.cursor="move",a.style.cursor=e?"-webkit-grabbing":"-webkit-grab",a.style.cursor=e?"-moz-grabbin":"-moz-grab",a.style.cursor=e?"grabbing":"grab"}},unsetGrabCursor:function(){var e=this;e.support.touch||e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e.el.style.cursor="")}},manipulation:{appendSlide:function(e){var t=this,a=t.$wrapperEl,i=t.params;if(i.loop&&t.loopDestroy(),"object"==typeof e&&"length"in e)for(var s=0;s<e.length;s+=1)e[s]&&a.append(e[s]);else a.append(e);i.loop&&t.loopCreate(),i.observer&&t.support.observer||t.update()},prependSlide:function(e){var t=this,a=t.params,i=t.$wrapperEl,s=t.activeIndex;a.loop&&t.loopDestroy();var r=s+1;if("object"==typeof e&&"length"in e){for(var n=0;n<e.length;n+=1)e[n]&&i.prepend(e[n]);r=s+e.length}else i.prepend(e);a.loop&&t.loopCreate(),a.observer&&t.support.observer||t.update(),t.slideTo(r,0,!1)},addSlide:function(e,t){var a=this,i=a.$wrapperEl,s=a.params,r=a.activeIndex;s.loop&&(r-=a.loopedSlides,a.loopDestroy(),a.slides=i.children("."+s.slideClass));var n=a.slides.length;if(e<=0)a.prependSlide(t);else if(e>=n)a.appendSlide(t);else{for(var l=r>e?r+1:r,o=[],d=n-1;d>=e;d-=1){var p=a.slides.eq(d);p.remove(),o.unshift(p)}if("object"==typeof t&&"length"in t){for(var u=0;u<t.length;u+=1)t[u]&&i.append(t[u]);l=r>e?r+t.length:r}else i.append(t);for(var c=0;c<o.length;c+=1)i.append(o[c]);s.loop&&a.loopCreate(),s.observer&&a.support.observer||a.update(),s.loop?a.slideTo(l+a.loopedSlides,0,!1):a.slideTo(l,0,!1)}},removeSlide:function(e){var t=this,a=t.params,i=t.$wrapperEl,s=t.activeIndex;a.loop&&(s-=t.loopedSlides,t.loopDestroy(),t.slides=i.children("."+a.slideClass));var r,n=s;if("object"==typeof e&&"length"in e){for(var l=0;l<e.length;l+=1)r=e[l],t.slides[r]&&t.slides.eq(r).remove(),r<n&&(n-=1);n=Math.max(n,0)}else r=e,t.slides[r]&&t.slides.eq(r).remove(),r<n&&(n-=1),n=Math.max(n,0);a.loop&&t.loopCreate(),a.observer&&t.support.observer||t.update(),a.loop?t.slideTo(n+t.loopedSlides,0,!1):t.slideTo(n,0,!1)},removeAllSlides:function(){for(var e=[],t=0;t<this.slides.length;t+=1)e.push(t);this.removeSlide(e)}},events:{attachEvents:function(){var e=this,t=r(),a=e.params,i=e.touchEvents,s=e.el,n=e.wrapperEl,l=e.device,o=e.support;e.onTouchStart=A.bind(e),e.onTouchMove=D.bind(e),e.onTouchEnd=N.bind(e),a.cssMode&&(e.onScroll=H.bind(e)),e.onClick=B.bind(e);var d=!!a.nested;if(!o.touch&&o.pointerEvents)s.addEventListener(i.start,e.onTouchStart,!1),t.addEventListener(i.move,e.onTouchMove,d),t.addEventListener(i.end,e.onTouchEnd,!1);else{if(o.touch){var p=!("touchstart"!==i.start||!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};s.addEventListener(i.start,e.onTouchStart,p),s.addEventListener(i.move,e.onTouchMove,o.passiveListener?{passive:!1,capture:d}:d),s.addEventListener(i.end,e.onTouchEnd,p),i.cancel&&s.addEventListener(i.cancel,e.onTouchEnd,p),X||(t.addEventListener("touchstart",Y),X=!0)}(a.simulateTouch&&!l.ios&&!l.android||a.simulateTouch&&!o.touch&&l.ios)&&(s.addEventListener("mousedown",e.onTouchStart,!1),t.addEventListener("mousemove",e.onTouchMove,d),t.addEventListener("mouseup",e.onTouchEnd,!1))}(a.preventClicks||a.preventClicksPropagation)&&s.addEventListener("click",e.onClick,!0),a.cssMode&&n.addEventListener("scroll",e.onScroll),a.updateOnWindowResize?e.on(l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",G,!0):e.on("observerUpdate",G,!0)},detachEvents:function(){var e=this,t=r(),a=e.params,i=e.touchEvents,s=e.el,n=e.wrapperEl,l=e.device,o=e.support,d=!!a.nested;if(!o.touch&&o.pointerEvents)s.removeEventListener(i.start,e.onTouchStart,!1),t.removeEventListener(i.move,e.onTouchMove,d),t.removeEventListener(i.end,e.onTouchEnd,!1);else{if(o.touch){var p=!("onTouchStart"!==i.start||!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};s.removeEventListener(i.start,e.onTouchStart,p),s.removeEventListener(i.move,e.onTouchMove,d),s.removeEventListener(i.end,e.onTouchEnd,p),i.cancel&&s.removeEventListener(i.cancel,e.onTouchEnd,p)}(a.simulateTouch&&!l.ios&&!l.android||a.simulateTouch&&!o.touch&&l.ios)&&(s.removeEventListener("mousedown",e.onTouchStart,!1),t.removeEventListener("mousemove",e.onTouchMove,d),t.removeEventListener("mouseup",e.onTouchEnd,!1))}(a.preventClicks||a.preventClicksPropagation)&&s.removeEventListener("click",e.onClick,!0),a.cssMode&&n.removeEventListener("scroll",e.onScroll),e.off(l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",G)}},breakpoints:{setBreakpoint:function(){var e=this,t=e.activeIndex,a=e.initialized,i=e.loopedSlides,s=void 0===i?0:i,r=e.params,n=e.$el,l=r.breakpoints;if(l&&(!l||0!==Object.keys(l).length)){var o=e.getBreakpoint(l,e.params.breakpointsBase,e.el);if(o&&e.currentBreakpoint!==o){var d=o in l?l[o]:void 0;d&&["slidesPerView","spaceBetween","slidesPerGroup","slidesPerGroupSkip","slidesPerColumn"].forEach((function(e){var t=d[e];void 0!==t&&(d[e]="slidesPerView"!==e||"AUTO"!==t&&"auto"!==t?"slidesPerView"===e?parseFloat(t):parseInt(t,10):"auto")}));var p=d||e.originalParams,u=r.slidesPerColumn>1,c=p.slidesPerColumn>1,h=r.enabled;u&&!c?(n.removeClass(r.containerModifierClass+"multirow "+r.containerModifierClass+"multirow-column"),e.emitContainerClasses()):!u&&c&&(n.addClass(r.containerModifierClass+"multirow"),"column"===p.slidesPerColumnFill&&n.addClass(r.containerModifierClass+"multirow-column"),e.emitContainerClasses());var v=p.direction&&p.direction!==r.direction,f=r.loop&&(p.slidesPerView!==r.slidesPerView||v);v&&a&&e.changeDirection(),S(e.params,p);var m=e.params.enabled;S(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),h&&!m?e.disable():!h&&m&&e.enable(),e.currentBreakpoint=o,e.emit("_beforeBreakpoint",p),f&&a&&(e.loopDestroy(),e.loopCreate(),e.updateSlides(),e.slideTo(t-s+e.loopedSlides,0,!1)),e.emit("breakpoint",p)}}},getBreakpoint:function(e,t,a){if(void 0===t&&(t="window"),e&&("container"!==t||a)){var i=!1,s=l(),r="window"===t?s.innerWidth:a.clientWidth,n="window"===t?s.innerHeight:a.clientHeight,o=Object.keys(e).map((function(e){if("string"==typeof e&&0===e.indexOf("@")){var t=parseFloat(e.substr(1));return{value:n*t,point:e}}return{value:e,point:e}}));o.sort((function(e,t){return parseInt(e.value,10)-parseInt(t.value,10)}));for(var d=0;d<o.length;d+=1){var p=o[d],u=p.point;p.value<=r&&(i=u)}return i||"max"}}},checkOverflow:{checkOverflow:function(){var e=this,t=e.params,a=e.isLocked,i=e.slides.length>0&&t.slidesOffsetBefore+t.spaceBetween*(e.slides.length-1)+e.slides[0].offsetWidth*e.slides.length;t.slidesOffsetBefore&&t.slidesOffsetAfter&&i?e.isLocked=i<=e.size:e.isLocked=1===e.snapGrid.length,e.allowSlideNext=!e.isLocked,e.allowSlidePrev=!e.isLocked,a!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock"),a&&a!==e.isLocked&&(e.isEnd=!1,e.navigation&&e.navigation.update())}},classes:{addClasses:function(){var e,t,a,i=this,s=i.classNames,r=i.params,n=i.rtl,l=i.$el,o=i.device,d=i.support,p=(e=["initialized",r.direction,{"pointer-events":d.pointerEvents&&!d.touch},{"free-mode":r.freeMode},{autoheight:r.autoHeight},{rtl:n},{multirow:r.slidesPerColumn>1},{"multirow-column":r.slidesPerColumn>1&&"column"===r.slidesPerColumnFill},{android:o.android},{ios:o.ios},{"css-mode":r.cssMode}],t=r.containerModifierClass,a=[],e.forEach((function(e){"object"==typeof e?Object.keys(e).forEach((function(i){e[i]&&a.push(t+i)})):"string"==typeof e&&a.push(t+e)})),a);s.push.apply(s,p),l.addClass([].concat(s).join(" ")),i.emitContainerClasses()},removeClasses:function(){var e=this,t=e.$el,a=e.classNames;t.removeClass(a.join(" ")),e.emitContainerClasses()}},images:{loadImage:function(e,t,a,i,s,r){var n,o=l();function d(){r&&r()}m(e).parent("picture")[0]||e.complete&&s?d():t?((n=new o.Image).onload=d,n.onerror=d,i&&(n.sizes=i),a&&(n.srcset=a),t&&(n.src=t)):d()},preloadImages:function(){var e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")))}e.imagesToLoad=e.$el.find("img");for(var a=0;a<e.imagesToLoad.length;a+=1){var i=e.imagesToLoad[a];e.loadImage(i,i.currentSrc||i.getAttribute("src"),i.srcset||i.getAttribute("srcset"),i.sizes||i.getAttribute("sizes"),!0,t)}}}},V={},F=function(){function t(){for(var e,a,i=arguments.length,s=new Array(i),r=0;r<i;r++)s[r]=arguments[r];if(1===s.length&&s[0].constructor&&"Object"===Object.prototype.toString.call(s[0]).slice(8,-1)?a=s[0]:(e=s[0],a=s[1]),a||(a={}),a=S({},a),e&&!a.el&&(a.el=e),a.el&&m(a.el).length>1){var n=[];return m(a.el).each((function(e){var i=S({},a,{el:e});n.push(new t(i))})),n}var l=this;l.__swiper__=!0,l.support=P(),l.device=k({userAgent:a.userAgent}),l.browser=$(),l.eventsListeners={},l.eventsAnyListeners=[],void 0===l.modules&&(l.modules={}),Object.keys(l.modules).forEach((function(e){var t=l.modules[e];if(t.params){var i=Object.keys(t.params)[0],s=t.params[i];if("object"!=typeof s||null===s)return;if(!(i in a)||!("enabled"in s))return;!0===a[i]&&(a[i]={enabled:!0}),"object"!=typeof a[i]||"enabled"in a[i]||(a[i].enabled=!0),a[i]||(a[i]={enabled:!1})}}));var o,d,p=S({},R);return l.useParams(p),l.params=S({},p,V,a),l.originalParams=S({},l.params),l.passedParams=S({},a),l.params&&l.params.on&&Object.keys(l.params.on).forEach((function(e){l.on(e,l.params.on[e])})),l.params&&l.params.onAny&&l.onAny(l.params.onAny),l.$=m,S(l,{enabled:l.params.enabled,el:e,classNames:[],slides:m(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:function(){return"horizontal"===l.params.direction},isVertical:function(){return"vertical"===l.params.direction},activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:l.params.allowSlideNext,allowSlidePrev:l.params.allowSlidePrev,touchEvents:(o=["touchstart","touchmove","touchend","touchcancel"],d=["mousedown","mousemove","mouseup"],l.support.pointerEvents&&(d=["pointerdown","pointermove","pointerup"]),l.touchEventsTouch={start:o[0],move:o[1],end:o[2],cancel:o[3]},l.touchEventsDesktop={start:d[0],move:d[1],end:d[2]},l.support.touch||!l.params.simulateTouch?l.touchEventsTouch:l.touchEventsDesktop),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,formElements:"input, select, option, textarea, button, video, label",lastClickTime:x(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:l.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),l.useModules(),l.emit("_swiper"),l.params.init&&l.init(),l}var a,i,s,r=t.prototype;return r.enable=function(){var e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))},r.disable=function(){var e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))},r.setProgress=function(e,t){var a=this;e=Math.min(Math.max(e,0),1);var i=a.minTranslate(),s=(a.maxTranslate()-i)*e+i;a.translateTo(s,void 0===t?0:t),a.updateActiveIndex(),a.updateSlidesClasses()},r.emitContainerClasses=function(){var e=this;if(e.params._emitClasses&&e.el){var t=e.el.className.split(" ").filter((function(t){return 0===t.indexOf("swiper-container")||0===t.indexOf(e.params.containerModifierClass)}));e.emit("_containerClasses",t.join(" "))}},r.getSlideClasses=function(e){var t=this;return e.className.split(" ").filter((function(e){return 0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass)})).join(" ")},r.emitSlidesClasses=function(){var e=this;if(e.params._emitClasses&&e.el){var t=[];e.slides.each((function(a){var i=e.getSlideClasses(a);t.push({slideEl:a,classNames:i}),e.emit("_slideClass",a,i)})),e.emit("_slideClasses",t)}},r.slidesPerViewDynamic=function(){var e=this,t=e.params,a=e.slides,i=e.slidesGrid,s=e.size,r=e.activeIndex,n=1;if(t.centeredSlides){for(var l,o=a[r].swiperSlideSize,d=r+1;d<a.length;d+=1)a[d]&&!l&&(n+=1,(o+=a[d].swiperSlideSize)>s&&(l=!0));for(var p=r-1;p>=0;p-=1)a[p]&&!l&&(n+=1,(o+=a[p].swiperSlideSize)>s&&(l=!0))}else for(var u=r+1;u<a.length;u+=1)i[u]-i[r]<s&&(n+=1);return n},r.update=function(){var e=this;if(e&&!e.destroyed){var t=e.snapGrid,a=e.params;a.breakpoints&&e.setBreakpoint(),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode?(i(),e.params.autoHeight&&e.updateAutoHeight()):(("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0))||i(),a.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}function i(){var t=e.rtlTranslate?-1*e.translate:e.translate,a=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(a),e.updateActiveIndex(),e.updateSlidesClasses()}},r.changeDirection=function(e,t){void 0===t&&(t=!0);var a=this,i=a.params.direction;return e||(e="horizontal"===i?"vertical":"horizontal"),e===i||"horizontal"!==e&&"vertical"!==e||(a.$el.removeClass(""+a.params.containerModifierClass+i).addClass(""+a.params.containerModifierClass+e),a.emitContainerClasses(),a.params.direction=e,a.slides.each((function(t){"vertical"===e?t.style.width="":t.style.height=""})),a.emit("changeDirection"),t&&a.update()),a},r.mount=function(e){var t=this;if(t.mounted)return!0;var a,i=m(e||t.params.el);return!!(e=i[0])&&(e.swiper=t,e&&e.shadowRoot&&e.shadowRoot.querySelector?(a=m(e.shadowRoot.querySelector("."+t.params.wrapperClass))).children=function(e){return i.children(e)}:a=i.children("."+t.params.wrapperClass),S(t,{$el:i,el:e,$wrapperEl:a,wrapperEl:a[0],mounted:!0,rtl:"rtl"===e.dir.toLowerCase()||"rtl"===i.css("direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===e.dir.toLowerCase()||"rtl"===i.css("direction")),wrongRTL:"-webkit-box"===a.css("display")}),!0)},r.init=function(e){var t=this;return t.initialized||!1===t.mount(e)||(t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.params.loop&&t.loopCreate(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.preloadImages&&t.preloadImages(),t.params.loop?t.slideTo(t.params.initialSlide+t.loopedSlides,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.attachEvents(),t.initialized=!0,t.emit("init"),t.emit("afterInit")),t},r.destroy=function(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);var a,i=this,s=i.params,r=i.$el,n=i.$wrapperEl,l=i.slides;return void 0===i.params||i.destroyed||(i.emit("beforeDestroy"),i.initialized=!1,i.detachEvents(),s.loop&&i.loopDestroy(),t&&(i.removeClasses(),r.removeAttr("style"),n.removeAttr("style"),l&&l.length&&l.removeClass([s.slideVisibleClass,s.slideActiveClass,s.slideNextClass,s.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),i.emit("destroy"),Object.keys(i.eventsListeners).forEach((function(e){i.off(e)})),!1!==e&&(i.$el[0].swiper=null,a=i,Object.keys(a).forEach((function(e){try{a[e]=null}catch(e){}try{delete a[e]}catch(e){}}))),i.destroyed=!0),null},t.extendDefaults=function(e){S(V,e)},t.installModule=function(e){t.prototype.modules||(t.prototype.modules={});var a=e.name||Object.keys(t.prototype.modules).length+"_"+x();t.prototype.modules[a]=e},t.use=function(e){return Array.isArray(e)?(e.forEach((function(e){return t.installModule(e)})),t):(t.installModule(e),t)},a=t,s=[{key:"extendedDefaults",get:function(){return V}},{key:"defaults",get:function(){return R}}],(i=null)&&e(a.prototype,i),s&&e(a,s),t}();Object.keys(W).forEach((function(e){Object.keys(W[e]).forEach((function(t){F.prototype[t]=W[e][t]}))})),F.use([L,O]);var _={update:function(e){var t=this,a=t.params,i=a.slidesPerView,s=a.slidesPerGroup,r=a.centeredSlides,n=t.params.virtual,l=n.addSlidesBefore,o=n.addSlidesAfter,d=t.virtual,p=d.from,u=d.to,c=d.slides,h=d.slidesGrid,v=d.renderSlide,f=d.offset;t.updateActiveIndex();var m,g,b,y=t.activeIndex||0;m=t.rtlTranslate?"right":t.isHorizontal()?"left":"top",r?(g=Math.floor(i/2)+s+o,b=Math.floor(i/2)+s+l):(g=i+(s-1)+o,b=s+l);var w=Math.max((y||0)-b,0),E=Math.min((y||0)+g,c.length-1),x=(t.slidesGrid[w]||0)-(t.slidesGrid[0]||0);function T(){t.updateSlides(),t.updateProgress(),t.updateSlidesClasses(),t.lazy&&t.params.lazy.enabled&&t.lazy.load()}if(S(t.virtual,{from:w,to:E,offset:x,slidesGrid:t.slidesGrid}),p===w&&u===E&&!e)return t.slidesGrid!==h&&x!==f&&t.slides.css(m,x+"px"),void t.updateProgress();if(t.params.virtual.renderExternal)return t.params.virtual.renderExternal.call(t,{offset:x,from:w,to:E,slides:function(){for(var e=[],t=w;t<=E;t+=1)e.push(c[t]);return e}()}),void(t.params.virtual.renderExternalUpdate&&T());var C=[],M=[];if(e)t.$wrapperEl.find("."+t.params.slideClass).remove();else for(var z=p;z<=u;z+=1)(z<w||z>E)&&t.$wrapperEl.find("."+t.params.slideClass+'[data-swiper-slide-index="'+z+'"]').remove();for(var P=0;P<c.length;P+=1)P>=w&&P<=E&&(void 0===u||e?M.push(P):(P>u&&M.push(P),P<p&&C.push(P)));M.forEach((function(e){t.$wrapperEl.append(v(c[e],e))})),C.sort((function(e,t){return t-e})).forEach((function(e){t.$wrapperEl.prepend(v(c[e],e))})),t.$wrapperEl.children(".swiper-slide").css(m,x+"px"),T()},renderSlide:function(e,t){var a=this,i=a.params.virtual;if(i.cache&&a.virtual.cache[t])return a.virtual.cache[t];var s=i.renderSlide?m(i.renderSlide.call(a,e,t)):m('<div class="'+a.params.slideClass+'" data-swiper-slide-index="'+t+'">'+e+"</div>");return s.attr("data-swiper-slide-index")||s.attr("data-swiper-slide-index",t),i.cache&&(a.virtual.cache[t]=s),s},appendSlide:function(e){var t=this;if("object"==typeof e&&"length"in e)for(var a=0;a<e.length;a+=1)e[a]&&t.virtual.slides.push(e[a]);else t.virtual.slides.push(e);t.virtual.update(!0)},prependSlide:function(e){var t=this,a=t.activeIndex,i=a+1,s=1;if(Array.isArray(e)){for(var r=0;r<e.length;r+=1)e[r]&&t.virtual.slides.unshift(e[r]);i=a+e.length,s=e.length}else t.virtual.slides.unshift(e);if(t.params.virtual.cache){var n=t.virtual.cache,l={};Object.keys(n).forEach((function(e){var t=n[e],a=t.attr("data-swiper-slide-index");a&&t.attr("data-swiper-slide-index",parseInt(a,10)+1),l[parseInt(e,10)+s]=t})),t.virtual.cache=l}t.virtual.update(!0),t.slideTo(i,0)},removeSlide:function(e){var t=this;if(null!=e){var a=t.activeIndex;if(Array.isArray(e))for(var i=e.length-1;i>=0;i-=1)t.virtual.slides.splice(e[i],1),t.params.virtual.cache&&delete t.virtual.cache[e[i]],e[i]<a&&(a-=1),a=Math.max(a,0);else t.virtual.slides.splice(e,1),t.params.virtual.cache&&delete t.virtual.cache[e],e<a&&(a-=1),a=Math.max(a,0);t.virtual.update(!0),t.slideTo(a,0)}},removeAllSlides:function(){var e=this;e.virtual.slides=[],e.params.virtual.cache&&(e.virtual.cache={}),e.virtual.update(!0),e.slideTo(0,0)}},q={name:"virtual",params:{virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}},create:function(){M(this,{virtual:t({},_,{slides:this.params.virtual.slides,cache:{}})})},on:{beforeInit:function(e){if(e.params.virtual.enabled){e.classNames.push(e.params.containerModifierClass+"virtual");var t={watchSlidesProgress:!0};S(e.params,t),S(e.originalParams,t),e.params.initialSlide||e.virtual.update()}},setTranslate:function(e){e.params.virtual.enabled&&e.virtual.update()}}},j={handle:function(e){var t=this;if(t.enabled){var a=l(),i=r(),s=t.rtlTranslate,n=e;n.originalEvent&&(n=n.originalEvent);var o=n.keyCode||n.charCode,d=t.params.keyboard.pageUpDown,p=d&&33===o,u=d&&34===o,c=37===o,h=39===o,v=38===o,f=40===o;if(!t.allowSlideNext&&(t.isHorizontal()&&h||t.isVertical()&&f||u))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&c||t.isVertical()&&v||p))return!1;if(!(n.shiftKey||n.altKey||n.ctrlKey||n.metaKey||i.activeElement&&i.activeElement.nodeName&&("input"===i.activeElement.nodeName.toLowerCase()||"textarea"===i.activeElement.nodeName.toLowerCase()))){if(t.params.keyboard.onlyInViewport&&(p||u||c||h||v||f)){var m=!1;if(t.$el.parents("."+t.params.slideClass).length>0&&0===t.$el.parents("."+t.params.slideActiveClass).length)return;var g=t.$el,b=g[0].clientWidth,y=g[0].clientHeight,w=a.innerWidth,E=a.innerHeight,x=t.$el.offset();s&&(x.left-=t.$el[0].scrollLeft);for(var T=[[x.left,x.top],[x.left+b,x.top],[x.left,x.top+y],[x.left+b,x.top+y]],C=0;C<T.length;C+=1){var S=T[C];if(S[0]>=0&&S[0]<=w&&S[1]>=0&&S[1]<=E){if(0===S[0]&&0===S[1])continue;m=!0}}if(!m)return}t.isHorizontal()?((p||u||c||h)&&(n.preventDefault?n.preventDefault():n.returnValue=!1),((u||h)&&!s||(p||c)&&s)&&t.slideNext(),((p||c)&&!s||(u||h)&&s)&&t.slidePrev()):((p||u||v||f)&&(n.preventDefault?n.preventDefault():n.returnValue=!1),(u||f)&&t.slideNext(),(p||v)&&t.slidePrev()),t.emit("keyPress",o)}}},enable:function(){var e=this,t=r();e.keyboard.enabled||(m(t).on("keydown",e.keyboard.handle),e.keyboard.enabled=!0)},disable:function(){var e=this,t=r();e.keyboard.enabled&&(m(t).off("keydown",e.keyboard.handle),e.keyboard.enabled=!1)}},U={name:"keyboard",params:{keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}},create:function(){M(this,{keyboard:t({enabled:!1},j)})},on:{init:function(e){e.params.keyboard.enabled&&e.keyboard.enable()},destroy:function(e){e.keyboard.enabled&&e.keyboard.disable()}}};var K={lastScrollTime:x(),lastEventBeforeSnap:void 0,recentWheelEvents:[],event:function(){return l().navigator.userAgent.indexOf("firefox")>-1?"DOMMouseScroll":function(){var e=r(),t="onwheel",a=t in e;if(!a){var i=e.createElement("div");i.setAttribute(t,"return;"),a="function"==typeof i.onwheel}return!a&&e.implementation&&e.implementation.hasFeature&&!0!==e.implementation.hasFeature("","")&&(a=e.implementation.hasFeature("Events.wheel","3.0")),a}()?"wheel":"mousewheel"},normalize:function(e){var t=0,a=0,i=0,s=0;return"detail"in e&&(a=e.detail),"wheelDelta"in e&&(a=-e.wheelDelta/120),"wheelDeltaY"in e&&(a=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=a,a=0),i=10*t,s=10*a,"deltaY"in e&&(s=e.deltaY),"deltaX"in e&&(i=e.deltaX),e.shiftKey&&!i&&(i=s,s=0),(i||s)&&e.deltaMode&&(1===e.deltaMode?(i*=40,s*=40):(i*=800,s*=800)),i&&!t&&(t=i<1?-1:1),s&&!a&&(a=s<1?-1:1),{spinX:t,spinY:a,pixelX:i,pixelY:s}},handleMouseEnter:function(){this.enabled&&(this.mouseEntered=!0)},handleMouseLeave:function(){this.enabled&&(this.mouseEntered=!1)},handle:function(e){var t=e,a=this;if(a.enabled){var i=a.params.mousewheel;a.params.cssMode&&t.preventDefault();var s=a.$el;if("container"!==a.params.mousewheel.eventsTarget&&(s=m(a.params.mousewheel.eventsTarget)),!a.mouseEntered&&!s[0].contains(t.target)&&!i.releaseOnEdges)return!0;t.originalEvent&&(t=t.originalEvent);var r=0,n=a.rtlTranslate?-1:1,l=K.normalize(t);if(i.forceToAxis)if(a.isHorizontal()){if(!(Math.abs(l.pixelX)>Math.abs(l.pixelY)))return!0;r=-l.pixelX*n}else{if(!(Math.abs(l.pixelY)>Math.abs(l.pixelX)))return!0;r=-l.pixelY}else r=Math.abs(l.pixelX)>Math.abs(l.pixelY)?-l.pixelX*n:-l.pixelY;if(0===r)return!0;i.invert&&(r=-r);var o=a.getTranslate()+r*i.sensitivity;if(o>=a.minTranslate()&&(o=a.minTranslate()),o<=a.maxTranslate()&&(o=a.maxTranslate()),(!!a.params.loop||!(o===a.minTranslate()||o===a.maxTranslate()))&&a.params.nested&&t.stopPropagation(),a.params.freeMode){var d={time:x(),delta:Math.abs(r),direction:Math.sign(r)},p=a.mousewheel.lastEventBeforeSnap,u=p&&d.time<p.time+500&&d.delta<=p.delta&&d.direction===p.direction;if(!u){a.mousewheel.lastEventBeforeSnap=void 0,a.params.loop&&a.loopFix();var c=a.getTranslate()+r*i.sensitivity,h=a.isBeginning,v=a.isEnd;if(c>=a.minTranslate()&&(c=a.minTranslate()),c<=a.maxTranslate()&&(c=a.maxTranslate()),a.setTransition(0),a.setTranslate(c),a.updateProgress(),a.updateActiveIndex(),a.updateSlidesClasses(),(!h&&a.isBeginning||!v&&a.isEnd)&&a.updateSlidesClasses(),a.params.freeModeSticky){clearTimeout(a.mousewheel.timeout),a.mousewheel.timeout=void 0;var f=a.mousewheel.recentWheelEvents;f.length>=15&&f.shift();var g=f.length?f[f.length-1]:void 0,b=f[0];if(f.push(d),g&&(d.delta>g.delta||d.direction!==g.direction))f.splice(0);else if(f.length>=15&&d.time-b.time<500&&b.delta-d.delta>=1&&d.delta<=6){var y=r>0?.8:.2;a.mousewheel.lastEventBeforeSnap=d,f.splice(0),a.mousewheel.timeout=E((function(){a.slideToClosest(a.params.speed,!0,void 0,y)}),0)}a.mousewheel.timeout||(a.mousewheel.timeout=E((function(){a.mousewheel.lastEventBeforeSnap=d,f.splice(0),a.slideToClosest(a.params.speed,!0,void 0,.5)}),500))}if(u||a.emit("scroll",t),a.params.autoplay&&a.params.autoplayDisableOnInteraction&&a.autoplay.stop(),c===a.minTranslate()||c===a.maxTranslate())return!0}}else{var w={time:x(),delta:Math.abs(r),direction:Math.sign(r),raw:e},T=a.mousewheel.recentWheelEvents;T.length>=2&&T.shift();var C=T.length?T[T.length-1]:void 0;if(T.push(w),C?(w.direction!==C.direction||w.delta>C.delta||w.time>C.time+150)&&a.mousewheel.animateSlider(w):a.mousewheel.animateSlider(w),a.mousewheel.releaseScroll(w))return!0}return t.preventDefault?t.preventDefault():t.returnValue=!1,!1}},animateSlider:function(e){var t=this,a=l();return!(this.params.mousewheel.thresholdDelta&&e.delta<this.params.mousewheel.thresholdDelta)&&(!(this.params.mousewheel.thresholdTime&&x()-t.mousewheel.lastScrollTime<this.params.mousewheel.thresholdTime)&&(e.delta>=6&&x()-t.mousewheel.lastScrollTime<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),t.emit("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),t.emit("scroll",e.raw)),t.mousewheel.lastScrollTime=(new a.Date).getTime(),!1)))},releaseScroll:function(e){var t=this,a=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&a.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&a.releaseOnEdges)return!0;return!1},enable:function(){var e=this,t=K.event();if(e.params.cssMode)return e.wrapperEl.removeEventListener(t,e.mousewheel.handle),!0;if(!t)return!1;if(e.mousewheel.enabled)return!1;var a=e.$el;return"container"!==e.params.mousewheel.eventsTarget&&(a=m(e.params.mousewheel.eventsTarget)),a.on("mouseenter",e.mousewheel.handleMouseEnter),a.on("mouseleave",e.mousewheel.handleMouseLeave),a.on(t,e.mousewheel.handle),e.mousewheel.enabled=!0,!0},disable:function(){var e=this,t=K.event();if(e.params.cssMode)return e.wrapperEl.addEventListener(t,e.mousewheel.handle),!0;if(!t)return!1;if(!e.mousewheel.enabled)return!1;var a=e.$el;return"container"!==e.params.mousewheel.eventsTarget&&(a=m(e.params.mousewheel.eventsTarget)),a.off(t,e.mousewheel.handle),e.mousewheel.enabled=!1,!0}},Z={toggleEl:function(e,t){e[t?"addClass":"removeClass"](this.params.navigation.disabledClass),e[0]&&"BUTTON"===e[0].tagName&&(e[0].disabled=t)},update:function(){var e=this,t=e.params.navigation,a=e.navigation.toggleEl;if(!e.params.loop){var i=e.navigation,s=i.$nextEl,r=i.$prevEl;r&&r.length>0&&(e.isBeginning?a(r,!0):a(r,!1),e.params.watchOverflow&&e.enabled&&r[e.isLocked?"addClass":"removeClass"](t.lockClass)),s&&s.length>0&&(e.isEnd?a(s,!0):a(s,!1),e.params.watchOverflow&&e.enabled&&s[e.isLocked?"addClass":"removeClass"](t.lockClass))}},onPrevClick:function(e){var t=this;e.preventDefault(),t.isBeginning&&!t.params.loop||t.slidePrev()},onNextClick:function(e){var t=this;e.preventDefault(),t.isEnd&&!t.params.loop||t.slideNext()},init:function(){var e,t,a=this,i=a.params.navigation;(i.nextEl||i.prevEl)&&(i.nextEl&&(e=m(i.nextEl),a.params.uniqueNavElements&&"string"==typeof i.nextEl&&e.length>1&&1===a.$el.find(i.nextEl).length&&(e=a.$el.find(i.nextEl))),i.prevEl&&(t=m(i.prevEl),a.params.uniqueNavElements&&"string"==typeof i.prevEl&&t.length>1&&1===a.$el.find(i.prevEl).length&&(t=a.$el.find(i.prevEl))),e&&e.length>0&&e.on("click",a.navigation.onNextClick),t&&t.length>0&&t.on("click",a.navigation.onPrevClick),S(a.navigation,{$nextEl:e,nextEl:e&&e[0],$prevEl:t,prevEl:t&&t[0]}),a.enabled||(e&&e.addClass(i.lockClass),t&&t.addClass(i.lockClass)))},destroy:function(){var e=this,t=e.navigation,a=t.$nextEl,i=t.$prevEl;a&&a.length&&(a.off("click",e.navigation.onNextClick),a.removeClass(e.params.navigation.disabledClass)),i&&i.length&&(i.off("click",e.navigation.onPrevClick),i.removeClass(e.params.navigation.disabledClass))}},J={update:function(){var e=this,t=e.rtl,a=e.params.pagination;if(a.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var i,s=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.slides.length,r=e.pagination.$el,n=e.params.loop?Math.ceil((s-2*e.loopedSlides)/e.params.slidesPerGroup):e.snapGrid.length;if(e.params.loop?((i=Math.ceil((e.activeIndex-e.loopedSlides)/e.params.slidesPerGroup))>s-1-2*e.loopedSlides&&(i-=s-2*e.loopedSlides),i>n-1&&(i-=n),i<0&&"bullets"!==e.params.paginationType&&(i=n+i)):i=void 0!==e.snapIndex?e.snapIndex:e.activeIndex||0,"bullets"===a.type&&e.pagination.bullets&&e.pagination.bullets.length>0){var l,o,d,p=e.pagination.bullets;if(a.dynamicBullets&&(e.pagination.bulletSize=p.eq(0)[e.isHorizontal()?"outerWidth":"outerHeight"](!0),r.css(e.isHorizontal()?"width":"height",e.pagination.bulletSize*(a.dynamicMainBullets+4)+"px"),a.dynamicMainBullets>1&&void 0!==e.previousIndex&&(e.pagination.dynamicBulletIndex+=i-e.previousIndex,e.pagination.dynamicBulletIndex>a.dynamicMainBullets-1?e.pagination.dynamicBulletIndex=a.dynamicMainBullets-1:e.pagination.dynamicBulletIndex<0&&(e.pagination.dynamicBulletIndex=0)),l=i-e.pagination.dynamicBulletIndex,d=((o=l+(Math.min(p.length,a.dynamicMainBullets)-1))+l)/2),p.removeClass(a.bulletActiveClass+" "+a.bulletActiveClass+"-next "+a.bulletActiveClass+"-next-next "+a.bulletActiveClass+"-prev "+a.bulletActiveClass+"-prev-prev "+a.bulletActiveClass+"-main"),r.length>1)p.each((function(e){var t=m(e),s=t.index();s===i&&t.addClass(a.bulletActiveClass),a.dynamicBullets&&(s>=l&&s<=o&&t.addClass(a.bulletActiveClass+"-main"),s===l&&t.prev().addClass(a.bulletActiveClass+"-prev").prev().addClass(a.bulletActiveClass+"-prev-prev"),s===o&&t.next().addClass(a.bulletActiveClass+"-next").next().addClass(a.bulletActiveClass+"-next-next"))}));else{var u=p.eq(i),c=u.index();if(u.addClass(a.bulletActiveClass),a.dynamicBullets){for(var h=p.eq(l),v=p.eq(o),f=l;f<=o;f+=1)p.eq(f).addClass(a.bulletActiveClass+"-main");if(e.params.loop)if(c>=p.length-a.dynamicMainBullets){for(var g=a.dynamicMainBullets;g>=0;g-=1)p.eq(p.length-g).addClass(a.bulletActiveClass+"-main");p.eq(p.length-a.dynamicMainBullets-1).addClass(a.bulletActiveClass+"-prev")}else h.prev().addClass(a.bulletActiveClass+"-prev").prev().addClass(a.bulletActiveClass+"-prev-prev"),v.next().addClass(a.bulletActiveClass+"-next").next().addClass(a.bulletActiveClass+"-next-next");else h.prev().addClass(a.bulletActiveClass+"-prev").prev().addClass(a.bulletActiveClass+"-prev-prev"),v.next().addClass(a.bulletActiveClass+"-next").next().addClass(a.bulletActiveClass+"-next-next")}}if(a.dynamicBullets){var b=Math.min(p.length,a.dynamicMainBullets+4),y=(e.pagination.bulletSize*b-e.pagination.bulletSize)/2-d*e.pagination.bulletSize,w=t?"right":"left";p.css(e.isHorizontal()?w:"top",y+"px")}}if("fraction"===a.type&&(r.find(z(a.currentClass)).text(a.formatFractionCurrent(i+1)),r.find(z(a.totalClass)).text(a.formatFractionTotal(n))),"progressbar"===a.type){var E;E=a.progressbarOpposite?e.isHorizontal()?"vertical":"horizontal":e.isHorizontal()?"horizontal":"vertical";var x=(i+1)/n,T=1,C=1;"horizontal"===E?T=x:C=x,r.find(z(a.progressbarFillClass)).transform("translate3d(0,0,0) scaleX("+T+") scaleY("+C+")").transition(e.params.speed)}"custom"===a.type&&a.renderCustom?(r.html(a.renderCustom(e,i+1,n)),e.emit("paginationRender",r[0])):e.emit("paginationUpdate",r[0]),e.params.watchOverflow&&e.enabled&&r[e.isLocked?"addClass":"removeClass"](a.lockClass)}},render:function(){var e=this,t=e.params.pagination;if(t.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var a=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.slides.length,i=e.pagination.$el,s="";if("bullets"===t.type){var r=e.params.loop?Math.ceil((a-2*e.loopedSlides)/e.params.slidesPerGroup):e.snapGrid.length;e.params.freeMode&&!e.params.loop&&r>a&&(r=a);for(var n=0;n<r;n+=1)t.renderBullet?s+=t.renderBullet.call(e,n,t.bulletClass):s+="<"+t.bulletElement+' class="'+t.bulletClass+'"></'+t.bulletElement+">";i.html(s),e.pagination.bullets=i.find(z(t.bulletClass))}"fraction"===t.type&&(s=t.renderFraction?t.renderFraction.call(e,t.currentClass,t.totalClass):'<span class="'+t.currentClass+'"></span> / <span class="'+t.totalClass+'"></span>',i.html(s)),"progressbar"===t.type&&(s=t.renderProgressbar?t.renderProgressbar.call(e,t.progressbarFillClass):'<span class="'+t.progressbarFillClass+'"></span>',i.html(s)),"custom"!==t.type&&e.emit("paginationRender",e.pagination.$el[0])}},init:function(){var e=this,t=e.params.pagination;if(t.el){var a=m(t.el);0!==a.length&&(e.params.uniqueNavElements&&"string"==typeof t.el&&a.length>1&&(a=e.$el.find(t.el)),"bullets"===t.type&&t.clickable&&a.addClass(t.clickableClass),a.addClass(t.modifierClass+t.type),"bullets"===t.type&&t.dynamicBullets&&(a.addClass(""+t.modifierClass+t.type+"-dynamic"),e.pagination.dynamicBulletIndex=0,t.dynamicMainBullets<1&&(t.dynamicMainBullets=1)),"progressbar"===t.type&&t.progressbarOpposite&&a.addClass(t.progressbarOppositeClass),t.clickable&&a.on("click",z(t.bulletClass),(function(t){t.preventDefault();var a=m(this).index()*e.params.slidesPerGroup;e.params.loop&&(a+=e.loopedSlides),e.slideTo(a)})),S(e.pagination,{$el:a,el:a[0]}),e.enabled||a.addClass(t.lockClass))}},destroy:function(){var e=this,t=e.params.pagination;if(t.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var a=e.pagination.$el;a.removeClass(t.hiddenClass),a.removeClass(t.modifierClass+t.type),e.pagination.bullets&&e.pagination.bullets.removeClass(t.bulletActiveClass),t.clickable&&a.off("click",z(t.bulletClass))}}},Q={setTranslate:function(){var e=this;if(e.params.scrollbar.el&&e.scrollbar.el){var t=e.scrollbar,a=e.rtlTranslate,i=e.progress,s=t.dragSize,r=t.trackSize,n=t.$dragEl,l=t.$el,o=e.params.scrollbar,d=s,p=(r-s)*i;a?(p=-p)>0?(d=s-p,p=0):-p+s>r&&(d=r+p):p<0?(d=s+p,p=0):p+s>r&&(d=r-p),e.isHorizontal()?(n.transform("translate3d("+p+"px, 0, 0)"),n[0].style.width=d+"px"):(n.transform("translate3d(0px, "+p+"px, 0)"),n[0].style.height=d+"px"),o.hide&&(clearTimeout(e.scrollbar.timeout),l[0].style.opacity=1,e.scrollbar.timeout=setTimeout((function(){l[0].style.opacity=0,l.transition(400)}),1e3))}},setTransition:function(e){var t=this;t.params.scrollbar.el&&t.scrollbar.el&&t.scrollbar.$dragEl.transition(e)},updateSize:function(){var e=this;if(e.params.scrollbar.el&&e.scrollbar.el){var t=e.scrollbar,a=t.$dragEl,i=t.$el;a[0].style.width="",a[0].style.height="";var s,r=e.isHorizontal()?i[0].offsetWidth:i[0].offsetHeight,n=e.size/e.virtualSize,l=n*(r/e.size);s="auto"===e.params.scrollbar.dragSize?r*n:parseInt(e.params.scrollbar.dragSize,10),e.isHorizontal()?a[0].style.width=s+"px":a[0].style.height=s+"px",i[0].style.display=n>=1?"none":"",e.params.scrollbar.hide&&(i[0].style.opacity=0),S(t,{trackSize:r,divider:n,moveDivider:l,dragSize:s}),e.params.watchOverflow&&e.enabled&&t.$el[e.isLocked?"addClass":"removeClass"](e.params.scrollbar.lockClass)}},getPointerPosition:function(e){return this.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientX:e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientY:e.clientY},setDragPosition:function(e){var t,a=this,i=a.scrollbar,s=a.rtlTranslate,r=i.$el,n=i.dragSize,l=i.trackSize,o=i.dragStartPos;t=(i.getPointerPosition(e)-r.offset()[a.isHorizontal()?"left":"top"]-(null!==o?o:n/2))/(l-n),t=Math.max(Math.min(t,1),0),s&&(t=1-t);var d=a.minTranslate()+(a.maxTranslate()-a.minTranslate())*t;a.updateProgress(d),a.setTranslate(d),a.updateActiveIndex(),a.updateSlidesClasses()},onDragStart:function(e){var t=this,a=t.params.scrollbar,i=t.scrollbar,s=t.$wrapperEl,r=i.$el,n=i.$dragEl;t.scrollbar.isTouched=!0,t.scrollbar.dragStartPos=e.target===n[0]||e.target===n?i.getPointerPosition(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),s.transition(100),n.transition(100),i.setDragPosition(e),clearTimeout(t.scrollbar.dragTimeout),r.transition(0),a.hide&&r.css("opacity",1),t.params.cssMode&&t.$wrapperEl.css("scroll-snap-type","none"),t.emit("scrollbarDragStart",e)},onDragMove:function(e){var t=this,a=t.scrollbar,i=t.$wrapperEl,s=a.$el,r=a.$dragEl;t.scrollbar.isTouched&&(e.preventDefault?e.preventDefault():e.returnValue=!1,a.setDragPosition(e),i.transition(0),s.transition(0),r.transition(0),t.emit("scrollbarDragMove",e))},onDragEnd:function(e){var t=this,a=t.params.scrollbar,i=t.scrollbar,s=t.$wrapperEl,r=i.$el;t.scrollbar.isTouched&&(t.scrollbar.isTouched=!1,t.params.cssMode&&(t.$wrapperEl.css("scroll-snap-type",""),s.transition("")),a.hide&&(clearTimeout(t.scrollbar.dragTimeout),t.scrollbar.dragTimeout=E((function(){r.css("opacity",0),r.transition(400)}),1e3)),t.emit("scrollbarDragEnd",e),a.snapOnRelease&&t.slideToClosest())},enableDraggable:function(){var e=this;if(e.params.scrollbar.el){var t=r(),a=e.scrollbar,i=e.touchEventsTouch,s=e.touchEventsDesktop,n=e.params,l=e.support,o=a.$el[0],d=!(!l.passiveListener||!n.passiveListeners)&&{passive:!1,capture:!1},p=!(!l.passiveListener||!n.passiveListeners)&&{passive:!0,capture:!1};o&&(l.touch?(o.addEventListener(i.start,e.scrollbar.onDragStart,d),o.addEventListener(i.move,e.scrollbar.onDragMove,d),o.addEventListener(i.end,e.scrollbar.onDragEnd,p)):(o.addEventListener(s.start,e.scrollbar.onDragStart,d),t.addEventListener(s.move,e.scrollbar.onDragMove,d),t.addEventListener(s.end,e.scrollbar.onDragEnd,p)))}},disableDraggable:function(){var e=this;if(e.params.scrollbar.el){var t=r(),a=e.scrollbar,i=e.touchEventsTouch,s=e.touchEventsDesktop,n=e.params,l=e.support,o=a.$el[0],d=!(!l.passiveListener||!n.passiveListeners)&&{passive:!1,capture:!1},p=!(!l.passiveListener||!n.passiveListeners)&&{passive:!0,capture:!1};o&&(l.touch?(o.removeEventListener(i.start,e.scrollbar.onDragStart,d),o.removeEventListener(i.move,e.scrollbar.onDragMove,d),o.removeEventListener(i.end,e.scrollbar.onDragEnd,p)):(o.removeEventListener(s.start,e.scrollbar.onDragStart,d),t.removeEventListener(s.move,e.scrollbar.onDragMove,d),t.removeEventListener(s.end,e.scrollbar.onDragEnd,p)))}},init:function(){var e=this;if(e.params.scrollbar.el){var t=e.scrollbar,a=e.$el,i=e.params.scrollbar,s=m(i.el);e.params.uniqueNavElements&&"string"==typeof i.el&&s.length>1&&1===a.find(i.el).length&&(s=a.find(i.el));var r=s.find("."+e.params.scrollbar.dragClass);0===r.length&&(r=m('<div class="'+e.params.scrollbar.dragClass+'"></div>'),s.append(r)),S(t,{$el:s,el:s[0],$dragEl:r,dragEl:r[0]}),i.draggable&&t.enableDraggable(),s&&s[e.enabled?"removeClass":"addClass"](e.params.scrollbar.lockClass)}},destroy:function(){this.scrollbar.disableDraggable()}},ee={setTransform:function(e,t){var a=this.rtl,i=m(e),s=a?-1:1,r=i.attr("data-swiper-parallax")||"0",n=i.attr("data-swiper-parallax-x"),l=i.attr("data-swiper-parallax-y"),o=i.attr("data-swiper-parallax-scale"),d=i.attr("data-swiper-parallax-opacity");if(n||l?(n=n||"0",l=l||"0"):this.isHorizontal()?(n=r,l="0"):(l=r,n="0"),n=n.indexOf("%")>=0?parseInt(n,10)*t*s+"%":n*t*s+"px",l=l.indexOf("%")>=0?parseInt(l,10)*t+"%":l*t+"px",null!=d){var p=d-(d-1)*(1-Math.abs(t));i[0].style.opacity=p}if(null==o)i.transform("translate3d("+n+", "+l+", 0px)");else{var u=o-(o-1)*(1-Math.abs(t));i.transform("translate3d("+n+", "+l+", 0px) scale("+u+")")}},setTranslate:function(){var e=this,t=e.$el,a=e.slides,i=e.progress,s=e.snapGrid;t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t){e.parallax.setTransform(t,i)})),a.each((function(t,a){var r=t.progress;e.params.slidesPerGroup>1&&"auto"!==e.params.slidesPerView&&(r+=Math.ceil(a/2)-i*(s.length-1)),r=Math.min(Math.max(r,-1),1),m(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t){e.parallax.setTransform(t,r)}))}))},setTransition:function(e){void 0===e&&(e=this.params.speed);this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t){var a=m(t),i=parseInt(a.attr("data-swiper-parallax-duration"),10)||e;0===e&&(i=0),a.transition(i)}))}},te={getDistanceBetweenTouches:function(e){if(e.targetTouches.length<2)return 1;var t=e.targetTouches[0].pageX,a=e.targetTouches[0].pageY,i=e.targetTouches[1].pageX,s=e.targetTouches[1].pageY;return Math.sqrt(Math.pow(i-t,2)+Math.pow(s-a,2))},onGestureStart:function(e){var t=this,a=t.support,i=t.params.zoom,s=t.zoom,r=s.gesture;if(s.fakeGestureTouched=!1,s.fakeGestureMoved=!1,!a.gestures){if("touchstart"!==e.type||"touchstart"===e.type&&e.targetTouches.length<2)return;s.fakeGestureTouched=!0,r.scaleStart=te.getDistanceBetweenTouches(e)}r.$slideEl&&r.$slideEl.length||(r.$slideEl=m(e.target).closest("."+t.params.slideClass),0===r.$slideEl.length&&(r.$slideEl=t.slides.eq(t.activeIndex)),r.$imageEl=r.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),r.$imageWrapEl=r.$imageEl.parent("."+i.containerClass),r.maxRatio=r.$imageWrapEl.attr("data-swiper-zoom")||i.maxRatio,0!==r.$imageWrapEl.length)?(r.$imageEl&&r.$imageEl.transition(0),t.zoom.isScaling=!0):r.$imageEl=void 0},onGestureChange:function(e){var t=this,a=t.support,i=t.params.zoom,s=t.zoom,r=s.gesture;if(!a.gestures){if("touchmove"!==e.type||"touchmove"===e.type&&e.targetTouches.length<2)return;s.fakeGestureMoved=!0,r.scaleMove=te.getDistanceBetweenTouches(e)}r.$imageEl&&0!==r.$imageEl.length?(a.gestures?s.scale=e.scale*s.currentScale:s.scale=r.scaleMove/r.scaleStart*s.currentScale,s.scale>r.maxRatio&&(s.scale=r.maxRatio-1+Math.pow(s.scale-r.maxRatio+1,.5)),s.scale<i.minRatio&&(s.scale=i.minRatio+1-Math.pow(i.minRatio-s.scale+1,.5)),r.$imageEl.transform("translate3d(0,0,0) scale("+s.scale+")")):"gesturechange"===e.type&&s.onGestureStart(e)},onGestureEnd:function(e){var t=this,a=t.device,i=t.support,s=t.params.zoom,r=t.zoom,n=r.gesture;if(!i.gestures){if(!r.fakeGestureTouched||!r.fakeGestureMoved)return;if("touchend"!==e.type||"touchend"===e.type&&e.changedTouches.length<2&&!a.android)return;r.fakeGestureTouched=!1,r.fakeGestureMoved=!1}n.$imageEl&&0!==n.$imageEl.length&&(r.scale=Math.max(Math.min(r.scale,n.maxRatio),s.minRatio),n.$imageEl.transition(t.params.speed).transform("translate3d(0,0,0) scale("+r.scale+")"),r.currentScale=r.scale,r.isScaling=!1,1===r.scale&&(n.$slideEl=void 0))},onTouchStart:function(e){var t=this.device,a=this.zoom,i=a.gesture,s=a.image;i.$imageEl&&0!==i.$imageEl.length&&(s.isTouched||(t.android&&e.cancelable&&e.preventDefault(),s.isTouched=!0,s.touchesStart.x="touchstart"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesStart.y="touchstart"===e.type?e.targetTouches[0].pageY:e.pageY))},onTouchMove:function(e){var t=this,a=t.zoom,i=a.gesture,s=a.image,r=a.velocity;if(i.$imageEl&&0!==i.$imageEl.length&&(t.allowClick=!1,s.isTouched&&i.$slideEl)){s.isMoved||(s.width=i.$imageEl[0].offsetWidth,s.height=i.$imageEl[0].offsetHeight,s.startX=T(i.$imageWrapEl[0],"x")||0,s.startY=T(i.$imageWrapEl[0],"y")||0,i.slideWidth=i.$slideEl[0].offsetWidth,i.slideHeight=i.$slideEl[0].offsetHeight,i.$imageWrapEl.transition(0),t.rtl&&(s.startX=-s.startX,s.startY=-s.startY));var n=s.width*a.scale,l=s.height*a.scale;if(!(n<i.slideWidth&&l<i.slideHeight)){if(s.minX=Math.min(i.slideWidth/2-n/2,0),s.maxX=-s.minX,s.minY=Math.min(i.slideHeight/2-l/2,0),s.maxY=-s.minY,s.touchesCurrent.x="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesCurrent.y="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,!s.isMoved&&!a.isScaling){if(t.isHorizontal()&&(Math.floor(s.minX)===Math.floor(s.startX)&&s.touchesCurrent.x<s.touchesStart.x||Math.floor(s.maxX)===Math.floor(s.startX)&&s.touchesCurrent.x>s.touchesStart.x))return void(s.isTouched=!1);if(!t.isHorizontal()&&(Math.floor(s.minY)===Math.floor(s.startY)&&s.touchesCurrent.y<s.touchesStart.y||Math.floor(s.maxY)===Math.floor(s.startY)&&s.touchesCurrent.y>s.touchesStart.y))return void(s.isTouched=!1)}e.cancelable&&e.preventDefault(),e.stopPropagation(),s.isMoved=!0,s.currentX=s.touchesCurrent.x-s.touchesStart.x+s.startX,s.currentY=s.touchesCurrent.y-s.touchesStart.y+s.startY,s.currentX<s.minX&&(s.currentX=s.minX+1-Math.pow(s.minX-s.currentX+1,.8)),s.currentX>s.maxX&&(s.currentX=s.maxX-1+Math.pow(s.currentX-s.maxX+1,.8)),s.currentY<s.minY&&(s.currentY=s.minY+1-Math.pow(s.minY-s.currentY+1,.8)),s.currentY>s.maxY&&(s.currentY=s.maxY-1+Math.pow(s.currentY-s.maxY+1,.8)),r.prevPositionX||(r.prevPositionX=s.touchesCurrent.x),r.prevPositionY||(r.prevPositionY=s.touchesCurrent.y),r.prevTime||(r.prevTime=Date.now()),r.x=(s.touchesCurrent.x-r.prevPositionX)/(Date.now()-r.prevTime)/2,r.y=(s.touchesCurrent.y-r.prevPositionY)/(Date.now()-r.prevTime)/2,Math.abs(s.touchesCurrent.x-r.prevPositionX)<2&&(r.x=0),Math.abs(s.touchesCurrent.y-r.prevPositionY)<2&&(r.y=0),r.prevPositionX=s.touchesCurrent.x,r.prevPositionY=s.touchesCurrent.y,r.prevTime=Date.now(),i.$imageWrapEl.transform("translate3d("+s.currentX+"px, "+s.currentY+"px,0)")}}},onTouchEnd:function(){var e=this.zoom,t=e.gesture,a=e.image,i=e.velocity;if(t.$imageEl&&0!==t.$imageEl.length){if(!a.isTouched||!a.isMoved)return a.isTouched=!1,void(a.isMoved=!1);a.isTouched=!1,a.isMoved=!1;var s=300,r=300,n=i.x*s,l=a.currentX+n,o=i.y*r,d=a.currentY+o;0!==i.x&&(s=Math.abs((l-a.currentX)/i.x)),0!==i.y&&(r=Math.abs((d-a.currentY)/i.y));var p=Math.max(s,r);a.currentX=l,a.currentY=d;var u=a.width*e.scale,c=a.height*e.scale;a.minX=Math.min(t.slideWidth/2-u/2,0),a.maxX=-a.minX,a.minY=Math.min(t.slideHeight/2-c/2,0),a.maxY=-a.minY,a.currentX=Math.max(Math.min(a.currentX,a.maxX),a.minX),a.currentY=Math.max(Math.min(a.currentY,a.maxY),a.minY),t.$imageWrapEl.transition(p).transform("translate3d("+a.currentX+"px, "+a.currentY+"px,0)")}},onTransitionEnd:function(){var e=this,t=e.zoom,a=t.gesture;a.$slideEl&&e.previousIndex!==e.activeIndex&&(a.$imageEl&&a.$imageEl.transform("translate3d(0,0,0) scale(1)"),a.$imageWrapEl&&a.$imageWrapEl.transform("translate3d(0,0,0)"),t.scale=1,t.currentScale=1,a.$slideEl=void 0,a.$imageEl=void 0,a.$imageWrapEl=void 0)},toggle:function(e){var t=this.zoom;t.scale&&1!==t.scale?t.out():t.in(e)},in:function(e){var t,a,i,s,r,n,o,d,p,u,c,h,v,f,m,g,b=this,y=l(),w=b.zoom,E=b.params.zoom,x=w.gesture,T=w.image;(x.$slideEl||(b.params.virtual&&b.params.virtual.enabled&&b.virtual?x.$slideEl=b.$wrapperEl.children("."+b.params.slideActiveClass):x.$slideEl=b.slides.eq(b.activeIndex),x.$imageEl=x.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),x.$imageWrapEl=x.$imageEl.parent("."+E.containerClass)),x.$imageEl&&0!==x.$imageEl.length&&x.$imageWrapEl&&0!==x.$imageWrapEl.length)&&(x.$slideEl.addClass(""+E.zoomedSlideClass),void 0===T.touchesStart.x&&e?(t="touchend"===e.type?e.changedTouches[0].pageX:e.pageX,a="touchend"===e.type?e.changedTouches[0].pageY:e.pageY):(t=T.touchesStart.x,a=T.touchesStart.y),w.scale=x.$imageWrapEl.attr("data-swiper-zoom")||E.maxRatio,w.currentScale=x.$imageWrapEl.attr("data-swiper-zoom")||E.maxRatio,e?(m=x.$slideEl[0].offsetWidth,g=x.$slideEl[0].offsetHeight,i=x.$slideEl.offset().left+y.scrollX+m/2-t,s=x.$slideEl.offset().top+y.scrollY+g/2-a,o=x.$imageEl[0].offsetWidth,d=x.$imageEl[0].offsetHeight,p=o*w.scale,u=d*w.scale,v=-(c=Math.min(m/2-p/2,0)),f=-(h=Math.min(g/2-u/2,0)),(r=i*w.scale)<c&&(r=c),r>v&&(r=v),(n=s*w.scale)<h&&(n=h),n>f&&(n=f)):(r=0,n=0),x.$imageWrapEl.transition(300).transform("translate3d("+r+"px, "+n+"px,0)"),x.$imageEl.transition(300).transform("translate3d(0,0,0) scale("+w.scale+")"))},out:function(){var e=this,t=e.zoom,a=e.params.zoom,i=t.gesture;i.$slideEl||(e.params.virtual&&e.params.virtual.enabled&&e.virtual?i.$slideEl=e.$wrapperEl.children("."+e.params.slideActiveClass):i.$slideEl=e.slides.eq(e.activeIndex),i.$imageEl=i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),i.$imageWrapEl=i.$imageEl.parent("."+a.containerClass)),i.$imageEl&&0!==i.$imageEl.length&&i.$imageWrapEl&&0!==i.$imageWrapEl.length&&(t.scale=1,t.currentScale=1,i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),i.$slideEl.removeClass(""+a.zoomedSlideClass),i.$slideEl=void 0)},toggleGestures:function(e){var t=this,a=t.zoom,i=a.slideSelector,s=a.passiveListener;t.$wrapperEl[e]("gesturestart",i,a.onGestureStart,s),t.$wrapperEl[e]("gesturechange",i,a.onGestureChange,s),t.$wrapperEl[e]("gestureend",i,a.onGestureEnd,s)},enableGestures:function(){this.zoom.gesturesEnabled||(this.zoom.gesturesEnabled=!0,this.zoom.toggleGestures("on"))},disableGestures:function(){this.zoom.gesturesEnabled&&(this.zoom.gesturesEnabled=!1,this.zoom.toggleGestures("off"))},enable:function(){var e=this,t=e.support,a=e.zoom;if(!a.enabled){a.enabled=!0;var i=!("touchstart"!==e.touchEvents.start||!t.passiveListener||!e.params.passiveListeners)&&{passive:!0,capture:!1},s=!t.passiveListener||{passive:!1,capture:!0},r="."+e.params.slideClass;e.zoom.passiveListener=i,e.zoom.slideSelector=r,t.gestures?(e.$wrapperEl.on(e.touchEvents.start,e.zoom.enableGestures,i),e.$wrapperEl.on(e.touchEvents.end,e.zoom.disableGestures,i)):"touchstart"===e.touchEvents.start&&(e.$wrapperEl.on(e.touchEvents.start,r,a.onGestureStart,i),e.$wrapperEl.on(e.touchEvents.move,r,a.onGestureChange,s),e.$wrapperEl.on(e.touchEvents.end,r,a.onGestureEnd,i),e.touchEvents.cancel&&e.$wrapperEl.on(e.touchEvents.cancel,r,a.onGestureEnd,i)),e.$wrapperEl.on(e.touchEvents.move,"."+e.params.zoom.containerClass,a.onTouchMove,s)}},disable:function(){var e=this,t=e.zoom;if(t.enabled){var a=e.support;e.zoom.enabled=!1;var i=!("touchstart"!==e.touchEvents.start||!a.passiveListener||!e.params.passiveListeners)&&{passive:!0,capture:!1},s=!a.passiveListener||{passive:!1,capture:!0},r="."+e.params.slideClass;a.gestures?(e.$wrapperEl.off(e.touchEvents.start,e.zoom.enableGestures,i),e.$wrapperEl.off(e.touchEvents.end,e.zoom.disableGestures,i)):"touchstart"===e.touchEvents.start&&(e.$wrapperEl.off(e.touchEvents.start,r,t.onGestureStart,i),e.$wrapperEl.off(e.touchEvents.move,r,t.onGestureChange,s),e.$wrapperEl.off(e.touchEvents.end,r,t.onGestureEnd,i),e.touchEvents.cancel&&e.$wrapperEl.off(e.touchEvents.cancel,r,t.onGestureEnd,i)),e.$wrapperEl.off(e.touchEvents.move,"."+e.params.zoom.containerClass,t.onTouchMove,s)}}},ae={loadInSlide:function(e,t){void 0===t&&(t=!0);var a=this,i=a.params.lazy;if(void 0!==e&&0!==a.slides.length){var s=a.virtual&&a.params.virtual.enabled?a.$wrapperEl.children("."+a.params.slideClass+'[data-swiper-slide-index="'+e+'"]'):a.slides.eq(e),r=s.find("."+i.elementClass+":not(."+i.loadedClass+"):not(."+i.loadingClass+")");!s.hasClass(i.elementClass)||s.hasClass(i.loadedClass)||s.hasClass(i.loadingClass)||r.push(s[0]),0!==r.length&&r.each((function(e){var r=m(e);r.addClass(i.loadingClass);var n=r.attr("data-background"),l=r.attr("data-src"),o=r.attr("data-srcset"),d=r.attr("data-sizes"),p=r.parent("picture");a.loadImage(r[0],l||n,o,d,!1,(function(){if(null!=a&&a&&(!a||a.params)&&!a.destroyed){if(n?(r.css("background-image",'url("'+n+'")'),r.removeAttr("data-background")):(o&&(r.attr("srcset",o),r.removeAttr("data-srcset")),d&&(r.attr("sizes",d),r.removeAttr("data-sizes")),p.length&&p.children("source").each((function(e){var t=m(e);t.attr("data-srcset")&&(t.attr("srcset",t.attr("data-srcset")),t.removeAttr("data-srcset"))})),l&&(r.attr("src",l),r.removeAttr("data-src"))),r.addClass(i.loadedClass).removeClass(i.loadingClass),s.find("."+i.preloaderClass).remove(),a.params.loop&&t){var e=s.attr("data-swiper-slide-index");if(s.hasClass(a.params.slideDuplicateClass)){var u=a.$wrapperEl.children('[data-swiper-slide-index="'+e+'"]:not(.'+a.params.slideDuplicateClass+")");a.lazy.loadInSlide(u.index(),!1)}else{var c=a.$wrapperEl.children("."+a.params.slideDuplicateClass+'[data-swiper-slide-index="'+e+'"]');a.lazy.loadInSlide(c.index(),!1)}}a.emit("lazyImageReady",s[0],r[0]),a.params.autoHeight&&a.updateAutoHeight()}})),a.emit("lazyImageLoad",s[0],r[0])}))}},load:function(){var e=this,t=e.$wrapperEl,a=e.params,i=e.slides,s=e.activeIndex,r=e.virtual&&a.virtual.enabled,n=a.lazy,l=a.slidesPerView;function o(e){if(r){if(t.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]').length)return!0}else if(i[e])return!0;return!1}function d(e){return r?m(e).attr("data-swiper-slide-index"):m(e).index()}if("auto"===l&&(l=0),e.lazy.initialImageLoaded||(e.lazy.initialImageLoaded=!0),e.params.watchSlidesVisibility)t.children("."+a.slideVisibleClass).each((function(t){var a=r?m(t).attr("data-swiper-slide-index"):m(t).index();e.lazy.loadInSlide(a)}));else if(l>1)for(var p=s;p<s+l;p+=1)o(p)&&e.lazy.loadInSlide(p);else e.lazy.loadInSlide(s);if(n.loadPrevNext)if(l>1||n.loadPrevNextAmount&&n.loadPrevNextAmount>1){for(var u=n.loadPrevNextAmount,c=l,h=Math.min(s+c+Math.max(u,c),i.length),v=Math.max(s-Math.max(c,u),0),f=s+l;f<h;f+=1)o(f)&&e.lazy.loadInSlide(f);for(var g=v;g<s;g+=1)o(g)&&e.lazy.loadInSlide(g)}else{var b=t.children("."+a.slideNextClass);b.length>0&&e.lazy.loadInSlide(d(b));var y=t.children("."+a.slidePrevClass);y.length>0&&e.lazy.loadInSlide(d(y))}},checkInViewOnLoad:function(){var e=l(),t=this;if(t&&!t.destroyed){var a=t.params.lazy.scrollingElement?m(t.params.lazy.scrollingElement):m(e),i=a[0]===e,s=i?e.innerWidth:a[0].offsetWidth,r=i?e.innerHeight:a[0].offsetHeight,n=t.$el.offset(),o=!1;t.rtlTranslate&&(n.left-=t.$el[0].scrollLeft);for(var d=[[n.left,n.top],[n.left+t.width,n.top],[n.left,n.top+t.height],[n.left+t.width,n.top+t.height]],p=0;p<d.length;p+=1){var u=d[p];if(u[0]>=0&&u[0]<=s&&u[1]>=0&&u[1]<=r){if(0===u[0]&&0===u[1])continue;o=!0}}o?(t.lazy.load(),a.off("scroll",t.lazy.checkInViewOnLoad)):t.lazy.scrollHandlerAttached||(t.lazy.scrollHandlerAttached=!0,a.on("scroll",t.lazy.checkInViewOnLoad))}}},ie={LinearSpline:function(e,t){var a,i,s,r,n,l=function(e,t){for(i=-1,a=e.length;a-i>1;)e[s=a+i>>1]<=t?i=s:a=s;return a};return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(n=l(this.x,e),r=n-1,(e-this.x[r])*(this.y[n]-this.y[r])/(this.x[n]-this.x[r])+this.y[r]):0},this},getInterpolateFunction:function(e){var t=this;t.controller.spline||(t.controller.spline=t.params.loop?new ie.LinearSpline(t.slidesGrid,e.slidesGrid):new ie.LinearSpline(t.snapGrid,e.snapGrid))},setTranslate:function(e,t){var a,i,s=this,r=s.controller.control,n=s.constructor;function l(e){var t=s.rtlTranslate?-s.translate:s.translate;"slide"===s.params.controller.by&&(s.controller.getInterpolateFunction(e),i=-s.controller.spline.interpolate(-t)),i&&"container"!==s.params.controller.by||(a=(e.maxTranslate()-e.minTranslate())/(s.maxTranslate()-s.minTranslate()),i=(t-s.minTranslate())*a+e.minTranslate()),s.params.controller.inverse&&(i=e.maxTranslate()-i),e.updateProgress(i),e.setTranslate(i,s),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(r))for(var o=0;o<r.length;o+=1)r[o]!==t&&r[o]instanceof n&&l(r[o]);else r instanceof n&&t!==r&&l(r)},setTransition:function(e,t){var a,i=this,s=i.constructor,r=i.controller.control;function n(t){t.setTransition(e,i),0!==e&&(t.transitionStart(),t.params.autoHeight&&E((function(){t.updateAutoHeight()})),t.$wrapperEl.transitionEnd((function(){r&&(t.params.loop&&"slide"===i.params.controller.by&&t.loopFix(),t.transitionEnd())})))}if(Array.isArray(r))for(a=0;a<r.length;a+=1)r[a]!==t&&r[a]instanceof s&&n(r[a]);else r instanceof s&&t!==r&&n(r)}},se={getRandomNumber:function(e){void 0===e&&(e=16);return"x".repeat(e).replace(/x/g,(function(){return Math.round(16*Math.random()).toString(16)}))},makeElFocusable:function(e){return e.attr("tabIndex","0"),e},makeElNotFocusable:function(e){return e.attr("tabIndex","-1"),e},addElRole:function(e,t){return e.attr("role",t),e},addElRoleDescription:function(e,t){return e.attr("aria-roledescription",t),e},addElControls:function(e,t){return e.attr("aria-controls",t),e},addElLabel:function(e,t){return e.attr("aria-label",t),e},addElId:function(e,t){return e.attr("id",t),e},addElLive:function(e,t){return e.attr("aria-live",t),e},disableEl:function(e){return e.attr("aria-disabled",!0),e},enableEl:function(e){return e.attr("aria-disabled",!1),e},onEnterOrSpaceKey:function(e){if(13===e.keyCode||32===e.keyCode){var t=this,a=t.params.a11y,i=m(e.target);t.navigation&&t.navigation.$nextEl&&i.is(t.navigation.$nextEl)&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?t.a11y.notify(a.lastSlideMessage):t.a11y.notify(a.nextSlideMessage)),t.navigation&&t.navigation.$prevEl&&i.is(t.navigation.$prevEl)&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?t.a11y.notify(a.firstSlideMessage):t.a11y.notify(a.prevSlideMessage)),t.pagination&&i.is(z(t.params.pagination.bulletClass))&&i[0].click()}},notify:function(e){var t=this.a11y.liveRegion;0!==t.length&&(t.html(""),t.html(e))},updateNavigation:function(){var e=this;if(!e.params.loop&&e.navigation){var t=e.navigation,a=t.$nextEl,i=t.$prevEl;i&&i.length>0&&(e.isBeginning?(e.a11y.disableEl(i),e.a11y.makeElNotFocusable(i)):(e.a11y.enableEl(i),e.a11y.makeElFocusable(i))),a&&a.length>0&&(e.isEnd?(e.a11y.disableEl(a),e.a11y.makeElNotFocusable(a)):(e.a11y.enableEl(a),e.a11y.makeElFocusable(a)))}},updatePagination:function(){var e=this,t=e.params.a11y;e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.bullets.each((function(a){var i=m(a);e.a11y.makeElFocusable(i),e.params.pagination.renderBullet||(e.a11y.addElRole(i,"button"),e.a11y.addElLabel(i,t.paginationBulletMessage.replace(/\{\{index\}\}/,i.index()+1)))}))},init:function(){var e=this,t=e.params.a11y;e.$el.append(e.a11y.liveRegion);var a=e.$el;t.containerRoleDescriptionMessage&&e.a11y.addElRoleDescription(a,t.containerRoleDescriptionMessage),t.containerMessage&&e.a11y.addElLabel(a,t.containerMessage);var i,s,r=e.$wrapperEl,n=r.attr("id")||"swiper-wrapper-"+e.a11y.getRandomNumber(16),l=e.params.autoplay&&e.params.autoplay.enabled?"off":"polite";e.a11y.addElId(r,n),e.a11y.addElLive(r,l),t.itemRoleDescriptionMessage&&e.a11y.addElRoleDescription(m(e.slides),t.itemRoleDescriptionMessage),e.a11y.addElRole(m(e.slides),t.slideRole),e.slides.each((function(a){var i=m(a),s=t.slideLabelMessage.replace(/\{\{index\}\}/,i.index()+1).replace(/\{\{slidesLength\}\}/,e.slides.length);e.a11y.addElLabel(i,s)})),e.navigation&&e.navigation.$nextEl&&(i=e.navigation.$nextEl),e.navigation&&e.navigation.$prevEl&&(s=e.navigation.$prevEl),i&&i.length&&(e.a11y.makeElFocusable(i),"BUTTON"!==i[0].tagName&&(e.a11y.addElRole(i,"button"),i.on("keydown",e.a11y.onEnterOrSpaceKey)),e.a11y.addElLabel(i,t.nextSlideMessage),e.a11y.addElControls(i,n)),s&&s.length&&(e.a11y.makeElFocusable(s),"BUTTON"!==s[0].tagName&&(e.a11y.addElRole(s,"button"),s.on("keydown",e.a11y.onEnterOrSpaceKey)),e.a11y.addElLabel(s,t.prevSlideMessage),e.a11y.addElControls(s,n)),e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.$el.on("keydown",z(e.params.pagination.bulletClass),e.a11y.onEnterOrSpaceKey)},destroy:function(){var e,t,a=this;a.a11y.liveRegion&&a.a11y.liveRegion.length>0&&a.a11y.liveRegion.remove(),a.navigation&&a.navigation.$nextEl&&(e=a.navigation.$nextEl),a.navigation&&a.navigation.$prevEl&&(t=a.navigation.$prevEl),e&&e.off("keydown",a.a11y.onEnterOrSpaceKey),t&&t.off("keydown",a.a11y.onEnterOrSpaceKey),a.pagination&&a.params.pagination.clickable&&a.pagination.bullets&&a.pagination.bullets.length&&a.pagination.$el.off("keydown",z(a.params.pagination.bulletClass),a.a11y.onEnterOrSpaceKey)}},re={init:function(){var e=this,t=l();if(e.params.history){if(!t.history||!t.history.pushState)return e.params.history.enabled=!1,void(e.params.hashNavigation.enabled=!0);var a=e.history;a.initialized=!0,a.paths=re.getPathValues(e.params.url),(a.paths.key||a.paths.value)&&(a.scrollToSlide(0,a.paths.value,e.params.runCallbacksOnInit),e.params.history.replaceState||t.addEventListener("popstate",e.history.setHistoryPopState))}},destroy:function(){var e=l();this.params.history.replaceState||e.removeEventListener("popstate",this.history.setHistoryPopState)},setHistoryPopState:function(){var e=this;e.history.paths=re.getPathValues(e.params.url),e.history.scrollToSlide(e.params.speed,e.history.paths.value,!1)},getPathValues:function(e){var t=l(),a=(e?new URL(e):t.location).pathname.slice(1).split("/").filter((function(e){return""!==e})),i=a.length;return{key:a[i-2],value:a[i-1]}},setHistory:function(e,t){var a=this,i=l();if(a.history.initialized&&a.params.history.enabled){var s;s=a.params.url?new URL(a.params.url):i.location;var r=a.slides.eq(t),n=re.slugify(r.attr("data-history"));if(a.params.history.root.length>0){var o=a.params.history.root;"/"===o[o.length-1]&&(o=o.slice(0,o.length-1)),n=o+"/"+e+"/"+n}else s.pathname.includes(e)||(n=e+"/"+n);var d=i.history.state;d&&d.value===n||(a.params.history.replaceState?i.history.replaceState({value:n},null,n):i.history.pushState({value:n},null,n))}},slugify:function(e){return e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,"")},scrollToSlide:function(e,t,a){var i=this;if(t)for(var s=0,r=i.slides.length;s<r;s+=1){var n=i.slides.eq(s);if(re.slugify(n.attr("data-history"))===t&&!n.hasClass(i.params.slideDuplicateClass)){var l=n.index();i.slideTo(l,e,a)}}else i.slideTo(0,e,a)}},ne={onHashCange:function(){var e=this,t=r();e.emit("hashChange");var a=t.location.hash.replace("#","");if(a!==e.slides.eq(e.activeIndex).attr("data-hash")){var i=e.$wrapperEl.children("."+e.params.slideClass+'[data-hash="'+a+'"]').index();if(void 0===i)return;e.slideTo(i)}},setHash:function(){var e=this,t=l(),a=r();if(e.hashNavigation.initialized&&e.params.hashNavigation.enabled)if(e.params.hashNavigation.replaceState&&t.history&&t.history.replaceState)t.history.replaceState(null,null,"#"+e.slides.eq(e.activeIndex).attr("data-hash")||""),e.emit("hashSet");else{var i=e.slides.eq(e.activeIndex),s=i.attr("data-hash")||i.attr("data-history");a.location.hash=s||"",e.emit("hashSet")}},init:function(){var e=this,t=r(),a=l();if(!(!e.params.hashNavigation.enabled||e.params.history&&e.params.history.enabled)){e.hashNavigation.initialized=!0;var i=t.location.hash.replace("#","");if(i)for(var s=0,n=e.slides.length;s<n;s+=1){var o=e.slides.eq(s);if((o.attr("data-hash")||o.attr("data-history"))===i&&!o.hasClass(e.params.slideDuplicateClass)){var d=o.index();e.slideTo(d,0,e.params.runCallbacksOnInit,!0)}}e.params.hashNavigation.watchState&&m(a).on("hashchange",e.hashNavigation.onHashCange)}},destroy:function(){var e=l();this.params.hashNavigation.watchState&&m(e).off("hashchange",this.hashNavigation.onHashCange)}},le={run:function(){var e=this,t=e.slides.eq(e.activeIndex),a=e.params.autoplay.delay;t.attr("data-swiper-autoplay")&&(a=t.attr("data-swiper-autoplay")||e.params.autoplay.delay),clearTimeout(e.autoplay.timeout),e.autoplay.timeout=E((function(){var t;e.params.autoplay.reverseDirection?e.params.loop?(e.loopFix(),t=e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.isBeginning?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(t=e.slideTo(e.slides.length-1,e.params.speed,!0,!0),e.emit("autoplay")):(t=e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.params.loop?(e.loopFix(),t=e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")):e.isEnd?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(t=e.slideTo(0,e.params.speed,!0,!0),e.emit("autoplay")):(t=e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")),(e.params.cssMode&&e.autoplay.running||!1===t)&&e.autoplay.run()}),a)},start:function(){var e=this;return void 0===e.autoplay.timeout&&(!e.autoplay.running&&(e.autoplay.running=!0,e.emit("autoplayStart"),e.autoplay.run(),!0))},stop:function(){var e=this;return!!e.autoplay.running&&(void 0!==e.autoplay.timeout&&(e.autoplay.timeout&&(clearTimeout(e.autoplay.timeout),e.autoplay.timeout=void 0),e.autoplay.running=!1,e.emit("autoplayStop"),!0))},pause:function(e){var t=this;t.autoplay.running&&(t.autoplay.paused||(t.autoplay.timeout&&clearTimeout(t.autoplay.timeout),t.autoplay.paused=!0,0!==e&&t.params.autoplay.waitForTransition?["transitionend","webkitTransitionEnd"].forEach((function(e){t.$wrapperEl[0].addEventListener(e,t.autoplay.onTransitionEnd)})):(t.autoplay.paused=!1,t.autoplay.run())))},onVisibilityChange:function(){var e=this,t=r();"hidden"===t.visibilityState&&e.autoplay.running&&e.autoplay.pause(),"visible"===t.visibilityState&&e.autoplay.paused&&(e.autoplay.run(),e.autoplay.paused=!1)},onTransitionEnd:function(e){var t=this;t&&!t.destroyed&&t.$wrapperEl&&e.target===t.$wrapperEl[0]&&(["transitionend","webkitTransitionEnd"].forEach((function(e){t.$wrapperEl[0].removeEventListener(e,t.autoplay.onTransitionEnd)})),t.autoplay.paused=!1,t.autoplay.running?t.autoplay.run():t.autoplay.stop())},onMouseEnter:function(){var e=this;e.autoplay.pause(),["transitionend","webkitTransitionEnd"].forEach((function(t){e.$wrapperEl[0].removeEventListener(t,e.autoplay.onTransitionEnd)}))},onMouseLeave:function(){this.autoplay.paused=!1,this.autoplay.run()},attachMouseEvents:function(){var e=this;e.params.autoplay.pauseOnMouseEnter&&(e.$el.on("mouseenter",e.autoplay.onMouseEnter),e.$el.on("mouseleave",e.autoplay.onMouseLeave))},detachMouseEvents:function(){var e=this;e.$el.off("mouseenter",e.autoplay.onMouseEnter),e.$el.off("mouseleave",e.autoplay.onMouseLeave)}},oe={setTranslate:function(){for(var e=this,t=e.slides,a=0;a<t.length;a+=1){var i=e.slides.eq(a),s=-i[0].swiperSlideOffset;e.params.virtualTranslate||(s-=e.translate);var r=0;e.isHorizontal()||(r=s,s=0);var n=e.params.fadeEffect.crossFade?Math.max(1-Math.abs(i[0].progress),0):1+Math.min(Math.max(i[0].progress,-1),0);i.css({opacity:n}).transform("translate3d("+s+"px, "+r+"px, 0px)")}},setTransition:function(e){var t=this,a=t.slides,i=t.$wrapperEl;if(a.transition(e),t.params.virtualTranslate&&0!==e){var s=!1;a.transitionEnd((function(){if(!s&&t&&!t.destroyed){s=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],a=0;a<e.length;a+=1)i.trigger(e[a])}}))}}},de={setTranslate:function(){var e,t=this,a=t.$el,i=t.$wrapperEl,s=t.slides,r=t.width,n=t.height,l=t.rtlTranslate,o=t.size,d=t.browser,p=t.params.cubeEffect,u=t.isHorizontal(),c=t.virtual&&t.params.virtual.enabled,h=0;p.shadow&&(u?(0===(e=i.find(".swiper-cube-shadow")).length&&(e=m('<div class="swiper-cube-shadow"></div>'),i.append(e)),e.css({height:r+"px"})):0===(e=a.find(".swiper-cube-shadow")).length&&(e=m('<div class="swiper-cube-shadow"></div>'),a.append(e)));for(var v=0;v<s.length;v+=1){var f=s.eq(v),g=v;c&&(g=parseInt(f.attr("data-swiper-slide-index"),10));var b=90*g,y=Math.floor(b/360);l&&(b=-b,y=Math.floor(-b/360));var w=Math.max(Math.min(f[0].progress,1),-1),E=0,x=0,T=0;g%4==0?(E=4*-y*o,T=0):(g-1)%4==0?(E=0,T=4*-y*o):(g-2)%4==0?(E=o+4*y*o,T=o):(g-3)%4==0&&(E=-o,T=3*o+4*o*y),l&&(E=-E),u||(x=E,E=0);var C="rotateX("+(u?0:-b)+"deg) rotateY("+(u?b:0)+"deg) translate3d("+E+"px, "+x+"px, "+T+"px)";if(w<=1&&w>-1&&(h=90*g+90*w,l&&(h=90*-g-90*w)),f.transform(C),p.slideShadows){var S=u?f.find(".swiper-slide-shadow-left"):f.find(".swiper-slide-shadow-top"),M=u?f.find(".swiper-slide-shadow-right"):f.find(".swiper-slide-shadow-bottom");0===S.length&&(S=m('<div class="swiper-slide-shadow-'+(u?"left":"top")+'"></div>'),f.append(S)),0===M.length&&(M=m('<div class="swiper-slide-shadow-'+(u?"right":"bottom")+'"></div>'),f.append(M)),S.length&&(S[0].style.opacity=Math.max(-w,0)),M.length&&(M[0].style.opacity=Math.max(w,0))}}if(i.css({"-webkit-transform-origin":"50% 50% -"+o/2+"px","-moz-transform-origin":"50% 50% -"+o/2+"px","-ms-transform-origin":"50% 50% -"+o/2+"px","transform-origin":"50% 50% -"+o/2+"px"}),p.shadow)if(u)e.transform("translate3d(0px, "+(r/2+p.shadowOffset)+"px, "+-r/2+"px) rotateX(90deg) rotateZ(0deg) scale("+p.shadowScale+")");else{var z=Math.abs(h)-90*Math.floor(Math.abs(h)/90),P=1.5-(Math.sin(2*z*Math.PI/360)/2+Math.cos(2*z*Math.PI/360)/2),k=p.shadowScale,$=p.shadowScale/P,L=p.shadowOffset;e.transform("scale3d("+k+", 1, "+$+") translate3d(0px, "+(n/2+L)+"px, "+-n/2/$+"px) rotateX(-90deg)")}var I=d.isSafari||d.isWebView?-o/2:0;i.transform("translate3d(0px,0,"+I+"px) rotateX("+(t.isHorizontal()?0:h)+"deg) rotateY("+(t.isHorizontal()?-h:0)+"deg)")},setTransition:function(e){var t=this,a=t.$el;t.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.cubeEffect.shadow&&!t.isHorizontal()&&a.find(".swiper-cube-shadow").transition(e)}},pe={setTranslate:function(){for(var e=this,t=e.slides,a=e.rtlTranslate,i=0;i<t.length;i+=1){var s=t.eq(i),r=s[0].progress;e.params.flipEffect.limitRotation&&(r=Math.max(Math.min(s[0].progress,1),-1));var n=-180*r,l=0,o=-s[0].swiperSlideOffset,d=0;if(e.isHorizontal()?a&&(n=-n):(d=o,o=0,l=-n,n=0),s[0].style.zIndex=-Math.abs(Math.round(r))+t.length,e.params.flipEffect.slideShadows){var p=e.isHorizontal()?s.find(".swiper-slide-shadow-left"):s.find(".swiper-slide-shadow-top"),u=e.isHorizontal()?s.find(".swiper-slide-shadow-right"):s.find(".swiper-slide-shadow-bottom");0===p.length&&(p=m('<div class="swiper-slide-shadow-'+(e.isHorizontal()?"left":"top")+'"></div>'),s.append(p)),0===u.length&&(u=m('<div class="swiper-slide-shadow-'+(e.isHorizontal()?"right":"bottom")+'"></div>'),s.append(u)),p.length&&(p[0].style.opacity=Math.max(-r,0)),u.length&&(u[0].style.opacity=Math.max(r,0))}s.transform("translate3d("+o+"px, "+d+"px, 0px) rotateX("+l+"deg) rotateY("+n+"deg)")}},setTransition:function(e){var t=this,a=t.slides,i=t.activeIndex,s=t.$wrapperEl;if(a.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.virtualTranslate&&0!==e){var r=!1;a.eq(i).transitionEnd((function(){if(!r&&t&&!t.destroyed){r=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],a=0;a<e.length;a+=1)s.trigger(e[a])}}))}}},ue={setTranslate:function(){for(var e=this,t=e.width,a=e.height,i=e.slides,s=e.slidesSizesGrid,r=e.params.coverflowEffect,n=e.isHorizontal(),l=e.translate,o=n?t/2-l:a/2-l,d=n?r.rotate:-r.rotate,p=r.depth,u=0,c=i.length;u<c;u+=1){var h=i.eq(u),v=s[u],f=(o-h[0].swiperSlideOffset-v/2)/v*r.modifier,g=n?d*f:0,b=n?0:d*f,y=-p*Math.abs(f),w=r.stretch;"string"==typeof w&&-1!==w.indexOf("%")&&(w=parseFloat(r.stretch)/100*v);var E=n?0:w*f,x=n?w*f:0,T=1-(1-r.scale)*Math.abs(f);Math.abs(x)<.001&&(x=0),Math.abs(E)<.001&&(E=0),Math.abs(y)<.001&&(y=0),Math.abs(g)<.001&&(g=0),Math.abs(b)<.001&&(b=0),Math.abs(T)<.001&&(T=0);var C="translate3d("+x+"px,"+E+"px,"+y+"px)  rotateX("+b+"deg) rotateY("+g+"deg) scale("+T+")";if(h.transform(C),h[0].style.zIndex=1-Math.abs(Math.round(f)),r.slideShadows){var S=n?h.find(".swiper-slide-shadow-left"):h.find(".swiper-slide-shadow-top"),M=n?h.find(".swiper-slide-shadow-right"):h.find(".swiper-slide-shadow-bottom");0===S.length&&(S=m('<div class="swiper-slide-shadow-'+(n?"left":"top")+'"></div>'),h.append(S)),0===M.length&&(M=m('<div class="swiper-slide-shadow-'+(n?"right":"bottom")+'"></div>'),h.append(M)),S.length&&(S[0].style.opacity=f>0?f:0),M.length&&(M[0].style.opacity=-f>0?-f:0)}}},setTransition:function(e){this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)}},ce={init:function(){var e=this,t=e.params.thumbs;if(e.thumbs.initialized)return!1;e.thumbs.initialized=!0;var a=e.constructor;return t.swiper instanceof a?(e.thumbs.swiper=t.swiper,S(e.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),S(e.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1})):C(t.swiper)&&(e.thumbs.swiper=new a(S({},t.swiper,{watchSlidesVisibility:!0,watchSlidesProgress:!0,slideToClickedSlide:!1})),e.thumbs.swiperCreated=!0),e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),e.thumbs.swiper.on("tap",e.thumbs.onThumbClick),!0},onThumbClick:function(){var e=this,t=e.thumbs.swiper;if(t){var a=t.clickedIndex,i=t.clickedSlide;if(!(i&&m(i).hasClass(e.params.thumbs.slideThumbActiveClass)||null==a)){var s;if(s=t.params.loop?parseInt(m(t.clickedSlide).attr("data-swiper-slide-index"),10):a,e.params.loop){var r=e.activeIndex;e.slides.eq(r).hasClass(e.params.slideDuplicateClass)&&(e.loopFix(),e._clientLeft=e.$wrapperEl[0].clientLeft,r=e.activeIndex);var n=e.slides.eq(r).prevAll('[data-swiper-slide-index="'+s+'"]').eq(0).index(),l=e.slides.eq(r).nextAll('[data-swiper-slide-index="'+s+'"]').eq(0).index();s=void 0===n?l:void 0===l?n:l-r<r-n?l:n}e.slideTo(s)}}},update:function(e){var t=this,a=t.thumbs.swiper;if(a){var i="auto"===a.params.slidesPerView?a.slidesPerViewDynamic():a.params.slidesPerView,s=t.params.thumbs.autoScrollOffset,r=s&&!a.params.loop;if(t.realIndex!==a.realIndex||r){var n,l,o=a.activeIndex;if(a.params.loop){a.slides.eq(o).hasClass(a.params.slideDuplicateClass)&&(a.loopFix(),a._clientLeft=a.$wrapperEl[0].clientLeft,o=a.activeIndex);var d=a.slides.eq(o).prevAll('[data-swiper-slide-index="'+t.realIndex+'"]').eq(0).index(),p=a.slides.eq(o).nextAll('[data-swiper-slide-index="'+t.realIndex+'"]').eq(0).index();n=void 0===d?p:void 0===p?d:p-o==o-d?o:p-o<o-d?p:d,l=t.activeIndex>t.previousIndex?"next":"prev"}else l=(n=t.realIndex)>t.previousIndex?"next":"prev";r&&(n+="next"===l?s:-1*s),a.visibleSlidesIndexes&&a.visibleSlidesIndexes.indexOf(n)<0&&(a.params.centeredSlides?n=n>o?n-Math.floor(i/2)+1:n+Math.floor(i/2)-1:n>o&&(n=n-i+1),a.slideTo(n,e?0:void 0))}var u=1,c=t.params.thumbs.slideThumbActiveClass;if(t.params.slidesPerView>1&&!t.params.centeredSlides&&(u=t.params.slidesPerView),t.params.thumbs.multipleActiveThumbs||(u=1),u=Math.floor(u),a.slides.removeClass(c),a.params.loop||a.params.virtual&&a.params.virtual.enabled)for(var h=0;h<u;h+=1)a.$wrapperEl.children('[data-swiper-slide-index="'+(t.realIndex+h)+'"]').addClass(c);else for(var v=0;v<u;v+=1)a.slides.eq(t.realIndex+v).addClass(c)}}},he=[q,U,{name:"mousewheel",params:{mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null}},create:function(){M(this,{mousewheel:{enabled:!1,lastScrollTime:x(),lastEventBeforeSnap:void 0,recentWheelEvents:[],enable:K.enable,disable:K.disable,handle:K.handle,handleMouseEnter:K.handleMouseEnter,handleMouseLeave:K.handleMouseLeave,animateSlider:K.animateSlider,releaseScroll:K.releaseScroll}})},on:{init:function(e){!e.params.mousewheel.enabled&&e.params.cssMode&&e.mousewheel.disable(),e.params.mousewheel.enabled&&e.mousewheel.enable()},destroy:function(e){e.params.cssMode&&e.mousewheel.enable(),e.mousewheel.enabled&&e.mousewheel.disable()}}},{name:"navigation",params:{navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock"}},create:function(){M(this,{navigation:t({},Z)})},on:{init:function(e){e.navigation.init(),e.navigation.update()},toEdge:function(e){e.navigation.update()},fromEdge:function(e){e.navigation.update()},destroy:function(e){e.navigation.destroy()},"enable disable":function(e){var t=e.navigation,a=t.$nextEl,i=t.$prevEl;a&&a[e.enabled?"removeClass":"addClass"](e.params.navigation.lockClass),i&&i[e.enabled?"removeClass":"addClass"](e.params.navigation.lockClass)},click:function(e,t){var a=e.navigation,i=a.$nextEl,s=a.$prevEl,r=t.target;if(e.params.navigation.hideOnClick&&!m(r).is(s)&&!m(r).is(i)){if(e.pagination&&e.params.pagination&&e.params.pagination.clickable&&(e.pagination.el===r||e.pagination.el.contains(r)))return;var n;i?n=i.hasClass(e.params.navigation.hiddenClass):s&&(n=s.hasClass(e.params.navigation.hiddenClass)),!0===n?e.emit("navigationShow"):e.emit("navigationHide"),i&&i.toggleClass(e.params.navigation.hiddenClass),s&&s.toggleClass(e.params.navigation.hiddenClass)}}}},{name:"pagination",params:{pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:function(e){return e},formatFractionTotal:function(e){return e},bulletClass:"swiper-pagination-bullet",bulletActiveClass:"swiper-pagination-bullet-active",modifierClass:"swiper-pagination-",currentClass:"swiper-pagination-current",totalClass:"swiper-pagination-total",hiddenClass:"swiper-pagination-hidden",progressbarFillClass:"swiper-pagination-progressbar-fill",progressbarOppositeClass:"swiper-pagination-progressbar-opposite",clickableClass:"swiper-pagination-clickable",lockClass:"swiper-pagination-lock"}},create:function(){M(this,{pagination:t({dynamicBulletIndex:0},J)})},on:{init:function(e){e.pagination.init(),e.pagination.render(),e.pagination.update()},activeIndexChange:function(e){(e.params.loop||void 0===e.snapIndex)&&e.pagination.update()},snapIndexChange:function(e){e.params.loop||e.pagination.update()},slidesLengthChange:function(e){e.params.loop&&(e.pagination.render(),e.pagination.update())},snapGridLengthChange:function(e){e.params.loop||(e.pagination.render(),e.pagination.update())},destroy:function(e){e.pagination.destroy()},"enable disable":function(e){var t=e.pagination.$el;t&&t[e.enabled?"removeClass":"addClass"](e.params.pagination.lockClass)},click:function(e,t){var a=t.target;if(e.params.pagination.el&&e.params.pagination.hideOnClick&&e.pagination.$el.length>0&&!m(a).hasClass(e.params.pagination.bulletClass)){if(e.navigation&&(e.navigation.nextEl&&a===e.navigation.nextEl||e.navigation.prevEl&&a===e.navigation.prevEl))return;!0===e.pagination.$el.hasClass(e.params.pagination.hiddenClass)?e.emit("paginationShow"):e.emit("paginationHide"),e.pagination.$el.toggleClass(e.params.pagination.hiddenClass)}}}},{name:"scrollbar",params:{scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag"}},create:function(){M(this,{scrollbar:t({isTouched:!1,timeout:null,dragTimeout:null},Q)})},on:{init:function(e){e.scrollbar.init(),e.scrollbar.updateSize(),e.scrollbar.setTranslate()},update:function(e){e.scrollbar.updateSize()},resize:function(e){e.scrollbar.updateSize()},observerUpdate:function(e){e.scrollbar.updateSize()},setTranslate:function(e){e.scrollbar.setTranslate()},setTransition:function(e,t){e.scrollbar.setTransition(t)},"enable disable":function(e){var t=e.scrollbar.$el;t&&t[e.enabled?"removeClass":"addClass"](e.params.scrollbar.lockClass)},destroy:function(e){e.scrollbar.destroy()}}},{name:"parallax",params:{parallax:{enabled:!1}},create:function(){M(this,{parallax:t({},ee)})},on:{beforeInit:function(e){e.params.parallax.enabled&&(e.params.watchSlidesProgress=!0,e.originalParams.watchSlidesProgress=!0)},init:function(e){e.params.parallax.enabled&&e.parallax.setTranslate()},setTranslate:function(e){e.params.parallax.enabled&&e.parallax.setTranslate()},setTransition:function(e,t){e.params.parallax.enabled&&e.parallax.setTransition(t)}}},{name:"zoom",params:{zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}},create:function(){var e=this;M(e,{zoom:t({enabled:!1,scale:1,currentScale:1,isScaling:!1,gesture:{$slideEl:void 0,slideWidth:void 0,slideHeight:void 0,$imageEl:void 0,$imageWrapEl:void 0,maxRatio:3},image:{isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},velocity:{x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0}},te)});var a=1;Object.defineProperty(e.zoom,"scale",{get:function(){return a},set:function(t){if(a!==t){var i=e.zoom.gesture.$imageEl?e.zoom.gesture.$imageEl[0]:void 0,s=e.zoom.gesture.$slideEl?e.zoom.gesture.$slideEl[0]:void 0;e.emit("zoomChange",t,i,s)}a=t}})},on:{init:function(e){e.params.zoom.enabled&&e.zoom.enable()},destroy:function(e){e.zoom.disable()},touchStart:function(e,t){e.zoom.enabled&&e.zoom.onTouchStart(t)},touchEnd:function(e,t){e.zoom.enabled&&e.zoom.onTouchEnd(t)},doubleTap:function(e,t){!e.animating&&e.params.zoom.enabled&&e.zoom.enabled&&e.params.zoom.toggle&&e.zoom.toggle(t)},transitionEnd:function(e){e.zoom.enabled&&e.params.zoom.enabled&&e.zoom.onTransitionEnd()},slideChange:function(e){e.zoom.enabled&&e.params.zoom.enabled&&e.params.cssMode&&e.zoom.onTransitionEnd()}}},{name:"lazy",params:{lazy:{checkInView:!1,enabled:!1,loadPrevNext:!1,loadPrevNextAmount:1,loadOnTransitionStart:!1,scrollingElement:"",elementClass:"swiper-lazy",loadingClass:"swiper-lazy-loading",loadedClass:"swiper-lazy-loaded",preloaderClass:"swiper-lazy-preloader"}},create:function(){M(this,{lazy:t({initialImageLoaded:!1},ae)})},on:{beforeInit:function(e){e.params.lazy.enabled&&e.params.preloadImages&&(e.params.preloadImages=!1)},init:function(e){e.params.lazy.enabled&&!e.params.loop&&0===e.params.initialSlide&&(e.params.lazy.checkInView?e.lazy.checkInViewOnLoad():e.lazy.load())},scroll:function(e){e.params.freeMode&&!e.params.freeModeSticky&&e.lazy.load()},"scrollbarDragMove resize _freeModeNoMomentumRelease":function(e){e.params.lazy.enabled&&e.lazy.load()},transitionStart:function(e){e.params.lazy.enabled&&(e.params.lazy.loadOnTransitionStart||!e.params.lazy.loadOnTransitionStart&&!e.lazy.initialImageLoaded)&&e.lazy.load()},transitionEnd:function(e){e.params.lazy.enabled&&!e.params.lazy.loadOnTransitionStart&&e.lazy.load()},slideChange:function(e){e.params.lazy.enabled&&e.params.cssMode&&e.lazy.load()}}},{name:"controller",params:{controller:{control:void 0,inverse:!1,by:"slide"}},create:function(){M(this,{controller:t({control:this.params.controller.control},ie)})},on:{update:function(e){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)},resize:function(e){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)},observerUpdate:function(e){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)},setTranslate:function(e,t,a){e.controller.control&&e.controller.setTranslate(t,a)},setTransition:function(e,t,a){e.controller.control&&e.controller.setTransition(t,a)}}},{name:"a11y",params:{a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,itemRoleDescriptionMessage:null,slideRole:"group"}},create:function(){M(this,{a11y:t({},se,{liveRegion:m('<span class="'+this.params.a11y.notificationClass+'" aria-live="assertive" aria-atomic="true"></span>')})})},on:{afterInit:function(e){e.params.a11y.enabled&&(e.a11y.init(),e.a11y.updateNavigation())},toEdge:function(e){e.params.a11y.enabled&&e.a11y.updateNavigation()},fromEdge:function(e){e.params.a11y.enabled&&e.a11y.updateNavigation()},paginationUpdate:function(e){e.params.a11y.enabled&&e.a11y.updatePagination()},destroy:function(e){e.params.a11y.enabled&&e.a11y.destroy()}}},{name:"history",params:{history:{enabled:!1,root:"",replaceState:!1,key:"slides"}},create:function(){M(this,{history:t({},re)})},on:{init:function(e){e.params.history.enabled&&e.history.init()},destroy:function(e){e.params.history.enabled&&e.history.destroy()},"transitionEnd _freeModeNoMomentumRelease":function(e){e.history.initialized&&e.history.setHistory(e.params.history.key,e.activeIndex)},slideChange:function(e){e.history.initialized&&e.params.cssMode&&e.history.setHistory(e.params.history.key,e.activeIndex)}}},{name:"hash-navigation",params:{hashNavigation:{enabled:!1,replaceState:!1,watchState:!1}},create:function(){M(this,{hashNavigation:t({initialized:!1},ne)})},on:{init:function(e){e.params.hashNavigation.enabled&&e.hashNavigation.init()},destroy:function(e){e.params.hashNavigation.enabled&&e.hashNavigation.destroy()},"transitionEnd _freeModeNoMomentumRelease":function(e){e.hashNavigation.initialized&&e.hashNavigation.setHash()},slideChange:function(e){e.hashNavigation.initialized&&e.params.cssMode&&e.hashNavigation.setHash()}}},{name:"autoplay",params:{autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}},create:function(){M(this,{autoplay:t({},le,{running:!1,paused:!1})})},on:{init:function(e){e.params.autoplay.enabled&&(e.autoplay.start(),r().addEventListener("visibilitychange",e.autoplay.onVisibilityChange),e.autoplay.attachMouseEvents())},beforeTransitionStart:function(e,t,a){e.autoplay.running&&(a||!e.params.autoplay.disableOnInteraction?e.autoplay.pause(t):e.autoplay.stop())},sliderFirstMove:function(e){e.autoplay.running&&(e.params.autoplay.disableOnInteraction?e.autoplay.stop():e.autoplay.pause())},touchEnd:function(e){e.params.cssMode&&e.autoplay.paused&&!e.params.autoplay.disableOnInteraction&&e.autoplay.run()},destroy:function(e){e.autoplay.detachMouseEvents(),e.autoplay.running&&e.autoplay.stop(),r().removeEventListener("visibilitychange",e.autoplay.onVisibilityChange)}}},{name:"effect-fade",params:{fadeEffect:{crossFade:!1}},create:function(){M(this,{fadeEffect:t({},oe)})},on:{beforeInit:function(e){if("fade"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"fade");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};S(e.params,t),S(e.originalParams,t)}},setTranslate:function(e){"fade"===e.params.effect&&e.fadeEffect.setTranslate()},setTransition:function(e,t){"fade"===e.params.effect&&e.fadeEffect.setTransition(t)}}},{name:"effect-cube",params:{cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}},create:function(){M(this,{cubeEffect:t({},de)})},on:{beforeInit:function(e){if("cube"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"cube"),e.classNames.push(e.params.containerModifierClass+"3d");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0};S(e.params,t),S(e.originalParams,t)}},setTranslate:function(e){"cube"===e.params.effect&&e.cubeEffect.setTranslate()},setTransition:function(e,t){"cube"===e.params.effect&&e.cubeEffect.setTransition(t)}}},{name:"effect-flip",params:{flipEffect:{slideShadows:!0,limitRotation:!0}},create:function(){M(this,{flipEffect:t({},pe)})},on:{beforeInit:function(e){if("flip"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"flip"),e.classNames.push(e.params.containerModifierClass+"3d");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};S(e.params,t),S(e.originalParams,t)}},setTranslate:function(e){"flip"===e.params.effect&&e.flipEffect.setTranslate()},setTransition:function(e,t){"flip"===e.params.effect&&e.flipEffect.setTransition(t)}}},{name:"effect-coverflow",params:{coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0}},create:function(){M(this,{coverflowEffect:t({},ue)})},on:{beforeInit:function(e){"coverflow"===e.params.effect&&(e.classNames.push(e.params.containerModifierClass+"coverflow"),e.classNames.push(e.params.containerModifierClass+"3d"),e.params.watchSlidesProgress=!0,e.originalParams.watchSlidesProgress=!0)},setTranslate:function(e){"coverflow"===e.params.effect&&e.coverflowEffect.setTranslate()},setTransition:function(e,t){"coverflow"===e.params.effect&&e.coverflowEffect.setTransition(t)}}},{name:"thumbs",params:{thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-container-thumbs"}},create:function(){M(this,{thumbs:t({swiper:null,initialized:!1},ce)})},on:{beforeInit:function(e){var t=e.params.thumbs;t&&t.swiper&&(e.thumbs.init(),e.thumbs.update(!0))},slideChange:function(e){e.thumbs.swiper&&e.thumbs.update()},update:function(e){e.thumbs.swiper&&e.thumbs.update()},resize:function(e){e.thumbs.swiper&&e.thumbs.update()},observerUpdate:function(e){e.thumbs.swiper&&e.thumbs.update()},setTransition:function(e,t){var a=e.thumbs.swiper;a&&a.setTransition(t)},beforeDestroy:function(e){var t=e.thumbs.swiper;t&&e.thumbs.swiperCreated&&t&&t.destroy()}}}];return F.use(he),F}));
//# sourceMappingURL=swiper-bundle.min.js.map

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(98);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../build-v2/node_modules/style-loader/index.js!../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./swiper-bundle.min.css", function() {
		var newContent = require("!!../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../build-v2/node_modules/style-loader/index.js!../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./swiper-bundle.min.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(7),
    __webpack_require__(8),
    __webpack_require__(2),
    __webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    EventBus,
    Events,
    Utils,
    _
){
    function ln2br(str){
        return (str||'').replace(/\n/g,'<br/>');
    }

    function uniqueId(){
        return Math.random().toString(36).substr(2, 4) + Date.now().toString(36);
    }

    function genGroceryDetailLink(id){
        return Utils.genPageLink('/grocery-detail?id='+id);
    }
    function genFurnitureDetailLink(id){
        return Utils.genPageLink('/furniture-detail?id='+id);
    }
    function genGalleryDetailLink(id){
        return Utils.genPageLink('/gallery-detail?id='+id);
    }

    function genGroceryL2Link(bom){
        return Utils.genPageLink('/grocery-l2?bom='+bom);
    }

    function genFurnitureL2Link(bom){
        return Utils.genPageLink('/furniture-l2?bom='+bom);
    }

    function genProductDetailLink(id, type){
        switch(parseInt(type)){
            case 1:
                return genFurnitureDetailLink(id);
            case 2:
                return genGroceryDetailLink(id);
            case 3:
                return genGalleryDetailLink(id);
            default:
                return genGroceryDetailLink(id);
        }
    }

    function getSkuMainImage(sku){
        var options = {
            color: sku.bgColorBase64,
            width: 500
        };
        return Utils.genFnjiImageUrl(sku.mainImage, options) || Utils.genCdnImageUrl(sku.mainImg, options);
    }
    function getSkuBgColor(sku){
        return sku.bgColor || '#f7f7f7';
    }
    function isSkuSoldOut(sku){
        return parseInt(sku.storeNum) <= 0;
    }
    function isSkuDiscount(sku){
        return sku.discountRate && parseFloat(sku.discountRate) > 0;
    }

    return _.assign({}, Utils, {
        ln2br: ln2br,

        genGroceryDetailLink: genGroceryDetailLink,
        genFurnitureDetailLink: genFurnitureDetailLink,
        uniqueId: uniqueId,
        genProductDetailLink: genProductDetailLink,
        getSkuMainImage: getSkuMainImage,
        getSkuBgColor: getSkuBgColor,
        genGroceryL2Link: genGroceryL2Link,
        genFurnitureL2Link: genFurnitureL2Link,
        isSkuSoldOut: isSkuSoldOut,
        isSkuDiscount: isSkuDiscount

    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(132),
    // 'common/api',
    __webpack_require__(1),
    __webpack_require__(111),
    __webpack_require__(96),

    __webpack_require__(97),
    __webpack_require__(133)

], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    // Api,
    $,Utils,
    Swiper
){
    return {
        template: tpl,
        data: function(){
            return {

            };
        },
        // 这里是传入的数据
        props: {
            SlickImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            },
            SwiperImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            SwiperType: String,
            ISPC: Boolean
        },
        methods: {
            init: function () {
                if(this.SwiperType=='base'){
                    new Swiper('#swiper-base',{
                        observer: true,
                        autoplay: {
                            delay: 2500,
                            disableOnInteraction: false,
                        }
                    });
                }
            }
        },
        watch: {
            SwiperType: function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = "<div id=\"swiper-base\" class=\"swiper-container\" style=\"height:100%\">\r\n    <div v-if=\"SwiperType=='base'&&ISPC\" class=\"swiper-wrapper\">\r\n        <div v-for=\"(item,index) in SwiperImage\" :key=\"index\" class=\"swiper-slide swiper-slide-image\" :style=\"{background: 'url(https://static.fnji.com/temp/upload/'+item+'?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1) center center / cover no-repeat',backgroundSize: 'cover'}\"></div>\r\n    </div>\r\n    <div v-if=\"SwiperType=='base'&&!ISPC\" class=\"swiper-wrapper\">\r\n        <div v-for=\"(item,index) in SwiperImage\" :key=\"index\" class=\"swiper-slide swiper-slide-image\" :style=\"{background: 'url(https://static.fnji.com/temp/upload/'+item+'?imageMogr2/thumbnail/1200x%3E/quality/100!/sharpen/1) center center / cover no-repeat',backgroundSize: 'cover'}\"></div>\r\n    </div>\r\n</div>"

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(134);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./swiper-title.css", function() {
		var newContent = require("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./swiper-title.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(136),
    // 'common/api',
    __webpack_require__(1),
    __webpack_require__(111),
    __webpack_require__(137)

], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    // Api,
    $,Utils
){
    return {
        template: tpl,
        data: function(){
            return {
                windowWidth: 1280,
                itemShow: 1000
            };
        },
        props: {
            link: String,
            showNum: Number,
            productList: Array,
            productWidth: Number,
            isPC: Boolean,
            lineNum: Number
        },
        computed: {

        },
        created: function () {
            var obj = this;
            obj.windowWidth = $(window).width();

        },
        methods: {
            init: function () {
                var _this = this;
            },
            showMore: function () {
                var _this = this;
                _this.showNum += 1000;
            },
            enter: function (index) {
                var _this = this;
                _this.itemShow = index;
                // $('.produc-list-item-info').eq(index).addClass('itemShow')
            },
            leave: function () {
                var _this = this;
                _this.itemShow = 1000;
                // $('.produc-list-item-info').removeClass('itemShow')
            },
            uploadLog: function () {
                var _this = this;
                if(_this.lineNum==1){
                    window.open('http://fnji.com/temp/upload/1637549316_2012.pdf');//山脊线
                    // window.location.href="http://fnji.com/temp/upload/1637549316_2012.pdf";
                }else{
                    window.open('http://fnji.com/temp/upload/1637549267_5568.pdf');//大地线
                    // window.location.href="http://fnji.com/temp/upload/1637549267_5568.pdf";
                }
            }
        },
        mounted: function(){
            this.init();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-list-con\">\r\n    <div v-if=\"isPC\" class=\"product-list-con\">\r\n        <div class=\"index2021-product-list-item\"\r\n             @mouseenter=\"enter(index)\" @mouseleave=\"leave()\"\r\n             @click=\"toDetail(item.link)\"\r\n             :style=\"{width:productWidth+'px',height:productWidth+'px','background':'linear-gradient('+item.bgColor+','+(item.bgColorDown&&(item.bgColorDown!='#000000')?item.bgColorDown:bgColor)+')'}\"\r\n             v-if=\"index<showNum\" v-for=\"(item,index) in productList\" :key=\"index\">\r\n            <a style=\"width: 100%;height: 100%;display: flex;justify-content: center;align-items: center\" :href=\"item.link\">\r\n                <img class=\"produc-list-img\" :src=\"'https://static.fnji.com/temp/upload/'+item.mainImage\" alt=\"\">\r\n                <div class=\"produc-list-item-info\"\r\n                     :class=\"[index==itemShow?'itemShow':'']\"\r\n                     :style=\"{height: windowWidth/35*2+'px'}\">\r\n                    <div class=\"produc-list-item-info-con\">\r\n                        <div style=\"position: relative;width: 100%;\">\r\n                            <div style=\"font-size: 15px;margin-bottom: 6px;\" class=\"produc-list-item-word\">{{item.name}}</div>\r\n                            <div style=\"font-size: 12px;font-weight: 700\" class=\"produc-list-item-word\">￥{{item.price}}</div>\r\n                            <div style=\"font-size: 12px;font-weight: 700\" class=\"produc-list-item-word\" v-if=\"item.status!='1'\">仅限实体店购买</div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </a>\r\n        </div>\r\n        <div style=\"clear: both\"></div>\r\n    </div>\r\n    <div v-if=\"!isPC\" class=\"product-list-con\">\r\n        <div @click=\"toDetail(items.link)\" class=\"index2021-product-list-item-phone\"\r\n             v-if=\"indexs<showNum\" v-for=\"(items,indexs) in productList\" :key=\"indexs\">\r\n            <div class=\"base-product-normal\">\r\n                <a class=\"base-product-normal\" :href=\"items.link\">\r\n                    <div style=\"width: 100%;height: 100%;display: flex;justify-content: center;align-items: center\" :style=\"{width:productWidth+'px',height:productWidth+'px','background':'linear-gradient('+items.bgColor+','+(items.bgColorDown&&(items.bgColorDown!='#000000')?items.bgColorDown:bgColor)+')'}\">\r\n                        <img class=\"produc-list-img\" :src=\"'https://static.fnji.com/temp/upload/'+items.mainImage\" alt=\"\">\r\n                    </div>\r\n                    <div class=\"index2021-product-list-word-phone\">\r\n                        <div>{{items.name}}</div>\r\n                        <div style=\"flex: 1;\"></div>\r\n                        <div>￥{{items.price}}</div>\r\n                    </div>\r\n                </a>\r\n            </div>\r\n        </div>\r\n        <div style=\"clear: both\"></div>\r\n    </div>\r\n    <div class=\"index2021-product-list-more\">\r\n        <a :href=\"link\">\r\n            <div :class=\"isPC?'index2021-product-list-button':'index2021-product-list-button-phone'\">查看全部</div>\r\n        </a>\r\n    </div>\r\n    <div class=\"index2021-product-list-more\" :style=\"{'margin-top': isPC?'20px':'35px'}\">\r\n        <div v-if=\"isPC\" @click=\"uploadLog\" class=\"index2021-product-list-button\" style=\"width: 109px;\">下载catalog</div>\r\n        <div v-if=\"!isPC\" @click=\"uploadLog\" class=\"index2021-product-list-button-phone\" style=\"width: 166px;\">下载catalog</div>\r\n    </div>\r\n</div>"

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(138);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./product-list.css", function() {
		var newContent = require("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./product-list.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(4),
    __webpack_require__(19),
    __webpack_require__(22),
    __webpack_require__(187),

    // 'WebCommon/init'
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Vue,
    i18n,
    PageMixin,

    PageContent
){
    var app = new Vue({
        mixins: [PageMixin],
        components: {
            PageContent: PageContent
        },
        i18n: i18n
    });
    app.$mount('#app');

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(188),
    __webpack_require__(189),
    __webpack_require__(1),
    __webpack_require__(111),
    __webpack_require__(131),
    __webpack_require__(135),

    __webpack_require__(190)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    Api,
    $,Utils,
    SwiperTitle,
    ProductList
){
    return {
        components: {
            SwiperTitle: SwiperTitle,
            ProductList: ProductList
        },
        template: tpl,
        data: function(){
            return {
                isPC: true,
                baseTitle: 's20480_1629787919_4828.png',
                baseCon: 's20480_1629788946_2456.png',
                baseList: ['s20480_1629790832_1932.png','s20480_1629790981_5151.png','s20480_1629791039_8607.png'],
                baseTitlePhone: 's20480_1629969161_8286.png',
                baseConPhone: 's20480_1629969233_1830.png',
                baseListPhone: ['s20480_1629969285_3275.png','s20480_1629969308_8754.png','s20480_1629969324_2699.png'],
                baseWidth: 0,
                baseHeight: 0,
                baseConWidth: 0,
                productList: [],
                ridgeNum: 16,
                productWidth: 0
            };
        },
        methods: {
            init: function(){
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                    $('.fixed-menu').css({display: 'none'});
                }else {
                    obj.isPC = true;
                }
                obj.getWidth();
                obj.getImages();
            },
            getWidth: function () {
                var obj = this;
                if(obj.isPC){
                    obj.productWidth = ($(window).width()-150)/4;
                    obj.baseConWidth = $(window).width()*94/100;
                    obj.baseWidth = obj.baseConWidth*600/1440;
                    obj.baseHeight = obj.baseWidth/600*752;
                }else {
                    obj.productWidth = 320;
                }
            },
            getImages: function () {
                var _this = this;
                Api.highListApi.ajax()
                    .done(function(data){
                        _this.productList = data.base;
                    });
            }
        },
        mounted: function(){
            this.init();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                obj.getWidth();
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = "<div class=\"base-line\">\r\n    <div v-if=\"isPC\" class=\"base-normal-h\" :style=\"{background: 'url(https://static.fnji.com/temp/upload/'+baseTitle+'?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1) center center / cover no-repeat',backgroundSize: 'cover'}\"></div>\r\n    <div v-if=\"!isPC\" class=\"base-normal-h\" :style=\"{background: 'url(https://static.fnji.com/temp/upload/'+baseTitlePhone+'?imageMogr2/thumbnail/1200x%3E/quality/100!/sharpen/1) center center / cover no-repeat',backgroundSize: 'cover'}\"></div>\r\n    <div :class=\"isPC?'base-line-info':'base-line-info-phone'\">\r\n        <div :class=\"isPC?'base-line-title':'base-line-title-phone'\">大地线</div>\r\n        <div :class=\"isPC?'base-line-title-words':'base-line-title-words-phone'\">简练淳厚  如无垠大地</div>\r\n        <div :class=\"isPC?'base-line-r':'base-line-r-phone'\">Wise and pure as boundless earth</div>\r\n        <div v-if=\"isPC\" style=\"margin:75px 0 130px 0;\" class=\"base-toDown\"><img style=\"width: 100%;height: 100%;\" src=\"/view-v2/web/static/img/site/index2021-toDown-new.png\" alt=\"\"></div>\r\n        <div v-if=\"!isPC\" style=\"margin:80px 0 180px 0;\" class=\"base-toDown\"><img style=\"width: 100%;height: 100%;\" src=\"/view-v2/web/static/img/site/index2021-toDown-new.png\" alt=\"\"></div>\r\n        <div v-if=\"isPC\" class=\"base-normal\" :style=\"{height: baseHeight+'px'}\">\r\n            <div :style=\"{width: baseConWidth-baseWidth+'px'}\" class=\"base-line-info-con\">\r\n                <div class=\"base-line-info-content\">\r\n                    <div class=\"base-line-info-content-title\">FNJI EARTH</div>\r\n                    <div class=\"base-line-info-content-zh\">\r\n                        <div>大地线作为品牌最早推出的系列，关注寻常人家生活中真实所需的家居设计，简</div>\r\n                        <div>单质朴，在葆有中国的设计语言的基础上，将大自然中的树木变为与家相融的家</div>\r\n                        <div>具，在四季更迭中长久陪伴，慢慢变成我们的家人。</div>\r\n                    </div>\r\n                    <div class=\"base-line-info-content-en\">\r\n                        <div>Earth Line, the original Fnji main line furniture, aims to make practical, sturdy,</div>\r\n                        <div>durable,and elegant everyday furniture,paying attention to practicability.Clean, </div>\r\n                        <div>simple, and endowed with China's design language, Earth Line furniture can be</div>\r\n                        <div>naturally integrated into daily life.</div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div :style=\"{width: baseWidth+'px'}\" class=\"base-line-info-con\">\r\n                <img style=\"width: 100%;height: 100%;\" :src=\"'https://static.fnji.com/temp/upload/'+baseCon+'?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1'\" alt=\"\">\r\n            </div>\r\n        </div>\r\n        <div v-if=\"!isPC\" class=\"base-info-phone\">\r\n            <div class=\"base-info-phone-title\">FNJI EARTH</div>\r\n            <div class=\"base-info-phone-zh\">\r\n                大地线作为品牌最早推出的系列，关注寻常人家生活中真实所需的家居设计，简单质朴， 在葆有中国的设计语言的基础上，将\r\n                大自然中的树木变为与家相融的家具，在四季更迭中长久陪伴，慢慢变成我们的家人。\r\n            </div>\r\n            <div class=\"base-info-phone-en\">\r\n                Earth Line, the original Fnji main line furniture, aims to make practical, sturdy, durable, and elegant\r\n                everyday furniture, paying attention to practicability. Clean, simple, and endowed with China's design\r\n                language, Earth Line furniture can be naturally integrated into daily life.\r\n            </div>\r\n            <div class=\"base-info-phone-img\">\r\n                <img style=\"width: 100%;height: 100%;\" :src=\"'https://static.fnji.com/temp/upload/'+baseConPhone+'?imageMogr2/thumbnail/1200x%3E/quality/100!/sharpen/1'\" alt=\"\">\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"base-normal-h\">\r\n        <swiper-title v-if=\"isPC\" :swiper-image=\"baseList\" swiper-type=\"base\" :ISPC=\"isPC\"></swiper-title>\r\n        <swiper-title v-if=\"!isPC\" :swiper-image=\"baseListPhone\" swiper-type=\"base\" :ISPC=\"isPC\"></swiper-title>\r\n    </div>\r\n    <div class=\"base-line-product\">\r\n        <product-list lineNum=\"2\" :link=\"'/furniture-l2?bom=base'\" :show-num=\"ridgeNum\" :product-list=\"productList\" :productWidth=\"productWidth\" :isPC=\"isPC\"></product-list>\r\n    </div>\r\n</div>"

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),
    __webpack_require__(3),
    __webpack_require__(9)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $,
    _,
    Toast
){
    // var BaseUrl = 'https://fnji.com';
    var BaseUrl = '';
    var ErrorEnum = {
        DataError: {
            code: 'DATA_ERROR',
            data: '数据异常'
        },
        NetworkError: {
            code: 'NETWORK_ERROR',
            data: '网络异常'
        },
        ParamError: {
            code: 'PARAM_ERROR',
            data: '参数错误'
        }
    };
    function Api(path, defaultOptions){
        this.url = BaseUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    Api.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    Api.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };

    return {
        Api: Api,
        // ridgeListApi: new Api('/m/s/SiteIndexEntity/ridge'),//山脊线产品（高端线）
        // earthListApi: new Api('/m/s/SiteIndexEntity/earth'),//大地线产品（高端线）
        // highListApi: new Api('/s/product-list/getLineProducts'),//高端线产品
        getIndexImagesApi: new Api('/m/s/SiteIndexEntity/getIndexImages'),//首页图片
        highListApi: new Api('/s/product-list/getLineProducts'),//高端线产品

        switchZhEnApi: new Api('/m/s/SiteIndexEntity/switchZhEn')//中英文切换
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(191);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-content.css", function() {
		var newContent = require("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-content.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/index2021-base-line.js?e5d14a9e